{
	"nm": "Provision - Start Animation V2 Light",
	"h": 568,
	"w": 968,
	"meta": { "g": "LottieFiles Figma v91" },
	"layers": [
		{
			"ty": 0,
			"nm": "Rovo 1",
			"sr": 1,
			"st": 0,
			"op": 109,
			"ip": 0,
			"hasMask": true,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [130, 86] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [838, 145] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": {
					"a": 1,
					"k": [
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 0
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 24
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 72
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 78
						},
						{ "s": [100], "t": 108 }
					]
				}
			},
			"masksProperties": [
				{
					"nm": "",
					"inv": false,
					"mode": "a",
					"x": { "a": 0, "k": 0 },
					"o": { "a": 0, "k": 100 },
					"pt": {
						"a": 1,
						"k": [
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[260, 0],
											[260, 172],
											[0, 172],
											[0, 0]
										]
									}
								],
								"t": 0
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[260, 0],
											[260, 172],
											[0, 172],
											[0, 0]
										]
									}
								],
								"t": 24
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[260, 0],
											[260, 172],
											[0, 172],
											[0, 0]
										]
									}
								],
								"t": 72
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[260, 0],
											[260, 172],
											[0, 172],
											[0, 0]
										]
									}
								],
								"t": 78
							},
							{
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[260, 0],
											[260, 172],
											[0, 172],
											[0, 0]
										]
									}
								],
								"t": 108
							}
						]
					}
				}
			],
			"w": 968,
			"h": 568,
			"refId": "1",
			"ind": 1
		},
		{
			"ty": 0,
			"nm": "Loom-Confluence",
			"sr": 1,
			"st": 0,
			"op": 109,
			"ip": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [143, 114.5] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [142, 233.5] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": {
					"a": 1,
					"k": [
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 0
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 24
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 72
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 78
						},
						{ "s": [100], "t": 108 }
					]
				}
			},
			"w": 968,
			"h": 568,
			"refId": "3",
			"ind": 2
		},
		{
			"ty": 0,
			"nm": "Team Goals",
			"sr": 1,
			"st": 0,
			"op": 109,
			"ip": 0,
			"hasMask": true,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [167.63, 80.97] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [718.63, 532.97] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": {
					"a": 1,
					"k": [
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 0
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 24
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 72
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [0],
							"t": 78
						},
						{ "s": [100], "t": 108 }
					]
				}
			},
			"masksProperties": [
				{
					"nm": "",
					"inv": false,
					"mode": "a",
					"x": { "a": 0, "k": 0 },
					"o": { "a": 0, "k": 100 },
					"pt": {
						"a": 1,
						"k": [
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[335.27, 0],
											[335.27, 161.93],
											[0, 161.93],
											[0, 0]
										]
									}
								],
								"t": 0
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[335.27, 0],
											[335.27, 161.93],
											[0, 161.93],
											[0, 0]
										]
									}
								],
								"t": 24
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[335.27, 0],
											[335.27, 161.93],
											[0, 161.93],
											[0, 0]
										]
									}
								],
								"t": 72
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[335.27, 0],
											[335.27, 161.93],
											[0, 161.93],
											[0, 0]
										]
									}
								],
								"t": 78
							},
							{
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[335.27, 0],
											[335.27, 161.93],
											[0, 161.93],
											[0, 0]
										]
									}
								],
								"t": 108
							}
						]
					}
				}
			],
			"w": 968,
			"h": 568,
			"refId": "17",
			"ind": 3
		},
		{
			"ty": 4,
			"nm": "Shapes/Pentagon 2",
			"sr": 1,
			"st": 0,
			"op": 109,
			"ip": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [129.01, 358.81] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": {
					"a": 1,
					"k": [
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [1162.83, -220.93],
							"t": 0
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [1162.83, -220.93],
							"t": 24
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [942.81, -70.93],
							"t": 72
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [942.81, -70.93],
							"t": 78
						},
						{ "s": [942.81, -70.93], "t": 108 }
					]
				},
				"r": {
					"a": 1,
					"k": [
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [174.23],
							"t": 0
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [174.23],
							"t": 24
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [191.43],
							"t": 72
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [191.43],
							"t": 78
						},
						{ "s": [191.43], "t": 108 }
					]
				},
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"shapes": [],
			"ind": 4
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 109,
			"ip": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [350.19, 129.02] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": {
					"a": 1,
					"k": [
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [129.38, 365.08],
							"t": 0
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [129.38, 365.08],
							"t": 24
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [129.39, 365.09],
							"t": 72
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [129.39, 365.09],
							"t": 78
						},
						{ "s": [129.39, 365.09], "t": 108 }
					]
				},
				"r": { "a": 0, "k": 90 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"shapes": [
				{
					"ty": "sh",
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[0, 0],
								[-99.213, 0],
								[-2.181, 91.394],
								[0, 0],
								[224.946, 0],
								[0, 181.363]
							],
							"o": [
								[0, 0],
								[2.181, 91.394],
								[99.213, 0],
								[0, 0],
								[0, 181.363],
								[-224.946, 0],
								[0, 0]
							],
							"v": [
								[0, 0],
								[198.416, 0],
								[346.06, 130.181],
								[495.964, 0],
								[694.38, 0],
								[346.06, 252.04],
								[0, 0]
							]
						}
					}
				},
				{
					"ty": "st",
					"nm": "",
					"lc": 1,
					"lj": 1,
					"ml": 4,
					"o": { "a": 0, "k": 100 },
					"w": {
						"a": 1,
						"k": [
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [6],
								"t": 0
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [6],
								"t": 24
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [6],
								"t": 72
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [6],
								"t": 78
							},
							{ "s": [6], "t": 108 }
						]
					},
					"c": { "a": 0, "k": [0.51, 0.708, 0.212] }
				},
				{
					"ty": "fl",
					"nm": "",
					"c": { "a": 0, "k": [0.51, 0.708, 0.212] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 5,
			"parent": 4
		},
		{
			"ty": 4,
			"nm": "Shapes/Pentagon 1",
			"sr": 1,
			"st": 0,
			"op": 109,
			"ip": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [171.22, 166.65] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": {
					"a": 1,
					"k": [
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [770.48, 758.15],
							"t": 0
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [770.48, 758.15],
							"t": 24
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [730.49, 587.62],
							"t": 72
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [730.49, 587.62],
							"t": 78
						},
						{ "s": [730.49, 587.62], "t": 108 }
					]
				},
				"r": {
					"a": 1,
					"k": [
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [-7.49],
							"t": 0
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [-7.49],
							"t": 24
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [17.6],
							"t": 72
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [17.6],
							"t": 78
						},
						{ "s": [17.6], "t": 108 }
					]
				},
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"shapes": [],
			"ind": 6
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 109,
			"ip": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [170.76, 166.84] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [173.2, 170.95] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"shapes": [
				{
					"ty": "sh",
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0]
							],
							"o": [
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0]
							],
							"v": [
								[112.734, 327.68],
								[222.845, 327.68],
								[335.52, 111.174],
								[167.731, 0],
								[0, 111.174],
								[112.734, 327.68]
							]
						}
					}
				},
				{
					"ty": "st",
					"nm": "",
					"lc": 1,
					"lj": 1,
					"ml": 4,
					"o": { "a": 0, "k": 100 },
					"w": {
						"a": 1,
						"k": [
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [6],
								"t": 0
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [6],
								"t": 24
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [6],
								"t": 72
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [6],
								"t": 78
							},
							{ "s": [6], "t": 108 }
						]
					},
					"c": { "a": 0, "k": [0.749, 0.388, 0.953] }
				},
				{
					"ty": "fl",
					"nm": "",
					"c": { "a": 0, "k": [0.749, 0.388, 0.953] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 7,
			"parent": 6
		},
		{
			"ty": 0,
			"nm": "Shapes/Round 5",
			"sr": 1,
			"st": 0,
			"op": 109,
			"ip": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [174.5, 160] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": {
					"a": 1,
					"k": [
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [-228.5, 154],
							"t": 0
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [-228.5, 154],
							"t": 24
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [-8.5, 254],
							"t": 72
						},
						{
							"o": { "x": 0.33, "y": 1 },
							"i": { "x": 0.68, "y": 1 },
							"s": [-8.5, 254],
							"t": 78
						},
						{ "s": [-8.5, 254], "t": 108 }
					]
				},
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"w": 968,
			"h": 568,
			"refId": "19",
			"ind": 8
		},
		{
			"ty": 4,
			"nm": "Background (White)",
			"sr": 1,
			"st": 0,
			"op": 109,
			"ip": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [484, 284] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [484, 284] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"shapes": [
				{
					"ty": "sh",
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0]
							],
							"o": [
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0]
							],
							"v": [
								[968, 0],
								[968, 568],
								[0, 568],
								[0, 0]
							]
						}
					}
				},
				{
					"ty": "fl",
					"nm": "",
					"c": { "a": 0, "k": [1, 1, 1] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 9
		},
		{
			"ty": 0,
			"nm": "Ambient/Atlassian/Abstract/Combo 2",
			"sr": 1,
			"st": 0,
			"op": 109,
			"ip": 0,
			"hasMask": true,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [690.5, 388.5] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [690.5, 388.5] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"masksProperties": [
				{
					"nm": "",
					"inv": false,
					"mode": "a",
					"x": { "a": 0, "k": 0 },
					"o": { "a": 0, "k": 100 },
					"pt": {
						"a": 1,
						"k": [
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[1381, 0],
											[1381, 777],
											[0, 777],
											[0, 0]
										]
									}
								],
								"t": 0
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[1381, 0],
											[1381, 777],
											[0, 777],
											[0, 0]
										]
									}
								],
								"t": 24
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[1381, 0],
											[1381, 777],
											[0, 777],
											[0, 0]
										]
									}
								],
								"t": 72
							},
							{
								"o": { "x": 0.33, "y": 1 },
								"i": { "x": 0.68, "y": 1 },
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[1381, 0],
											[1381, 777],
											[0, 777],
											[0, 0]
										]
									}
								],
								"t": 78
							},
							{
								"s": [
									{
										"c": true,
										"i": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"o": [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										"v": [
											[1381, 0],
											[1381, 777],
											[0, 777],
											[0, 0]
										]
									}
								],
								"t": 108
							}
						]
					}
				}
			],
			"w": 1381,
			"h": 777,
			"refId": "20",
			"ind": 10
		},
		{
			"ty": 4,
			"nm": "Modal Bg",
			"sr": 1,
			"st": 0,
			"op": 109,
			"ip": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [484, 284] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [484, 284] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"shapes": [
				{
					"ty": "sh",
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0]
							],
							"o": [
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0]
							],
							"v": [
								[968, 0],
								[968, 568],
								[0, 568],
								[0, 0]
							]
						}
					}
				},
				{
					"ty": "fl",
					"nm": "",
					"c": { "a": 0, "k": [1, 1, 1] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 11
		}
	],
	"v": "5.7.0",
	"fr": 60,
	"op": 108,
	"ip": 0,
	"assets": [
		{
			"nm": "[Asset] Rovo 1",
			"id": "1",
			"layers": [
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.39, 1.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [10.36, 9.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.48, 0.14],
										[0.92, 0.01],
										[0.7, 0.03],
										[0.48, 0.1],
										[0.07, -0.01],
										[1.93, 0.1],
										[0.44, 0],
										[0.77, -0.26],
										[-0.42, -0.14],
										[-1.04, -0.01],
										[-1.19, -0.05],
										[-0.19, 0.05],
										[0, 0],
										[-1.36, 0],
										[-0.3, 0],
										[-0.68, 0.2],
										[0, 0]
									],
									"o": [
										[0.48, -0.14],
										[-0.68, -0.2],
										[-1.04, 0.06],
										[-1.19, 0],
										[-0.07, -0.01],
										[-0.51, 0.05],
										[-1.37, 0],
										[-1.04, 0.01],
										[-0.42, 0.14],
										[0.77, 0.26],
										[0.4, 0],
										[0.2, 0.01],
										[1.66, -0.44],
										[0, 0],
										[1.02, 0],
										[0.92, -0.01],
										[0, 0],
										[0, 0]
									],
									"v": [
										[18.43, 2.14],
										[18.43, 0.49],
										[16.12, 0.18],
										[14.12, 0.49],
										[10.45, 0.01],
										[10.24, 0.01],
										[5.55, 0.17],
										[2.9, 0.18],
										[0.31, 0.58],
										[0.31, 2.04],
										[2.9, 2.45],
										[5.34, 2.83],
										[5.92, 2.77],
										[9.73, 2.45],
										[14.31, 2.45],
										[16.12, 2.45],
										[18.43, 2.13],
										[18.43, 2.14]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.063, 0.071, 0.079] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.42, 9.39] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [10.35, 9.4] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.14, -0.48],
										[0.01, -0.92],
										[0.03, -0.7],
										[0.1, -0.48],
										[-0.01, -0.07],
										[0.1, -1.93],
										[0, -0.44],
										[-0.26, -0.77],
										[-0.14, 0.42],
										[-0.01, 1.04],
										[-0.05, 1.19],
										[0.05, 0.19],
										[0, 0],
										[0, 1.36],
										[0, 0.3],
										[0.2, 0.68],
										[0, 0]
									],
									"o": [
										[-0.14, -0.48],
										[-0.2, 0.68],
										[0.06, 1.04],
										[0, 1.19],
										[-0.01, 0.07],
										[0.05, 0.51],
										[0, 1.37],
										[0.01, 1.04],
										[0.14, 0.42],
										[0.26, -0.77],
										[0, -0.4],
										[0.01, -0.19],
										[-0.44, -1.66],
										[0, 0],
										[0, -1.02],
										[-0.01, -0.92],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.14, 0.36],
										[0.49, 0.36],
										[0.18, 2.67],
										[0.49, 4.67],
										[0.01, 8.34],
										[0.01, 8.55],
										[0.17, 13.24],
										[0.18, 15.89],
										[0.58, 18.47],
										[2.04, 18.47],
										[2.45, 15.89],
										[2.83, 13.45],
										[2.77, 12.87],
										[2.45, 9.05],
										[2.45, 4.48],
										[2.45, 2.67],
										[2.13, 0.36],
										[2.14, 0.36]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.063, 0.071, 0.079] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.39, 1.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [49.55, 17.23] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.48, -0.14],
										[-0.92, -0.01],
										[-0.7, -0.03],
										[-0.48, -0.1],
										[-0.07, 0.01],
										[-1.93, -0.1],
										[-0.44, 0],
										[-0.77, 0.26],
										[0.42, 0.14],
										[1.04, 0.01],
										[1.19, 0.05],
										[0.19, -0.05],
										[0, 0],
										[1.36, 0],
										[0.3, 0],
										[0.68, -0.2],
										[0, 0]
									],
									"o": [
										[-0.48, 0.14],
										[0.68, 0.2],
										[1.04, -0.06],
										[1.19, 0],
										[0.07, 0.01],
										[0.51, -0.05],
										[1.37, 0],
										[1.04, -0.01],
										[0.42, -0.14],
										[-0.77, -0.26],
										[-0.4, 0],
										[-0.2, -0.01],
										[-1.66, 0.44],
										[0, 0],
										[-1.02, 0],
										[-0.92, 0.01],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.36, 0.69],
										[0.36, 2.34],
										[2.67, 2.66],
										[4.67, 2.34],
										[8.34, 2.82],
										[8.55, 2.83],
										[13.24, 2.67],
										[15.89, 2.66],
										[18.47, 2.25],
										[18.47, 0.79],
										[15.89, 0.38],
										[13.45, 0],
										[12.87, 0.07],
										[9.05, 0.38],
										[4.48, 0.38],
										[2.67, 0.38],
										[0.36, 0.7],
										[0.36, 0.69]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.063, 0.071, 0.079] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.42, 9.39] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [49.54, 17.22] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.14, -0.48],
										[0.01, -0.92],
										[0.03, -0.7],
										[0.1, -0.48],
										[-0.01, -0.07],
										[0.1, -1.93],
										[0, -0.44],
										[-0.26, -0.77],
										[-0.14, 0.42],
										[-0.01, 1.04],
										[-0.05, 1.19],
										[0.05, 0.19],
										[0, 0],
										[0, 1.36],
										[0, 0.3],
										[0.2, 0.68],
										[0, 0]
									],
									"o": [
										[-0.14, -0.48],
										[-0.2, 0.68],
										[0.06, 1.04],
										[0, 1.19],
										[-0.01, 0.07],
										[0.05, 0.51],
										[0, 1.37],
										[0.01, 1.04],
										[0.14, 0.42],
										[0.26, -0.77],
										[0, -0.4],
										[0.01, -0.2],
										[-0.44, -1.66],
										[0, 0],
										[0, -1.02],
										[-0.01, -0.92],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.14, 0.36],
										[0.49, 0.36],
										[0.18, 2.67],
										[0.49, 4.67],
										[0.01, 8.34],
										[0.01, 8.55],
										[0.17, 13.24],
										[0.18, 15.89],
										[0.58, 18.47],
										[2.04, 18.47],
										[2.45, 15.89],
										[2.83, 13.45],
										[2.77, 12.87],
										[2.45, 9.05],
										[2.45, 4.48],
										[2.45, 2.67],
										[2.13, 0.36],
										[2.14, 0.36]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.063, 0.071, 0.079] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 4
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.39, 1.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [30.24, 43.26] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.48, 0.14],
										[0.92, 0.01],
										[0.7, 0.03],
										[0.48, 0.1],
										[0.07, -0.01],
										[1.93, 0.1],
										[0.44, 0],
										[0.77, -0.26],
										[-0.42, -0.14],
										[-1.04, -0.01],
										[-1.19, -0.05],
										[-0.19, 0.05],
										[0, 0],
										[-1.36, 0],
										[-0.3, 0],
										[-0.68, 0.2],
										[0, 0]
									],
									"o": [
										[0.48, -0.14],
										[-0.68, -0.2],
										[-1.04, 0.06],
										[-1.19, 0],
										[-0.07, -0.01],
										[-0.51, 0.05],
										[-1.37, 0],
										[-1.04, 0.01],
										[-0.42, 0.14],
										[0.77, 0.26],
										[0.4, 0],
										[0.2, 0.01],
										[1.66, -0.44],
										[0, 0],
										[1.02, 0],
										[0.92, -0.01],
										[0, 0],
										[0, 0]
									],
									"v": [
										[18.43, 2.14],
										[18.43, 0.49],
										[16.12, 0.18],
										[14.12, 0.49],
										[10.45, 0.01],
										[10.24, 0.01],
										[5.55, 0.17],
										[2.9, 0.18],
										[0.31, 0.58],
										[0.31, 2.04],
										[2.9, 2.45],
										[5.34, 2.83],
										[5.92, 2.77],
										[9.73, 2.45],
										[14.31, 2.45],
										[16.12, 2.45],
										[18.43, 2.13],
										[18.43, 2.14]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.063, 0.071, 0.079] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 5
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.42, 9.39] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [30.24, 43.27] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.14, 0.48],
										[-0.01, 0.92],
										[-0.03, 0.7],
										[-0.1, 0.48],
										[0.01, 0.07],
										[-0.1, 1.93],
										[0, 0.44],
										[0.26, 0.77],
										[0.14, -0.42],
										[0.01, -1.04],
										[0.05, -1.19],
										[-0.05, -0.19],
										[0, 0],
										[0, -1.36],
										[0, -0.3],
										[-0.2, -0.68],
										[0, 0]
									],
									"o": [
										[0.14, 0.48],
										[0.2, -0.68],
										[-0.06, -1.04],
										[0, -1.19],
										[0.01, -0.07],
										[-0.05, -0.51],
										[0, -1.37],
										[-0.01, -1.04],
										[-0.14, -0.42],
										[-0.26, 0.77],
										[0, 0.4],
										[-0.01, 0.2],
										[0.44, 1.66],
										[0, 0],
										[0, 1.02],
										[0.01, 0.92],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.69, 18.43],
										[2.34, 18.43],
										[2.66, 16.12],
										[2.34, 14.12],
										[2.82, 10.45],
										[2.83, 10.24],
										[2.67, 5.55],
										[2.66, 2.9],
										[2.25, 0.31],
										[0.79, 0.31],
										[0.38, 2.9],
										[0, 5.34],
										[0.07, 5.92],
										[0.38, 9.73],
										[0.38, 14.31],
										[0.38, 16.12],
										[0.7, 18.43],
										[0.69, 18.43]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.063, 0.071, 0.079] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 6
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.19, 3.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [158.87, 126.16] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.26, 0.06],
										[0.18, 0.13],
										[0.1, 0.17],
										[0, 0],
										[-0.1, -0.09],
										[-0.16, -0.05],
										[-0.24, 0.03],
										[-0.19, 0.18],
										[0.04, 0.34],
										[0, 0],
										[0, 0],
										[0.08, -0.13],
										[0.16, -0.1],
										[0.27, -0.03],
										[0.3, 0.14],
										[0.2, 0.31],
										[0.05, 0.47],
										[-0.13, 0.36],
										[-0.26, 0.21],
										[-0.36, 0.04],
										[-0.18, -0.07],
										[-0.11, -0.11],
										[-0.06, -0.09],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.15, -0.27],
										[0.29, -0.15],
										[0.38, -0.04],
										[0, 0]
									],
									"o": [
										[-0.34, 0.04],
										[-0.26, -0.06],
										[-0.18, -0.13],
										[0, 0],
										[0.06, 0.08],
										[0.1, 0.09],
										[0.16, 0.05],
										[0.34, -0.04],
										[0.19, -0.18],
										[0, 0],
										[0, 0],
										[-0.04, 0.1],
										[-0.08, 0.13],
										[-0.16, 0.1],
										[-0.35, 0.04],
										[-0.3, -0.14],
										[-0.2, -0.31],
										[-0.05, -0.47],
										[0.13, -0.36],
										[0.26, -0.21],
										[0.28, -0.03],
										[0.18, 0.07],
										[0.11, 0.11],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.04, 0.39],
										[-0.15, 0.27],
										[-0.29, 0.15],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.53, 6.45],
										[1.62, 6.42],
										[0.95, 6.13],
										[0.53, 5.69],
										[1.23, 5.26],
										[1.47, 5.51],
										[1.86, 5.71],
										[2.45, 5.75],
										[3.26, 5.41],
										[3.49, 4.62],
										[3.4, 3.75],
										[3.32, 3.76],
										[3.13, 4.1],
										[2.77, 4.45],
										[2.12, 4.64],
										[1.15, 4.5],
										[0.4, 3.84],
										[0.02, 2.66],
										[0.14, 1.42],
										[0.72, 0.56],
										[1.65, 0.18],
										[2.34, 0.25],
										[2.78, 0.53],
										[3.03, 0.83],
										[3.1, 0.82],
										[3.02, 0.09],
										[3.88, 0],
										[4.37, 4.53],
										[4.21, 5.53],
										[3.55, 6.16],
										[2.53, 6.45],
										[2.53, 6.45]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.16, 0.14],
										[-0.06, 0.23],
										[0.03, 0.3],
										[0.11, 0.22],
										[0.18, 0.11],
										[0.25, -0.03],
										[0.16, -0.15],
										[0.06, -0.24],
										[-0.03, -0.28],
										[-0.11, -0.21],
										[-0.19, -0.1],
										[-0.26, 0.03],
										[0, 0]
									],
									"o": [
										[0.25, -0.03],
										[0.16, -0.13],
										[0.06, -0.23],
										[-0.03, -0.3],
										[-0.11, -0.22],
										[-0.18, -0.11],
										[-0.25, 0.03],
										[-0.16, 0.15],
										[-0.06, 0.24],
										[0.03, 0.28],
										[0.11, 0.21],
										[0.19, 0.1],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.25, 3.89],
										[2.86, 3.64],
										[3.2, 3.1],
										[3.24, 2.3],
										[3.03, 1.52],
										[2.58, 1.03],
										[1.93, 0.91],
										[1.3, 1.18],
										[0.97, 1.77],
										[0.92, 2.55],
										[1.13, 3.31],
										[1.58, 3.78],
										[2.25, 3.89],
										[2.25, 3.89]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 7
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.11, 2.39] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [153.85, 125.96] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.23, 0.21],
										[-0.35, 0.04],
										[-0.24, -0.1],
										[-0.15, -0.24],
										[-0.04, -0.37],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.19, 0.16],
										[0.29, -0.03],
										[0.15, -0.1],
										[0.07, -0.18],
										[-0.03, -0.24],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.09, -0.41],
										[0.23, -0.21],
										[0.3, -0.03],
										[0.24, 0.1],
										[0.15, 0.24],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.03, -0.32],
										[-0.19, -0.16],
										[-0.2, 0.02],
										[-0.15, 0.1],
										[-0.07, 0.18],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.08, 2.03],
										[1.36, 4.68],
										[0.48, 4.78],
										[0, 0.31],
										[0.84, 0.22],
										[0.97, 1.31],
										[0.88, 1.32],
										[1.35, 0.38],
										[2.22, 0.01],
										[3.04, 0.12],
										[3.63, 0.63],
										[3.92, 1.53],
										[4.23, 4.37],
										[3.35, 4.47],
										[3.05, 1.74],
										[2.72, 1.01],
										[2, 0.81],
										[1.48, 1],
										[1.15, 1.42],
										[1.08, 2.03],
										[1.08, 2.03]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.78, 3.06] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [150.26, 125.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.1, 0.98],
										[0, 0.1],
										[0.93, 0],
										[1.03, 0.88],
										[0.1, 0.98]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.68, 6.12],
										[0.19, 1.66],
										[1.07, 1.56],
										[1.56, 6.03],
										[0.68, 6.12]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 9
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.19, 3.02] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [146.78, 126.08] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.23, 0.21],
										[-0.35, 0.04],
										[-0.24, -0.1],
										[-0.15, -0.24],
										[-0.04, -0.37],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.19, 0.16],
										[0.29, -0.03],
										[0.15, -0.1],
										[0.07, -0.18],
										[-0.02, -0.24]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.09, -0.41],
										[0.23, -0.21],
										[0.3, -0.03],
										[0.24, 0.1],
										[0.15, 0.24],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.03, -0.32],
										[-0.19, -0.16],
										[-0.2, 0.02],
										[-0.15, 0.1],
										[-0.07, 0.18],
										[0, 0]
									],
									"v": [
										[1.24, 3.31],
										[1.53, 5.95],
										[0.65, 6.05],
										[0, 0.09],
										[0.87, 0],
										[1.15, 2.58],
										[1.04, 2.6],
										[1.51, 1.66],
										[2.38, 1.29],
										[3.2, 1.39],
										[3.79, 1.9],
										[4.08, 2.81],
										[4.39, 5.65],
										[3.51, 5.74],
										[3.21, 3.01],
										[2.88, 2.28],
										[2.16, 2.09],
										[1.64, 2.27],
										[1.31, 2.69],
										[1.24, 3.31]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 10
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.51, 2.78] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [142.96, 126.54] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.42, 0.97],
										[2.5, 1.68],
										[0.08, 1.94],
										[0, 1.23],
										[2.42, 0.97]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.08, -0.08],
										[-0.17, 0.02],
										[-0.07, 0.02],
										[-0.05, 0.02],
										[0, 0],
										[0.11, -0.03],
										[0.11, -0.01],
										[0.25, 0.18],
										[0.04, 0.38],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0.02, 0.18],
										[0.09, 0.08],
										[0.05, -0.01],
										[0.07, -0.02],
										[0, 0],
										[-0.09, 0.04],
										[-0.1, 0.03],
										[-0.4, 0.04],
										[-0.25, -0.19],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.53, 0.1],
										[1.41, 0],
										[1.88, 4.33],
										[2.04, 4.71],
										[2.43, 4.79],
										[2.61, 4.76],
										[2.79, 4.7],
										[3.02, 5.39],
										[2.73, 5.49],
										[2.42, 5.55],
										[1.44, 5.34],
										[1.01, 4.49],
										[0.53, 0.09],
										[0.53, 0.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 11
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.17, 3.28] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [138.88, 128.31] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.12, 0.03],
										[-0.08, 0.1],
										[-0.03, 0.2],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.1, -0.27],
										[-0.11, -0.27],
										[0, 0],
										[-0.04, 0.29],
										[-0.07, 0.29],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.11, -0.17],
										[0.17, -0.1],
										[0.24, -0.03],
										[0.11, 0.01],
										[0.06, 0.02],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0.16, 0.02],
										[0.12, -0.03],
										[0.08, -0.11],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, 0.27],
										[0.1, 0.27],
										[0, 0],
										[0.05, -0.29],
										[0.04, -0.29],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, 0.25],
										[-0.11, 0.18],
										[-0.17, 0.1],
										[-0.14, 0.02],
										[-0.11, -0.01],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.01, 6.51],
										[1.15, 5.77],
										[1.25, 5.78],
										[1.66, 5.77],
										[1.96, 5.57],
										[2.13, 5.11],
										[2.19, 4.77],
										[0, 0.47],
										[0.95, 0.37],
										[2.11, 2.81],
										[2.45, 3.63],
										[2.75, 4.44],
										[2.48, 4.47],
										[2.61, 3.61],
										[2.77, 2.74],
										[3.4, 0.1],
										[4.34, 0],
										[2.95, 5.3],
										[2.68, 5.94],
										[2.25, 6.35],
										[1.63, 6.54],
										[1.26, 6.55],
										[1.01, 6.51],
										[1.01, 6.51]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 12
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.11, 2.39] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [134.44, 128.06] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.23, 0.21],
										[-0.35, 0.04],
										[-0.24, -0.1],
										[-0.15, -0.24],
										[-0.04, -0.37],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.19, 0.16],
										[0.29, -0.03],
										[0.15, -0.1],
										[0.07, -0.17],
										[-0.02, -0.24],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.09, -0.41],
										[0.23, -0.21],
										[0.3, -0.03],
										[0.24, 0.1],
										[0.15, 0.24],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.03, -0.32],
										[-0.19, -0.16],
										[-0.2, 0.02],
										[-0.15, 0.1],
										[-0.07, 0.18],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.08, 2.03],
										[1.36, 4.68],
										[0.48, 4.78],
										[0, 0.31],
										[0.84, 0.22],
										[0.97, 1.31],
										[0.88, 1.32],
										[1.35, 0.39],
										[2.22, 0.01],
										[3.04, 0.12],
										[3.63, 0.63],
										[3.92, 1.54],
										[4.23, 4.37],
										[3.35, 4.47],
										[3.05, 1.74],
										[2.72, 1.01],
										[2, 0.81],
										[1.48, 1],
										[1.15, 1.42],
										[1.08, 2.03],
										[1.08, 2.03]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 13
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.17, 2.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [129.45, 128.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.3, 0.15],
										[0.2, 0.33],
										[0.05, 0.48],
										[-0.13, 0.36],
										[-0.26, 0.21],
										[-0.36, 0.04],
										[-0.18, -0.07],
										[-0.11, -0.11],
										[-0.06, -0.09],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.09, -0.13],
										[0.16, -0.11],
										[0.27, -0.03],
										[0, 0]
									],
									"o": [
										[-0.36, 0.04],
										[-0.3, -0.15],
										[-0.2, -0.33],
										[-0.05, -0.48],
										[0.13, -0.36],
										[0.26, -0.21],
										[0.28, -0.03],
										[0.18, 0.07],
										[0.11, 0.12],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.04, 0.1],
										[-0.08, 0.13],
										[-0.16, 0.11],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.14, 4.8],
										[1.15, 4.62],
										[0.4, 3.9],
										[0.02, 2.69],
										[0.13, 1.42],
										[0.72, 0.56],
										[1.65, 0.18],
										[2.33, 0.25],
										[2.76, 0.53],
										[3.02, 0.83],
										[3.07, 0.82],
										[2.99, 0.1],
										[3.86, 0],
										[4.35, 4.47],
										[3.48, 4.56],
										[3.41, 3.86],
										[3.35, 3.87],
										[3.16, 4.22],
										[2.79, 4.59],
										[2.14, 4.8],
										[2.14, 4.8]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.16, 0.15],
										[-0.06, 0.24],
										[0.03, 0.31],
										[0.11, 0.22],
										[0.18, 0.11],
										[0.25, -0.03],
										[0.16, -0.15],
										[0.06, -0.24],
										[-0.03, -0.3],
										[-0.11, -0.23],
										[-0.19, -0.12],
										[-0.26, 0.03],
										[0, 0]
									],
									"o": [
										[0.25, -0.03],
										[0.16, -0.15],
										[0.06, -0.24],
										[-0.03, -0.31],
										[-0.11, -0.22],
										[-0.18, -0.11],
										[-0.25, 0.03],
										[-0.16, 0.15],
										[-0.06, 0.24],
										[0.03, 0.3],
										[0.11, 0.23],
										[0.19, 0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.26, 4.03],
										[2.88, 3.76],
										[3.2, 3.17],
										[3.25, 2.34],
										[3.03, 1.54],
										[2.58, 1.04],
										[1.93, 0.91],
										[1.3, 1.19],
										[0.97, 1.78],
										[0.92, 2.59],
										[1.14, 3.38],
										[1.6, 3.9],
										[2.26, 4.03],
										[2.26, 4.03]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 14
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.07, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [122.36, 129.33] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.34, 0.15],
										[0.21, 0.33],
										[0.05, 0.46],
										[-0.13, 0.37],
										[-0.29, 0.23],
										[-0.42, 0.05],
										[-0.25, -0.06],
										[-0.21, -0.16],
										[-0.14, -0.27],
										[-0.04, -0.4],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.11, 0.2],
										[0.18, 0.1],
										[0.25, -0.03],
										[0.16, -0.14],
										[0.07, -0.21],
										[-0.02, -0.23],
										[0, 0],
										[-0.13, -0.2],
										[-0.2, -0.09],
										[-0.25, 0.03],
										[-0.13, 0.06],
										[-0.09, 0.1],
										[-0.04, 0.14],
										[0, 0],
										[0.15, -0.19],
										[0.24, -0.12],
										[0.32, -0.03],
										[0, 0]
									],
									"o": [
										[-0.44, 0.05],
										[-0.34, -0.15],
										[-0.21, -0.33],
										[-0.05, -0.46],
										[0.13, -0.37],
										[0.29, -0.23],
										[0.26, -0.03],
										[0.25, 0.06],
										[0.21, 0.16],
										[0.14, 0.27],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.03, -0.27],
										[-0.11, -0.2],
										[-0.18, -0.1],
										[-0.25, 0.03],
										[-0.16, 0.14],
										[-0.07, 0.21],
										[0, 0],
										[0.03, 0.31],
										[0.13, 0.2],
										[0.2, 0.09],
										[0.17, -0.02],
										[0.13, -0.06],
										[0.09, -0.1],
										[0, 0],
										[-0.05, 0.24],
										[-0.15, 0.19],
										[-0.24, 0.13],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.4, 4.62],
										[1.23, 4.46],
										[0.41, 3.74],
										[0.02, 2.56],
										[0.14, 1.32],
										[0.77, 0.43],
										[1.83, 0.01],
										[2.58, 0.06],
										[3.26, 0.38],
										[3.79, 1.03],
										[4.07, 2.04],
										[4.1, 2.35],
										[0.54, 2.74],
										[0.47, 2.08],
										[3.58, 1.75],
										[3.19, 2.01],
										[2.98, 1.3],
										[2.55, 0.85],
										[1.91, 0.74],
										[1.29, 0.99],
										[0.94, 1.51],
										[0.87, 2.16],
										[0.92, 2.61],
										[1.16, 3.37],
										[1.66, 3.8],
										[2.33, 3.89],
										[2.77, 3.77],
										[3.1, 3.52],
										[3.28, 3.15],
										[4.13, 3.26],
										[3.84, 3.9],
										[3.25, 4.38],
										[2.41, 4.62],
										[2.4, 4.62]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 15
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.29, 2.53] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [116.29, 130.02] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.12, 0.18],
										[-0.17, 0.1],
										[-0.19, 0.02],
										[-0.22, -0.18],
										[-0.11, -0.35],
										[0, 0],
										[-0.13, 0.19],
										[-0.19, 0.11],
										[-0.23, 0.03],
										[-0.23, -0.09],
										[-0.15, -0.21],
										[-0.04, -0.34],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.18, 0.12],
										[0.22, -0.02],
										[0.12, -0.09],
										[0.06, -0.15],
										[-0.02, -0.18],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.17, 0.13],
										[0.24, -0.03],
										[0.13, -0.09],
										[0.07, -0.16],
										[-0.02, -0.22],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.04, -0.26],
										[0.12, -0.18],
										[0.17, -0.1],
										[0.33, -0.04],
										[0.22, 0.18],
										[0, 0],
										[0.03, -0.25],
										[0.13, -0.19],
										[0.19, -0.11],
										[0.26, -0.03],
										[0.23, 0.09],
										[0.15, 0.21],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.03, -0.3],
										[-0.18, -0.12],
										[-0.18, 0.02],
										[-0.12, 0.09],
										[-0.05, 0.15],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.03, -0.24],
										[-0.17, -0.13],
										[-0.16, 0.02],
										[-0.13, 0.09],
										[-0.07, 0.16],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.48, 5.06],
										[0, 0.59],
										[0.83, 0.5],
										[0.97, 1.54],
										[0.9, 1.54],
										[1.13, 0.89],
										[1.56, 0.47],
										[2.11, 0.29],
										[2.93, 0.5],
										[3.42, 1.3],
										[3.31, 1.31],
										[3.55, 0.66],
										[4.03, 0.21],
										[4.66, 0.01],
										[5.4, 0.1],
										[5.97, 0.56],
										[6.25, 1.39],
										[6.57, 4.4],
										[5.69, 4.5],
										[5.38, 1.57],
										[5.06, 0.95],
										[4.45, 0.81],
										[3.98, 0.98],
										[3.71, 1.34],
										[3.66, 1.82],
										[3.97, 4.68],
										[3.1, 4.78],
										[2.78, 1.8],
										[2.48, 1.25],
										[1.87, 1.09],
										[1.43, 1.26],
										[1.13, 1.63],
										[1.07, 2.19],
										[1.37, 4.97],
										[0.49, 5.06],
										[0.48, 5.06]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 16
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.27, 3.03] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [108.36, 130.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.65, 6.05],
										[0, 0.1],
										[0.88, 0],
										[1.53, 5.95],
										[0.65, 6.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.29, 4.46],
										[1.18, 3.38],
										[1.32, 3.36],
										[2.88, 1.29],
										[3.94, 1.17],
										[2.15, 3.55],
										[2, 3.57],
										[1.29, 4.46],
										[1.29, 4.46]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.46, 5.75],
										[1.64, 3.81],
										[2.18, 3.12],
										[4.55, 5.63],
										[3.46, 5.75]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 17
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.87, 2.33] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [103.77, 131.36] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.26, 0.07],
										[0.18, 0.16],
										[0.08, 0.26],
										[0, 0],
										[-0.18, -0.09],
										[-0.26, 0.03],
										[-0.16, 0.14],
										[0.02, 0.16],
										[0.11, 0.08],
										[0.22, 0.02],
										[0, 0],
										[0.23, 0.18],
										[0.04, 0.32],
										[-0.13, 0.22],
										[-0.25, 0.14],
										[-0.34, 0.04],
										[-0.24, -0.07],
										[-0.16, -0.15],
										[-0.08, -0.22],
										[0, 0],
										[0.15, 0.1],
										[0.26, -0.03],
										[0.15, -0.13],
										[-0.02, -0.17],
										[-0.12, -0.08],
										[-0.25, -0.03],
										[0, 0],
										[-0.22, -0.18],
										[-0.03, -0.31],
										[0.14, -0.23],
										[0.26, -0.15],
										[0.37, -0.04],
										[0, 0]
									],
									"o": [
										[-0.32, 0.03],
										[-0.26, -0.07],
										[-0.18, -0.16],
										[0, 0],
										[0.09, 0.23],
										[0.18, 0.09],
										[0.28, -0.03],
										[0.16, -0.14],
										[-0.01, -0.14],
										[-0.11, -0.08],
										[0, 0],
										[-0.43, -0.05],
										[-0.22, -0.18],
										[-0.03, -0.27],
										[0.13, -0.22],
										[0.25, -0.14],
										[0.34, -0.04],
										[0.24, 0.07],
										[0.16, 0.15],
										[0, 0],
										[-0.07, -0.15],
										[-0.15, -0.1],
										[-0.24, 0.03],
										[-0.15, 0.13],
										[0.02, 0.15],
										[0.12, 0.08],
										[0, 0],
										[0.42, 0.05],
										[0.22, 0.18],
										[0.03, 0.27],
										[-0.13, 0.23],
										[-0.26, 0.15],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.04, 4.64],
										[1.16, 4.59],
										[0.5, 4.25],
										[0.1, 3.61],
										[0.91, 3.35],
										[1.31, 3.83],
										[1.97, 3.93],
										[2.63, 3.68],
										[2.83, 3.22],
										[2.64, 2.89],
										[2.14, 2.73],
										[1.37, 2.64],
										[0.4, 2.29],
										[0.01, 1.54],
										[0.15, 0.81],
										[0.72, 0.28],
										[1.59, 0.02],
										[2.44, 0.07],
										[3.04, 0.4],
										[3.4, 0.95],
										[2.64, 1.21],
										[2.3, 0.83],
										[1.68, 0.72],
										[1.09, 0.94],
										[0.89, 1.39],
										[1.09, 1.73],
										[1.65, 1.9],
										[2.38, 1.98],
										[3.35, 2.32],
										[3.73, 3.05],
										[3.57, 3.8],
										[2.98, 4.36],
										[2.04, 4.64],
										[2.04, 4.64]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 18
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.7, 3.15] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [98.86, 131.27] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.15, 0.35],
										[0.2, 0.5],
										[0, 0],
										[0.07, -0.38],
										[0.06, -0.26],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.12, -0.26],
										[-0.15, -0.35],
										[0, 0],
										[-0.08, 0.53],
										[-0.07, 0.38],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 6.31],
										[1.47, 0.12],
										[2.59, 0],
										[5.4, 5.72],
										[4.41, 5.83],
										[2.89, 2.64],
										[2.49, 1.72],
										[1.97, 0.45],
										[2.16, 0.43],
										[1.94, 1.8],
										[1.75, 2.77],
										[0.99, 6.2],
										[0, 6.31]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.98, 4.61],
										[0.89, 3.85],
										[3.99, 3.52],
										[4.07, 4.27],
										[0.98, 4.61]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.494, 0.506, 0.533] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 19
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.69, 3.7] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [231.68, 116.59] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.18, -1.65],
										[-1.65, 0.18],
										[-0.41, 0.3],
										[0, 0],
										[0.67, -0.07],
										[0.22, 2.03],
										[-2.03, 0.22],
										[-0.22, -2.03],
										[0.21, -0.37],
										[0.52, -0.06],
										[0.2, 0.13],
										[0.08, 0.15],
										[0.75, 0.33],
										[-0.39, 0.88],
										[-0.87, -0.38],
										[-0.05, -0.57],
										[0, -0.02],
										[-0.11, -0.23],
										[-0.06, -0.04],
										[-0.12, 0.01],
										[-0.13, 0.23],
										[0.03, 0.25],
										[1.65, -0.18]
									],
									"o": [
										[-1.65, 0.18],
										[0.18, 1.65],
										[0.55, -0.06],
										[0, 0],
										[-0.51, 0.37],
										[-2.03, 0.22],
										[-0.22, -2.03],
										[2.03, -0.22],
										[0.04, 0.39],
										[-0.21, 0.37],
										[-0.26, 0.03],
										[-0.15, -0.1],
										[-0.46, 0.67],
										[-0.87, -0.38],
										[0.39, -0.88],
										[0.55, 0.24],
										[0, 0.02],
										[0.03, 0.32],
										[0.06, 0.11],
										[0.05, 0.03],
										[0.25, -0.03],
										[0.13, -0.23],
										[-0.18, -1.65],
										[0, 0]
									],
									"v": [
										[3.38, 0.71],
										[0.71, 4.02],
										[4.02, 6.69],
										[5.48, 6.13],
										[5.89, 6.69],
										[4.1, 7.38],
										[0.02, 4.1],
										[3.3, 0.02],
										[7.38, 3.3],
										[7.13, 4.5],
										[6.04, 5.24],
										[5.34, 5.08],
										[4.99, 4.7],
										[2.95, 5.39],
										[2.22, 3.05],
										[4.45, 2.01],
										[5.35, 3.35],
										[5.36, 3.41],
										[5.56, 4.29],
										[5.73, 4.51],
										[5.96, 4.55],
										[6.53, 4.15],
										[6.69, 3.38],
										[3.38, 0.71]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.27, 0.12],
										[0.28, -0.64],
										[-0.42, -0.18],
										[-0.28, 0.64],
										[0.01, 0.2],
										[0, 0]
									],
									"o": [
										[-0.03, -0.37],
										[-0.42, -0.18],
										[-0.28, 0.64],
										[0.42, 0.18],
										[0.09, -0.21],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.66, 3.41],
										[4.17, 2.64],
										[2.85, 3.33],
										[3.23, 4.76],
										[4.55, 4.07],
										[4.66, 3.46],
										[4.66, 3.41]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 2,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 20
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.05, 3.35] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [220.65, 117.78] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.78, -0.63],
										[0.63, -0.78],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.48, 0.39],
										[0.39, -0.48],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0.63, -0.78],
										[0.78, 0.63],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.39, -0.48],
										[-0.48, -0.39],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.86, 0.68],
										[5.42, 0.4],
										[5.7, 2.96],
										[4.77, 4.1],
										[4.23, 3.67],
										[5.15, 2.52],
										[4.98, 0.94],
										[3.4, 1.11],
										[2.48, 2.26],
										[1.94, 1.83],
										[2.86, 0.68]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.45, 2.16],
										[2.19, 4.97],
										[1.65, 4.53],
										[3.91, 1.73],
										[4.45, 2.16]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.48, -0.39],
										[-0.39, 0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.78, 0.63],
										[-0.63, 0.78]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.39, 0.48],
										[0.49, 0.39],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.63, 0.78],
										[-0.78, -0.63],
										[0, 0]
									],
									"v": [
										[0.4, 3.74],
										[1.32, 2.59],
										[1.86, 3.02],
										[0.94, 4.17],
										[1.11, 5.75],
										[2.7, 5.58],
										[3.62, 4.43],
										[4.16, 4.87],
										[3.24, 6.02],
										[0.68, 6.29],
										[0.4, 3.74]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 2,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 21
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [79.49, 18.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [164.79, 124.27] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0.17, 1.57],
										[0, 0],
										[1.56, -0.17],
										[0, 0],
										[-0.17, -1.56],
										[0, 0],
										[-1.56, 0.17]
									],
									"o": [
										[0, 0],
										[1.57, -0.17],
										[0, 0],
										[-0.17, -1.57],
										[0, 0],
										[-1.56, 0.17],
										[0, 0],
										[0.17, 1.56],
										[0, 0]
									],
									"v": [
										[4.75, 36.81],
										[156.43, 20.36],
										[158.96, 17.22],
										[157.37, 2.54],
										[154.23, 0.02],
										[2.54, 16.47],
										[0.02, 19.61],
										[1.61, 34.29],
										[4.75, 36.81]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 78
									},
									{ "s": [1], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.094, 0.408, 0.859] }
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 22
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.56, 5.84] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [225.19, 68.8] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.08, 0.39],
										[-0.21, 0.25],
										[-0.3, 0.23],
										[-0.2, 0.3],
										[0.04, 0.4],
										[0.16, 0.2],
										[0.24, 0.09],
										[0.29, -0.03],
										[0.23, -0.14],
										[0.13, -0.24],
										[-0.02, -0.35],
										[0, 0],
										[-0.27, 0.5],
										[-0.51, 0.29],
										[-0.64, 0.07],
										[-0.56, -0.19],
										[-0.35, -0.42],
										[-0.07, -0.62],
										[0.24, -0.47],
										[0.48, -0.36],
										[0.17, -0.2],
										[0.06, -0.25],
										[-0.04, -0.4],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-0.07, -0.66],
										[0.08, -0.39],
										[0.21, -0.25],
										[0.32, -0.25],
										[0.2, -0.3],
										[-0.03, -0.29],
										[-0.16, -0.2],
										[-0.24, -0.09],
										[-0.26, 0.03],
										[-0.23, 0.14],
										[-0.13, 0.24],
										[0, 0],
										[-0.06, -0.7],
										[0.27, -0.5],
										[0.51, -0.29],
										[0.7, -0.08],
										[0.56, 0.19],
										[0.35, 0.42],
										[0.07, 0.62],
										[-0.24, 0.47],
										[-0.28, 0.22],
										[-0.17, 0.2],
										[-0.06, 0.25],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.89, 8.19],
										[2.87, 8.04],
										[2.88, 6.47],
										[3.31, 5.52],
										[4.08, 4.81],
										[4.85, 3.98],
										[5.09, 2.93],
										[4.8, 2.19],
										[4.19, 1.76],
										[3.39, 1.66],
										[2.66, 1.91],
										[2.13, 2.48],
										[1.96, 3.37],
										[0.02, 3.58],
										[0.33, 1.77],
										[1.5, 0.58],
										[3.22, 0.03],
										[5.12, 0.2],
										[6.48, 1.12],
										[7.11, 2.68],
										[6.84, 4.33],
										[5.76, 5.57],
										[5.07, 6.2],
										[4.72, 6.87],
										[4.69, 7.85],
										[4.71, 7.99],
										[2.89, 8.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.02, 11.68],
										[2.79, 9.58],
										[5.05, 9.34],
										[5.28, 11.43],
										[3.02, 11.68]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 23
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.26, 6.15] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [216.6, 72.9] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.16, 0.25],
										[-0.3, 0.21],
										[-0.5, 0.05],
										[-0.56, -0.28],
										[-0.38, -0.62],
										[-0.1, -0.94],
										[0.23, -0.69],
										[0.49, -0.4],
										[0.68, -0.07],
										[0.34, 0.13],
										[0.22, 0.21],
										[0.12, 0.19],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.08, -0.21],
										[0.16, -0.25],
										[0.3, -0.21],
										[0.66, -0.07],
										[0.56, 0.28],
										[0.38, 0.62],
										[0.1, 0.94],
										[-0.23, 0.69],
										[-0.49, 0.4],
										[-0.48, 0.05],
										[-0.34, -0.13],
										[-0.22, -0.21],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.27, 12.3],
										[0, 0.62],
										[1.93, 0.41],
										[2.09, 1.81],
										[2.22, 1.8],
										[2.58, 1.1],
										[3.28, 0.41],
										[4.49, 0.02],
										[6.32, 0.33],
										[7.74, 1.67],
										[8.47, 4.02],
										[8.27, 6.45],
										[7.18, 8.08],
										[5.43, 8.79],
										[4.19, 8.67],
										[3.35, 8.15],
										[2.84, 7.55],
										[2.76, 7.56],
										[3.25, 12.08],
										[1.27, 12.3],
										[1.27, 12.3]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.27, 0.27],
										[-0.11, 0.43],
										[0.06, 0.53],
										[0.19, 0.4],
										[0.32, 0.2],
										[0.45, -0.05],
										[0.27, -0.26],
										[0.11, -0.43],
										[-0.06, -0.55],
										[-0.2, -0.4],
										[-0.33, -0.2],
										[-0.43, 0.05],
										[0, 0]
									],
									"o": [
										[0.44, -0.05],
										[0.27, -0.27],
										[0.11, -0.43],
										[-0.06, -0.53],
										[-0.2, -0.4],
										[-0.33, -0.2],
										[-0.45, 0.05],
										[-0.27, 0.26],
										[-0.11, 0.43],
										[0.06, 0.55],
										[0.2, 0.4],
										[0.33, 0.2],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.72, 7.22],
										[5.79, 6.74],
										[6.36, 5.67],
										[6.43, 4.23],
										[6.06, 2.84],
										[5.28, 1.94],
										[4.12, 1.71],
										[3.05, 2.17],
										[2.48, 3.2],
										[2.4, 4.67],
										[2.79, 6.09],
										[3.58, 6.99],
										[4.72, 7.22],
										[4.72, 7.22]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 24
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.34, 5.69] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [209.73, 70.52] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.42, 0.32],
										[0.08, 0.71],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.11, -0.12],
										[-0.25, 0.03],
										[-0.07, 0.01],
										[-0.05, 0.03],
										[0, 0],
										[0.19, -0.06],
										[0.24, -0.03],
										[0, 0]
									],
									"o": [
										[-0.79, 0.09],
										[-0.42, -0.32],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.03, 0.31],
										[0.11, 0.12],
										[0.13, -0.01],
										[0.07, -0.02],
										[0, 0],
										[-0.12, 0.05],
										[-0.19, 0.06],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.55, 11.35],
										[1.74, 11],
										[1, 9.45],
										[0, 0.21],
										[1.98, 0],
										[2.94, 8.91],
										[3.16, 9.57],
										[3.69, 9.71],
										[3.99, 9.67],
										[4.18, 9.61],
										[4.67, 11.07],
										[4.2, 11.23],
										[3.55, 11.35],
										[3.55, 11.35]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 25
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.01, 4.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [202.56, 72.76] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.66, 0.29],
										[0.4, 0.62],
										[0.1, 0.89],
										[-0.26, 0.69],
										[-0.56, 0.44],
										[-0.81, 0.09],
										[-0.49, -0.12],
										[-0.4, -0.31],
										[-0.27, -0.52],
										[-0.08, -0.75],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.19, 0.35],
										[0.31, 0.17],
										[0.44, -0.05],
										[0.28, -0.24],
										[0.12, -0.36],
										[-0.05, -0.42],
										[0, 0],
										[-0.22, -0.35],
										[-0.35, -0.15],
										[-0.44, 0.05],
										[-0.23, 0.11],
										[-0.16, 0.18],
										[-0.06, 0.25],
										[0, 0],
										[0.29, -0.38],
										[0.48, -0.24],
										[0.64, -0.07],
										[0, 0]
									],
									"o": [
										[-0.86, 0.09],
										[-0.65, -0.29],
										[-0.4, -0.62],
										[-0.1, -0.89],
										[0.26, -0.69],
										[0.56, -0.44],
										[0.52, -0.06],
										[0.49, 0.12],
										[0.4, 0.31],
										[0.26, 0.52],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.05, -0.48],
										[-0.19, -0.35],
										[-0.31, -0.17],
										[-0.44, 0.05],
										[-0.28, 0.24],
										[-0.12, 0.36],
										[0, 0],
										[0.06, 0.54],
										[0.22, 0.35],
										[0.35, 0.15],
										[0.29, -0.03],
										[0.23, -0.11],
										[0.16, -0.18],
										[0, 0],
										[-0.09, 0.47],
										[-0.29, 0.38],
										[-0.47, 0.24],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.65, 8.8],
										[2.38, 8.5],
										[0.79, 7.13],
										[0.04, 4.87],
										[0.28, 2.52],
										[1.5, 0.82],
										[3.56, 0.03],
										[5.07, 0.12],
										[6.4, 0.76],
										[7.4, 2],
										[7.92, 3.89],
										[7.98, 4.52],
										[1.03, 5.27],
										[0.88, 3.92],
										[6.86, 3.28],
										[5.97, 3.77],
										[5.62, 2.54],
										[4.87, 1.76],
										[3.74, 1.57],
										[2.66, 2],
										[2.06, 2.9],
										[1.94, 4.07],
										[2.04, 5],
										[2.46, 6.33],
										[3.32, 7.09],
										[4.5, 7.24],
										[5.27, 7.03],
										[5.85, 6.59],
										[6.17, 5.95],
										[8.03, 6.12],
										[7.46, 7.4],
										[6.31, 8.33],
										[4.64, 8.8],
										[4.65, 8.8]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 26
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.34, 5.77] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [192.98, 72.64] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.42, 0.42],
										[-0.7, 0.08],
										[-0.47, -0.2],
										[-0.29, -0.45],
										[-0.07, -0.68],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.33, 0.29],
										[0.52, -0.06],
										[0.26, -0.18],
										[0.13, -0.31],
										[-0.04, -0.41],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.16, -0.76],
										[0.42, -0.42],
										[0.58, -0.06],
										[0.47, 0.2],
										[0.29, 0.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, -0.57],
										[-0.33, -0.29],
										[-0.35, 0.04],
										[-0.26, 0.18],
										[-0.12, 0.31],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.67, 6.35],
										[3.21, 11.33],
										[1.23, 11.55],
										[0, 0.21],
										[1.95, 0],
										[2.48, 4.93],
										[2.28, 4.95],
										[3.15, 3.18],
										[4.83, 2.44],
										[6.4, 2.65],
										[7.53, 3.63],
										[8.08, 5.33],
										[8.67, 10.74],
										[6.69, 10.95],
										[6.13, 5.85],
										[5.55, 4.56],
										[4.28, 4.2],
										[3.36, 4.53],
										[2.79, 5.27],
										[2.67, 6.35],
										[2.67, 6.35]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 27
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.63, 6] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [180.66, 73.68] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.23, 11.99],
										[1.04, 10.28],
										[3.04, 10.06],
										[2.19, 2.15],
										[0.18, 2.37],
										[0, 0.65],
										[6.03, 0],
										[6.21, 1.71],
										[4.22, 1.93],
										[5.08, 9.84],
										[7.07, 9.62],
										[7.26, 11.34],
										[1.23, 11.99]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 28
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.18, 4.56] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [168.5, 76.52] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.42, 0.42],
										[-0.7, 0.08],
										[-0.46, -0.2],
										[-0.29, -0.45],
										[-0.07, -0.68],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.33, 0.29],
										[0.52, -0.06],
										[0.26, -0.18],
										[0.13, -0.31],
										[-0.04, -0.41],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.16, -0.76],
										[0.42, -0.42],
										[0.58, -0.06],
										[0.46, 0.2],
										[0.29, 0.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, -0.57],
										[-0.33, -0.29],
										[-0.35, 0.04],
										[-0.26, 0.18],
										[-0.12, 0.31],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.36, 3.93],
										[2.9, 8.91],
										[0.92, 9.13],
										[0, 0.62],
										[1.87, 0.42],
										[2.13, 2.52],
										[1.97, 2.53],
										[2.84, 0.76],
										[4.51, 0.02],
										[6.09, 0.23],
										[7.22, 1.21],
										[7.77, 2.91],
										[8.36, 8.32],
										[6.38, 8.53],
										[5.83, 3.43],
										[5.24, 2.14],
										[3.97, 1.78],
										[3.06, 2.11],
										[2.49, 2.85],
										[2.36, 3.93],
										[2.36, 3.93]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 29
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.25, 4.58] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [158.9, 77.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.56, 0.29],
										[0.38, 0.62],
										[0.1, 0.93],
										[-0.24, 0.68],
										[-0.49, 0.39],
										[-0.65, 0.07],
										[-0.34, -0.13],
										[-0.21, -0.22],
										[-0.12, -0.19],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.17, -0.26],
										[0.31, -0.2],
										[0.49, -0.05],
										[0, 0]
									],
									"o": [
										[-0.66, 0.07],
										[-0.56, -0.28],
										[-0.37, -0.62],
										[-0.1, -0.93],
										[0.24, -0.69],
										[0.49, -0.39],
										[0.5, -0.05],
										[0.34, 0.13],
										[0.21, 0.22],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.07, 0.21],
										[-0.17, 0.26],
										[-0.31, 0.2],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.02, 9.15],
										[2.17, 8.83],
										[0.76, 7.47],
										[0.04, 5.14],
										[0.26, 2.69],
										[1.36, 1.08],
										[3.08, 0.38],
										[4.35, 0.5],
										[5.18, 1.02],
										[5.67, 1.63],
										[5.77, 1.62],
										[5.61, 0.21],
										[7.58, 0],
										[8.51, 8.51],
										[6.54, 8.72],
										[6.4, 7.37],
										[6.3, 7.38],
										[5.94, 8.09],
										[5.22, 8.77],
										[4.02, 9.15],
										[4.02, 9.15]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.28, 0.26],
										[-0.11, 0.43],
										[0.06, 0.55],
										[0.2, 0.39],
										[0.32, 0.2],
										[0.44, -0.05],
										[0.28, -0.27],
										[0.11, -0.43],
										[-0.06, -0.53],
										[-0.2, -0.4],
										[-0.33, -0.21],
										[-0.44, 0.05],
										[0, 0]
									],
									"o": [
										[0.43, -0.05],
										[0.27, -0.26],
										[0.11, -0.43],
										[-0.06, -0.55],
										[-0.2, -0.39],
										[-0.32, -0.19],
										[-0.44, 0.05],
										[-0.28, 0.27],
										[-0.11, 0.43],
										[0.06, 0.53],
										[0.2, 0.4],
										[0.33, 0.21],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.4, 7.46],
										[5.46, 6.99],
										[6.04, 5.95],
										[6.11, 4.47],
										[5.73, 3.05],
										[4.94, 2.17],
										[3.8, 1.95],
										[2.72, 2.43],
										[2.14, 3.47],
										[2.07, 4.91],
										[2.45, 6.3],
										[3.25, 7.22],
										[4.4, 7.46],
										[4.4, 7.46]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 30
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.99, 4.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [149.56, 78.5] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.65, 0.3],
										[0.4, 0.62],
										[0.1, 0.87],
										[-0.26, 0.7],
										[-0.57, 0.43],
										[-0.83, 0.09],
										[-0.42, -0.08],
										[-0.35, -0.2],
										[-0.25, -0.31],
										[-0.14, -0.41],
										[0, 0],
										[0.12, 0.17],
										[0.17, 0.11],
										[0.21, 0.05],
										[0.24, -0.03],
										[0.28, -0.28],
										[0.11, -0.43],
										[-0.06, -0.53],
										[-0.2, -0.4],
										[-0.33, -0.21],
										[-0.46, 0.05],
										[-0.19, 0.09],
										[-0.14, 0.15],
										[-0.09, 0.2],
										[-0.03, 0.23],
										[0, 0],
										[0.18, -0.36],
										[0.3, -0.27],
										[0.4, -0.17],
										[0.48, -0.05],
										[0, 0]
									],
									"o": [
										[-0.83, 0.09],
										[-0.65, -0.3],
										[-0.4, -0.62],
										[-0.09, -0.87],
										[0.26, -0.7],
										[0.57, -0.43],
										[0.47, -0.05],
										[0.42, 0.08],
										[0.35, 0.2],
										[0.25, 0.31],
										[0, 0],
										[-0.08, -0.21],
										[-0.12, -0.17],
										[-0.17, -0.11],
										[-0.2, -0.05],
										[-0.46, 0.05],
										[-0.28, 0.28],
										[-0.11, 0.43],
										[0.06, 0.53],
										[0.2, 0.4],
										[0.33, 0.21],
										[0.24, -0.03],
										[0.19, -0.09],
										[0.14, -0.15],
										[0.09, -0.2],
										[0, 0],
										[-0.04, 0.44],
										[-0.18, 0.36],
										[-0.3, 0.27],
										[-0.39, 0.17],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.58, 8.82],
										[2.36, 8.5],
										[0.79, 7.12],
										[0.04, 4.88],
										[0.29, 2.51],
										[1.53, 0.81],
										[3.62, 0.03],
										[4.96, 0.07],
										[6.11, 0.48],
										[7, 1.24],
										[7.58, 2.3],
										[5.77, 2.89],
										[5.47, 2.32],
										[5.04, 1.9],
										[4.48, 1.67],
										[3.81, 1.64],
										[2.71, 2.13],
										[2.13, 3.2],
										[2.06, 4.65],
										[2.44, 6.04],
										[3.23, 6.97],
										[4.42, 7.21],
										[5.07, 7.03],
										[5.57, 6.67],
										[5.91, 6.15],
										[6.08, 5.5],
										[7.97, 5.69],
										[7.64, 6.88],
										[6.92, 7.82],
										[5.88, 8.48],
										[4.58, 8.82],
										[4.58, 8.82]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 31
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.21, 4.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [134.01, 79.98] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.22, -0.64],
										[-0.22, -0.79],
										[0, 0],
										[-0.08, 0.67],
										[-0.08, 0.58],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.22, -0.64],
										[-0.23, -0.78],
										[0, 0],
										[-0.07, 0.67],
										[-0.08, 0.58],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.14, 0.39],
										[0.14, 0.41],
										[0.14, 0.37],
										[0, 0],
										[0.05, -0.43],
										[0.05, -0.42],
										[0.06, -0.35],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0.19, 0.53],
										[0.22, 0.64],
										[0, 0],
										[0.05, -0.8],
										[0.09, -0.67],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.2, 0.54],
										[0.23, 0.64],
										[0, 0],
										[0.05, -0.8],
										[0.07, -0.67],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.14, -0.34],
										[-0.14, -0.39],
										[-0.14, -0.41],
										[0, 0],
										[-0.05, 0.4],
										[-0.05, 0.43],
										[-0.05, 0.42],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.46, 9.58],
										[0, 1.35],
										[2.09, 1.12],
										[3.28, 4.36],
										[3.9, 6.12],
										[4.57, 8.26],
										[4.32, 8.28],
										[4.53, 6.08],
										[4.78, 4.2],
										[5.27, 0.77],
										[7.16, 0.57],
										[8.36, 3.81],
										[8.99, 5.58],
										[9.67, 7.7],
										[9.42, 7.73],
										[9.61, 5.52],
										[9.84, 3.65],
										[10.31, 0.23],
										[12.41, 0],
										[10.79, 8.78],
										[8.79, 9],
										[7.42, 5.64],
										[7, 4.54],
										[6.59, 3.35],
										[6.18, 2.17],
										[6.55, 2.13],
										[6.4, 3.37],
										[6.25, 4.63],
										[6.08, 5.78],
										[5.46, 9.36],
										[3.46, 9.58]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 32
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.1, 4.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [123.43, 81.35] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.65, 0.3],
										[0.4, 0.62],
										[0.09, 0.87],
										[-0.26, 0.7],
										[-0.57, 0.43],
										[-0.83, 0.09],
										[-0.65, -0.3],
										[-0.4, -0.63],
										[-0.1, -0.88],
										[0.26, -0.69],
										[0.57, -0.43],
										[0.83, -0.09]
									],
									"o": [
										[-0.83, 0.09],
										[-0.65, -0.3],
										[-0.4, -0.62],
										[-0.09, -0.87],
										[0.26, -0.7],
										[0.57, -0.43],
										[0.83, -0.09],
										[0.65, 0.3],
										[0.4, 0.63],
										[0.1, 0.88],
										[-0.26, 0.69],
										[-0.57, 0.43],
										[0, 0]
									],
									"v": [
										[4.58, 8.82],
										[2.36, 8.5],
										[0.79, 7.12],
										[0.04, 4.88],
										[0.29, 2.51],
										[1.53, 0.81],
										[3.62, 0.03],
										[5.84, 0.34],
										[7.42, 1.73],
										[8.17, 4],
										[7.92, 6.34],
										[6.68, 8.03],
										[4.58, 8.82]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.28, 0.28],
										[-0.1, 0.44],
										[0.06, 0.52],
										[0.2, 0.4],
										[0.33, 0.22],
										[0.46, -0.05],
										[0.28, -0.28],
										[0.11, -0.43],
										[-0.06, -0.53],
										[-0.2, -0.4],
										[-0.33, -0.22],
										[-0.46, 0.05]
									],
									"o": [
										[0.46, -0.05],
										[0.28, -0.28],
										[0.1, -0.44],
										[-0.06, -0.52],
										[-0.2, -0.4],
										[-0.33, -0.21],
										[-0.46, 0.05],
										[-0.27, 0.28],
										[-0.1, 0.43],
										[0.06, 0.53],
										[0.2, 0.4],
										[0.33, 0.22],
										[0, 0]
									],
									"v": [
										[4.4, 7.22],
										[5.52, 6.72],
										[6.09, 5.64],
										[6.16, 4.21],
										[5.78, 2.82],
										[4.99, 1.89],
										[3.8, 1.64],
										[2.69, 2.14],
										[2.12, 3.21],
										[2.05, 4.65],
										[2.43, 6.04],
										[3.22, 6.97],
										[4.4, 7.22]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 33
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.34, 5.77] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [113.75, 81.23] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.42, 0.42],
										[-0.69, 0.08],
										[-0.46, -0.2],
										[-0.29, -0.45],
										[-0.07, -0.68],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.33, 0.29],
										[0.52, -0.06],
										[0.26, -0.18],
										[0.13, -0.31],
										[-0.04, -0.41],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.16, -0.76],
										[0.42, -0.42],
										[0.58, -0.06],
										[0.47, 0.2],
										[0.29, 0.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, -0.57],
										[-0.33, -0.29],
										[-0.35, 0.04],
										[-0.26, 0.18],
										[-0.12, 0.31],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.67, 6.35],
										[3.21, 11.33],
										[1.23, 11.55],
										[0, 0.21],
										[1.95, 0],
										[2.48, 4.93],
										[2.28, 4.95],
										[3.15, 3.18],
										[4.82, 2.44],
										[6.4, 2.65],
										[7.53, 3.63],
										[8.08, 5.33],
										[8.67, 10.74],
										[6.69, 10.95],
										[6.13, 5.85],
										[5.55, 4.56],
										[4.28, 4.2],
										[3.37, 4.53],
										[2.79, 5.27],
										[2.67, 6.35],
										[2.67, 6.35]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 34
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.27, 2.36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [103.41, 87.84] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.12, 0.21],
										[0.04, 0.33],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.31, -0.41],
										[0.64, -0.07],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0.3, -0.03],
										[0.12, -0.21],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.08, 0.7],
										[-0.3, 0.41],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.48, 4.72],
										[0.38, 3.73],
										[0.66, 3.7],
										[1.29, 3.34],
										[1.42, 2.52],
										[1.37, 2.05],
										[1.61, 2.28],
										[0.24, 2.43],
										[0, 0.25],
										[2.26, 0],
										[2.51, 2.31],
										[2.17, 3.98],
										[0.75, 4.7],
										[0.49, 4.73],
										[0.48, 4.72]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 35
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.64, 5.91] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [98.34, 82.47] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.2, 2.09],
										[0, 0.22],
										[2.05, 0],
										[2.26, 1.86],
										[0.2, 2.09]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.29, 11.82],
										[0.37, 3.32],
										[2.35, 3.1],
										[3.27, 11.61],
										[1.29, 11.82]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 36
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.28, 6.17] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [90.52, 83.45] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.23, 12.35],
										[0, 1.01],
										[2.03, 0.79],
										[2.54, 5.48],
										[7.81, 4.91],
										[7.3, 0.22],
										[9.33, 0],
										[10.56, 11.34],
										[8.53, 11.56],
										[8, 6.62],
										[2.72, 7.19],
										[3.26, 12.13],
										[1.23, 12.35]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 37
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.74, 2.95] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [123.09, 52.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.43, 0.2],
										[0.27, 0.41],
										[0.06, 0.58],
										[-0.17, 0.47],
										[-0.38, 0.29],
										[-0.55, 0.06],
										[-0.43, -0.2],
										[-0.27, -0.42],
										[-0.06, -0.59],
										[0.17, -0.46],
										[0.38, -0.29],
										[0.56, -0.06]
									],
									"o": [
										[-0.55, 0.06],
										[-0.43, -0.2],
										[-0.27, -0.41],
										[-0.06, -0.58],
										[0.17, -0.46],
										[0.38, -0.29],
										[0.55, -0.06],
										[0.43, 0.2],
										[0.27, 0.42],
										[0.06, 0.59],
										[-0.17, 0.46],
										[-0.38, 0.29],
										[0, 0]
									],
									"v": [
										[3.05, 5.88],
										[1.58, 5.67],
										[0.52, 4.75],
										[0.03, 3.25],
										[0.19, 1.67],
										[1.02, 0.54],
										[2.42, 0.02],
										[3.9, 0.23],
										[4.95, 1.16],
										[5.45, 2.66],
										[5.28, 4.23],
										[4.45, 5.36],
										[3.05, 5.88]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.19, 0.19],
										[-0.07, 0.29],
										[0.04, 0.35],
										[0.13, 0.27],
										[0.22, 0.14],
										[0.31, -0.03],
										[0.19, -0.19],
										[0.07, -0.29],
										[-0.04, -0.35],
										[-0.13, -0.27],
										[-0.22, -0.14],
										[-0.31, 0.03],
										[0, 0]
									],
									"o": [
										[0.31, -0.03],
										[0.19, -0.19],
										[0.07, -0.29],
										[-0.04, -0.35],
										[-0.13, -0.27],
										[-0.22, -0.14],
										[-0.31, 0.03],
										[-0.18, 0.19],
										[-0.07, 0.29],
										[0.04, 0.35],
										[0.13, 0.27],
										[0.22, 0.14],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.94, 4.81],
										[3.68, 4.48],
										[4.06, 3.76],
										[4.11, 2.81],
										[3.86, 1.88],
										[3.33, 1.26],
										[2.53, 1.09],
										[1.79, 1.42],
										[1.41, 2.14],
										[1.37, 3.1],
										[1.62, 4.02],
										[2.14, 4.65],
										[2.93, 4.81],
										[2.94, 4.81]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.314, 0.322, 0.345] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 38
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.85, 3.03] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [116.76, 53.09] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.13, -0.36],
										[-0.13, -0.37],
										[0, 0],
										[-0.05, 0.38],
										[-0.08, 0.37],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0.16, 0.35],
										[0.13, 0.36],
										[0, 0],
										[0.06, -0.39],
										[0.05, -0.38],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.73, 6.06],
										[0, 0.62],
										[1.41, 0.47],
										[2.78, 3.44],
										[3.21, 4.49],
										[3.6, 5.58],
										[3.27, 5.61],
										[3.42, 4.47],
										[3.61, 3.35],
										[4.31, 0.15],
										[5.71, 0],
										[4.2, 5.9],
										[2.72, 6.06],
										[2.73, 6.06]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.314, 0.322, 0.345] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 39
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.74, 2.95] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [111.05, 53.88] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.43, 0.2],
										[0.27, 0.41],
										[0.06, 0.58],
										[-0.17, 0.47],
										[-0.38, 0.29],
										[-0.55, 0.06],
										[-0.43, -0.2],
										[-0.27, -0.42],
										[-0.06, -0.59],
										[0.17, -0.46],
										[0.38, -0.29],
										[0.55, -0.06]
									],
									"o": [
										[-0.55, 0.06],
										[-0.43, -0.2],
										[-0.27, -0.41],
										[-0.06, -0.58],
										[0.17, -0.47],
										[0.38, -0.29],
										[0.55, -0.06],
										[0.43, 0.2],
										[0.27, 0.42],
										[0.06, 0.59],
										[-0.17, 0.46],
										[-0.38, 0.29],
										[0, 0]
									],
									"v": [
										[3.05, 5.88],
										[1.58, 5.67],
										[0.52, 4.75],
										[0.03, 3.25],
										[0.19, 1.67],
										[1.02, 0.54],
										[2.42, 0.02],
										[3.9, 0.23],
										[4.95, 1.16],
										[5.45, 2.66],
										[5.28, 4.23],
										[4.45, 5.36],
										[3.05, 5.88]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.19, 0.19],
										[-0.07, 0.29],
										[0.04, 0.35],
										[0.13, 0.27],
										[0.22, 0.14],
										[0.31, -0.03],
										[0.19, -0.19],
										[0.07, -0.29],
										[-0.04, -0.35],
										[-0.13, -0.27],
										[-0.22, -0.14],
										[-0.31, 0.03],
										[0, 0]
									],
									"o": [
										[0.31, -0.03],
										[0.19, -0.19],
										[0.07, -0.29],
										[-0.04, -0.35],
										[-0.13, -0.27],
										[-0.22, -0.14],
										[-0.31, 0.03],
										[-0.18, 0.19],
										[-0.07, 0.29],
										[0.04, 0.35],
										[0.13, 0.27],
										[0.22, 0.14],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.94, 4.81],
										[3.68, 4.48],
										[4.06, 3.76],
										[4.11, 2.81],
										[3.86, 1.88],
										[3.33, 1.26],
										[2.53, 1.09],
										[1.79, 1.42],
										[1.41, 2.14],
										[1.37, 3.1],
										[1.62, 4.02],
										[2.14, 4.65],
										[2.93, 4.81],
										[2.94, 4.81]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.314, 0.322, 0.345] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 40
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.29, 3.95] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [104.78, 53.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.42, -0.16],
										[-0.24, -0.34],
										[-0.05, -0.48],
										[0.17, -0.38],
										[0.38, -0.23],
										[0.58, -0.06],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.2, 0.12],
										[-0.08, 0.2],
										[0.03, 0.26],
										[0.13, 0.18],
										[0.23, 0.08],
										[0.34, -0.04],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0.58, -0.06],
										[0.42, 0.16],
										[0.24, 0.34],
										[0.05, 0.48],
										[-0.17, 0.38],
										[-0.38, 0.24],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.34, -0.04],
										[0.21, -0.12],
										[0.09, -0.2],
										[-0.03, -0.26],
										[-0.12, -0.18],
										[-0.23, -0.08],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.82, 7.89],
										[0, 0.33],
										[2.83, 0.03],
										[4.32, 0.17],
										[5.31, 0.93],
										[5.75, 2.16],
										[5.58, 3.44],
										[4.77, 4.36],
										[3.33, 4.81],
										[1.31, 5.03],
										[1.19, 3.91],
										[3.03, 3.71],
										[3.85, 3.47],
										[4.29, 3],
										[4.37, 2.31],
										[4.14, 1.63],
										[3.61, 1.25],
										[2.75, 1.19],
										[1.48, 1.32],
										[2.18, 7.75],
										[0.82, 7.89],
										[0.82, 7.89]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[5.07, 7.43],
										[2.86, 4.2],
										[4.35, 4.04],
										[6.59, 7.27],
										[5.07, 7.43]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.314, 0.322, 0.345] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 41
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.45, 6.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [87.17, 55.99] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.06, -0.56],
										[0, 0],
										[-0.53, -0.23],
										[0, 0],
										[-0.46, 0.32],
										[-0.01, 0.01],
										[-0.08, 0.38],
										[0.02, 0.16],
										[0, 0],
										[0, 0],
										[0.08, 0.74],
										[0, 0],
										[-0.04, 0.21],
										[-0.01, 0.02]
									],
									"o": [
										[0, 0],
										[-0.47, 0.33],
										[0, 0],
										[0.06, 0.56],
										[0, 0],
										[0.52, 0.22],
										[0.01, -0.01],
										[0.33, -0.24],
										[0.03, -0.16],
										[0, 0],
										[0, 0],
										[-0.7, -0.3],
										[0, 0],
										[-0.02, -0.22],
										[0, -0.02],
										[0, 0]
									],
									"v": [
										[4.04, 0],
										[0.67, 2.41],
										[0.01, 3.86],
										[0.59, 9.23],
										[1.55, 10.5],
										[6.61, 12.67],
										[8.2, 12.51],
										[8.22, 12.49],
										[8.86, 11.53],
										[8.88, 11.05],
										[8.66, 8.97],
										[5.82, 7.75],
										[4.57, 6.08],
										[3.99, 0.71],
										[4.02, 0.07],
										[4.04, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.45, 6.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [91.65, 54.88] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.52, -0.22],
										[0, 0],
										[-0.06, -0.56],
										[0, 0],
										[0.47, -0.33],
										[0, 0],
										[0, 0.02],
										[0.02, 0.22],
										[0, 0],
										[0.7, 0.29],
										[0, 0],
										[0, 0],
										[-0.03, 0.16],
										[-0.33, 0.24],
										[-0.01, 0.01],
										[0, 0]
									],
									"o": [
										[0.46, -0.32],
										[0, 0],
										[0.53, 0.23],
										[0, 0],
										[0.06, 0.56],
										[0, 0],
										[0, -0.02],
										[0.04, -0.21],
										[0, 0],
										[-0.08, -0.74],
										[0, 0],
										[0, 0],
										[-0.02, -0.16],
										[0.08, -0.38],
										[0.01, -0.01],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.69, 0.29],
										[2.28, 0.13],
										[7.34, 2.3],
										[8.3, 3.57],
										[8.88, 8.94],
										[8.22, 10.39],
										[4.86, 12.8],
										[4.87, 12.73],
										[4.91, 12.09],
										[4.32, 6.72],
										[3.07, 5.05],
										[0.23, 3.84],
										[0.01, 1.76],
										[0.03, 1.27],
										[0.67, 0.31],
										[0.69, 0.29],
										[0.69, 0.29]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 43
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [96.03, 62.93] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [160.26, 88.21] },
						"r": { "a": 0, "k": -6.19 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -2.21],
										[0, 0],
										[-2.21, 0],
										[0, 0],
										[0, 2.21],
										[0, 0],
										[2.21, 0]
									],
									"o": [
										[0, 0],
										[-2.21, 0],
										[0, 0],
										[0, 2.21],
										[0, 0],
										[2.21, 0],
										[0, 0],
										[0, -2.21],
										[0, 0]
									],
									"v": [
										[188.06, 0],
										[4, 0],
										[0, 4],
										[0, 121.87],
										[4, 125.87],
										[188.06, 125.87],
										[192.06, 121.87],
										[192.06, 4],
										[188.06, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 44
				},
				{
					"ty": 4,
					"nm": "Vector (Border)",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [98.25, 64.935] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [160.249, 88.209] },
						"r": { "a": 0, "k": -6.19 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -3.314],
										[0, 0],
										[-3.314, 0],
										[0, 0],
										[0, 3.314],
										[0, 0],
										[3.314, 0]
									],
									"o": [
										[0, 0],
										[-3.314, 0],
										[0, 0],
										[0, 3.314],
										[0, 0],
										[3.314, 0],
										[0, 0],
										[0, -3.314],
										[0, 0]
									],
									"v": [
										[190.5, 0],
										[6, 0],
										[0, 6],
										[0, 123.87],
										[6, 129.87],
										[190.5, 129.87],
										[196.5, 123.87],
										[196.5, 6],
										[190.5, 0]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 2,
							"lj": 2,
							"ml": 1,
							"o": { "a": 0, "k": 0 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 78
									},
									{ "s": [1], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0, 0, 0] }
						}
					],
					"ind": 45
				},
				{
					"ty": 4,
					"nm": "Vector (Mask)",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"td": 1,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [0, 0] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "gr",
							"nm": "",
							"it": [
								{
									"ty": "sh",
									"nm": "",
									"d": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, -3.314],
															[0, 0],
															[-3.314, 0],
															[0, 0],
															[0, 3.314],
															[0, 0],
															[3.314, 0]
														],
														"o": [
															[0, 0],
															[-3.314, 0],
															[0, 0],
															[0, 3.314],
															[0, 0],
															[3.314, 0],
															[0, 0],
															[0, -3.314],
															[0, 0]
														],
														"v": [
															[190.5, 0],
															[6, 0],
															[0, 6],
															[0, 123.87],
															[6, 129.87],
															[190.5, 129.87],
															[196.5, 123.87],
															[196.5, 6],
															[190.5, 0]
														]
													}
												],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, -3.314],
															[0, 0],
															[-3.314, 0],
															[0, 0],
															[0, 3.314],
															[0, 0],
															[3.314, 0]
														],
														"o": [
															[0, 0],
															[-3.314, 0],
															[0, 0],
															[0, 3.314],
															[0, 0],
															[3.314, 0],
															[0, 0],
															[0, -3.314],
															[0, 0]
														],
														"v": [
															[190.5, 0],
															[6, 0],
															[0, 6],
															[0, 123.87],
															[6, 129.87],
															[190.5, 129.87],
															[196.5, 123.87],
															[196.5, 6],
															[190.5, 0]
														]
													}
												],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, -3.314],
															[0, 0],
															[-3.314, 0],
															[0, 0],
															[0, 3.314],
															[0, 0],
															[3.314, 0]
														],
														"o": [
															[0, 0],
															[-3.314, 0],
															[0, 0],
															[0, 3.314],
															[0, 0],
															[3.314, 0],
															[0, 0],
															[0, -3.314],
															[0, 0]
														],
														"v": [
															[190.5, 0],
															[6, 0],
															[0, 6],
															[0, 123.87],
															[6, 129.87],
															[190.5, 129.87],
															[196.5, 123.87],
															[196.5, 6],
															[190.5, 0]
														]
													}
												],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, -3.314],
															[0, 0],
															[-3.314, 0],
															[0, 0],
															[0, 3.314],
															[0, 0],
															[3.314, 0]
														],
														"o": [
															[0, 0],
															[-3.314, 0],
															[0, 0],
															[0, 3.314],
															[0, 0],
															[3.314, 0],
															[0, 0],
															[0, -3.314],
															[0, 0]
														],
														"v": [
															[190.5, 0],
															[6, 0],
															[0, 6],
															[0, 123.87],
															[6, 129.87],
															[190.5, 129.87],
															[196.5, 123.87],
															[196.5, 6],
															[190.5, 0]
														]
													}
												],
												"t": 78
											},
											{
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, -3.314],
															[0, 0],
															[-3.314, 0],
															[0, 0],
															[0, 3.314],
															[0, 0],
															[3.314, 0]
														],
														"o": [
															[0, 0],
															[-3.314, 0],
															[0, 0],
															[0, 3.314],
															[0, 0],
															[3.314, 0],
															[0, 0],
															[0, -3.314],
															[0, 0]
														],
														"v": [
															[190.5, 0],
															[6, 0],
															[0, 6],
															[0, 123.87],
															[6, 129.87],
															[190.5, 129.87],
															[196.5, 123.87],
															[196.5, 6],
															[190.5, 0]
														]
													}
												],
												"t": 108
											}
										]
									}
								},
								{
									"ty": "fl",
									"nm": "",
									"c": { "a": 0, "k": [1, 0, 0] },
									"r": 2,
									"o": { "a": 0, "k": 100 }
								},
								{
									"ty": "tr",
									"a": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [98.25, 64.935],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [98.25, 64.935],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [98.25, 64.935],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [98.25, 64.935],
												"t": 78
											},
											{ "s": [98.25, 64.935], "t": 108 }
										]
									},
									"s": { "a": 0, "k": [100, 100] },
									"sk": { "a": 0, "k": 0 },
									"p": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [160.249, 88.209],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [160.249, 88.209],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [160.249, 88.209],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [160.249, 88.209],
												"t": 78
											},
											{ "s": [160.249, 88.209], "t": 108 }
										]
									},
									"r": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [-6.19],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [-6.19],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [-6.19],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [-6.19],
												"t": 78
											},
											{ "s": [-6.19], "t": 108 }
										]
									},
									"sa": { "a": 0, "k": 0 },
									"o": { "a": 0, "k": 100 }
								}
							]
						}
					],
					"ind": 46
				},
				{
					"ty": 2,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"tt": 1,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [589, 390] },
						"s": { "a": 0, "k": [16.681, 16.65] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [160.249, 88.209] },
						"r": { "a": 0, "k": -6.19 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"refId": "48a1157520b9d763cec117f6649f955bd33f0f83",
					"ind": 47
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [98.03, 64.94] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [154.17, 96.96] },
						"r": { "a": 0, "k": -6.19 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -3.31],
										[0, 0],
										[-3.31, 0],
										[0, 0],
										[0, 3.31],
										[0, 0],
										[3.31, 0]
									],
									"o": [
										[0, 0],
										[-3.31, 0],
										[0, 0],
										[0, 3.31],
										[0, 0],
										[3.31, 0],
										[0, 0],
										[0, -3.31],
										[0, 0]
									],
									"v": [
										[190.06, 0],
										[6, 0],
										[0, 6],
										[0, 123.87],
										[6, 129.87],
										[190.06, 129.87],
										[196.06, 123.87],
										[196.06, 6],
										[190.06, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.031, 0.059, 0.13] },
							"r": 1,
							"o": { "a": 0, "k": 10 }
						}
					],
					"ind": 48
				},
				{
					"ty": 4,
					"nm": "Rovo 1 Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [130, 86] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [130, 86] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 78
								},
								{ "s": [100], "t": 108 }
							]
						}
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[260, 0],
										[260, 172],
										[0, 172],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 49
				}
			]
		},
		{
			"id": "48a1157520b9d763cec117f6649f955bd33f0f83",
			"e": 1,
			"w": 1178,
			"h": 780,
			"p": "data:image/webp;base64,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",
			"u": ""
		},
		{
			"nm": "[Asset] Loom-Confluence",
			"id": "3",
			"layers": [
				{
					"ty": 4,
					"nm": "Telepointer",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [41.97, 19.6] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [137.46, 195.5] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.8, 5.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [49.9, 25.38] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[2.09, 0],
										[0.4, 0.14],
										[0, 0],
										[-0.48, 0],
										[0, 0.96],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 1.93],
										[-0.75, 0],
										[0, 0],
										[0.4, 0.16],
										[1.08, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.79, 0],
										[4.7, 0],
										[4.7, 7.29],
										[1.72, 10.54],
										[0, 10.27],
										[0, 8.5],
										[1.34, 8.74],
										[2.79, 7.13],
										[2.79, 0],
										[2.79, 0]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 2.52],
										[-2.5, 0],
										[0, -2.47],
										[0, 0],
										[0, 0],
										[-1.69, 0],
										[-0.75, 0.24],
										[0, 0],
										[0.88, 0]
									],
									"o": [
										[-3.08, 0],
										[0, -2.52],
										[2.5, 0],
										[0, 0],
										[0, 0],
										[0.19, 1.23],
										[0.94, 0],
										[0, 0],
										[-0.68, 0.34],
										[0, 0]
									],
									"v": [
										[10.54, 10.64],
										[6.12, 6.48],
										[9.98, 2.27],
										[13.54, 6.48],
										[13.54, 7.1],
										[7.91, 7.1],
										[10.59, 9.03],
										[13.13, 8.61],
										[13.13, 10.16],
										[10.54, 10.64]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[1.18, 0],
										[0.13, -1.31]
									],
									"o": [
										[0, 0],
										[-0.08, -1.39],
										[-1.28, 0],
										[0, 0]
									],
									"v": [
										[7.89, 5.87],
										[11.8, 5.87],
										[9.94, 3.73],
										[7.89, 5.87]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[1.11, 0],
										[0, -1.42],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.08, 0],
										[0, -2.19],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, -1.24],
										[-1.11, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.5, -0.96],
										[1.82, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[22.04, 10.48],
										[20.24, 10.48],
										[20.24, 5.63],
										[18.63, 3.85],
										[16.78, 6],
										[16.78, 10.48],
										[14.98, 10.48],
										[14.98, 2.43],
										[16.78, 2.43],
										[16.78, 3.77],
										[19.26, 2.27],
										[22.05, 5.72],
										[22.05, 10.49],
										[22.04, 10.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[1.11, 0],
										[0, -1.42],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.08, 0],
										[0, -2.19],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, -1.24],
										[-1.11, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.5, -0.96],
										[1.82, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.82, 10.48],
										[29.02, 10.48],
										[29.02, 5.63],
										[27.41, 3.85],
										[25.56, 6],
										[25.56, 10.48],
										[23.76, 10.48],
										[23.76, 2.43],
										[25.56, 2.43],
										[25.56, 3.77],
										[28.03, 2.27],
										[30.82, 5.72],
										[30.82, 10.49],
										[30.82, 10.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.18, 0],
										[0, 2.38],
										[-2.19, 0],
										[-0.46, -1.02],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[-0.5, 1.07],
										[-2.07, 0],
										[0, -2.38],
										[1.13, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[37.79, 9.03],
										[35.17, 10.64],
										[32.09, 6.46],
										[35.33, 2.27],
										[37.79, 3.86],
										[37.79, 2.42],
										[39.59, 2.42],
										[39.59, 10.48],
										[37.79, 10.48],
										[37.79, 9.02],
										[37.79, 9.03]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 1.56],
										[0, 0],
										[1.02, 0],
										[0, -1.68],
										[-1.23, 0],
										[0, 0]
									],
									"o": [
										[1.05, 0],
										[0, 0],
										[0, -1.56],
										[-1.34, 0],
										[0, 1.68],
										[0, 0],
										[0, 0]
									],
									"v": [
										[35.78, 9.03],
										[37.79, 6.78],
										[37.79, 6.12],
										[35.91, 3.88],
										[33.88, 6.46],
										[35.78, 9.03],
										[35.78, 9.03]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 2,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [8.46, 8.36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [8.46, 8.36] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[16.92, 5.83],
										[0, 0],
										[5.64, 16.71],
										[9.3, 9.33],
										[16.92, 5.83]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.788, 0.486, 0.957] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [33.8, 13.47] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [50.14, 25.74] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -7.44],
										[-7.44, 0],
										[0, 0],
										[0, 7.44],
										[7.44, 0]
									],
									"o": [
										[0, 0],
										[-7.44, 0],
										[0, 7.44],
										[0, 0],
										[7.44, 0],
										[0, -7.44],
										[0, 0]
									],
									"v": [
										[54.13, 0],
										[13.47, 0],
										[0, 13.47],
										[13.47, 26.93],
										[54.13, 26.93],
										[67.6, 13.47],
										[54.13, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.788, 0.486, 0.957] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 4,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Group 2018776146",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [96.68, 14.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [124.6, 161.95] },
						"r": { "a": 0, "k": -8.84 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 5
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [60.55, 6.57] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [67.63, 14.27] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 6,
					"parent": 5
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.87, 6.57] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [6.87, 6.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.73, 0],
										[1.55, -2.38],
										[0, 0],
										[0, -0.14],
										[-0.26, -0.16],
										[0, 0],
										[-0.11, 0],
										[-0.14, 0.21],
										[0, 0],
										[-0.74, 0],
										[-0.95, -0.46],
										[0, 0],
										[-0.14, 0.32],
										[0, 0],
										[0.32, 0.16],
										[0, 0]
									],
									"o": [
										[-4.11, -1.99],
										[-2.03, 0],
										[0, 0],
										[-0.21, 0.32],
										[0, 0.14],
										[0, 0],
										[0.14, 0.09],
										[0.14, 0],
										[0, 0],
										[0.65, -0.98],
										[0.65, 0],
										[0, 0],
										[0.28, 0.14],
										[0, 0],
										[0.14, -0.32],
										[0, 0],
										[0, 0]
									],
									"v": [
										[12.87, 9.08],
										[5.82, 6.79],
										[0.51, 10.02],
										[0.26, 10.4],
										[0, 10.98],
										[0.32, 11.39],
										[2.94, 13.01],
										[3.3, 13.15],
										[3.67, 12.87],
										[4.09, 12.23],
										[6.05, 10.93],
										[8.41, 11.57],
										[11.13, 12.85],
										[11.85, 12.6],
										[13.14, 9.76],
										[12.86, 9.08],
										[12.87, 9.08]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.73, 0],
										[-1.55, 2.38],
										[0, 0],
										[0, 0.14],
										[0.26, 0.16],
										[0, 0],
										[0.11, 0],
										[0.14, -0.21],
										[0, 0],
										[0.74, 0],
										[0.95, 0.46],
										[0, 0],
										[0.14, -0.32],
										[0, 0],
										[-0.32, -0.16],
										[0, 0]
									],
									"o": [
										[4.11, 1.99],
										[2.03, 0],
										[0, 0],
										[0.21, -0.32],
										[0, -0.14],
										[0, 0],
										[-0.14, -0.09],
										[-0.14, 0],
										[0, 0],
										[-0.65, 0.98],
										[-0.65, 0],
										[0, 0],
										[-0.28, -0.14],
										[0, 0],
										[-0.14, 0.32],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.88, 4.07],
										[7.92, 6.36],
										[13.24, 3.13],
										[13.49, 2.74],
										[13.75, 2.17],
										[13.42, 1.76],
										[10.81, 0.14],
										[10.44, 0],
										[10.08, 0.28],
										[9.66, 0.92],
										[7.7, 2.22],
										[5.34, 1.58],
										[2.62, 0.3],
										[1.9, 0.55],
										[0.61, 3.38],
										[0.88, 4.07],
										[0.88, 4.07]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.094, 0.408, 0.859] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 7,
					"parent": 6
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [50.38, 5.82] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [70.73, 6.42] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 8,
					"parent": 6
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.35, 2.74] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [98.41, 6.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.37, 0.22],
										[0.2, 0.41],
										[0, 0.54],
										[-0.2, 0.41],
										[-0.37, 0.23],
										[-0.5, 0],
										[-0.24, -0.07],
										[-0.19, -0.13],
										[-0.13, -0.19],
										[-0.06, -0.24],
										[0, 0],
										[0.07, 0.11],
										[0.1, 0.08],
										[0.14, 0.04],
										[0.16, 0],
										[0.21, -0.17],
										[0.1, -0.28],
										[0, -0.34],
										[-0.1, -0.28],
										[-0.21, -0.17],
										[-0.32, 0],
										[-0.14, 0.04],
										[-0.11, 0.08],
										[-0.07, 0.12],
										[-0.03, 0.14],
										[0, 0],
										[0.14, -0.2],
										[0.2, -0.14],
										[0.24, -0.07],
										[0.28, 0],
										[0, 0]
									],
									"o": [
										[-0.5, 0],
										[-0.37, -0.23],
										[-0.2, -0.41],
										[0, -0.54],
										[0.2, -0.41],
										[0.37, -0.23],
										[0.28, 0],
										[0.24, 0.07],
										[0.2, 0.14],
										[0.14, 0.2],
										[0, 0],
										[-0.04, -0.14],
										[-0.07, -0.11],
										[-0.1, -0.08],
										[-0.14, -0.04],
										[-0.32, 0],
										[-0.21, 0.17],
										[-0.1, 0.28],
										[0, 0.34],
										[0.1, 0.28],
										[0.21, 0.17],
										[0.16, 0],
										[0.14, -0.04],
										[0.11, -0.08],
										[0.07, -0.12],
										[0, 0],
										[-0.06, 0.25],
										[-0.14, 0.2],
										[-0.2, 0.14],
										[-0.24, 0.07],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.48, 5.48],
										[1.17, 5.14],
										[0.31, 4.18],
										[0, 2.74],
										[0.31, 1.3],
										[1.17, 0.34],
										[2.48, 0],
										[3.25, 0.11],
										[3.9, 0.42],
										[4.39, 0.91],
										[4.69, 1.56],
										[3.7, 1.8],
										[3.54, 1.43],
										[3.28, 1.14],
										[2.92, 0.95],
										[2.48, 0.88],
										[1.68, 1.13],
										[1.21, 1.81],
										[1.06, 2.74],
										[1.21, 3.67],
										[1.68, 4.34],
										[2.48, 4.6],
										[2.93, 4.53],
										[3.29, 4.33],
										[3.56, 4.03],
										[3.72, 3.64],
										[4.71, 3.87],
										[4.41, 4.54],
										[3.91, 5.05],
										[3.26, 5.36],
										[2.47, 5.47],
										[2.48, 5.48]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 9,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.48, 2.74] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [92.66, 6.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.37, 0.22],
										[0.21, 0.41],
										[0, 0.54],
										[-0.2, 0.41],
										[-0.37, 0.23],
										[-0.5, 0],
										[-0.37, -0.22],
										[-0.21, -0.41],
										[0, -0.55],
										[0.2, -0.41],
										[0.37, -0.23],
										[0.5, 0]
									],
									"o": [
										[-0.5, 0],
										[-0.37, -0.23],
										[-0.2, -0.41],
										[0, -0.54],
										[0.2, -0.41],
										[0.37, -0.23],
										[0.5, 0],
										[0.37, 0.22],
										[0.2, 0.41],
										[0, 0.55],
										[-0.2, 0.41],
										[-0.37, 0.23],
										[0, 0]
									],
									"v": [
										[2.48, 5.48],
										[1.18, 5.14],
										[0.31, 4.18],
										[0, 2.74],
										[0.31, 1.3],
										[1.18, 0.34],
										[2.48, 0],
										[3.79, 0.34],
										[4.66, 1.3],
										[4.96, 2.74],
										[4.66, 4.18],
										[3.79, 5.14],
										[2.48, 5.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.21, 0.17],
										[-0.1, 0.28],
										[0, 0.34],
										[0.1, 0.28],
										[0.21, 0.17],
										[0.32, 0],
										[0.21, -0.17],
										[0.1, -0.28],
										[0, -0.34],
										[-0.1, -0.28],
										[-0.21, -0.17],
										[-0.32, 0]
									],
									"o": [
										[0.32, 0],
										[0.21, -0.17],
										[0.1, -0.28],
										[0, -0.34],
										[-0.1, -0.28],
										[-0.21, -0.17],
										[-0.32, 0],
										[-0.21, 0.17],
										[-0.1, 0.28],
										[0, 0.34],
										[0.1, 0.28],
										[0.21, 0.17],
										[0, 0]
									],
									"v": [
										[2.48, 4.59],
										[3.28, 4.34],
										[3.75, 3.67],
										[3.9, 2.74],
										[3.75, 1.81],
										[3.28, 1.13],
										[2.48, 0.88],
										[1.69, 1.13],
										[1.22, 1.81],
										[1.06, 2.74],
										[1.22, 3.67],
										[1.69, 4.34],
										[2.48, 4.59]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 10,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.42, 3.59] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [86.6, 5.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.34, 0.22],
										[0.19, 0.41],
										[0, 0.57],
										[-0.19, 0.41],
										[-0.34, 0.22],
										[-0.42, 0],
										[-0.2, -0.11],
										[-0.11, -0.15],
										[-0.06, -0.11],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.12, -0.14],
										[0.2, -0.11],
										[0.32, 0],
										[0, 0]
									],
									"o": [
										[-0.43, 0],
										[-0.34, -0.22],
										[-0.19, -0.41],
										[0, -0.57],
										[0.19, -0.41],
										[0.34, -0.22],
										[0.33, 0],
										[0.2, 0.11],
										[0.12, 0.14],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, 0.11],
										[-0.12, 0.14],
										[-0.2, 0.11],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.22, 7.18],
										[1.07, 6.85],
										[0.28, 5.9],
										[0, 4.44],
										[0.29, 2.96],
										[1.08, 2.02],
										[2.22, 1.7],
										[3.02, 1.86],
										[3.49, 2.25],
										[3.75, 2.63],
										[3.8, 2.63],
										[3.8, 0],
										[4.85, 0],
										[4.85, 7.07],
										[3.83, 7.07],
										[3.83, 6.24],
										[3.75, 6.24],
										[3.48, 6.63],
										[3, 7.01],
										[2.22, 7.18],
										[2.22, 7.18]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.2, 0.16],
										[-0.1, 0.28],
										[0, 0.37],
										[0.1, 0.28],
										[0.2, 0.15],
										[0.3, 0],
										[0.2, -0.16],
										[0.1, -0.28],
										[0, -0.35],
										[-0.1, -0.28],
										[-0.2, -0.16],
										[-0.3, 0],
										[0, 0]
									],
									"o": [
										[0.3, 0],
										[0.2, -0.16],
										[0.11, -0.28],
										[0, -0.37],
										[-0.1, -0.27],
										[-0.2, -0.15],
										[-0.3, 0],
										[-0.2, 0.16],
										[-0.1, 0.28],
										[0, 0.35],
										[0.1, 0.28],
										[0.2, 0.16],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.45, 6.29],
										[3.2, 6.06],
										[3.66, 5.4],
										[3.82, 4.43],
										[3.67, 3.46],
										[3.2, 2.82],
										[2.45, 2.59],
										[1.68, 2.83],
										[1.22, 3.49],
										[1.06, 4.42],
										[1.22, 5.37],
										[1.68, 6.04],
										[2.44, 6.29],
										[2.45, 6.29]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 11,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.41, 2.74] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [78.27, 6.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.38, 0.22],
										[0.2, 0.41],
										[0, 0.55],
										[-0.2, 0.42],
										[-0.37, 0.24],
										[-0.5, 0],
										[-0.28, -0.1],
										[-0.22, -0.21],
										[-0.13, -0.34],
										[0, -0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, 0.25],
										[0.2, 0.14],
										[0.3, 0],
										[0.21, -0.14],
										[0.11, -0.24],
										[0, -0.27],
										[0, 0],
										[-0.12, -0.25],
										[-0.22, -0.13],
										[-0.3, 0],
										[-0.16, 0.06],
										[-0.12, 0.11],
										[-0.06, 0.16],
										[0, 0],
										[0.2, -0.21],
										[0.3, -0.12],
										[0.38, 0],
										[0, 0]
									],
									"o": [
										[-0.52, 0],
										[-0.38, -0.22],
										[-0.2, -0.41],
										[0, -0.55],
										[0.2, -0.42],
										[0.37, -0.23],
										[0.3, 0],
										[0.28, 0.1],
										[0.22, 0.21],
										[0.13, 0.34],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.33],
										[-0.1, -0.25],
										[-0.2, -0.14],
										[-0.3, 0],
										[-0.21, 0.14],
										[-0.11, 0.23],
										[0, 0],
										[0, 0.36],
										[0.12, 0.25],
										[0.22, 0.13],
										[0.2, 0],
										[0.16, -0.06],
										[0.12, -0.11],
										[0, 0],
										[-0.08, 0.27],
										[-0.2, 0.21],
										[-0.3, 0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.53, 5.48],
										[1.18, 5.15],
										[0.3, 4.2],
										[0, 2.76],
										[0.3, 1.32],
										[1.15, 0.35],
										[2.44, 0],
										[3.32, 0.15],
										[4.08, 0.62],
										[4.62, 1.44],
										[4.81, 2.67],
										[4.81, 3.04],
										[0.58, 3.04],
										[0.58, 2.26],
										[4.28, 2.26],
										[3.79, 2.52],
										[3.64, 1.66],
										[3.19, 1.08],
										[2.44, 0.87],
										[1.69, 1.08],
										[1.21, 1.64],
										[1.05, 2.4],
										[1.05, 2.94],
										[1.24, 3.86],
										[1.76, 4.43],
										[2.54, 4.62],
										[3.08, 4.54],
										[3.49, 4.28],
										[3.75, 3.87],
										[4.74, 4.1],
										[4.31, 4.82],
										[3.56, 5.31],
										[2.54, 5.48],
										[2.53, 5.48]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 12,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.57, 2.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [72.8, 6.7] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.08, -0.34],
										[-0.09, -0.33],
										[0, 0],
										[-0.08, 0.34],
										[-0.12, 0.33],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0.12, 0.33],
										[0.08, 0.33],
										[0, 0],
										[0.09, -0.33],
										[0.08, -0.34],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2, 5.31],
										[0, 0],
										[1.13, 0],
										[2.18, 3.02],
										[2.48, 4.02],
										[2.74, 5.01],
										[2.42, 5.01],
										[2.68, 4.02],
										[2.98, 3.02],
										[4.02, 0],
										[5.14, 0],
										[3.14, 5.31],
										[2, 5.31],
										[2, 5.31]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 13,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.55, 3.58] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [68.78, 5.78] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 1.04],
										[0, 0],
										[1.1, 0],
										[1.1, 1.04],
										[0, 1.04]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.03, 7.15],
										[0.03, 1.84],
										[1.07, 1.84],
										[1.07, 7.15],
										[0.03, 7.15]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 14,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.14, 3.54] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [64.99, 5.82] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 7.07],
										[0, 0],
										[1.08, 0],
										[1.08, 6.14],
										[4.29, 6.14],
										[4.29, 7.08],
										[0, 7.08],
										[0, 7.07]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 15,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.47, 5.82] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [57.79, 5.82] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.94, 0],
										[0.94, 11.63],
										[0, 11.63],
										[0, 0],
										[0.94, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.867, 0.871, 0.882] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 16,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.41, 2.74] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [50.67, 6.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.38, 0.22],
										[0.2, 0.41],
										[0, 0.55],
										[-0.2, 0.42],
										[-0.37, 0.24],
										[-0.5, 0],
										[-0.28, -0.1],
										[-0.22, -0.21],
										[-0.13, -0.34],
										[0, -0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, 0.25],
										[0.2, 0.14],
										[0.3, 0],
										[0.21, -0.14],
										[0.11, -0.24],
										[0, -0.27],
										[0, 0],
										[-0.12, -0.25],
										[-0.22, -0.13],
										[-0.3, 0],
										[-0.16, 0.06],
										[-0.12, 0.11],
										[-0.06, 0.16],
										[0, 0],
										[0.2, -0.21],
										[0.3, -0.12],
										[0.38, 0],
										[0, 0]
									],
									"o": [
										[-0.52, 0],
										[-0.38, -0.22],
										[-0.2, -0.41],
										[0, -0.55],
										[0.2, -0.42],
										[0.37, -0.23],
										[0.3, 0],
										[0.28, 0.1],
										[0.22, 0.21],
										[0.13, 0.34],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.33],
										[-0.1, -0.25],
										[-0.2, -0.14],
										[-0.3, 0],
										[-0.21, 0.14],
										[-0.11, 0.23],
										[0, 0],
										[0, 0.36],
										[0.12, 0.25],
										[0.22, 0.13],
										[0.2, 0],
										[0.16, -0.06],
										[0.12, -0.11],
										[0, 0],
										[-0.08, 0.27],
										[-0.2, 0.21],
										[-0.3, 0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.53, 5.48],
										[1.18, 5.15],
										[0.3, 4.2],
										[0, 2.76],
										[0.3, 1.32],
										[1.15, 0.35],
										[2.44, 0],
										[3.32, 0.15],
										[4.08, 0.62],
										[4.62, 1.44],
										[4.81, 2.67],
										[4.81, 3.04],
										[0.58, 3.04],
										[0.58, 2.26],
										[4.28, 2.26],
										[3.79, 2.52],
										[3.64, 1.66],
										[3.19, 1.08],
										[2.44, 0.87],
										[1.69, 1.08],
										[1.21, 1.64],
										[1.05, 2.4],
										[1.05, 2.94],
										[1.24, 3.86],
										[1.76, 4.43],
										[2.54, 4.62],
										[3.08, 4.54],
										[3.49, 4.28],
										[3.75, 3.87],
										[4.74, 4.1],
										[4.31, 4.82],
										[3.56, 5.31],
										[2.54, 5.48],
										[2.53, 5.48]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 17,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.35, 2.74] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [45.01, 6.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.37, 0.22],
										[0.2, 0.41],
										[0, 0.54],
										[-0.2, 0.41],
										[-0.37, 0.23],
										[-0.5, 0],
										[-0.24, -0.07],
										[-0.19, -0.13],
										[-0.13, -0.19],
										[-0.06, -0.24],
										[0, 0],
										[0.07, 0.11],
										[0.1, 0.08],
										[0.14, 0.04],
										[0.16, 0],
										[0.21, -0.17],
										[0.1, -0.28],
										[0, -0.34],
										[-0.1, -0.28],
										[-0.21, -0.17],
										[-0.32, 0],
										[-0.14, 0.04],
										[-0.11, 0.08],
										[-0.07, 0.12],
										[-0.03, 0.14],
										[0, 0],
										[0.14, -0.2],
										[0.2, -0.14],
										[0.24, -0.07],
										[0.28, 0],
										[0, 0]
									],
									"o": [
										[-0.5, 0],
										[-0.37, -0.23],
										[-0.2, -0.41],
										[0, -0.54],
										[0.2, -0.41],
										[0.37, -0.23],
										[0.28, 0],
										[0.24, 0.07],
										[0.2, 0.14],
										[0.14, 0.2],
										[0, 0],
										[-0.04, -0.14],
										[-0.07, -0.11],
										[-0.1, -0.08],
										[-0.14, -0.04],
										[-0.32, 0],
										[-0.21, 0.17],
										[-0.1, 0.28],
										[0, 0.34],
										[0.1, 0.28],
										[0.21, 0.17],
										[0.16, 0],
										[0.14, -0.04],
										[0.11, -0.08],
										[0.07, -0.12],
										[0, 0],
										[-0.06, 0.25],
										[-0.14, 0.2],
										[-0.2, 0.14],
										[-0.24, 0.07],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.48, 5.48],
										[1.17, 5.14],
										[0.31, 4.18],
										[0, 2.74],
										[0.31, 1.3],
										[1.17, 0.34],
										[2.48, 0],
										[3.25, 0.11],
										[3.9, 0.42],
										[4.39, 0.91],
										[4.69, 1.56],
										[3.7, 1.8],
										[3.54, 1.43],
										[3.28, 1.14],
										[2.92, 0.95],
										[2.48, 0.88],
										[1.68, 1.13],
										[1.21, 1.81],
										[1.06, 2.74],
										[1.21, 3.67],
										[1.68, 4.34],
										[2.48, 4.6],
										[2.93, 4.53],
										[3.29, 4.33],
										[3.56, 4.03],
										[3.72, 3.64],
										[4.71, 3.87],
										[4.41, 4.54],
										[3.91, 5.05],
										[3.26, 5.36],
										[2.47, 5.47],
										[2.48, 5.48]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 18,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.22, 2.69] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [39.27, 6.67] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.3, 0.22],
										[-0.42, 0],
										[-0.27, -0.15],
										[-0.15, -0.3],
										[0, -0.44],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.2, 0.22],
										[0.35, 0],
										[0.19, -0.1],
										[0.11, -0.2],
										[0, -0.28],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.16, -0.48],
										[0.3, -0.22],
										[0.36, 0],
										[0.27, 0.15],
										[0.15, 0.3],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.38],
										[-0.2, -0.22],
										[-0.24, 0],
										[-0.19, 0.1],
										[-0.11, 0.2],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.04, 2.23],
										[1.04, 5.38],
										[0, 5.38],
										[0, 0.07],
										[1, 0.07],
										[1, 1.37],
										[0.9, 1.37],
										[1.57, 0.33],
										[2.64, 0],
										[3.58, 0.23],
										[4.22, 0.9],
										[4.44, 2],
										[4.44, 5.38],
										[3.4, 5.38],
										[3.4, 2.13],
										[3.1, 1.24],
										[2.28, 0.91],
										[1.65, 1.07],
										[1.21, 1.52],
										[1.05, 2.23],
										[1.04, 2.23]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 19,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.41, 2.74] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [33.5, 6.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.38, 0.22],
										[0.2, 0.41],
										[0, 0.55],
										[-0.2, 0.42],
										[-0.37, 0.24],
										[-0.5, 0],
										[-0.28, -0.1],
										[-0.22, -0.21],
										[-0.13, -0.34],
										[0, -0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, 0.25],
										[0.2, 0.14],
										[0.3, 0],
										[0.21, -0.14],
										[0.11, -0.24],
										[0, -0.27],
										[0, 0],
										[-0.12, -0.25],
										[-0.22, -0.13],
										[-0.3, 0],
										[-0.16, 0.06],
										[-0.12, 0.11],
										[-0.06, 0.16],
										[0, 0],
										[0.2, -0.21],
										[0.3, -0.12],
										[0.38, 0],
										[0, 0]
									],
									"o": [
										[-0.52, 0],
										[-0.38, -0.22],
										[-0.2, -0.41],
										[0, -0.55],
										[0.2, -0.42],
										[0.37, -0.23],
										[0.3, 0],
										[0.28, 0.1],
										[0.22, 0.21],
										[0.13, 0.34],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.33],
										[-0.1, -0.25],
										[-0.2, -0.14],
										[-0.3, 0],
										[-0.21, 0.14],
										[-0.11, 0.23],
										[0, 0],
										[0, 0.36],
										[0.12, 0.25],
										[0.22, 0.13],
										[0.2, 0],
										[0.16, -0.06],
										[0.12, -0.11],
										[0, 0],
										[-0.08, 0.27],
										[-0.2, 0.21],
										[-0.3, 0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.53, 5.48],
										[1.18, 5.15],
										[0.3, 4.2],
										[0, 2.76],
										[0.3, 1.32],
										[1.15, 0.35],
										[2.44, 0],
										[3.32, 0.15],
										[4.08, 0.62],
										[4.62, 1.44],
										[4.81, 2.67],
										[4.81, 3.04],
										[0.58, 3.04],
										[0.58, 2.26],
										[4.28, 2.26],
										[3.79, 2.52],
										[3.64, 1.66],
										[3.19, 1.08],
										[2.44, 0.87],
										[1.69, 1.08],
										[1.21, 1.64],
										[1.05, 2.4],
										[1.05, 2.94],
										[1.24, 3.86],
										[1.76, 4.43],
										[2.54, 4.62],
										[3.08, 4.54],
										[3.49, 4.28],
										[3.75, 3.87],
										[4.74, 4.1],
										[4.31, 4.82],
										[3.56, 5.31],
										[2.54, 5.48],
										[2.53, 5.48]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 20,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.22, 2.69] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [27.72, 6.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.27, 0.15],
										[0.15, 0.3],
										[0, 0.44],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.2, -0.21],
										[-0.35, 0],
										[-0.18, 0.1],
										[-0.11, 0.2],
										[0, 0.28],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.3, -0.22],
										[0.4, 0],
										[0, 0]
									],
									"o": [
										[-0.36, 0],
										[-0.27, -0.15],
										[-0.15, -0.3],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0.38],
										[0.2, 0.22],
										[0.24, 0],
										[0.18, -0.1],
										[0.11, -0.2],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.16, 0.48],
										[-0.3, 0.22],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.8, 5.38],
										[0.86, 5.15],
										[0.22, 4.48],
										[0, 3.38],
										[0, 0],
										[1.04, 0],
										[1.04, 3.25],
										[1.34, 4.14],
										[2.16, 4.47],
										[2.8, 4.31],
										[3.24, 3.86],
										[3.4, 3.14],
										[3.4, 0],
										[4.44, 0],
										[4.44, 5.31],
										[3.44, 5.31],
										[3.44, 4.01],
										[3.54, 4.01],
										[2.86, 5.05],
										[1.81, 5.38],
										[1.8, 5.38]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 21,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.99, 3.56] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [23.69, 5.84] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.22, 0.22],
										[0, 0.41],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, -0.09],
										[-0.17, 0],
										[-0.04, 0.01],
										[-0.03, 0.01],
										[0, 0],
										[0.12, -0.02],
										[0.13, 0],
										[0, 0]
									],
									"o": [
										[-0.45, 0],
										[-0.22, -0.22],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0.22],
										[0.06, 0.09],
										[0.09, 0],
										[0.04, -0.01],
										[0, 0],
										[-0.08, 0.02],
										[-0.12, 0.02],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.32, 7.11],
										[0.32, 6.78],
										[0, 5.83],
										[0, 0],
										[1.04, 0],
										[1.04, 5.62],
										[1.13, 6.09],
										[1.47, 6.23],
										[1.67, 6.22],
										[1.79, 6.19],
										[1.98, 7.02],
										[1.69, 7.08],
										[1.32, 7.11],
										[1.32, 7.11]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 22,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.73, 3.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [20.14, 5.65] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.24, 2.11],
										[3.24, 2.96],
										[0, 2.96],
										[0, 2.11],
										[3.24, 2.11]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.15, 0.22],
										[-0.24, 0.11],
										[-0.28, 0],
										[-0.15, -0.04],
										[-0.07, -0.03],
										[0, 0],
										[0.08, 0.02],
										[0.11, 0],
										[0.11, -0.12],
										[0, -0.23],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, -0.33],
										[0.15, -0.22],
										[0.24, -0.11],
										[0.21, 0],
										[0.15, 0.04],
										[0, 0],
										[-0.05, -0.02],
										[-0.08, -0.02],
										[-0.25, 0],
										[-0.11, 0.12],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1, 7.41],
										[1, 1.5],
										[1.22, 0.67],
										[1.8, 0.17],
										[2.58, 0],
										[3.13, 0.05],
										[3.46, 0.14],
										[3.22, 0.99],
										[3.03, 0.94],
										[2.75, 0.91],
										[2.22, 1.1],
										[2.05, 1.63],
										[2.05, 7.4],
										[1, 7.4],
										[1, 7.41]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 23,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.22, 2.69] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [15.39, 6.67] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.3, 0.22],
										[-0.42, 0],
										[-0.27, -0.15],
										[-0.15, -0.3],
										[0, -0.44],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.2, 0.22],
										[0.35, 0],
										[0.19, -0.1],
										[0.11, -0.2],
										[0, -0.28],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.16, -0.48],
										[0.3, -0.22],
										[0.36, 0],
										[0.27, 0.15],
										[0.15, 0.3],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.38],
										[-0.2, -0.22],
										[-0.24, 0],
										[-0.19, 0.1],
										[-0.11, 0.2],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.04, 2.23],
										[1.04, 5.38],
										[0, 5.38],
										[0, 0.07],
										[1, 0.07],
										[1, 1.37],
										[0.9, 1.37],
										[1.57, 0.33],
										[2.64, 0],
										[3.58, 0.23],
										[4.22, 0.9],
										[4.44, 2],
										[4.44, 5.38],
										[3.4, 5.38],
										[3.4, 2.13],
										[3.1, 1.24],
										[2.28, 0.91],
										[1.65, 1.07],
										[1.21, 1.52],
										[1.05, 2.23],
										[1.04, 2.23]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 24,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.48, 2.74] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [9.53, 6.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.37, 0.22],
										[0.21, 0.41],
										[0, 0.54],
										[-0.2, 0.41],
										[-0.37, 0.23],
										[-0.5, 0],
										[-0.37, -0.22],
										[-0.21, -0.41],
										[0, -0.55],
										[0.2, -0.41],
										[0.37, -0.23],
										[0.5, 0]
									],
									"o": [
										[-0.5, 0],
										[-0.37, -0.23],
										[-0.2, -0.41],
										[0, -0.54],
										[0.2, -0.41],
										[0.37, -0.23],
										[0.5, 0],
										[0.37, 0.22],
										[0.2, 0.41],
										[0, 0.55],
										[-0.2, 0.41],
										[-0.37, 0.23],
										[0, 0]
									],
									"v": [
										[2.48, 5.48],
										[1.18, 5.14],
										[0.31, 4.18],
										[0, 2.74],
										[0.31, 1.3],
										[1.18, 0.34],
										[2.48, 0],
										[3.79, 0.34],
										[4.66, 1.3],
										[4.96, 2.74],
										[4.66, 4.18],
										[3.79, 5.14],
										[2.48, 5.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.21, 0.17],
										[-0.1, 0.28],
										[0, 0.34],
										[0.1, 0.28],
										[0.21, 0.17],
										[0.32, 0],
										[0.21, -0.17],
										[0.1, -0.28],
										[0, -0.34],
										[-0.1, -0.28],
										[-0.21, -0.17],
										[-0.32, 0]
									],
									"o": [
										[0.32, 0],
										[0.21, -0.17],
										[0.1, -0.28],
										[0, -0.34],
										[-0.1, -0.28],
										[-0.21, -0.17],
										[-0.32, 0],
										[-0.21, 0.17],
										[-0.1, 0.28],
										[0, 0.34],
										[0.1, 0.28],
										[0.21, 0.17],
										[0, 0]
									],
									"v": [
										[2.48, 4.59],
										[3.28, 4.34],
										[3.75, 3.67],
										[3.9, 2.74],
										[3.75, 1.81],
										[3.28, 1.13],
										[2.48, 0.88],
										[1.69, 1.13],
										[1.22, 1.81],
										[1.06, 2.74],
										[1.22, 3.67],
										[1.69, 4.34],
										[2.48, 4.59]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 25,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.05, 3.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [3.05, 5.82] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.48, 0.29],
										[0.28, 0.54],
										[0, 0.75],
										[-0.28, 0.54],
										[-0.48, 0.29],
										[-0.61, 0],
										[-0.33, -0.11],
										[-0.26, -0.2],
										[-0.17, -0.3],
										[-0.06, -0.37],
										[0, 0],
										[0.11, 0.17],
										[0.16, 0.12],
										[0.2, 0.06],
										[0.22, 0],
										[0.32, -0.21],
										[0.18, -0.39],
										[0, -0.57],
										[-0.19, -0.39],
										[-0.32, -0.2],
										[-0.4, 0],
										[-0.2, 0.06],
										[-0.16, 0.12],
										[-0.11, 0.18],
										[-0.04, 0.22],
										[0, 0],
										[0.16, -0.29],
										[0.26, -0.22],
										[0.33, -0.12],
										[0.39, 0],
										[0, 0]
									],
									"o": [
										[-0.61, 0],
										[-0.48, -0.29],
										[-0.28, -0.54],
										[0, -0.75],
										[0.28, -0.54],
										[0.48, -0.29],
										[0.37, 0],
										[0.33, 0.11],
										[0.26, 0.2],
										[0.17, 0.3],
										[0, 0],
										[-0.04, -0.22],
										[-0.11, -0.17],
										[-0.16, -0.12],
										[-0.2, -0.06],
										[-0.4, 0],
										[-0.32, 0.2],
										[-0.18, 0.39],
										[0, 0.57],
										[0.19, 0.4],
										[0.32, 0.2],
										[0.22, 0],
										[0.2, -0.06],
										[0.16, -0.12],
										[0.11, -0.18],
										[0, 0],
										[-0.05, 0.35],
										[-0.16, 0.29],
										[-0.26, 0.22],
										[-0.33, 0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.18, 7.26],
										[1.55, 6.83],
										[0.41, 5.58],
										[0, 3.64],
										[0.41, 1.69],
										[1.55, 0.44],
										[3.18, 0],
										[4.24, 0.16],
										[5.12, 0.63],
										[5.76, 1.38],
										[6.1, 2.38],
										[5.01, 2.38],
										[4.78, 1.78],
										[4.36, 1.34],
										[3.82, 1.07],
										[3.19, 0.98],
										[2.1, 1.29],
										[1.35, 2.18],
										[1.07, 3.63],
										[1.35, 5.07],
										[2.11, 5.96],
										[3.2, 6.26],
										[3.82, 6.17],
										[4.36, 5.9],
										[4.78, 5.46],
										[5.01, 4.87],
										[6.1, 4.87],
										[5.78, 5.82],
										[5.14, 6.58],
										[4.26, 7.08],
										[3.18, 7.25],
										[3.18, 7.26]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 26,
					"parent": 8
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [96.68, 14.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [96.68, 14.27] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -1.77],
										[0, 0],
										[-1.77, 0],
										[0, 0],
										[0, 1.77],
										[0, 0],
										[1.77, 0]
									],
									"o": [
										[0, 0],
										[-1.77, 0],
										[0, 0],
										[0, 1.77],
										[0, 0],
										[1.77, 0],
										[0, 0],
										[0, -1.77],
										[0, 0]
									],
									"v": [
										[190.15, 0],
										[3.2, 0],
										[0, 3.2],
										[0, 25.34],
										[3.2, 28.54],
										[190.15, 28.54],
										[193.35, 25.34],
										[193.35, 3.2],
										[190.15, 0]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 78
									},
									{ "s": [1], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.867, 0.871, 0.882] }
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 27,
					"parent": 5
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [111.8, 84] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [122.2, 93.97] },
						"r": { "a": 0, "k": -2.83 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 28
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [95.25, 19.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [115.38, 31.44] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 29,
					"parent": 28
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [18.42, 4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [34.09, 30.58],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [34.09, 30.58],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [34.09, 30.58],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [34.09, 30.58],
									"t": 78
								},
								{ "s": [34.09, 30.57], "t": 108 }
							]
						},
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -0.88],
										[0, 0],
										[-0.88, 0],
										[0, 0],
										[0, 0.88],
										[0, 0],
										[0.88, 0]
									],
									"o": [
										[0, 0],
										[-0.88, 0],
										[0, 0],
										[0, 0.88],
										[0, 0],
										[0.88, 0],
										[0, 0],
										[0, -0.88],
										[0, 0]
									],
									"v": [
										[35.23, 0],
										[1.6, 0],
										[0, 1.6],
										[0, 6.4],
										[1.6, 8],
										[35.23, 8],
										[36.83, 6.4],
										[36.83, 1.6],
										[35.23, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.93, 0.93, 0.93] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 30,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.2, 9.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [181.31, 30.73],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [181.31, 30.73],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [181.31, 30.73],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [181.31, 30.73],
									"t": 78
								},
								{ "s": [181.31, 30.72], "t": 108 }
							]
						},
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 31,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Clip path group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.2, 9.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [9.2, 9.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 32,
					"parent": 31
				},
				{
					"ty": 0,
					"nm": "clippath",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"td": 1,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.2, 9.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [9.2, 9.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"w": 968,
					"h": 568,
					"refId": "5",
					"ind": 33,
					"parent": 32
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"tt": 1,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.58, 10.51] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [9.45, 12.46] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 34,
					"parent": 32
				},
				{
					"ty": 0,
					"nm": "clippath",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"td": 1,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.2, 9.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [9.2, 9.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"w": 968,
					"h": 568,
					"refId": "5",
					"ind": 35,
					"parent": 32
				},
				{
					"ty": 4,
					"nm": "Layer 1 (Border)",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"tt": 1,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.44, 10.35] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [12.605, 10.469],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [12.605, 10.469],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [12.605, 10.469],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [12.605, 10.469],
									"t": 78
								},
								{ "s": [12.604, 10.469], "t": 108 }
							]
						},
						"r": { "a": 0, "k": 179.2 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[22.88, 0],
										[22.88, 20.7],
										[0, 20.7],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 2,
							"lj": 2,
							"ml": 1,
							"o": { "a": 0, "k": 0 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.02],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.02],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.02],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.02],
										"t": 78
									},
									{ "s": [0.02], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0, 0, 0] }
						}
					],
					"ind": 36,
					"parent": 34
				},
				{
					"ty": 0,
					"nm": "clippath",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"td": 1,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.2, 9.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [9.2, 9.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"w": 968,
					"h": 568,
					"refId": "5",
					"ind": 37,
					"parent": 32
				},
				{
					"ty": 4,
					"nm": "Layer 1 (Mask)",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"tt": 1,
					"hasMask": false,
					"td": 1,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [0, 0] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "gr",
							"nm": "",
							"it": [
								{
									"ty": "sh",
									"nm": "",
									"d": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[22.88, 0],
															[22.88, 20.7],
															[0, 20.7],
															[0, 0]
														]
													}
												],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[22.88, 0],
															[22.88, 20.7],
															[0, 20.7],
															[0, 0]
														]
													}
												],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[22.88, 0],
															[22.88, 20.7],
															[0, 20.7],
															[0, 0]
														]
													}
												],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[22.88, 0],
															[22.88, 20.7],
															[0, 20.7],
															[0, 0]
														]
													}
												],
												"t": 78
											},
											{
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[22.88, 0],
															[22.88, 20.7],
															[0, 20.7],
															[0, 0]
														]
													}
												],
												"t": 108
											}
										]
									}
								},
								{
									"ty": "fl",
									"nm": "",
									"c": { "a": 0, "k": [1, 0, 0] },
									"r": 2,
									"o": { "a": 0, "k": 100 }
								},
								{
									"ty": "tr",
									"a": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [11.44, 10.35],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [11.44, 10.35],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [11.44, 10.35],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [11.44, 10.35],
												"t": 78
											},
											{ "s": [11.44, 10.35], "t": 108 }
										]
									},
									"s": { "a": 0, "k": [100, 100] },
									"sk": { "a": 0, "k": 0 },
									"p": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [12.605, 10.469],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [12.605, 10.469],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [12.605, 10.469],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [12.605, 10.469],
												"t": 78
											},
											{ "s": [12.604, 10.469], "t": 108 }
										]
									},
									"r": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [179.2],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [179.2],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [179.2],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [179.2],
												"t": 78
											},
											{ "s": [179.2], "t": 108 }
										]
									},
									"sa": { "a": 0, "k": 0 },
									"o": { "a": 0, "k": 100 }
								}
							]
						}
					],
					"ind": 38,
					"parent": 34
				},
				{
					"ty": 0,
					"nm": "clippath",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"td": 1,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.2, 9.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [9.2, 9.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"w": 968,
					"h": 568,
					"refId": "5",
					"ind": 39,
					"parent": 32
				},
				{
					"ty": 2,
					"nm": "Layer 1",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"tt": 1,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [572, 517.5] },
						"s": { "a": 0, "k": [2, 2] },
						"sk": { "a": 0, "k": 0 },
						"p": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [12.605, 10.469],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [12.605, 10.469],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [12.605, 10.469],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [12.605, 10.469],
									"t": 78
								},
								{ "s": [12.604, 10.469], "t": 108 }
							]
						},
						"r": { "a": 0, "k": 179.2 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"refId": "9c709431a159a33704f4280c2f65046d4be7785e",
					"ind": 40,
					"parent": 34
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.2, 9.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [9.2, 9.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 5.08],
										[5.08, 0],
										[0, -5.08],
										[-5.08, 0]
									],
									"o": [
										[5.08, 0],
										[0, -5.08],
										[-5.08, 0],
										[0, 5.08],
										[0, 0]
									],
									"v": [
										[9.2, 18.4],
										[18.4, 9.2],
										[9.2, 0],
										[0, 9.2],
										[9.2, 18.4]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.749, 0.388, 0.953] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 41,
					"parent": 31
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [60.21, 4.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [60.49, 4.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 42,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.36, 3.69] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [118.06, 5.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.11, 0.14],
										[-0.2, 0.11],
										[-0.34, 0],
										[-0.34, -0.22],
										[-0.19, -0.41],
										[0, -0.56],
										[0.19, -0.41],
										[0.34, -0.22],
										[0.44, 0],
										[0.21, 0.11],
										[0.11, 0.15],
										[0.06, 0.1],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.06, -0.1],
										[0.11, -0.14],
										[0.2, -0.12],
										[0.44, 0],
										[0.34, 0.22],
										[0.19, 0.41],
										[0, 0.56],
										[-0.19, 0.41],
										[-0.34, 0.22],
										[-0.34, 0],
										[-0.21, -0.12],
										[-0.11, -0.15],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 7.39],
										[0, 0.07],
										[0.83, 0.07],
										[0.83, 0.92],
										[0.92, 0.92],
										[1.18, 0.56],
										[1.64, 0.17],
										[2.47, 0],
										[3.64, 0.33],
										[4.44, 1.28],
										[4.73, 2.74],
										[4.44, 4.21],
										[3.65, 5.17],
										[2.48, 5.51],
										[1.66, 5.34],
										[1.18, 4.94],
										[0.93, 4.57],
										[0.86, 4.57],
										[0.86, 7.39],
										[0, 7.39]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.22, 0.18],
										[-0.11, 0.3],
										[0, 0.37],
										[0.11, 0.3],
										[0.22, 0.18],
										[0.34, 0],
										[0.22, -0.16],
										[0.11, -0.29],
										[0, -0.4],
										[-0.12, -0.3],
										[-0.22, -0.17],
										[-0.32, 0],
										[0, 0]
									],
									"o": [
										[0.33, 0],
										[0.22, -0.18],
										[0.11, -0.3],
										[0, -0.37],
										[-0.11, -0.3],
										[-0.22, -0.18],
										[-0.34, 0],
										[-0.22, 0.16],
										[-0.11, 0.3],
										[0, 0.4],
										[0.12, 0.3],
										[0.22, 0.17],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.34, 4.74],
										[3.18, 4.48],
										[3.68, 3.75],
										[3.85, 2.74],
										[3.68, 1.74],
										[3.18, 1.03],
										[2.34, 0.77],
										[1.52, 1.02],
										[1.01, 1.7],
										[0.84, 2.74],
										[1.02, 3.78],
										[1.52, 4.49],
										[2.34, 4.74],
										[2.34, 4.74]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 43,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.47, 3.55] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [113.76, 3.88] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0.94],
										[0, 0],
										[0.94, 0],
										[0.94, 0.94],
										[0, 0.94]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.04, 7.1],
										[0.04, 1.78],
										[0.9, 1.78],
										[0.9, 7.1],
										[0.04, 7.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 44,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.13, 3.55] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [109.68, 3.88],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [109.68, 3.88],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [109.68, 3.88],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [109.68, 3.88],
									"t": 78
								},
								{ "s": [109.69, 3.88], "t": 108 }
							]
						},
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.3, 0.2],
										[-0.4, 0],
										[-0.27, -0.14],
										[-0.15, -0.3],
										[0, -0.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.21, 0.23],
										[0.37, 0],
										[0.2, -0.11],
										[0.12, -0.22],
										[0, -0.3],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.16, -0.49],
										[0.3, -0.21],
										[0.36, 0],
										[0.27, 0.14],
										[0.15, 0.3],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.41],
										[-0.21, -0.23],
										[-0.26, 0],
										[-0.2, 0.11],
										[-0.12, 0.22],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.86, 3.91],
										[0.86, 7.1],
										[0, 7.1],
										[0, 0],
										[0.86, 0],
										[0.86, 3.06],
										[0.71, 3.06],
										[1.4, 2.02],
										[2.46, 1.7],
										[3.41, 1.92],
										[4.04, 2.59],
										[4.27, 3.72],
										[4.27, 7.1],
										[3.4, 7.1],
										[3.4, 3.79],
										[3.08, 2.82],
										[2.2, 2.48],
										[1.52, 2.64],
										[1.04, 3.13],
										[0.86, 3.91],
										[0.86, 3.91]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 45,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.08, 2.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [104.24, 4.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.28, 0.11],
										[0.18, 0.21],
										[0.06, 0.3],
										[0, 0],
										[-0.21, -0.14],
										[-0.32, 0],
										[-0.22, 0.16],
										[0, 0.22],
										[0.13, 0.12],
										[0.26, 0.06],
										[0, 0],
										[0.23, 0.24],
										[0, 0.38],
										[-0.17, 0.23],
										[-0.3, 0.13],
										[-0.38, 0],
										[-0.26, -0.11],
										[-0.16, -0.19],
										[-0.08, -0.25],
										[0, 0],
										[0.17, 0.16],
										[0.34, 0],
										[0.21, -0.15],
										[0, -0.22],
										[-0.14, -0.12],
										[-0.31, -0.07],
										[0, 0],
										[-0.23, -0.24],
										[0, -0.36],
										[0.18, -0.24],
										[0.32, -0.14],
										[0.42, 0],
										[0, 0]
									],
									"o": [
										[-0.36, 0],
										[-0.28, -0.11],
										[-0.18, -0.21],
										[0, 0],
										[0.08, 0.29],
										[0.21, 0.14],
										[0.37, 0],
										[0.22, -0.16],
										[0, -0.18],
										[-0.13, -0.12],
										[0, 0],
										[-0.48, -0.12],
										[-0.24, -0.24],
										[0, -0.3],
										[0.17, -0.23],
										[0.3, -0.13],
										[0.38, 0],
										[0.26, 0.11],
										[0.16, 0.19],
										[0, 0],
										[-0.07, -0.19],
										[-0.17, -0.16],
										[-0.32, 0],
										[-0.21, 0.15],
										[0, 0.2],
										[0.14, 0.12],
										[0, 0],
										[0.48, 0.12],
										[0.23, 0.24],
										[0, 0.31],
										[-0.18, 0.24],
										[-0.32, 0.14],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.05, 5.52],
										[1.08, 5.36],
										[0.37, 4.88],
										[0, 4.11],
										[0.82, 3.92],
										[1.25, 4.56],
										[2.04, 4.76],
										[2.93, 4.52],
										[3.26, 3.96],
										[3.07, 3.5],
										[2.48, 3.22],
										[1.59, 3.01],
										[0.52, 2.48],
										[0.16, 1.56],
										[0.42, 0.75],
										[1.12, 0.2],
										[2.14, 0],
										[3.07, 0.16],
										[3.69, 0.62],
										[4.05, 1.28],
										[3.28, 1.48],
										[2.91, 0.96],
										[2.14, 0.73],
										[1.35, 0.95],
										[1.04, 1.5],
										[1.25, 1.98],
										[1.93, 2.26],
										[2.74, 2.46],
										[3.81, 2.99],
										[4.16, 3.9],
										[3.89, 4.73],
										[3.15, 5.3],
										[2.05, 5.51],
										[2.05, 5.52]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 46,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.35, 2.7] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [100.08, 4.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.25, 0.16],
										[-0.32, 0],
										[-0.09, 0],
										[-0.05, 0],
										[0, 0],
										[0.1, 0.01],
										[0.12, 0],
										[0.2, -0.11],
										[0.12, -0.19],
										[0, -0.24],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, -0.27],
										[0.25, -0.16],
										[0.06, 0],
										[0.09, 0],
										[0, 0],
										[-0.02, -0.01],
										[-0.1, -0.01],
										[-0.26, 0],
										[-0.2, 0.11],
										[-0.12, 0.18],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 5.4],
										[0, 0.08],
										[0.83, 0.08],
										[0.83, 0.9],
										[0.89, 0.9],
										[1.42, 0.24],
										[2.27, 0],
										[2.5, 0],
										[2.71, 0.01],
										[2.71, 0.88],
										[2.52, 0.85],
										[2.19, 0.83],
										[1.51, 0.99],
										[1.03, 1.43],
										[0.86, 2.07],
										[0.86, 5.4],
										[0, 5.4],
										[0, 5.4]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 47,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.36, 2.75] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [95.13, 4.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.37, 0.23],
										[0.2, 0.41],
										[0, 0.55],
										[-0.2, 0.42],
										[-0.36, 0.24],
										[-0.48, 0],
										[-0.28, -0.09],
										[-0.22, -0.21],
										[-0.13, -0.34],
										[0, -0.49],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.11, 0.27],
										[0.22, 0.16],
										[0.32, 0],
										[0.23, -0.16],
										[0.12, -0.25],
										[0, -0.29],
										[0, 0],
										[-0.14, -0.28],
										[-0.25, -0.14],
										[-0.32, 0],
										[-0.17, 0.06],
										[-0.12, 0.12],
										[-0.07, 0.18],
										[0, 0],
										[0.2, -0.2],
										[0.29, -0.12],
										[0.36, 0],
										[0, 0]
									],
									"o": [
										[-0.52, 0],
										[-0.37, -0.23],
										[-0.2, -0.41],
										[0, -0.55],
										[0.2, -0.42],
										[0.36, -0.24],
										[0.28, 0],
										[0.28, 0.09],
										[0.22, 0.21],
										[0.13, 0.34],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.35],
										[-0.11, -0.27],
										[-0.22, -0.16],
										[-0.32, 0],
										[-0.23, 0.16],
										[-0.12, 0.25],
										[0, 0],
										[0, 0.4],
										[0.14, 0.28],
										[0.25, 0.14],
										[0.21, 0],
										[0.17, -0.06],
										[0.12, -0.12],
										[0, 0],
										[-0.08, 0.27],
										[-0.2, 0.2],
										[-0.29, 0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.5, 5.51],
										[1.17, 5.16],
										[0.3, 4.21],
										[0, 2.77],
										[0.3, 1.33],
										[1.13, 0.35],
										[2.4, 0],
										[3.23, 0.14],
										[3.98, 0.59],
										[4.52, 1.41],
										[4.72, 2.66],
										[4.72, 3.02],
										[0.58, 3.02],
										[0.58, 2.29],
										[4.26, 2.29],
										[3.86, 2.56],
										[3.69, 1.63],
										[3.2, 0.99],
										[2.4, 0.76],
										[1.58, 0.99],
										[1.05, 1.61],
										[0.87, 2.42],
										[0.87, 2.9],
										[1.08, 3.9],
										[1.65, 4.53],
										[2.51, 4.74],
										[3.08, 4.65],
										[3.52, 4.38],
										[3.81, 3.92],
										[4.64, 4.15],
										[4.22, 4.85],
										[3.49, 5.33],
										[2.5, 5.5],
										[2.5, 5.51]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 48,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.37, 3.61] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [89.17, 3.94] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.34, 0.23],
										[0.19, 0.41],
										[0, 0.56],
										[-0.19, 0.41],
										[-0.34, 0.22],
										[-0.44, 0],
										[-0.2, -0.12],
										[-0.11, -0.14],
										[-0.06, -0.1],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.11, -0.15],
										[0.2, -0.12],
										[0.34, 0],
										[0, 0]
									],
									"o": [
										[-0.44, 0],
										[-0.34, -0.22],
										[-0.19, -0.41],
										[0, -0.56],
										[0.19, -0.41],
										[0.34, -0.22],
										[0.35, 0],
										[0.2, 0.12],
										[0.11, 0.14],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, 0.1],
										[-0.11, 0.15],
										[-0.2, 0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.25, 7.22],
										[1.08, 6.88],
										[0.28, 5.92],
										[0, 4.45],
										[0.29, 2.99],
										[1.09, 2.04],
										[2.26, 1.71],
										[3.08, 1.88],
										[3.55, 2.27],
										[3.8, 2.63],
										[3.87, 2.63],
										[3.87, 0],
										[4.73, 0],
										[4.73, 7.1],
										[3.9, 7.1],
										[3.9, 6.28],
										[3.81, 6.28],
										[3.55, 6.65],
										[3.08, 7.04],
										[2.26, 7.22],
										[2.25, 7.22]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.22, 0.17],
										[-0.11, 0.3],
										[0, 0.4],
										[0.11, 0.3],
										[0.22, 0.16],
										[0.33, 0],
										[0.22, -0.18],
										[0.11, -0.3],
										[0, -0.37],
										[-0.11, -0.3],
										[-0.23, -0.18],
										[-0.33, 0]
									],
									"o": [
										[0.32, 0],
										[0.22, -0.17],
										[0.12, -0.3],
										[0, -0.4],
										[-0.11, -0.3],
										[-0.22, -0.16],
										[-0.33, 0],
										[-0.22, 0.18],
										[-0.11, 0.3],
										[0, 0.37],
										[0.11, 0.3],
										[0.22, 0.18],
										[0, 0]
									],
									"v": [
										[2.38, 6.45],
										[3.2, 6.2],
										[3.7, 5.49],
										[3.88, 4.44],
										[3.71, 3.41],
										[3.2, 2.72],
										[2.38, 2.48],
										[1.54, 2.74],
										[1.04, 3.45],
										[0.87, 4.45],
										[1.04, 5.46],
										[1.54, 6.18],
										[2.38, 6.45]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 49,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.37, 2.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [83.19, 4.8],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [83.19, 4.8],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [83.19, 4.8],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [83.19, 4.8],
									"t": 78
								},
								{ "s": [83.19, 4.79], "t": 108 }
							]
						},
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.34, 0.23],
										[0.19, 0.41],
										[0, 0.56],
										[-0.2, 0.41],
										[-0.34, 0.22],
										[-0.44, 0],
										[-0.2, -0.11],
										[-0.11, -0.14],
										[-0.06, -0.1],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.11, -0.15],
										[0.21, -0.12],
										[0.34, 0],
										[0, 0]
									],
									"o": [
										[-0.44, 0],
										[-0.34, -0.22],
										[-0.19, -0.41],
										[0, -0.56],
										[0.19, -0.41],
										[0.34, -0.22],
										[0.34, 0],
										[0.2, 0.11],
										[0.11, 0.15],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, 0.1],
										[-0.11, 0.15],
										[-0.21, 0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.25, 5.51],
										[1.08, 5.17],
										[0.29, 4.21],
										[0, 2.74],
										[0.29, 1.28],
										[1.1, 0.33],
										[2.27, 0],
										[3.09, 0.17],
										[3.56, 0.56],
										[3.81, 0.92],
										[3.88, 0.92],
										[3.88, 0.07],
										[4.73, 0.07],
										[4.73, 5.4],
										[3.88, 5.4],
										[3.88, 4.57],
										[3.81, 4.57],
										[3.55, 4.94],
										[3.07, 5.34],
										[2.25, 5.51],
										[2.25, 5.51]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.22, 0.17],
										[-0.11, 0.3],
										[0, 0.4],
										[0.11, 0.3],
										[0.22, 0.16],
										[0.33, 0],
										[0.22, -0.17],
										[0.11, -0.3],
										[0, -0.37],
										[-0.12, -0.3],
										[-0.22, -0.18],
										[-0.34, 0],
										[0, 0]
									],
									"o": [
										[0.32, 0],
										[0.22, -0.17],
										[0.12, -0.3],
										[0, -0.4],
										[-0.11, -0.3],
										[-0.22, -0.16],
										[-0.33, 0],
										[-0.22, 0.17],
										[-0.11, 0.3],
										[0, 0.37],
										[0.12, 0.3],
										[0.22, 0.18],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.39, 4.74],
										[3.21, 4.49],
										[3.72, 3.78],
										[3.89, 2.74],
										[3.72, 1.7],
										[3.22, 1.02],
										[2.39, 0.77],
										[1.55, 1.03],
										[1.04, 1.73],
										[0.87, 2.74],
										[1.04, 3.75],
										[1.55, 4.47],
										[2.39, 4.74],
										[2.39, 4.74]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 50,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.36, 2.75] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [77.49, 4.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.37, 0.23],
										[0.2, 0.41],
										[0, 0.55],
										[-0.2, 0.42],
										[-0.36, 0.24],
										[-0.48, 0],
										[-0.28, -0.09],
										[-0.22, -0.21],
										[-0.13, -0.34],
										[0, -0.49],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.11, 0.27],
										[0.22, 0.16],
										[0.32, 0],
										[0.23, -0.16],
										[0.12, -0.25],
										[0, -0.29],
										[0, 0],
										[-0.14, -0.28],
										[-0.25, -0.14],
										[-0.32, 0],
										[-0.17, 0.06],
										[-0.12, 0.12],
										[-0.07, 0.18],
										[0, 0],
										[0.2, -0.2],
										[0.29, -0.12],
										[0.36, 0],
										[0, 0]
									],
									"o": [
										[-0.52, 0],
										[-0.37, -0.23],
										[-0.2, -0.41],
										[0, -0.55],
										[0.2, -0.42],
										[0.36, -0.24],
										[0.28, 0],
										[0.28, 0.09],
										[0.22, 0.21],
										[0.13, 0.34],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.35],
										[-0.11, -0.27],
										[-0.22, -0.16],
										[-0.32, 0],
										[-0.23, 0.16],
										[-0.12, 0.25],
										[0, 0],
										[0, 0.4],
										[0.14, 0.28],
										[0.25, 0.14],
										[0.21, 0],
										[0.17, -0.06],
										[0.12, -0.12],
										[0, 0],
										[-0.08, 0.27],
										[-0.2, 0.2],
										[-0.29, 0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.5, 5.51],
										[1.17, 5.16],
										[0.3, 4.21],
										[0, 2.77],
										[0.3, 1.33],
										[1.13, 0.35],
										[2.4, 0],
										[3.23, 0.14],
										[3.98, 0.59],
										[4.52, 1.41],
										[4.72, 2.66],
										[4.72, 3.02],
										[0.58, 3.02],
										[0.58, 2.29],
										[4.26, 2.29],
										[3.86, 2.56],
										[3.69, 1.63],
										[3.2, 0.99],
										[2.4, 0.76],
										[1.58, 0.99],
										[1.05, 1.61],
										[0.87, 2.42],
										[0.87, 2.9],
										[1.08, 3.9],
										[1.65, 4.53],
										[2.51, 4.74],
										[3.08, 4.65],
										[3.52, 4.38],
										[3.81, 3.92],
										[4.64, 4.15],
										[4.22, 4.85],
										[3.49, 5.33],
										[2.5, 5.5],
										[2.5, 5.51]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 51,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.91, 3.57] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [73.75, 3.9] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.2, 0.21],
										[0, 0.38],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, -0.1],
										[-0.18, 0],
										[-0.04, 0.01],
										[-0.04, 0.01],
										[0, 0],
										[0.11, -0.02],
										[0.12, 0]
									],
									"o": [
										[-0.4, 0],
										[-0.2, -0.21],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0.24],
										[0.06, 0.1],
										[0.09, 0],
										[0.05, -0.01],
										[0, 0],
										[-0.08, 0.02],
										[-0.11, 0.02],
										[0, 0]
									],
									"v": [
										[1.2, 7.14],
										[0.3, 6.82],
										[0, 5.92],
										[0, 0],
										[0.86, 0],
										[0.86, 5.7],
										[0.95, 6.22],
										[1.3, 6.37],
										[1.51, 6.36],
										[1.64, 6.34],
										[1.82, 7.06],
										[1.54, 7.12],
										[1.2, 7.14]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 52,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.35, 2.7] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [67.77, 4.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.25, 0.16],
										[-0.32, 0],
										[-0.09, 0],
										[-0.05, 0],
										[0, 0],
										[0.1, 0.01],
										[0.12, 0],
										[0.2, -0.11],
										[0.12, -0.19],
										[0, -0.24],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, -0.27],
										[0.25, -0.16],
										[0.06, 0],
										[0.09, 0],
										[0, 0],
										[-0.02, -0.01],
										[-0.1, -0.01],
										[-0.26, 0],
										[-0.2, 0.11],
										[-0.12, 0.18],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 5.4],
										[0, 0.08],
										[0.83, 0.08],
										[0.83, 0.9],
										[0.89, 0.9],
										[1.42, 0.24],
										[2.27, 0],
										[2.5, 0],
										[2.71, 0.01],
										[2.71, 0.88],
										[2.52, 0.85],
										[2.19, 0.83],
										[1.51, 0.99],
										[1.03, 1.43],
										[0.86, 2.07],
										[0.86, 5.4],
										[0, 5.4],
										[0, 5.4]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 53,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.43, 2.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [62.74, 4.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.36, 0.23],
										[0.2, 0.42],
										[0, 0.55],
										[-0.2, 0.42],
										[-0.36, 0.23],
										[-0.48, 0],
										[-0.36, -0.23],
										[-0.2, -0.41],
										[0, -0.56],
										[0.2, -0.41],
										[0.36, -0.23],
										[0.48, 0]
									],
									"o": [
										[-0.48, 0],
										[-0.36, -0.23],
										[-0.2, -0.41],
										[0, -0.55],
										[0.2, -0.42],
										[0.36, -0.23],
										[0.48, 0],
										[0.36, 0.23],
										[0.2, 0.42],
										[0, 0.56],
										[-0.2, 0.41],
										[-0.36, 0.23],
										[0, 0]
									],
									"v": [
										[2.43, 5.51],
										[1.16, 5.17],
										[0.3, 4.2],
										[0, 2.76],
										[0.3, 1.31],
										[1.16, 0.34],
										[2.43, 0],
										[3.7, 0.34],
										[4.56, 1.31],
										[4.86, 2.76],
										[4.56, 4.2],
										[3.7, 5.17],
										[2.43, 5.51]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.23, 0.18],
										[-0.11, 0.3],
										[0, 0.35],
										[0.11, 0.3],
										[0.23, 0.18],
										[0.36, 0],
										[0.23, -0.19],
										[0.11, -0.3],
										[0, -0.36],
										[-0.11, -0.3],
										[-0.23, -0.18],
										[-0.36, 0],
										[0, 0]
									],
									"o": [
										[0.36, 0],
										[0.23, -0.18],
										[0.11, -0.3],
										[0, -0.35],
										[-0.11, -0.3],
										[-0.23, -0.18],
										[-0.36, 0],
										[-0.23, 0.18],
										[-0.11, 0.3],
										[0, 0.36],
										[0.11, 0.3],
										[0.23, 0.18],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.43, 4.75],
										[3.32, 4.47],
										[3.83, 3.74],
										[4, 2.77],
										[3.83, 1.78],
										[3.32, 1.05],
										[2.43, 0.77],
										[1.55, 1.05],
										[1.04, 1.78],
										[0.88, 2.77],
										[1.04, 3.75],
										[1.55, 4.48],
										[2.43, 4.75],
										[2.43, 4.75]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 54,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.68, 3.72] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [58.26, 3.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.14, 2.11],
										[3.14, 2.84],
										[0, 2.84],
										[0, 2.11],
										[3.14, 2.11]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.14, 0.21],
										[-0.23, 0.1],
										[-0.26, 0],
										[-0.13, -0.03],
										[-0.06, -0.03],
										[0, 0],
										[0.07, 0.02],
										[0.12, 0],
										[0.12, -0.14],
										[0, -0.26],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, -0.31],
										[0.14, -0.21],
										[0.23, -0.1],
										[0.2, 0],
										[0.13, 0.03],
										[0, 0],
										[-0.04, -0.02],
										[-0.07, -0.02],
										[-0.26, 0],
										[-0.12, 0.14],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.05, 7.44],
										[1.05, 1.4],
										[1.26, 0.62],
										[1.83, 0.16],
										[2.56, 0],
										[3.06, 0.05],
										[3.36, 0.14],
										[3.12, 0.87],
										[2.94, 0.82],
										[2.66, 0.79],
										[2.08, 1],
										[1.9, 1.58],
										[1.9, 7.43],
										[1.04, 7.43],
										[1.05, 7.44]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 55,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.43, 2.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [50.81, 4.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.36, 0.23],
										[0.2, 0.42],
										[0, 0.55],
										[-0.2, 0.42],
										[-0.36, 0.23],
										[-0.48, 0],
										[-0.36, -0.23],
										[-0.2, -0.41],
										[0, -0.56],
										[0.2, -0.41],
										[0.36, -0.23],
										[0.48, 0]
									],
									"o": [
										[-0.48, 0],
										[-0.36, -0.23],
										[-0.2, -0.41],
										[0, -0.55],
										[0.2, -0.42],
										[0.36, -0.23],
										[0.48, 0],
										[0.36, 0.23],
										[0.2, 0.42],
										[0, 0.56],
										[-0.2, 0.41],
										[-0.36, 0.23],
										[0, 0]
									],
									"v": [
										[2.43, 5.51],
										[1.16, 5.17],
										[0.3, 4.2],
										[0, 2.76],
										[0.3, 1.31],
										[1.16, 0.34],
										[2.43, 0],
										[3.7, 0.34],
										[4.56, 1.31],
										[4.86, 2.76],
										[4.56, 4.2],
										[3.7, 5.17],
										[2.43, 5.51]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.23, 0.18],
										[-0.11, 0.3],
										[0, 0.35],
										[0.11, 0.3],
										[0.23, 0.18],
										[0.36, 0],
										[0.23, -0.19],
										[0.11, -0.3],
										[0, -0.36],
										[-0.11, -0.3],
										[-0.23, -0.18],
										[-0.36, 0],
										[0, 0]
									],
									"o": [
										[0.36, 0],
										[0.23, -0.18],
										[0.11, -0.3],
										[0, -0.35],
										[-0.11, -0.3],
										[-0.23, -0.18],
										[-0.36, 0],
										[-0.23, 0.18],
										[-0.11, 0.3],
										[0, 0.36],
										[0.11, 0.3],
										[0.23, 0.18],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.43, 4.75],
										[3.32, 4.47],
										[3.83, 3.74],
										[4, 2.77],
										[3.83, 1.78],
										[3.32, 1.05],
										[2.43, 0.77],
										[1.55, 1.05],
										[1.04, 1.78],
										[0.88, 2.77],
										[1.04, 3.75],
										[1.55, 4.48],
										[2.43, 4.75],
										[2.43, 4.75]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 56,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.52, 2.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [43.61, 4.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.16, 0.19],
										[-0.21, 0.1],
										[-0.23, 0],
										[-0.24, -0.24],
										[-0.07, -0.39],
										[0, 0],
										[-0.17, 0.2],
										[-0.24, 0.1],
										[-0.28, 0],
										[-0.26, -0.13],
										[-0.15, -0.27],
										[0, -0.41],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.22, 0.16],
										[0.28, 0],
										[0.17, -0.1],
										[0.09, -0.18],
										[0, -0.22],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.2, 0.18],
										[0.3, 0],
										[0.18, -0.1],
										[0.11, -0.19],
										[0, -0.28],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.07, -0.29],
										[0.16, -0.19],
										[0.21, -0.1],
										[0.39, 0],
										[0.24, 0.24],
										[0, 0],
										[0.06, -0.27],
										[0.17, -0.19],
										[0.24, -0.1],
										[0.31, 0],
										[0.26, 0.13],
										[0.15, 0.27],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.38],
										[-0.22, -0.16],
										[-0.24, 0],
										[-0.17, 0.1],
										[-0.09, 0.18],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.3],
										[-0.2, -0.18],
										[-0.21, 0],
										[-0.18, 0.1],
										[-0.11, 0.19],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 5.42],
										[0, 0.1],
										[0.84, 0.1],
										[0.84, 1.29],
										[0.78, 1.29],
										[1.12, 0.57],
										[1.67, 0.14],
										[2.33, 0],
										[3.27, 0.36],
										[3.74, 1.3],
										[3.62, 1.3],
										[3.97, 0.6],
										[4.58, 0.16],
										[5.36, 0],
										[6.21, 0.2],
										[6.82, 0.8],
										[7.04, 1.83],
										[7.04, 5.42],
										[6.19, 5.42],
										[6.19, 1.85],
										[5.86, 1.03],
										[5.11, 0.78],
										[4.5, 0.93],
										[4.1, 1.34],
										[3.96, 1.94],
										[3.96, 5.42],
										[3.1, 5.42],
										[3.1, 1.77],
										[2.8, 1.05],
										[2.05, 0.78],
										[1.47, 0.92],
										[1.03, 1.36],
										[0.86, 2.07],
										[0.86, 5.42],
										[0, 5.42],
										[0, 5.42]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 57,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.36, 2.75] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [36.5, 4.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.37, 0.23],
										[0.2, 0.41],
										[0, 0.55],
										[-0.2, 0.42],
										[-0.36, 0.24],
										[-0.48, 0],
										[-0.28, -0.09],
										[-0.22, -0.21],
										[-0.13, -0.34],
										[0, -0.49],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.11, 0.27],
										[0.22, 0.16],
										[0.32, 0],
										[0.23, -0.16],
										[0.12, -0.25],
										[0, -0.29],
										[0, 0],
										[-0.14, -0.28],
										[-0.25, -0.14],
										[-0.32, 0],
										[-0.17, 0.06],
										[-0.12, 0.12],
										[-0.06, 0.18],
										[0, 0],
										[0.2, -0.2],
										[0.29, -0.12],
										[0.36, 0],
										[0, 0]
									],
									"o": [
										[-0.52, 0],
										[-0.37, -0.23],
										[-0.2, -0.41],
										[0, -0.55],
										[0.2, -0.42],
										[0.36, -0.24],
										[0.28, 0],
										[0.28, 0.09],
										[0.22, 0.21],
										[0.13, 0.34],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.35],
										[-0.11, -0.27],
										[-0.22, -0.16],
										[-0.32, 0],
										[-0.23, 0.16],
										[-0.12, 0.25],
										[0, 0],
										[0, 0.4],
										[0.14, 0.28],
										[0.25, 0.14],
										[0.21, 0],
										[0.17, -0.06],
										[0.12, -0.12],
										[0, 0],
										[-0.08, 0.27],
										[-0.2, 0.2],
										[-0.29, 0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.5, 5.51],
										[1.17, 5.16],
										[0.3, 4.21],
										[0, 2.77],
										[0.3, 1.33],
										[1.13, 0.35],
										[2.4, 0],
										[3.23, 0.14],
										[3.98, 0.59],
										[4.52, 1.41],
										[4.72, 2.66],
										[4.72, 3.02],
										[0.58, 3.02],
										[0.58, 2.29],
										[4.26, 2.29],
										[3.86, 2.56],
										[3.69, 1.63],
										[3.2, 0.99],
										[2.4, 0.76],
										[1.58, 0.99],
										[1.05, 1.61],
										[0.87, 2.42],
										[0.87, 2.9],
										[1.08, 3.9],
										[1.65, 4.53],
										[2.51, 4.74],
										[3.08, 4.65],
										[3.52, 4.38],
										[3.81, 3.92],
										[4.64, 4.15],
										[4.22, 4.85],
										[3.48, 5.33],
										[2.5, 5.5],
										[2.5, 5.51]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 58,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.37, 3.61] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [30.53, 3.94] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.34, 0.23],
										[0.19, 0.41],
										[0, 0.56],
										[-0.19, 0.41],
										[-0.34, 0.22],
										[-0.44, 0],
										[-0.2, -0.12],
										[-0.11, -0.14],
										[-0.06, -0.1],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.11, -0.15],
										[0.2, -0.12],
										[0.34, 0],
										[0, 0]
									],
									"o": [
										[-0.44, 0],
										[-0.34, -0.22],
										[-0.19, -0.41],
										[0, -0.56],
										[0.19, -0.41],
										[0.34, -0.22],
										[0.35, 0],
										[0.2, 0.12],
										[0.11, 0.14],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, 0.1],
										[-0.11, 0.15],
										[-0.2, 0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.26, 7.22],
										[1.08, 6.88],
										[0.29, 5.92],
										[0, 4.45],
										[0.29, 2.99],
										[1.09, 2.04],
										[2.26, 1.71],
										[3.08, 1.88],
										[3.55, 2.27],
										[3.8, 2.63],
										[3.87, 2.63],
										[3.87, 0],
										[4.73, 0],
										[4.73, 7.1],
										[3.9, 7.1],
										[3.9, 6.28],
										[3.81, 6.28],
										[3.55, 6.65],
										[3.08, 7.04],
										[2.26, 7.22],
										[2.26, 7.22]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.22, 0.17],
										[-0.11, 0.3],
										[0, 0.4],
										[0.11, 0.3],
										[0.22, 0.16],
										[0.33, 0],
										[0.22, -0.18],
										[0.11, -0.3],
										[0, -0.37],
										[-0.11, -0.3],
										[-0.22, -0.18],
										[-0.33, 0]
									],
									"o": [
										[0.32, 0],
										[0.22, -0.17],
										[0.12, -0.3],
										[0, -0.4],
										[-0.11, -0.3],
										[-0.22, -0.16],
										[-0.33, 0],
										[-0.22, 0.18],
										[-0.11, 0.3],
										[0, 0.37],
										[0.11, 0.3],
										[0.22, 0.18],
										[0, 0]
									],
									"v": [
										[2.38, 6.45],
										[3.2, 6.2],
										[3.71, 5.49],
										[3.88, 4.44],
										[3.71, 3.41],
										[3.21, 2.72],
										[2.38, 2.48],
										[1.54, 2.74],
										[1.04, 3.45],
										[0.87, 4.45],
										[1.04, 5.46],
										[1.55, 6.18],
										[2.38, 6.45]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 59,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.52, 2.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [20.64, 4.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.16, 0.19],
										[-0.21, 0.1],
										[-0.23, 0],
										[-0.24, -0.24],
										[-0.07, -0.39],
										[0, 0],
										[-0.17, 0.2],
										[-0.24, 0.1],
										[-0.28, 0],
										[-0.26, -0.13],
										[-0.15, -0.27],
										[0, -0.41],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.22, 0.16],
										[0.28, 0],
										[0.17, -0.1],
										[0.09, -0.18],
										[0, -0.22],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.2, 0.18],
										[0.3, 0],
										[0.18, -0.1],
										[0.11, -0.19],
										[0, -0.28],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.07, -0.29],
										[0.16, -0.19],
										[0.21, -0.1],
										[0.39, 0],
										[0.24, 0.24],
										[0, 0],
										[0.06, -0.27],
										[0.17, -0.19],
										[0.24, -0.1],
										[0.31, 0],
										[0.26, 0.13],
										[0.15, 0.27],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.38],
										[-0.22, -0.16],
										[-0.24, 0],
										[-0.17, 0.1],
										[-0.09, 0.18],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.3],
										[-0.2, -0.18],
										[-0.21, 0],
										[-0.18, 0.1],
										[-0.11, 0.19],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 5.42],
										[0, 0.1],
										[0.84, 0.1],
										[0.84, 1.29],
										[0.78, 1.29],
										[1.12, 0.57],
										[1.67, 0.14],
										[2.33, 0],
										[3.27, 0.36],
										[3.74, 1.3],
										[3.62, 1.3],
										[3.97, 0.6],
										[4.58, 0.16],
										[5.36, 0],
										[6.21, 0.2],
										[6.82, 0.8],
										[7.04, 1.83],
										[7.04, 5.42],
										[6.19, 5.42],
										[6.19, 1.85],
										[5.86, 1.03],
										[5.11, 0.78],
										[4.5, 0.93],
										[4.1, 1.34],
										[3.96, 1.94],
										[3.96, 5.42],
										[3.1, 5.42],
										[3.1, 1.77],
										[2.8, 1.05],
										[2.05, 0.78],
										[1.47, 0.92],
										[1.03, 1.36],
										[0.86, 2.07],
										[0.86, 5.42],
										[0, 5.42],
										[0, 5.42]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 60,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.43, 2.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [13.44, 4.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.36, 0.23],
										[0.2, 0.42],
										[0, 0.55],
										[-0.2, 0.42],
										[-0.36, 0.23],
										[-0.48, 0],
										[-0.36, -0.23],
										[-0.2, -0.41],
										[0, -0.56],
										[0.2, -0.41],
										[0.36, -0.23],
										[0.48, 0]
									],
									"o": [
										[-0.48, 0],
										[-0.36, -0.23],
										[-0.2, -0.41],
										[0, -0.55],
										[0.2, -0.42],
										[0.36, -0.23],
										[0.48, 0],
										[0.36, 0.23],
										[0.2, 0.42],
										[0, 0.56],
										[-0.2, 0.41],
										[-0.36, 0.23],
										[0, 0]
									],
									"v": [
										[2.43, 5.51],
										[1.16, 5.17],
										[0.3, 4.2],
										[0, 2.76],
										[0.3, 1.31],
										[1.16, 0.34],
										[2.43, 0],
										[3.7, 0.34],
										[4.56, 1.31],
										[4.86, 2.76],
										[4.56, 4.2],
										[3.7, 5.17],
										[2.43, 5.51]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.23, 0.18],
										[-0.11, 0.3],
										[0, 0.35],
										[0.11, 0.3],
										[0.23, 0.18],
										[0.36, 0],
										[0.23, -0.19],
										[0.11, -0.3],
										[0, -0.36],
										[-0.11, -0.3],
										[-0.23, -0.18],
										[-0.36, 0],
										[0, 0]
									],
									"o": [
										[0.36, 0],
										[0.23, -0.18],
										[0.11, -0.3],
										[0, -0.35],
										[-0.11, -0.3],
										[-0.23, -0.18],
										[-0.36, 0],
										[-0.23, 0.19],
										[-0.11, 0.3],
										[0, 0.36],
										[0.11, 0.3],
										[0.23, 0.18],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.43, 4.75],
										[3.32, 4.47],
										[3.83, 3.74],
										[4, 2.77],
										[3.83, 1.78],
										[3.32, 1.05],
										[2.43, 0.77],
										[1.55, 1.05],
										[1.04, 1.78],
										[0.87, 2.77],
										[1.04, 3.75],
										[1.55, 4.48],
										[2.43, 4.75],
										[2.43, 4.75]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 61,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.43, 2.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [7.59, 4.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.36, 0.23],
										[0.2, 0.42],
										[0, 0.55],
										[-0.2, 0.42],
										[-0.36, 0.23],
										[-0.48, 0],
										[-0.36, -0.23],
										[-0.2, -0.41],
										[0, -0.56],
										[0.2, -0.41],
										[0.36, -0.23],
										[0.48, 0]
									],
									"o": [
										[-0.48, 0],
										[-0.36, -0.23],
										[-0.2, -0.41],
										[0, -0.55],
										[0.2, -0.42],
										[0.36, -0.23],
										[0.48, 0],
										[0.36, 0.23],
										[0.2, 0.42],
										[0, 0.56],
										[-0.2, 0.41],
										[-0.36, 0.23],
										[0, 0]
									],
									"v": [
										[2.43, 5.51],
										[1.16, 5.17],
										[0.3, 4.2],
										[0, 2.76],
										[0.3, 1.31],
										[1.16, 0.34],
										[2.43, 0],
										[3.7, 0.34],
										[4.56, 1.31],
										[4.86, 2.76],
										[4.56, 4.2],
										[3.7, 5.17],
										[2.43, 5.51]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.23, 0.18],
										[-0.11, 0.3],
										[0, 0.35],
										[0.11, 0.3],
										[0.23, 0.18],
										[0.36, 0],
										[0.23, -0.19],
										[0.11, -0.3],
										[0, -0.36],
										[-0.11, -0.3],
										[-0.23, -0.18],
										[-0.36, 0],
										[0, 0]
									],
									"o": [
										[0.36, 0],
										[0.23, -0.18],
										[0.11, -0.3],
										[0, -0.35],
										[-0.11, -0.3],
										[-0.23, -0.18],
										[-0.36, 0],
										[-0.23, 0.19],
										[-0.11, 0.3],
										[0, 0.36],
										[0.11, 0.3],
										[0.23, 0.18],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.43, 4.75],
										[3.32, 4.47],
										[3.83, 3.74],
										[4, 2.77],
										[3.83, 1.78],
										[3.32, 1.05],
										[2.43, 0.77],
										[1.55, 1.05],
										[1.04, 1.78],
										[0.87, 2.77],
										[1.04, 3.75],
										[1.55, 4.48],
										[2.43, 4.75],
										[2.43, 4.75]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 62,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.1, 3.55] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [2.1, 3.88] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 7.1],
										[0, 0],
										[0.91, 0],
										[0.91, 6.3],
										[4.2, 6.3],
										[4.2, 7.1],
										[0, 7.1],
										[0, 7.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.161, 0.165, 0.18] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 63,
					"parent": 42
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.38, 5.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [4.38, 30.86] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0.24, 0],
										[0, 0],
										[0, -0.23],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, -0.23],
										[0, 0],
										[-0.24, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.37, 8.7],
										[7.43, 10.05],
										[7.44, 1.66],
										[7.01, 1.25],
										[1.76, 1.24],
										[1.32, 1.66],
										[1.31, 10.04],
										[4.38, 8.7],
										[4.37, 8.7]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0.6],
										[0, 0],
										[-0.97, 0],
										[0, 0],
										[0, -0.92],
										[0, 0],
										[0.58, 0.26],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-0.58, 0.25],
										[0, 0],
										[0, -0.91],
										[0, 0],
										[0.96, 0],
										[0, 0],
										[0, 0.6],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.37, 10.07],
										[1.24, 11.43],
										[0, 10.68],
										[0.01, 1.65],
										[1.76, 0],
										[7.01, 0.01],
										[8.76, 1.66],
										[8.75, 10.7],
										[7.5, 11.44],
										[4.38, 10.07],
										[4.37, 10.07]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.58, 0.773, 0.282] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 64,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.54, 3.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [160.02, 31.05] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 65,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.54, 1.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [4.54, 1.42] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": false,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[4.53, 2.84],
										[9.07, 0]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 2,
							"lj": 2,
							"ml": 4,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.532],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.532],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.532],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.532],
										"t": 78
									},
									{ "s": [1.532], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.094, 0.408, 0.859] }
						}
					],
					"ind": 66,
					"parent": 65
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.54, 1.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [4.54, 5.09] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": false,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[4.54, 2.84],
										[9.07, 0]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 2,
							"lj": 2,
							"ml": 4,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.532],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.532],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.532],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.532],
										"t": 78
									},
									{ "s": [1.532], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.094, 0.408, 0.859] }
						}
					],
					"ind": 67,
					"parent": 65
				},
				{
					"ty": 4,
					"nm": "Frame 2087326864",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [107.5, 84] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [116.11, 84] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 68,
					"parent": 28
				},
				{
					"ty": 0,
					"nm": "Loom",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": true,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [95, 36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [107, 95] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"masksProperties": [
						{
							"nm": "",
							"inv": false,
							"mode": "a",
							"x": { "a": 0, "k": 0 },
							"o": { "a": 0, "k": 100 },
							"pt": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -1.1],
													[0, 0],
													[1.1, 0],
													[0, 0],
													[0, 1.1],
													[0, 0],
													[-1.1, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 1.1],
													[0, 0],
													[-1.1, 0],
													[0, 0],
													[0, -1.1],
													[0, 0],
													[1.1, 0]
												],
												"v": [
													[190, 2],
													[190, 70],
													[188, 72],
													[2, 72],
													[0, 70],
													[0, 2],
													[2, 0],
													[188, 0]
												]
											}
										],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -1.1],
													[0, 0],
													[1.1, 0],
													[0, 0],
													[0, 1.1],
													[0, 0],
													[-1.1, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 1.1],
													[0, 0],
													[-1.1, 0],
													[0, 0],
													[0, -1.1],
													[0, 0],
													[1.1, 0]
												],
												"v": [
													[190, 2],
													[190, 70],
													[188, 72],
													[2, 72],
													[0, 70],
													[0, 2],
													[2, 0],
													[188, 0]
												]
											}
										],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -1.1],
													[0, 0],
													[1.1, 0],
													[0, 0],
													[0, 1.1],
													[0, 0],
													[-1.1, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 1.1],
													[0, 0],
													[-1.1, 0],
													[0, 0],
													[0, -1.1],
													[0, 0],
													[1.1, 0]
												],
												"v": [
													[190, 2],
													[190, 70],
													[188, 72],
													[2, 72],
													[0, 70],
													[0, 2],
													[2, 0],
													[188, 0]
												]
											}
										],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -1.1],
													[0, 0],
													[1.1, 0],
													[0, 0],
													[0, 1.1],
													[0, 0],
													[-1.1, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 1.1],
													[0, 0],
													[-1.1, 0],
													[0, 0],
													[0, -1.1],
													[0, 0],
													[1.1, 0]
												],
												"v": [
													[190, 2],
													[190, 70],
													[188, 72],
													[2, 72],
													[0, 70],
													[0, 2],
													[2, 0],
													[188, 0]
												]
											}
										],
										"t": 78
									},
									{
										"s": [
											{
												"c": true,
												"i": [
													[0, -1.1],
													[0, 0],
													[1.1, 0],
													[0, 0],
													[0, 1.1],
													[0, 0],
													[-1.1, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 1.1],
													[0, 0],
													[-1.1, 0],
													[0, 0],
													[0, -1.1],
													[0, 0],
													[1.1, 0]
												],
												"v": [
													[190, 2],
													[190, 70],
													[188, 72],
													[2, 72],
													[0, 70],
													[0, 2],
													[2, 0],
													[188, 0]
												]
											}
										],
										"t": 108
									}
								]
							}
						}
					],
					"w": 968,
					"h": 568,
					"refId": "7",
					"ind": 69,
					"parent": 68
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [107.62, 69.45] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [107.13, 68.97] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -2.65],
										[0, 0],
										[-2.65, 0],
										[0, 0],
										[0, 2.65],
										[0, 0],
										[2.65, 0]
									],
									"o": [
										[0, 0],
										[-2.65, 0],
										[0, 0],
										[0, 2.65],
										[0, 0],
										[2.65, 0],
										[0, 0],
										[0, -2.65],
										[0, 0]
									],
									"v": [
										[210.43, 0],
										[4.8, 0],
										[0, 4.8],
										[0, 134.11],
										[4.8, 138.91],
										[210.43, 138.91],
										[215.23, 134.11],
										[215.23, 4.8],
										[210.43, 0]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 78
									},
									{ "s": [1], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.867, 0.871, 0.882] }
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 70,
					"parent": 68
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"bm": 1,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [107.62, 69.45] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [107.62, 76.67] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -3.71],
										[0, 0],
										[-2.41, 0],
										[0, 0],
										[0, 3.71],
										[0, 0],
										[2.41, 0]
									],
									"o": [
										[0, 0],
										[-2.41, 0],
										[0, 0],
										[0, 3.71],
										[0, 0],
										[2.41, 0],
										[0, 0],
										[0, -3.71],
										[0, 0]
									],
									"v": [
										[210.88, 0],
										[4.36, 0],
										[0, 6.71],
										[0, 132.19],
										[4.36, 138.9],
										[210.88, 138.9],
										[215.23, 132.19],
										[215.23, 6.71],
										[210.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.031, 0.059, 0.13] },
							"r": 1,
							"o": { "a": 0, "k": 10 }
						}
					],
					"ind": 71,
					"parent": 28
				},
				{
					"ty": 4,
					"nm": "Loom-Confluence Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [143, 114.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [143, 114.5] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 78
								},
								{ "s": [100], "t": 108 }
							]
						}
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[286, 0],
										[286, 229],
										[0, 229],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 72
				}
			]
		},
		{
			"id": "9c709431a159a33704f4280c2f65046d4be7785e",
			"e": 1,
			"w": 1144,
			"h": 1035,
			"p": "data:image/webp;base64,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",
			"u": ""
		},
		{
			"nm": "[Asset] clippath",
			"id": "5",
			"layers": [
				{
					"ty": 4,
					"nm": "Vector (Border)",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.2, 9.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [9.2, 9.2],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [9.2, 9.2],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [9.2, 9.2],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [9.2, 9.2],
									"t": 78
								},
								{ "s": [9.2, 9.2], "t": 108 }
							]
						},
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 5.081],
										[5.081, 0],
										[0, -5.081],
										[-5.081, 0]
									],
									"o": [
										[5.081, 0],
										[0, -5.081],
										[-5.081, 0],
										[0, 5.081],
										[0, 0]
									],
									"v": [
										[9.2, 18.4],
										[18.4, 9.2],
										[9.2, 0],
										[0, 9.2],
										[9.2, 18.4]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 2,
							"lj": 2,
							"ml": 1,
							"o": { "a": 0, "k": 0 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.4],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.4],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.4],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.4],
										"t": 78
									},
									{ "s": [0.4], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0, 0, 0] }
						}
					],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Vector (Mask)",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"td": 1,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [0, 0] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "gr",
							"nm": "",
							"it": [
								{
									"ty": "sh",
									"nm": "",
									"d": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 5.081],
															[5.081, 0],
															[0, -5.081],
															[-5.081, 0]
														],
														"o": [
															[5.081, 0],
															[0, -5.081],
															[-5.081, 0],
															[0, 5.081],
															[0, 0]
														],
														"v": [
															[9.2, 18.4],
															[18.4, 9.2],
															[9.2, 0],
															[0, 9.2],
															[9.2, 18.4]
														]
													}
												],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 5.081],
															[5.081, 0],
															[0, -5.081],
															[-5.081, 0]
														],
														"o": [
															[5.081, 0],
															[0, -5.081],
															[-5.081, 0],
															[0, 5.081],
															[0, 0]
														],
														"v": [
															[9.2, 18.4],
															[18.4, 9.2],
															[9.2, 0],
															[0, 9.2],
															[9.2, 18.4]
														]
													}
												],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 5.081],
															[5.081, 0],
															[0, -5.081],
															[-5.081, 0]
														],
														"o": [
															[5.081, 0],
															[0, -5.081],
															[-5.081, 0],
															[0, 5.081],
															[0, 0]
														],
														"v": [
															[9.2, 18.4],
															[18.4, 9.2],
															[9.2, 0],
															[0, 9.2],
															[9.2, 18.4]
														]
													}
												],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 5.081],
															[5.081, 0],
															[0, -5.081],
															[-5.081, 0]
														],
														"o": [
															[5.081, 0],
															[0, -5.081],
															[-5.081, 0],
															[0, 5.081],
															[0, 0]
														],
														"v": [
															[9.2, 18.4],
															[18.4, 9.2],
															[9.2, 0],
															[0, 9.2],
															[9.2, 18.4]
														]
													}
												],
												"t": 78
											},
											{
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 5.081],
															[5.081, 0],
															[0, -5.081],
															[-5.081, 0]
														],
														"o": [
															[5.081, 0],
															[0, -5.081],
															[-5.081, 0],
															[0, 5.081],
															[0, 0]
														],
														"v": [
															[9.2, 18.4],
															[18.4, 9.2],
															[9.2, 0],
															[0, 9.2],
															[9.2, 18.4]
														]
													}
												],
												"t": 108
											}
										]
									}
								},
								{
									"ty": "fl",
									"nm": "",
									"c": { "a": 0, "k": [1, 0, 0] },
									"r": 2,
									"o": { "a": 0, "k": 100 }
								},
								{
									"ty": "tr",
									"a": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [9.2, 9.2],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [9.2, 9.2],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [9.2, 9.2],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [9.2, 9.2],
												"t": 78
											},
											{ "s": [9.2, 9.2], "t": 108 }
										]
									},
									"s": { "a": 0, "k": [100, 100] },
									"sk": { "a": 0, "k": 0 },
									"p": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [9.2, 9.2],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [9.2, 9.2],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [9.2, 9.2],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [9.2, 9.2],
												"t": 78
											},
											{ "s": [9.2, 9.2], "t": 108 }
										]
									},
									"r": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 78
											},
											{ "s": [0], "t": 108 }
										]
									},
									"sa": { "a": 0, "k": 0 },
									"o": { "a": 0, "k": 100 }
								}
							]
						}
					],
					"ind": 2
				},
				{
					"ty": 2,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"tt": 1,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [128, 128] },
						"s": { "a": 0, "k": [7.187, 7.187] },
						"sk": { "a": 0, "k": 0 },
						"p": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [9.2, 9.2],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [9.2, 9.2],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [9.2, 9.2],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [9.2, 9.2],
									"t": 78
								},
								{ "s": [9.2, 9.2], "t": 108 }
							]
						},
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"refId": "7f12ea1300756f144a0fb5daaf68dbfc01103a46",
					"ind": 3
				}
			]
		},
		{
			"id": "7f12ea1300756f144a0fb5daaf68dbfc01103a46",
			"e": 1,
			"w": 256,
			"h": 256,
			"p": "data:image/webp;base64,UklGRloBAABXRUJQVlA4IE4BAABQFQCdASoAAQABPmUokEWkIqGeGAwAQAZEtLdwGDPDNAvAH4AdAqwSwTgHwBeAGL6yYIBTYkm7rFcLlBNtjsQklA7cAsXivizvALF4r4WMjRAqkmXrsWXdivhYvFfDASZeuxXwsXqzGeFi8V8LKtD67FfCxeNlA7cAsXivizvALF4r4WMjRAqkmXrsWXdivhYvFfDASZeuxXwsXqzGeFi8V8LKtD67FfCxeNlA7cAsXivfgAD++5qrPr0+mVn16fTKz6/cd0gHJfdbrewX6kA5L7rdbr/uMHEA5L7rdb2C/UgHJfdbrdf9xg4gHJfdbrewX6kA5L7rdbr/uMHEA5L7rdb2C/UgHJfdbrdf9xg4gHJfdbrewX6kA5L7rdbr/uMHEA5L7rdb2C/UgHJfdbrdf9xg4gHJfdbrewX6kA5L7rdbr/uMHEA5L7rdboAA",
			"u": ""
		},
		{
			"nm": "[Asset] Loom",
			"id": "7",
			"layers": [
				{
					"ty": 4,
					"nm": "Group 2018775846",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12, 12.1] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [95.14, 51.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 60 }
					},
					"shapes": [],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12, 12.1] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [12, 12.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 2,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.56, 4.18] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [12.59, 12.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.47, 0.29],
										[0, 0],
										[0.43, 0.27],
										[0, 0],
										[0, -0.53]
									],
									"o": [
										[0, 0],
										[0, 0.53],
										[0, 0],
										[0.43, -0.26],
										[0, 0],
										[-0.47, -0.29],
										[0, 0]
									],
									"v": [
										[0, 0.68],
										[0, 7.69],
										[1.08, 8.25],
										[6.79, 4.75],
										[6.79, 3.61],
										[1.08, 0.11],
										[0, 0.68]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.26, 11.35] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [12, 12.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -6.27],
										[0, 0],
										[-6.22, 0],
										[0, 0],
										[0, 6.27],
										[0, 0],
										[6.22, 0]
									],
									"o": [
										[0, 0],
										[-6.22, 0],
										[0, 0],
										[0, 6.27],
										[0, 0],
										[6.22, 0],
										[0, 0],
										[0, -6.27],
										[0, 0]
									],
									"v": [
										[11.26, 0],
										[11.26, 0],
										[0, 11.35],
										[0, 11.35],
										[11.26, 22.7],
										[11.26, 22.7],
										[22.52, 11.35],
										[22.52, 11.35],
										[11.26, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.063, 0.071, 0.079] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 4,
					"parent": 1
				},
				{
					"ty": 0,
					"nm": "Emoji",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.92, 1.92] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [118.22, 72.13] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"w": 968,
					"h": 568,
					"refId": "8",
					"ind": 5
				},
				{
					"ty": 0,
					"nm": "Frame",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": true,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [83.5, 53.14] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [94.5, 60.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [
						{
							"ty": 25,
							"nm": "",
							"en": 1,
							"ef": [
								{
									"ty": 2,
									"nm": "color",
									"v": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0.118, 0.122, 0.13, 0.16],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0.118, 0.122, 0.13, 0.16],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0.118, 0.122, 0.13, 0.16],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0.118, 0.122, 0.13, 0.16],
												"t": 78
											},
											{
												"s": [0.118, 0.122, 0.13, 0.16],
												"t": 108
											}
										]
									}
								},
								{
									"ty": 0,
									"nm": "opacity",
									"v": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [40.96],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [40.96],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [40.96],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [40.96],
												"t": 78
											},
											{ "s": [40.96], "t": 108 }
										]
									}
								},
								{
									"ty": 1,
									"nm": "angle",
									"v": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [90],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [90],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [90],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [90],
												"t": 78
											},
											{ "s": [90], "t": 108 }
										]
									}
								},
								{
									"ty": 0,
									"nm": "distance",
									"v": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 78
											},
											{ "s": [0], "t": 108 }
										]
									}
								},
								{
									"ty": 0,
									"nm": "blur",
									"v": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [8.5],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [8.5],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [8.5],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [8.5],
												"t": 78
											},
											{ "s": [8.5], "t": 108 }
										]
									}
								}
							]
						},
						{
							"ty": 25,
							"nm": "",
							"en": 1,
							"ef": [
								{
									"ty": 2,
									"nm": "color",
									"v": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0.118, 0.122, 0.13, 0.12],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0.118, 0.122, 0.13, 0.12],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0.118, 0.122, 0.13, 0.12],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0.118, 0.122, 0.13, 0.12],
												"t": 78
											},
											{
												"s": [0.118, 0.122, 0.13, 0.12],
												"t": 108
											}
										]
									}
								},
								{
									"ty": 0,
									"nm": "opacity",
									"v": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [30.72],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [30.72],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [30.72],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [30.72],
												"t": 78
											},
											{ "s": [30.72], "t": 108 }
										]
									}
								},
								{
									"ty": 1,
									"nm": "angle",
									"v": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [90],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [90],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [90],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [90],
												"t": 78
											},
											{ "s": [90], "t": 108 }
										]
									}
								},
								{
									"ty": 0,
									"nm": "distance",
									"v": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 78
											},
											{ "s": [0], "t": 108 }
										]
									}
								},
								{
									"ty": 0,
									"nm": "blur",
									"v": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.06],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.06],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.06],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.06],
												"t": 78
											},
											{ "s": [1.06], "t": 108 }
										]
									}
								}
							]
						}
					],
					"masksProperties": [
						{
							"nm": "",
							"inv": false,
							"mode": "a",
							"x": { "a": 0, "k": 0 },
							"o": { "a": 0, "k": 100 },
							"pt": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -2.79],
													[0, 0],
													[2.79, 0],
													[0, 0],
													[0, 2.79],
													[0, 0],
													[-2.79, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 2.79],
													[0, 0],
													[-2.79, 0],
													[0, 0],
													[0, -2.79],
													[0, 0],
													[2.79, 0]
												],
												"v": [
													[167, 5.06],
													[167, 101.21],
													[161.94, 106.27],
													[5.06, 106.27],
													[0, 101.21],
													[0, 5.06],
													[5.06, 0],
													[161.94, 0]
												]
											}
										],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -2.79],
													[0, 0],
													[2.79, 0],
													[0, 0],
													[0, 2.79],
													[0, 0],
													[-2.79, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 2.79],
													[0, 0],
													[-2.79, 0],
													[0, 0],
													[0, -2.79],
													[0, 0],
													[2.79, 0]
												],
												"v": [
													[167, 5.06],
													[167, 101.21],
													[161.94, 106.27],
													[5.06, 106.27],
													[0, 101.21],
													[0, 5.06],
													[5.06, 0],
													[161.94, 0]
												]
											}
										],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -2.79],
													[0, 0],
													[2.79, 0],
													[0, 0],
													[0, 2.79],
													[0, 0],
													[-2.79, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 2.79],
													[0, 0],
													[-2.79, 0],
													[0, 0],
													[0, -2.79],
													[0, 0],
													[2.79, 0]
												],
												"v": [
													[167, 5.06],
													[167, 101.21],
													[161.94, 106.27],
													[5.06, 106.27],
													[0, 101.21],
													[0, 5.06],
													[5.06, 0],
													[161.94, 0]
												]
											}
										],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -2.79],
													[0, 0],
													[2.79, 0],
													[0, 0],
													[0, 2.79],
													[0, 0],
													[-2.79, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 2.79],
													[0, 0],
													[-2.79, 0],
													[0, 0],
													[0, -2.79],
													[0, 0],
													[2.79, 0]
												],
												"v": [
													[167, 5.06],
													[167, 101.21],
													[161.94, 106.27],
													[5.06, 106.27],
													[0, 101.21],
													[0, 5.06],
													[5.06, 0],
													[161.94, 0]
												]
											}
										],
										"t": 78
									},
									{
										"s": [
											{
												"c": true,
												"i": [
													[0, -2.79],
													[0, 0],
													[2.79, 0],
													[0, 0],
													[0, 2.79],
													[0, 0],
													[-2.79, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 2.79],
													[0, 0],
													[-2.79, 0],
													[0, 0],
													[0, -2.79],
													[0, 0],
													[2.79, 0]
												],
												"v": [
													[167, 5.06],
													[167, 101.21],
													[161.94, 106.27],
													[5.06, 106.27],
													[0, 101.21],
													[0, 5.06],
													[5.06, 0],
													[161.94, 0]
												]
											}
										],
										"t": 108
									}
								]
							}
						}
					],
					"w": 968,
					"h": 568,
					"refId": "10",
					"ind": 6
				},
				{
					"ty": 4,
					"nm": "Loom Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [95, 36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [95, 36] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -1.1],
										[0, 0],
										[1.1, 0],
										[0, 0],
										[0, 1.1],
										[0, 0],
										[-1.1, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 1.1],
										[0, 0],
										[-1.1, 0],
										[0, 0],
										[0, -1.1],
										[0, 0],
										[1.1, 0]
									],
									"v": [
										[190, 2],
										[190, 70],
										[188, 72],
										[2, 72],
										[0, 70],
										[0, 2],
										[2, 0],
										[188, 0]
									]
								}
							}
						},
						{
							"ty": "gf",
							"nm": "",
							"e": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [6.4, -120.44],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [6.4, -120.44],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [6.4, -120.44],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [6.4, -120.44],
										"t": 78
									},
									{ "s": [6.4, -120.44], "t": 108 }
								]
							},
							"g": {
								"p": 2,
								"k": {
									"a": 0,
									"k": [0, 0.933, 0.843, 0.988, 1, 0.847, 0.627, 0.969]
								}
							},
							"t": 1,
							"a": { "a": 0, "k": 0 },
							"h": { "a": 0, "k": 0 },
							"s": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [91.6, -51.02],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [91.6, -51.02],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [91.6, -51.02],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [91.6, -51.02],
										"t": 78
									},
									{ "s": [91.6, -51.02], "t": 108 }
								]
							},
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 7
				}
			]
		},
		{
			"nm": "[Asset] Emoji",
			"id": "8",
			"layers": [
				{
					"ty": 4,
					"nm": "image 4 (Border)",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.924, 1.924] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1.924, 1.924] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[3.847, 0],
										[3.847, 3.847],
										[0, 3.847],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 2,
							"lj": 2,
							"ml": 1,
							"o": { "a": 0, "k": 0 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.175],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.175],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.175],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.175],
										"t": 78
									},
									{ "s": [0.175], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0, 0, 0] }
						}
					],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "image 4 (Mask)",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"td": 1,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [0, 0] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "gr",
							"nm": "",
							"it": [
								{
									"ty": "sh",
									"nm": "",
									"d": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[3.847, 0],
															[3.847, 3.847],
															[0, 3.847],
															[0, 0]
														]
													}
												],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[3.847, 0],
															[3.847, 3.847],
															[0, 3.847],
															[0, 0]
														]
													}
												],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[3.847, 0],
															[3.847, 3.847],
															[0, 3.847],
															[0, 0]
														]
													}
												],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[3.847, 0],
															[3.847, 3.847],
															[0, 3.847],
															[0, 0]
														]
													}
												],
												"t": 78
											},
											{
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[3.847, 0],
															[3.847, 3.847],
															[0, 3.847],
															[0, 0]
														]
													}
												],
												"t": 108
											}
										]
									}
								},
								{
									"ty": "fl",
									"nm": "",
									"c": { "a": 0, "k": [1, 0, 0] },
									"r": 2,
									"o": { "a": 0, "k": 100 }
								},
								{
									"ty": "tr",
									"a": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.924, 1.924],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.924, 1.924],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.924, 1.924],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.924, 1.924],
												"t": 78
											},
											{ "s": [1.924, 1.924], "t": 108 }
										]
									},
									"s": { "a": 0, "k": [100, 100] },
									"sk": { "a": 0, "k": 0 },
									"p": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.924, 1.924],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.924, 1.924],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.924, 1.924],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [1.924, 1.924],
												"t": 78
											},
											{ "s": [1.924, 1.924], "t": 108 }
										]
									},
									"r": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 78
											},
											{ "s": [0], "t": 108 }
										]
									},
									"sa": { "a": 0, "k": 0 },
									"o": { "a": 0, "k": 100 }
								}
							]
						}
					],
					"ind": 2
				},
				{
					"ty": 2,
					"nm": "image 4",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"tt": 1,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [42, 42] },
						"s": { "a": 0, "k": [4.58, 4.58] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1.924, 1.924] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 0 }
					},
					"refId": "8b1b606e858c9ca515012345c6eed8320d6185b8",
					"ind": 3
				},
				{
					"ty": 4,
					"nm": "Emoji Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.92, 1.92] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1.92, 1.92] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.85, 0],
										[3.85, 3.85],
										[0, 3.85],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 4
				}
			]
		},
		{
			"id": "8b1b606e858c9ca515012345c6eed8320d6185b8",
			"e": 1,
			"w": 84,
			"h": 84,
			"p": "data:image/webp;base64,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",
			"u": ""
		},
		{
			"nm": "[Asset] Frame",
			"id": "10",
			"layers": [
				{
					"ty": 4,
					"nm": "UI Collage/telepointer",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.94, 9.49] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [96.98, 26.75] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Cursor box",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.74, 9.49] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [27.15, 9.49] },
						"r": { "a": 0, "k": -180 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 2,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Cursor",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.31, 3.39] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [4.74, 4.74] },
						"r": { "a": 0, "k": -45 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 6.78],
										[3.32, 0],
										[6.63, 6.78],
										[3.31, 5.67],
										[0, 6.78]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.094, 0.408, 0.859] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3,
					"parent": 2
				},
				{
					"ty": 0,
					"nm": "@ user tag",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.21, 4.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [11.21, 4.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"w": 968,
					"h": 568,
					"refId": "11",
					"ind": 4,
					"parent": 1
				},
				{
					"ty": 0,
					"nm": "Purple Sticky Note",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.18, 17.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [130.67, 41.9] },
						"r": { "a": 0, "k": 6.52 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"w": 968,
					"h": 568,
					"refId": "12",
					"ind": 5
				},
				{
					"ty": 0,
					"nm": "Green Sticky Note",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.18, 17.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [63.27, 76.95] },
						"r": { "a": 0, "k": 3.07 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"w": 968,
					"h": 568,
					"refId": "13",
					"ind": 6
				},
				{
					"ty": 0,
					"nm": "Yellow Sticky Note",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.18, 17.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [36.43, 31.63] },
						"r": { "a": 0, "k": -5.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"w": 968,
					"h": 568,
					"refId": "15",
					"ind": 7
				},
				{
					"ty": 0,
					"nm": "Frame 2087326861",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": true,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [76.05, 45.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [83.52, 54.19] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"masksProperties": [
						{
							"nm": "",
							"inv": false,
							"mode": "a",
							"x": { "a": 0, "k": 0 },
							"o": { "a": 0, "k": 100 },
							"pt": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"v": [
													[152.1, 0],
													[152.1, 91],
													[0, 91],
													[0, 0]
												]
											}
										],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"v": [
													[152.1, 0],
													[152.1, 91],
													[0, 91],
													[0, 0]
												]
											}
										],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"v": [
													[152.1, 0],
													[152.1, 91],
													[0, 91],
													[0, 0]
												]
											}
										],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"v": [
													[152.1, 0],
													[152.1, 91],
													[0, 91],
													[0, 0]
												]
											}
										],
										"t": 78
									},
									{
										"s": [
											{
												"c": true,
												"i": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"v": [
													[152.1, 0],
													[152.1, 91],
													[0, 91],
													[0, 0]
												]
											}
										],
										"t": 108
									}
								]
							}
						}
					],
					"w": 968,
					"h": 568,
					"refId": "16",
					"ind": 8
				},
				{
					"ty": 4,
					"nm": "Frame Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [83.5, 53.14] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [83.5, 53.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -2.79],
										[0, 0],
										[2.79, 0],
										[0, 0],
										[0, 2.79],
										[0, 0],
										[-2.79, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 2.79],
										[0, 0],
										[-2.79, 0],
										[0, 0],
										[0, -2.79],
										[0, 0],
										[2.79, 0]
									],
									"v": [
										[167, 5.06],
										[167, 101.21],
										[161.94, 106.27],
										[5.06, 106.27],
										[0, 101.21],
										[0, 5.06],
										[5.06, 0],
										[161.94, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 9
				}
			]
		},
		{
			"nm": "[Asset] @ user tag",
			"id": "11",
			"layers": [
				{
					"ty": 4,
					"nm": "Line",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.59, 0.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [11.21, 4.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[15.18, 0],
										[15.18, 1.27],
										[0, 1.27],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "@ user tag Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.21, 4.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [11.21, 4.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -2.34],
										[0, 0],
										[2.34, 0],
										[0, 0],
										[0, 2.34],
										[0, 0],
										[-2.34, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 2.34],
										[0, 0],
										[-2.34, 0],
										[0, 0],
										[0, -2.34],
										[0, 0],
										[2.34, 0]
									],
									"v": [
										[22.41, 4.25],
										[22.41, 4.25],
										[18.16, 8.49],
										[4.25, 8.49],
										[0, 4.25],
										[0, 4.25],
										[4.25, 0],
										[18.16, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.094, 0.408, 0.859] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 2
				}
			]
		},
		{
			"nm": "[Asset] Purple Sticky Note",
			"id": "12",
			"layers": [
				{
					"ty": 4,
					"nm": "Text",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.39, 7.59] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [15.18, 11.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Line",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.33, 1.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [6.33, 13.92] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[12.65, 0],
										[12.65, 2.53],
										[0, 2.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.788, 0.486, 0.957] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 2,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Line",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [8.86, 1.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [8.86, 7.59] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[17.71, 0],
										[17.71, 2.53],
										[0, 2.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.788, 0.486, 0.957] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Line",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [8.22, 1.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [8.22, 1.27] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 0 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[16.45, 0],
										[16.45, 2.53],
										[0, 2.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.788, 0.486, 0.957] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 4,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Purple Sticky Note Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.18, 17.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [15.18, 17.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.36, 0],
										[30.36, 35.42],
										[0, 35.42],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.933, 0.843, 0.988] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 5
				}
			]
		},
		{
			"nm": "[Asset] Green Sticky Note",
			"id": "13",
			"layers": [
				{
					"ty": 0,
					"nm": "Gestural Line/scribble 15",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": true,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.39, 3.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [15.18, 9.74] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"masksProperties": [
						{
							"nm": "",
							"inv": false,
							"mode": "a",
							"x": { "a": 0, "k": 0 },
							"o": { "a": 0, "k": 100 },
							"pt": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"v": [
													[22.77, 0],
													[22.77, 6.83],
													[0, 6.83],
													[0, 0]
												]
											}
										],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"v": [
													[22.77, 0],
													[22.77, 6.83],
													[0, 6.83],
													[0, 0]
												]
											}
										],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"v": [
													[22.77, 0],
													[22.77, 6.83],
													[0, 6.83],
													[0, 0]
												]
											}
										],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"v": [
													[22.77, 0],
													[22.77, 6.83],
													[0, 6.83],
													[0, 0]
												]
											}
										],
										"t": 78
									},
									{
										"s": [
											{
												"c": true,
												"i": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0]
												],
												"v": [
													[22.77, 0],
													[22.77, 6.83],
													[0, 6.83],
													[0, 0]
												]
											}
										],
										"t": 108
									}
								]
							}
						}
					],
					"w": 968,
					"h": 568,
					"refId": "14",
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Green Sticky Note Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.18, 17.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [15.18, 17.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.36, 0],
										[30.36, 35.42],
										[0, 35.42],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.828, 0.945, 0.655] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 2
				}
			]
		},
		{
			"nm": "[Asset] Gestural Line/scribble 15",
			"id": "14",
			"layers": [
				{
					"ty": 4,
					"nm": "Group 6272481",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.32, 3.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [11.41, 3.42] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Layer_1-2",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.32, 3.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [11.31, 3.42] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 2,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.26, 0.36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [8.44, 6.47] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.37, -0.05],
										[-0.71, -0.02],
										[-0.54, -0.02],
										[-0.37, -0.03],
										[-0.06, 0],
										[-1.49, -0.05],
										[-0.34, -0.01],
										[-0.58, 0.02],
										[0.35, 0.07],
										[0.81, 0.03],
										[0.92, 0.03],
										[0.15, -0.01],
										[0, 0],
										[1.05, 0.02],
										[0.23, 0.01],
										[0.52, -0.02],
										[0, 0]
									],
									"o": [
										[-0.37, 0.01],
										[0.53, 0.07],
										[0.8, 0.01],
										[0.92, 0.02],
										[0.06, 0],
										[0.4, 0],
										[1.05, 0.02],
										[0.8, 0.02],
										[0.29, 0],
										[-0.59, -0.09],
										[-0.31, -0.01],
										[-0.15, -0.01],
										[-1.29, 0.06],
										[0, 0],
										[-0.79, -0.02],
										[-0.71, -0.02],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.29, 0.02],
										[0.27, 0.36],
										[2.05, 0.49],
										[3.6, 0.45],
										[6.44, 0.61],
										[6.61, 0.61],
										[10.24, 0.65],
										[12.28, 0.7],
										[14.28, 0.7],
										[14.3, 0.39],
										[12.3, 0.23],
										[10.41, 0.1],
										[9.96, 0.1],
										[7.01, 0.11],
										[3.47, 0.04],
										[2.07, 0.01],
										[0.29, 0.02],
										[0.29, 0.02]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.416, 0.604, 0.137] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.32, 1.73] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [11.31, 1.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.03, -0.06],
										[0.01, -0.05],
										[-0.03, -0.02],
										[-0.08, 0.06],
										[-0.05, 0.05],
										[-0.06, 0.07],
										[-0.09, 0.1],
										[-0.1, 0.09],
										[-0.23, 0.17],
										[-0.65, 0.25],
										[-0.09, 0.03],
										[-0.08, 0.02],
										[-0.07, 0.02],
										[-0.06, 0.01],
										[-0.18, -0.04],
										[-0.09, -0.13],
										[0.06, -0.25],
										[0.09, -0.27],
										[0.01, -0.17],
										[-0.02, -0.09],
										[-0.04, -0.08],
										[-0.18, -0.07],
										[-0.17, 0.01],
										[-0.27, 0.17],
										[-0.19, 0.18],
										[-0.16, 0.15],
										[-0.15, 0.1],
										[-0.09, 0.05],
										[-0.2, 0.07],
										[-0.13, 0.01],
										[-0.03, 0],
										[-0.04, 0],
										[-0.03, 0],
										[-0.04, -0.01],
										[-0.14, -0.11],
										[-0.03, -0.03],
										[-0.02, -0.04],
										[-0.03, -0.09],
										[0.01, -0.09],
										[0.05, -0.14],
										[0.02, -0.09],
										[0, -0.06],
										[-0.01, -0.05],
										[-0.07, -0.11],
										[-0.06, -0.05],
										[-0.07, -0.02],
										[-0.12, 0.05],
										[-0.09, 0.08],
										[-0.07, 0.08],
										[-0.09, 0.08],
										[-0.25, 0.13],
										[-0.28, 0.07],
										[-0.23, 0.02],
										[-0.21, 0],
										[-0.34, -0.05],
										[-0.34, -0.07],
										[-0.69, 0],
										[-0.59, 0.24],
										[-0.06, 0.03],
										[-0.03, 0.03],
										[0.02, 0.03],
										[0.08, -0.01],
										[0.06, -0.01],
										[0.08, -0.03],
										[0.65, 0.03],
										[0.81, 0.17],
										[0.65, 0.13],
										[0.42, 0.03],
										[0.49, -0.09],
										[0.3, -0.13],
										[0.32, -0.29],
										[0, 0],
										[0, 0],
										[0.06, -0.07],
										[0.05, -0.03],
										[0.02, 0],
										[0.01, 0],
										[0.01, 0.01],
										[0.01, 0.03],
										[0, 0.04],
										[0, 0.02],
										[-0.01, 0.02],
										[-0.04, 0.12],
										[-0.01, 0.07],
										[-0.01, 0.03],
										[0, 0],
										[0, 0],
										[0, 0.03],
										[0, 0.03],
										[0.02, 0.06],
										[0.07, 0.09],
										[0.16, 0.1],
										[0.15, 0.04],
										[0.04, 0.01],
										[0.03, 0],
										[0.06, 0],
										[0.04, 0],
										[0.03, 0],
										[0.01, 0],
										[0, 0],
										[0.15, -0.04],
										[0.24, -0.14],
										[0.26, -0.24],
										[0.27, -0.26],
										[0.15, -0.12],
										[0.07, -0.05],
										[0.08, -0.03],
										[0.16, 0],
										[0.06, 0.02],
										[0.05, 0.05],
										[-0.01, 0.15],
										[-0.05, 0.16],
										[0, 0.33],
										[0.16, 0.17],
										[0.17, 0.05],
										[0.24, -0.04],
										[0.1, -0.03],
										[0.08, -0.03],
										[0.07, -0.02],
										[0.06, -0.02],
										[0.48, -0.39],
										[0.19, -0.21],
										[0.09, -0.11],
										[0.08, -0.11],
										[0, 0]
									],
									"o": [
										[-0.06, 0.08],
										[-0.03, 0.07],
										[-0.03, 0.1],
										[0.03, 0.02],
										[0.04, -0.03],
										[0.05, -0.05],
										[0.08, -0.1],
										[0.09, -0.09],
										[0.19, -0.19],
										[0.46, -0.34],
										[0.09, -0.04],
										[0.09, -0.03],
										[0.08, -0.02],
										[0.07, -0.02],
										[0.26, -0.04],
										[0.18, 0.04],
										[0.09, 0.13],
										[-0.05, 0.21],
										[-0.04, 0.14],
										[-0.01, 0.08],
										[0.02, 0.09],
										[0.09, 0.16],
										[0.18, 0.08],
										[0.34, -0.03],
										[0.25, -0.17],
										[0.2, -0.18],
										[0.31, -0.3],
										[0.09, -0.06],
										[0.1, -0.06],
										[0.1, -0.03],
										[0.03, 0],
										[0.03, 0],
										[0.03, 0],
										[0.03, 0.01],
										[0.14, 0.04],
										[0.04, 0.03],
										[0.03, 0.03],
										[0.06, 0.07],
										[0.03, 0.09],
										[-0.01, 0.09],
										[-0.03, 0.07],
										[-0.01, 0.04],
										[0, 0.05],
										[0.01, 0.11],
										[0.03, 0.05],
										[0.06, 0.04],
										[0.1, 0.03],
										[0.12, -0.05],
										[0.09, -0.08],
										[0.07, -0.08],
										[0.19, -0.16],
										[0.25, -0.13],
										[0.25, -0.07],
										[0.23, -0.03],
										[0.42, 0.01],
										[0.67, 0.11],
										[0.81, 0.17],
										[0.69, 0],
										[0.08, -0.04],
										[0.06, -0.03],
										[0.07, -0.06],
										[-0.02, -0.03],
										[-0.04, 0.01],
										[-0.06, 0.01],
										[-0.56, 0.17],
										[-0.65, -0.03],
										[-0.31, -0.06],
										[-0.33, -0.06],
										[-0.42, -0.02],
										[-0.32, 0.06],
										[-0.37, 0.17],
										[0, 0],
										[0, 0],
										[-0.07, 0.08],
										[-0.06, 0.07],
										[-0.03, 0.02],
										[-0.02, 0],
										[-0.01, 0],
										[-0.01, -0.02],
										[-0.01, -0.03],
										[0, -0.02],
										[0, -0.02],
										[0.02, -0.09],
										[0.02, -0.06],
										[0.01, -0.03],
										[0, 0],
										[0, 0],
										[0, -0.03],
										[0, -0.03],
										[-0.01, -0.07],
										[-0.04, -0.12],
										[-0.13, -0.19],
										[-0.16, -0.1],
										[-0.04, -0.01],
										[-0.04, 0],
										[-0.07, -0.01],
										[-0.05, 0],
										[-0.04, 0],
										[-0.03, 0],
										[-0.01, 0],
										[0, 0],
										[-0.15, 0.04],
										[-0.24, 0.14],
										[-0.26, 0.23],
										[-0.14, 0.13],
										[-0.07, 0.06],
										[-0.07, 0.05],
										[-0.16, 0.07],
										[-0.08, 0],
										[-0.06, -0.03],
										[-0.09, -0.1],
										[0.01, -0.15],
										[0.11, -0.32],
										[0, -0.25],
										[-0.16, -0.17],
										[-0.35, -0.09],
										[-0.12, 0.02],
										[-0.1, 0.03],
										[-0.08, 0.03],
										[-0.07, 0.02],
										[-0.7, 0.27],
										[-0.24, 0.2],
										[-0.1, 0.1],
										[-0.09, 0.11],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.22, 2.61],
										[0.08, 2.83],
										[0.02, 3],
										[0.03, 3.18],
										[0.2, 3.12],
										[0.33, 3],
										[0.49, 2.82],
										[0.75, 2.52],
										[1.03, 2.24],
										[1.67, 1.7],
										[3.32, 0.78],
										[3.59, 0.68],
										[3.83, 0.6],
										[4.06, 0.53],
										[4.25, 0.49],
										[4.91, 0.48],
										[5.32, 0.72],
										[5.38, 1.28],
										[5.15, 1.99],
										[5.05, 2.43],
										[5.06, 2.7],
										[5.16, 2.96],
										[5.58, 3.34],
										[6.11, 3.42],
										[7.02, 3.09],
										[7.69, 2.56],
										[8.21, 2.07],
										[8.92, 1.48],
										[9.19, 1.32],
										[9.63, 1.11],
										[9.97, 1.04],
										[10.07, 1.04],
										[10.18, 1.04],
										[10.28, 1.05],
										[10.38, 1.07],
										[10.81, 1.29],
										[10.91, 1.38],
										[10.99, 1.49],
										[11.12, 1.73],
										[11.14, 2],
										[11.04, 2.33],
										[10.97, 2.56],
										[10.95, 2.71],
										[10.95, 2.87],
										[11.06, 3.19],
										[11.19, 3.35],
										[11.39, 3.45],
										[11.75, 3.43],
										[12.06, 3.22],
										[12.3, 2.96],
										[12.55, 2.72],
										[13.22, 2.27],
										[14.02, 1.96],
										[14.74, 1.83],
										[15.41, 1.81],
										[16.55, 1.91],
										[18.06, 2.2],
										[20.3, 2.49],
										[22.22, 2.15],
										[22.42, 2.04],
										[22.56, 1.94],
										[22.63, 1.8],
										[22.47, 1.77],
										[22.32, 1.8],
										[22.11, 1.86],
										[20.31, 2.05],
										[18.15, 1.74],
										[16.71, 1.42],
										[15.6, 1.27],
										[14.23, 1.34],
										[13.29, 1.64],
										[12.23, 2.33],
										[12.11, 2.44],
										[12, 2.56],
										[11.79, 2.79],
										[11.62, 2.95],
										[11.56, 2.98],
										[11.52, 2.98],
										[11.48, 2.95],
										[11.45, 2.88],
										[11.43, 2.77],
										[11.44, 2.71],
										[11.45, 2.64],
										[11.56, 2.33],
										[11.61, 2.14],
										[11.63, 2.04],
										[11.63, 1.99],
										[11.63, 1.94],
										[11.63, 1.84],
										[11.62, 1.74],
										[11.57, 1.55],
										[11.41, 1.23],
										[10.95, 0.8],
										[10.48, 0.59],
										[10.36, 0.56],
										[10.26, 0.55],
										[10.08, 0.54],
										[9.93, 0.54],
										[9.83, 0.56],
										[9.77, 0.57],
										[9.74, 0.57],
										[9.5, 0.63],
										[8.9, 0.89],
										[8.15, 1.46],
										[7.36, 2.22],
										[6.93, 2.6],
										[6.71, 2.76],
										[6.47, 2.88],
										[5.97, 2.99],
										[5.75, 2.95],
										[5.59, 2.84],
										[5.47, 2.47],
										[5.58, 2.01],
										[5.83, 1.04],
										[5.58, 0.37],
										[5.05, 0.06],
										[4.16, 0.03],
										[3.83, 0.11],
										[3.56, 0.19],
										[3.34, 0.26],
										[3.15, 0.33],
										[1.4, 1.35],
										[0.75, 1.96],
										[0.47, 2.28],
										[0.22, 2.61],
										[0.22, 2.61]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.416, 0.604, 0.137] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 4,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Gestural Line/scribble 15 Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.39, 3.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [11.39, 3.42] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[22.77, 0],
										[22.77, 6.83],
										[0, 6.83],
										[0, 0]
									]
								}
							}
						}
					],
					"ind": 5
				}
			]
		},
		{
			"nm": "[Asset] Yellow Sticky Note",
			"id": "15",
			"layers": [
				{
					"ty": 4,
					"nm": "Text",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.39, 7.59] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [15.18, 11.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Line",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.43, 1.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [4.43, 13.92] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[8.86, 0],
										[8.86, 2.53],
										[0, 2.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.933, 0.82, 0.169] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 2,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Line",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [10.12, 1.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [10.12, 7.59] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[20.24, 0],
										[20.24, 2.53],
										[0, 2.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.933, 0.82, 0.169] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Line",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [8.22, 1.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [8.22, 1.27] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[16.45, 0],
										[16.45, 2.53],
										[0, 2.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.933, 0.82, 0.169] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 4,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Yellow Sticky Note Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.18, 17.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [15.18, 17.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.36, 0],
										[30.36, 35.42],
										[0, 35.42],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.996, 0.969, 0.784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 5
				}
			]
		},
		{
			"nm": "[Asset] Frame 2087326861",
			"id": "16",
			"layers": [
				{
					"ty": 4,
					"nm": "Dot matrix",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [89.19, 58.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [89.05, 58.36] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 0.63],
										[0.63, 1.27],
										[0, 0.63],
										[0.63, 0],
										[1.27, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 9.49],
										[0.63, 10.12],
										[0, 9.49],
										[0.63, 8.86],
										[1.27, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 18.34],
										[0.63, 18.98],
										[0, 18.34],
										[0.63, 17.71],
										[1.27, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 27.2],
										[0.63, 27.83],
										[0, 27.2],
										[0.63, 26.57],
										[1.27, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 36.06],
										[0.63, 36.69],
										[0, 36.06],
										[0.63, 35.42],
										[1.27, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 44.91],
										[0.63, 45.55],
										[0, 44.91],
										[0.63, 44.28],
										[1.27, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 53.77],
										[0.63, 54.4],
										[0, 53.77],
										[0.63, 53.14],
										[1.27, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 62.63],
										[0.63, 63.26],
										[0, 62.63],
										[0.63, 61.99],
										[1.27, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 71.48],
										[0.63, 72.11],
										[0, 71.48],
										[0.63, 70.85],
										[1.27, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 80.34],
										[0.63, 80.97],
										[0, 80.34],
										[0.63, 79.7],
										[1.27, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 89.19],
										[0.63, 89.83],
										[0, 89.19],
										[0.63, 88.56],
										[1.27, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 98.05],
										[0.63, 98.68],
										[0, 98.05],
										[0.63, 97.42],
										[1.27, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 106.91],
										[0.63, 107.54],
										[0, 106.91],
										[0.63, 106.27],
										[1.27, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[1.27, 115.76],
										[0.63, 116.39],
										[0, 115.76],
										[0.63, 115.13],
										[1.27, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 0.63],
										[9.49, 1.27],
										[8.86, 0.63],
										[9.49, 0],
										[10.12, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 9.49],
										[9.49, 10.12],
										[8.86, 9.49],
										[9.49, 8.86],
										[10.12, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 18.34],
										[9.49, 18.98],
										[8.86, 18.34],
										[9.49, 17.71],
										[10.12, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 27.2],
										[9.49, 27.83],
										[8.86, 27.2],
										[9.49, 26.57],
										[10.12, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 36.06],
										[9.49, 36.69],
										[8.86, 36.06],
										[9.49, 35.42],
										[10.12, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 44.91],
										[9.49, 45.55],
										[8.86, 44.91],
										[9.49, 44.28],
										[10.12, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 53.77],
										[9.49, 54.4],
										[8.86, 53.77],
										[9.49, 53.14],
										[10.12, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 62.63],
										[9.49, 63.26],
										[8.86, 62.63],
										[9.49, 61.99],
										[10.12, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 71.48],
										[9.49, 72.11],
										[8.86, 71.48],
										[9.49, 70.85],
										[10.12, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 80.34],
										[9.49, 80.97],
										[8.86, 80.34],
										[9.49, 79.7],
										[10.12, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 89.19],
										[9.49, 89.83],
										[8.86, 89.19],
										[9.49, 88.56],
										[10.12, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 98.05],
										[9.49, 98.68],
										[8.86, 98.05],
										[9.49, 97.42],
										[10.12, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 106.91],
										[9.49, 107.54],
										[8.86, 106.91],
										[9.49, 106.27],
										[10.12, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[10.12, 115.76],
										[9.49, 116.39],
										[8.86, 115.76],
										[9.49, 115.13],
										[10.12, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 0.63],
										[18.34, 1.27],
										[17.71, 0.63],
										[18.34, 0],
										[18.98, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 9.49],
										[18.34, 10.12],
										[17.71, 9.49],
										[18.34, 8.86],
										[18.98, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 18.34],
										[18.34, 18.98],
										[17.71, 18.34],
										[18.34, 17.71],
										[18.98, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 27.2],
										[18.34, 27.83],
										[17.71, 27.2],
										[18.34, 26.57],
										[18.98, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 36.06],
										[18.34, 36.69],
										[17.71, 36.06],
										[18.34, 35.42],
										[18.98, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 44.91],
										[18.34, 45.55],
										[17.71, 44.91],
										[18.34, 44.28],
										[18.98, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 53.77],
										[18.34, 54.4],
										[17.71, 53.77],
										[18.34, 53.14],
										[18.98, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 62.63],
										[18.34, 63.26],
										[17.71, 62.63],
										[18.34, 61.99],
										[18.98, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 71.48],
										[18.34, 72.11],
										[17.71, 71.48],
										[18.34, 70.85],
										[18.98, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 80.34],
										[18.34, 80.97],
										[17.71, 80.34],
										[18.34, 79.7],
										[18.98, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 89.19],
										[18.34, 89.83],
										[17.71, 89.19],
										[18.34, 88.56],
										[18.98, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 98.05],
										[18.34, 98.68],
										[17.71, 98.05],
										[18.34, 97.42],
										[18.98, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 106.91],
										[18.34, 107.54],
										[17.71, 106.91],
										[18.34, 106.27],
										[18.98, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[18.98, 115.76],
										[18.34, 116.39],
										[17.71, 115.76],
										[18.34, 115.13],
										[18.98, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 0.63],
										[27.2, 1.27],
										[26.57, 0.63],
										[27.2, 0],
										[27.83, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 9.49],
										[27.2, 10.12],
										[26.57, 9.49],
										[27.2, 8.86],
										[27.83, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 18.34],
										[27.2, 18.98],
										[26.57, 18.34],
										[27.2, 17.71],
										[27.83, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 27.2],
										[27.2, 27.83],
										[26.57, 27.2],
										[27.2, 26.57],
										[27.83, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 36.06],
										[27.2, 36.69],
										[26.57, 36.06],
										[27.2, 35.42],
										[27.83, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 44.91],
										[27.2, 45.55],
										[26.57, 44.91],
										[27.2, 44.28],
										[27.83, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 53.77],
										[27.2, 54.4],
										[26.57, 53.77],
										[27.2, 53.14],
										[27.83, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 62.63],
										[27.2, 63.26],
										[26.57, 62.63],
										[27.2, 61.99],
										[27.83, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 71.48],
										[27.2, 72.11],
										[26.57, 71.48],
										[27.2, 70.85],
										[27.83, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 80.34],
										[27.2, 80.97],
										[26.57, 80.34],
										[27.2, 79.7],
										[27.83, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 89.19],
										[27.2, 89.83],
										[26.57, 89.19],
										[27.2, 88.56],
										[27.83, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 98.05],
										[27.2, 98.68],
										[26.57, 98.05],
										[27.2, 97.42],
										[27.83, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 106.91],
										[27.2, 107.54],
										[26.57, 106.91],
										[27.2, 106.27],
										[27.83, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[27.83, 115.76],
										[27.2, 116.39],
										[26.57, 115.76],
										[27.2, 115.13],
										[27.83, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 0.63],
										[36.06, 1.27],
										[35.42, 0.63],
										[36.06, 0],
										[36.69, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 9.49],
										[36.06, 10.12],
										[35.42, 9.49],
										[36.06, 8.86],
										[36.69, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 18.34],
										[36.06, 18.98],
										[35.42, 18.34],
										[36.06, 17.71],
										[36.69, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 27.2],
										[36.06, 27.83],
										[35.42, 27.2],
										[36.06, 26.57],
										[36.69, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 36.06],
										[36.06, 36.69],
										[35.42, 36.06],
										[36.06, 35.42],
										[36.69, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 44.91],
										[36.06, 45.55],
										[35.42, 44.91],
										[36.06, 44.28],
										[36.69, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 53.77],
										[36.06, 54.4],
										[35.42, 53.77],
										[36.06, 53.14],
										[36.69, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 62.63],
										[36.06, 63.26],
										[35.42, 62.63],
										[36.06, 61.99],
										[36.69, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 71.48],
										[36.06, 72.11],
										[35.42, 71.48],
										[36.06, 70.85],
										[36.69, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 80.34],
										[36.06, 80.97],
										[35.42, 80.34],
										[36.06, 79.7],
										[36.69, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 89.19],
										[36.06, 89.83],
										[35.42, 89.19],
										[36.06, 88.56],
										[36.69, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 98.05],
										[36.06, 98.68],
										[35.42, 98.05],
										[36.06, 97.42],
										[36.69, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 106.91],
										[36.06, 107.54],
										[35.42, 106.91],
										[36.06, 106.27],
										[36.69, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[36.69, 115.76],
										[36.06, 116.39],
										[35.42, 115.76],
										[36.06, 115.13],
										[36.69, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 0.63],
										[44.91, 1.27],
										[44.28, 0.63],
										[44.91, 0],
										[45.55, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 9.49],
										[44.91, 10.12],
										[44.28, 9.49],
										[44.91, 8.86],
										[45.55, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 18.34],
										[44.91, 18.98],
										[44.28, 18.34],
										[44.91, 17.71],
										[45.55, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 27.2],
										[44.91, 27.83],
										[44.28, 27.2],
										[44.91, 26.57],
										[45.55, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 36.06],
										[44.91, 36.69],
										[44.28, 36.06],
										[44.91, 35.42],
										[45.55, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 44.91],
										[44.91, 45.55],
										[44.28, 44.91],
										[44.91, 44.28],
										[45.55, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 53.77],
										[44.91, 54.4],
										[44.28, 53.77],
										[44.91, 53.14],
										[45.55, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 62.63],
										[44.91, 63.26],
										[44.28, 62.63],
										[44.91, 61.99],
										[45.55, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 71.48],
										[44.91, 72.11],
										[44.28, 71.48],
										[44.91, 70.85],
										[45.55, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 80.34],
										[44.91, 80.97],
										[44.28, 80.34],
										[44.91, 79.7],
										[45.55, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 89.19],
										[44.91, 89.83],
										[44.28, 89.19],
										[44.91, 88.56],
										[45.55, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 98.05],
										[44.91, 98.68],
										[44.28, 98.05],
										[44.91, 97.42],
										[45.55, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 106.91],
										[44.91, 107.54],
										[44.28, 106.91],
										[44.91, 106.27],
										[45.55, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[45.55, 115.76],
										[44.91, 116.39],
										[44.28, 115.76],
										[44.91, 115.13],
										[45.55, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 0.63],
										[53.77, 1.27],
										[53.14, 0.63],
										[53.77, 0],
										[54.4, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 9.49],
										[53.77, 10.12],
										[53.14, 9.49],
										[53.77, 8.86],
										[54.4, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 18.34],
										[53.77, 18.98],
										[53.14, 18.34],
										[53.77, 17.71],
										[54.4, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 27.2],
										[53.77, 27.83],
										[53.14, 27.2],
										[53.77, 26.57],
										[54.4, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 36.06],
										[53.77, 36.69],
										[53.14, 36.06],
										[53.77, 35.42],
										[54.4, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 44.91],
										[53.77, 45.55],
										[53.14, 44.91],
										[53.77, 44.28],
										[54.4, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 53.77],
										[53.77, 54.4],
										[53.14, 53.77],
										[53.77, 53.14],
										[54.4, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 62.63],
										[53.77, 63.26],
										[53.14, 62.63],
										[53.77, 61.99],
										[54.4, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 71.48],
										[53.77, 72.11],
										[53.14, 71.48],
										[53.77, 70.85],
										[54.4, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 80.34],
										[53.77, 80.97],
										[53.14, 80.34],
										[53.77, 79.7],
										[54.4, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 89.19],
										[53.77, 89.83],
										[53.14, 89.19],
										[53.77, 88.56],
										[54.4, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 98.05],
										[53.77, 98.68],
										[53.14, 98.05],
										[53.77, 97.42],
										[54.4, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 106.91],
										[53.77, 107.54],
										[53.14, 106.91],
										[53.77, 106.27],
										[54.4, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[54.4, 115.76],
										[53.77, 116.39],
										[53.14, 115.76],
										[53.77, 115.13],
										[54.4, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 0.63],
										[62.63, 1.27],
										[61.99, 0.63],
										[62.63, 0],
										[63.26, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 9.49],
										[62.63, 10.12],
										[61.99, 9.49],
										[62.63, 8.86],
										[63.26, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 18.34],
										[62.63, 18.98],
										[61.99, 18.34],
										[62.63, 17.71],
										[63.26, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 27.2],
										[62.63, 27.83],
										[61.99, 27.2],
										[62.63, 26.57],
										[63.26, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 36.06],
										[62.63, 36.69],
										[61.99, 36.06],
										[62.63, 35.42],
										[63.26, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 44.91],
										[62.63, 45.55],
										[61.99, 44.91],
										[62.63, 44.28],
										[63.26, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 53.77],
										[62.63, 54.4],
										[61.99, 53.77],
										[62.63, 53.14],
										[63.26, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 62.63],
										[62.63, 63.26],
										[61.99, 62.63],
										[62.63, 61.99],
										[63.26, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 71.48],
										[62.63, 72.11],
										[61.99, 71.48],
										[62.63, 70.85],
										[63.26, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 80.34],
										[62.63, 80.97],
										[61.99, 80.34],
										[62.63, 79.7],
										[63.26, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 89.19],
										[62.63, 89.83],
										[61.99, 89.19],
										[62.63, 88.56],
										[63.26, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 98.05],
										[62.63, 98.68],
										[61.99, 98.05],
										[62.63, 97.42],
										[63.26, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 106.91],
										[62.63, 107.54],
										[61.99, 106.91],
										[62.63, 106.27],
										[63.26, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[63.26, 115.76],
										[62.63, 116.39],
										[61.99, 115.76],
										[62.63, 115.13],
										[63.26, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 0.63],
										[71.48, 1.27],
										[70.85, 0.63],
										[71.48, 0],
										[72.11, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 9.49],
										[71.48, 10.12],
										[70.85, 9.49],
										[71.48, 8.86],
										[72.11, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 18.34],
										[71.48, 18.98],
										[70.85, 18.34],
										[71.48, 17.71],
										[72.11, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 27.2],
										[71.48, 27.83],
										[70.85, 27.2],
										[71.48, 26.57],
										[72.11, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 36.06],
										[71.48, 36.69],
										[70.85, 36.06],
										[71.48, 35.42],
										[72.11, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 44.91],
										[71.48, 45.55],
										[70.85, 44.91],
										[71.48, 44.28],
										[72.11, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 53.77],
										[71.48, 54.4],
										[70.85, 53.77],
										[71.48, 53.14],
										[72.11, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 62.63],
										[71.48, 63.26],
										[70.85, 62.63],
										[71.48, 61.99],
										[72.11, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 71.48],
										[71.48, 72.11],
										[70.85, 71.48],
										[71.48, 70.85],
										[72.11, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 80.34],
										[71.48, 80.97],
										[70.85, 80.34],
										[71.48, 79.7],
										[72.11, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 89.19],
										[71.48, 89.83],
										[70.85, 89.19],
										[71.48, 88.56],
										[72.11, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 98.05],
										[71.48, 98.68],
										[70.85, 98.05],
										[71.48, 97.42],
										[72.11, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 106.91],
										[71.48, 107.54],
										[70.85, 106.91],
										[71.48, 106.27],
										[72.11, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[72.11, 115.76],
										[71.48, 116.39],
										[70.85, 115.76],
										[71.48, 115.13],
										[72.11, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 0.63],
										[80.34, 1.27],
										[79.7, 0.63],
										[80.34, 0],
										[80.97, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 9.49],
										[80.34, 10.12],
										[79.7, 9.49],
										[80.34, 8.86],
										[80.97, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 18.34],
										[80.34, 18.98],
										[79.7, 18.34],
										[80.34, 17.71],
										[80.97, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 27.2],
										[80.34, 27.83],
										[79.7, 27.2],
										[80.34, 26.57],
										[80.97, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 36.06],
										[80.34, 36.69],
										[79.7, 36.06],
										[80.34, 35.42],
										[80.97, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 44.91],
										[80.34, 45.55],
										[79.7, 44.91],
										[80.34, 44.28],
										[80.97, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 53.77],
										[80.34, 54.4],
										[79.7, 53.77],
										[80.34, 53.14],
										[80.97, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 62.63],
										[80.34, 63.26],
										[79.7, 62.63],
										[80.34, 61.99],
										[80.97, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 71.48],
										[80.34, 72.11],
										[79.7, 71.48],
										[80.34, 70.85],
										[80.97, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 80.34],
										[80.34, 80.97],
										[79.7, 80.34],
										[80.34, 79.7],
										[80.97, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 89.19],
										[80.34, 89.83],
										[79.7, 89.19],
										[80.34, 88.56],
										[80.97, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 98.05],
										[80.34, 98.68],
										[79.7, 98.05],
										[80.34, 97.42],
										[80.97, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 106.91],
										[80.34, 107.54],
										[79.7, 106.91],
										[80.34, 106.27],
										[80.97, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[80.97, 115.76],
										[80.34, 116.39],
										[79.7, 115.76],
										[80.34, 115.13],
										[80.97, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 0.63],
										[89.19, 1.27],
										[88.56, 0.63],
										[89.19, 0],
										[89.83, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 9.49],
										[89.19, 10.12],
										[88.56, 9.49],
										[89.19, 8.86],
										[89.83, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 18.34],
										[89.19, 18.98],
										[88.56, 18.34],
										[89.19, 17.71],
										[89.83, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 27.2],
										[89.19, 27.83],
										[88.56, 27.2],
										[89.19, 26.57],
										[89.83, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 36.06],
										[89.19, 36.69],
										[88.56, 36.06],
										[89.19, 35.42],
										[89.83, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 44.91],
										[89.19, 45.55],
										[88.56, 44.91],
										[89.19, 44.28],
										[89.83, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 53.77],
										[89.19, 54.4],
										[88.56, 53.77],
										[89.19, 53.14],
										[89.83, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 62.63],
										[89.19, 63.26],
										[88.56, 62.63],
										[89.19, 61.99],
										[89.83, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 71.48],
										[89.19, 72.11],
										[88.56, 71.48],
										[89.19, 70.85],
										[89.83, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 80.34],
										[89.19, 80.97],
										[88.56, 80.34],
										[89.19, 79.7],
										[89.83, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 89.19],
										[89.19, 89.83],
										[88.56, 89.19],
										[89.19, 88.56],
										[89.83, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 98.05],
										[89.19, 98.68],
										[88.56, 98.05],
										[89.19, 97.42],
										[89.83, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 106.91],
										[89.19, 107.54],
										[88.56, 106.91],
										[89.19, 106.27],
										[89.83, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[89.83, 115.76],
										[89.19, 116.39],
										[88.56, 115.76],
										[89.19, 115.13],
										[89.83, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 0.63],
										[98.05, 1.27],
										[97.42, 0.63],
										[98.05, 0],
										[98.68, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 9.49],
										[98.05, 10.12],
										[97.42, 9.49],
										[98.05, 8.86],
										[98.68, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 18.34],
										[98.05, 18.98],
										[97.42, 18.34],
										[98.05, 17.71],
										[98.68, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 27.2],
										[98.05, 27.83],
										[97.42, 27.2],
										[98.05, 26.57],
										[98.68, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 36.06],
										[98.05, 36.69],
										[97.42, 36.06],
										[98.05, 35.42],
										[98.68, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 44.91],
										[98.05, 45.55],
										[97.42, 44.91],
										[98.05, 44.28],
										[98.68, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 53.77],
										[98.05, 54.4],
										[97.42, 53.77],
										[98.05, 53.14],
										[98.68, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 62.63],
										[98.05, 63.26],
										[97.42, 62.63],
										[98.05, 61.99],
										[98.68, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 71.48],
										[98.05, 72.11],
										[97.42, 71.48],
										[98.05, 70.85],
										[98.68, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 80.34],
										[98.05, 80.97],
										[97.42, 80.34],
										[98.05, 79.7],
										[98.68, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 89.19],
										[98.05, 89.83],
										[97.42, 89.19],
										[98.05, 88.56],
										[98.68, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 98.05],
										[98.05, 98.68],
										[97.42, 98.05],
										[98.05, 97.42],
										[98.68, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 106.91],
										[98.05, 107.54],
										[97.42, 106.91],
										[98.05, 106.27],
										[98.68, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[98.68, 115.76],
										[98.05, 116.39],
										[97.42, 115.76],
										[98.05, 115.13],
										[98.68, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 0.63],
										[106.91, 1.27],
										[106.27, 0.63],
										[106.91, 0],
										[107.54, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 9.49],
										[106.91, 10.12],
										[106.27, 9.49],
										[106.91, 8.86],
										[107.54, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 18.34],
										[106.91, 18.98],
										[106.27, 18.34],
										[106.91, 17.71],
										[107.54, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 27.2],
										[106.91, 27.83],
										[106.27, 27.2],
										[106.91, 26.57],
										[107.54, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 36.06],
										[106.91, 36.69],
										[106.27, 36.06],
										[106.91, 35.42],
										[107.54, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 44.91],
										[106.91, 45.55],
										[106.27, 44.91],
										[106.91, 44.28],
										[107.54, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 53.77],
										[106.91, 54.4],
										[106.27, 53.77],
										[106.91, 53.14],
										[107.54, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 62.63],
										[106.91, 63.26],
										[106.27, 62.63],
										[106.91, 61.99],
										[107.54, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 71.48],
										[106.91, 72.11],
										[106.27, 71.48],
										[106.91, 70.85],
										[107.54, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 80.34],
										[106.91, 80.97],
										[106.27, 80.34],
										[106.91, 79.7],
										[107.54, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 89.19],
										[106.91, 89.83],
										[106.27, 89.19],
										[106.91, 88.56],
										[107.54, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 98.05],
										[106.91, 98.68],
										[106.27, 98.05],
										[106.91, 97.42],
										[107.54, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 106.91],
										[106.91, 107.54],
										[106.27, 106.91],
										[106.91, 106.27],
										[107.54, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[107.54, 115.76],
										[106.91, 116.39],
										[106.27, 115.76],
										[106.91, 115.13],
										[107.54, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 0.63],
										[115.76, 1.27],
										[115.13, 0.63],
										[115.76, 0],
										[116.39, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 9.49],
										[115.76, 10.12],
										[115.13, 9.49],
										[115.76, 8.86],
										[116.39, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 18.34],
										[115.76, 18.98],
										[115.13, 18.34],
										[115.76, 17.71],
										[116.39, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 27.2],
										[115.76, 27.83],
										[115.13, 27.2],
										[115.76, 26.57],
										[116.39, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 36.06],
										[115.76, 36.69],
										[115.13, 36.06],
										[115.76, 35.42],
										[116.39, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 44.91],
										[115.76, 45.55],
										[115.13, 44.91],
										[115.76, 44.28],
										[116.39, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 53.77],
										[115.76, 54.4],
										[115.13, 53.77],
										[115.76, 53.14],
										[116.39, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 62.63],
										[115.76, 63.26],
										[115.13, 62.63],
										[115.76, 61.99],
										[116.39, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 71.48],
										[115.76, 72.11],
										[115.13, 71.48],
										[115.76, 70.85],
										[116.39, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 80.34],
										[115.76, 80.97],
										[115.13, 80.34],
										[115.76, 79.7],
										[116.39, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 89.19],
										[115.76, 89.83],
										[115.13, 89.19],
										[115.76, 88.56],
										[116.39, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 98.05],
										[115.76, 98.68],
										[115.13, 98.05],
										[115.76, 97.42],
										[116.39, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 106.91],
										[115.76, 107.54],
										[115.13, 106.91],
										[115.76, 106.27],
										[116.39, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[116.39, 115.76],
										[115.76, 116.39],
										[115.13, 115.76],
										[115.76, 115.13],
										[116.39, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 0.63],
										[124.62, 1.27],
										[123.99, 0.63],
										[124.62, 0],
										[125.25, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 9.49],
										[124.62, 10.12],
										[123.99, 9.49],
										[124.62, 8.86],
										[125.25, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 18.34],
										[124.62, 18.98],
										[123.99, 18.34],
										[124.62, 17.71],
										[125.25, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 27.2],
										[124.62, 27.83],
										[123.99, 27.2],
										[124.62, 26.57],
										[125.25, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 36.06],
										[124.62, 36.69],
										[123.99, 36.06],
										[124.62, 35.42],
										[125.25, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 44.91],
										[124.62, 45.55],
										[123.99, 44.91],
										[124.62, 44.28],
										[125.25, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 53.77],
										[124.62, 54.4],
										[123.99, 53.77],
										[124.62, 53.14],
										[125.25, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 62.63],
										[124.62, 63.26],
										[123.99, 62.63],
										[124.62, 61.99],
										[125.25, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 71.48],
										[124.62, 72.11],
										[123.99, 71.48],
										[124.62, 70.85],
										[125.25, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 80.34],
										[124.62, 80.97],
										[123.99, 80.34],
										[124.62, 79.7],
										[125.25, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 89.19],
										[124.62, 89.83],
										[123.99, 89.19],
										[124.62, 88.56],
										[125.25, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 98.05],
										[124.62, 98.68],
										[123.99, 98.05],
										[124.62, 97.42],
										[125.25, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 106.91],
										[124.62, 107.54],
										[123.99, 106.91],
										[124.62, 106.27],
										[125.25, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[125.25, 115.76],
										[124.62, 116.39],
										[123.99, 115.76],
										[124.62, 115.13],
										[125.25, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 0.63],
										[133.47, 1.27],
										[132.84, 0.63],
										[133.47, 0],
										[134.11, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 9.49],
										[133.47, 10.12],
										[132.84, 9.49],
										[133.47, 8.86],
										[134.11, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 18.34],
										[133.47, 18.98],
										[132.84, 18.34],
										[133.47, 17.71],
										[134.11, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 27.2],
										[133.47, 27.83],
										[132.84, 27.2],
										[133.47, 26.57],
										[134.11, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 36.06],
										[133.47, 36.69],
										[132.84, 36.06],
										[133.47, 35.42],
										[134.11, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 44.91],
										[133.47, 45.55],
										[132.84, 44.91],
										[133.47, 44.28],
										[134.11, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 53.77],
										[133.47, 54.4],
										[132.84, 53.77],
										[133.47, 53.14],
										[134.11, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 62.63],
										[133.47, 63.26],
										[132.84, 62.63],
										[133.47, 61.99],
										[134.11, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 71.48],
										[133.47, 72.11],
										[132.84, 71.48],
										[133.47, 70.85],
										[134.11, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 80.34],
										[133.47, 80.97],
										[132.84, 80.34],
										[133.47, 79.7],
										[134.11, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 89.19],
										[133.47, 89.83],
										[132.84, 89.19],
										[133.47, 88.56],
										[134.11, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 98.05],
										[133.47, 98.68],
										[132.84, 98.05],
										[133.47, 97.42],
										[134.11, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 106.91],
										[133.47, 107.54],
										[132.84, 106.91],
										[133.47, 106.27],
										[134.11, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[134.11, 115.76],
										[133.47, 116.39],
										[132.84, 115.76],
										[133.47, 115.13],
										[134.11, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 0.63],
										[142.33, 1.27],
										[141.7, 0.63],
										[142.33, 0],
										[142.96, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 0.63],
										[151.19, 1.27],
										[150.55, 0.63],
										[151.19, 0],
										[151.82, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 0.63],
										[160.04, 1.27],
										[159.41, 0.63],
										[160.04, 0],
										[160.67, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 0.63],
										[168.9, 1.27],
										[168.27, 0.63],
										[168.9, 0],
										[169.53, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 0.63],
										[177.75, 1.27],
										[177.12, 0.63],
										[177.75, 0],
										[178.39, 0.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 9.49],
										[142.33, 10.12],
										[141.7, 9.49],
										[142.33, 8.86],
										[142.96, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 9.49],
										[151.19, 10.12],
										[150.55, 9.49],
										[151.19, 8.86],
										[151.82, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 9.49],
										[160.04, 10.12],
										[159.41, 9.49],
										[160.04, 8.86],
										[160.67, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 9.49],
										[168.9, 10.12],
										[168.27, 9.49],
										[168.9, 8.86],
										[169.53, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 9.49],
										[177.75, 10.12],
										[177.12, 9.49],
										[177.75, 8.86],
										[178.39, 9.49]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 18.34],
										[142.33, 18.98],
										[141.7, 18.34],
										[142.33, 17.71],
										[142.96, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 18.34],
										[151.19, 18.98],
										[150.55, 18.34],
										[151.19, 17.71],
										[151.82, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 18.34],
										[160.04, 18.98],
										[159.41, 18.34],
										[160.04, 17.71],
										[160.67, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 18.34],
										[168.9, 18.98],
										[168.27, 18.34],
										[168.9, 17.71],
										[169.53, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 18.34],
										[177.75, 18.98],
										[177.12, 18.34],
										[177.75, 17.71],
										[178.39, 18.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 27.2],
										[142.33, 27.83],
										[141.7, 27.2],
										[142.33, 26.57],
										[142.96, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 27.2],
										[151.19, 27.83],
										[150.55, 27.2],
										[151.19, 26.57],
										[151.82, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 27.2],
										[160.04, 27.83],
										[159.41, 27.2],
										[160.04, 26.57],
										[160.67, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 27.2],
										[168.9, 27.83],
										[168.27, 27.2],
										[168.9, 26.57],
										[169.53, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 27.2],
										[177.75, 27.83],
										[177.12, 27.2],
										[177.75, 26.57],
										[178.39, 27.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 36.06],
										[142.33, 36.69],
										[141.7, 36.06],
										[142.33, 35.42],
										[142.96, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 36.06],
										[151.19, 36.69],
										[150.55, 36.06],
										[151.19, 35.42],
										[151.82, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 36.06],
										[160.04, 36.69],
										[159.41, 36.06],
										[160.04, 35.42],
										[160.67, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 36.06],
										[168.9, 36.69],
										[168.27, 36.06],
										[168.9, 35.42],
										[169.53, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 36.06],
										[177.75, 36.69],
										[177.12, 36.06],
										[177.75, 35.42],
										[178.39, 36.06]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 44.91],
										[142.33, 45.55],
										[141.7, 44.91],
										[142.33, 44.28],
										[142.96, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 44.91],
										[151.19, 45.55],
										[150.55, 44.91],
										[151.19, 44.28],
										[151.82, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 44.91],
										[160.04, 45.55],
										[159.41, 44.91],
										[160.04, 44.28],
										[160.67, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 44.91],
										[168.9, 45.55],
										[168.27, 44.91],
										[168.9, 44.28],
										[169.53, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 44.91],
										[177.75, 45.55],
										[177.12, 44.91],
										[177.75, 44.28],
										[178.39, 44.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 53.77],
										[142.33, 54.4],
										[141.7, 53.77],
										[142.33, 53.14],
										[142.96, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 53.77],
										[151.19, 54.4],
										[150.55, 53.77],
										[151.19, 53.14],
										[151.82, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 53.77],
										[160.04, 54.4],
										[159.41, 53.77],
										[160.04, 53.14],
										[160.67, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 53.77],
										[168.9, 54.4],
										[168.27, 53.77],
										[168.9, 53.14],
										[169.53, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 53.77],
										[177.75, 54.4],
										[177.12, 53.77],
										[177.75, 53.14],
										[178.39, 53.77]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 62.63],
										[142.33, 63.26],
										[141.7, 62.63],
										[142.33, 61.99],
										[142.96, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 62.63],
										[151.19, 63.26],
										[150.55, 62.63],
										[151.19, 61.99],
										[151.82, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 62.63],
										[160.04, 63.26],
										[159.41, 62.63],
										[160.04, 61.99],
										[160.67, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 62.63],
										[168.9, 63.26],
										[168.27, 62.63],
										[168.9, 61.99],
										[169.53, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 62.63],
										[177.75, 63.26],
										[177.12, 62.63],
										[177.75, 61.99],
										[178.39, 62.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 71.48],
										[142.33, 72.11],
										[141.7, 71.48],
										[142.33, 70.85],
										[142.96, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 71.48],
										[151.19, 72.11],
										[150.55, 71.48],
										[151.19, 70.85],
										[151.82, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 71.48],
										[160.04, 72.11],
										[159.41, 71.48],
										[160.04, 70.85],
										[160.67, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 71.48],
										[168.9, 72.11],
										[168.27, 71.48],
										[168.9, 70.85],
										[169.53, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 71.48],
										[177.75, 72.11],
										[177.12, 71.48],
										[177.75, 70.85],
										[178.39, 71.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 80.34],
										[142.33, 80.97],
										[141.7, 80.34],
										[142.33, 79.7],
										[142.96, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 80.34],
										[151.19, 80.97],
										[150.55, 80.34],
										[151.19, 79.7],
										[151.82, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 80.34],
										[160.04, 80.97],
										[159.41, 80.34],
										[160.04, 79.7],
										[160.67, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 80.34],
										[168.9, 80.97],
										[168.27, 80.34],
										[168.9, 79.7],
										[169.53, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 80.34],
										[177.75, 80.97],
										[177.12, 80.34],
										[177.75, 79.7],
										[178.39, 80.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 89.19],
										[142.33, 89.83],
										[141.7, 89.19],
										[142.33, 88.56],
										[142.96, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 89.19],
										[151.19, 89.83],
										[150.55, 89.19],
										[151.19, 88.56],
										[151.82, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 89.19],
										[160.04, 89.83],
										[159.41, 89.19],
										[160.04, 88.56],
										[160.67, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 89.19],
										[168.9, 89.83],
										[168.27, 89.19],
										[168.9, 88.56],
										[169.53, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 89.19],
										[177.75, 89.83],
										[177.12, 89.19],
										[177.75, 88.56],
										[178.39, 89.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 98.05],
										[142.33, 98.68],
										[141.7, 98.05],
										[142.33, 97.42],
										[142.96, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 98.05],
										[151.19, 98.68],
										[150.55, 98.05],
										[151.19, 97.42],
										[151.82, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 98.05],
										[160.04, 98.68],
										[159.41, 98.05],
										[160.04, 97.42],
										[160.67, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 98.05],
										[168.9, 98.68],
										[168.27, 98.05],
										[168.9, 97.42],
										[169.53, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 98.05],
										[177.75, 98.68],
										[177.12, 98.05],
										[177.75, 97.42],
										[178.39, 98.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 106.91],
										[142.33, 107.54],
										[141.7, 106.91],
										[142.33, 106.27],
										[142.96, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 106.91],
										[151.19, 107.54],
										[150.55, 106.91],
										[151.19, 106.27],
										[151.82, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 106.91],
										[160.04, 107.54],
										[159.41, 106.91],
										[160.04, 106.27],
										[160.67, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 106.91],
										[168.9, 107.54],
										[168.27, 106.91],
										[168.9, 106.27],
										[169.53, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 106.91],
										[177.75, 107.54],
										[177.12, 106.91],
										[177.75, 106.27],
										[178.39, 106.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[142.96, 115.76],
										[142.33, 116.39],
										[141.7, 115.76],
										[142.33, 115.13],
										[142.96, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[151.82, 115.76],
										[151.19, 116.39],
										[150.55, 115.76],
										[151.19, 115.13],
										[151.82, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[160.67, 115.76],
										[160.04, 116.39],
										[159.41, 115.76],
										[160.04, 115.13],
										[160.67, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[169.53, 115.76],
										[168.9, 116.39],
										[168.27, 115.76],
										[168.9, 115.13],
										[169.53, 115.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0],
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35]
									],
									"o": [
										[0, 0.35],
										[-0.35, 0],
										[0, -0.35],
										[0.35, 0],
										[0, 0]
									],
									"v": [
										[178.39, 115.76],
										[177.75, 116.39],
										[177.12, 115.76],
										[177.75, 115.13],
										[178.39, 115.76]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.867, 0.871, 0.882] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Frame 2087326861 Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [76.05, 45.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [76.05, 45.5] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[152.1, 0],
										[152.1, 91],
										[0, 91],
										[0, 0]
									]
								}
							}
						}
					],
					"ind": 2
				}
			]
		},
		{
			"nm": "[Asset] Team Goals",
			"id": "17",
			"layers": [
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [166.81, 78.14] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [168.46, 78.15] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Layer 1",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [166.81, 78.14] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [166.81, 78.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 2,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [166.81, 78.14] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [166.81, 78.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 3,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Human Avatars 1 (Border)",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [70.505, 22.836] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [263.109, 22.836],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [263.109, 22.836],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [263.109, 22.836],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [263.109, 22.836],
									"t": 78
								},
								{ "s": [263.11, 22.836], "t": 108 }
							]
						},
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[141.01, 0],
										[141.01, 45.672],
										[0, 45.672],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 2,
							"lj": 2,
							"ml": 1,
							"o": { "a": 0, "k": 0 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.25],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.25],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.25],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [0.25],
										"t": 78
									},
									{ "s": [0.25], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0, 0, 0] }
						}
					],
					"ind": 4,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Human Avatars 1 (Mask)",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"td": 1,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [0, 0] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "gr",
							"nm": "",
							"it": [
								{
									"ty": "sh",
									"nm": "",
									"d": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[141.01, 0],
															[141.01, 45.672],
															[0, 45.672],
															[0, 0]
														]
													}
												],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[141.01, 0],
															[141.01, 45.672],
															[0, 45.672],
															[0, 0]
														]
													}
												],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[141.01, 0],
															[141.01, 45.672],
															[0, 45.672],
															[0, 0]
														]
													}
												],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[141.01, 0],
															[141.01, 45.672],
															[0, 45.672],
															[0, 0]
														]
													}
												],
												"t": 78
											},
											{
												"s": [
													{
														"c": true,
														"i": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"o": [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0]
														],
														"v": [
															[0, 0],
															[141.01, 0],
															[141.01, 45.672],
															[0, 45.672],
															[0, 0]
														]
													}
												],
												"t": 108
											}
										]
									}
								},
								{
									"ty": "fl",
									"nm": "",
									"c": { "a": 0, "k": [1, 0, 0] },
									"r": 2,
									"o": { "a": 0, "k": 100 }
								},
								{
									"ty": "tr",
									"a": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [70.505, 22.836],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [70.505, 22.836],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [70.505, 22.836],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [70.505, 22.836],
												"t": 78
											},
											{ "s": [70.505, 22.836], "t": 108 }
										]
									},
									"s": { "a": 0, "k": [100, 100] },
									"sk": { "a": 0, "k": 0 },
									"p": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [263.109, 22.836],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [263.109, 22.836],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [263.109, 22.836],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [263.109, 22.836],
												"t": 78
											},
											{ "s": [263.11, 22.836], "t": 108 }
										]
									},
									"r": {
										"a": 1,
										"k": [
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 0
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 24
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 72
											},
											{
												"o": { "x": 0.33, "y": 1 },
												"i": { "x": 0.68, "y": 1 },
												"s": [0],
												"t": 78
											},
											{ "s": [0], "t": 108 }
										]
									},
									"sa": { "a": 0, "k": 0 },
									"o": { "a": 0, "k": 100 }
								}
							]
						}
					],
					"ind": 5,
					"parent": 3
				},
				{
					"ty": 2,
					"nm": "Human Avatars 1",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"tt": 1,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [282.5, 91.5] },
						"s": { "a": 0, "k": [24.958, 24.958] },
						"sk": { "a": 0, "k": 0 },
						"p": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [263.109, 22.836],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [263.109, 22.836],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [263.109, 22.836],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [263.109, 22.836],
									"t": 78
								},
								{ "s": [263.11, 22.836], "t": 108 }
							]
						},
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"refId": "3975f5e9ec0071838e2f478b030e45a745141912",
					"ind": 6,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [134.84, 7.67] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [160.33, 103.66] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[-0.03, 0.45],
										[269.66, 15.79],
										[269.69, 15.34],
										[269.71, 14.89],
										[0.03, -0.45],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.941, 0.945, 0.949] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 7,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [134.84, 7.67] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [161.71, 79.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[-0.03, 0.45],
										[269.66, 15.79],
										[269.69, 15.34],
										[269.71, 14.89],
										[0.03, -0.45],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.941, 0.945, 0.949] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 8,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [23.66, 8.1] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [255.07, 121.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 9,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [18.32, 4.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [23.67, 7.85] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 10,
					"parent": 9
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.88, 3.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [33.75, 5.06] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 6.55],
										[0.38, 0],
										[1.55, 0.07],
										[1.44, 2.01],
										[1.33, 3.58],
										[1.32, 4.16],
										[1.18, 6.61],
										[0.01, 6.55],
										[0, 6.55]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.14, 0.2],
										[-0.16, 0.19],
										[-0.2, 0.21],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0.16, -0.22],
										[0.15, -0.19],
										[0.17, -0.19],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.94, 4.99],
										[1.01, 3.87],
										[1.45, 3.25],
										[1.92, 2.68],
										[2.48, 2.09],
										[4.3, 0.22],
										[5.76, 0.31],
										[2.81, 3.29],
										[2.73, 3.25],
										[0.94, 4.99]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.05, 6.78],
										[2.14, 3.58],
										[2.94, 2.74],
										[5.44, 6.86],
										[4.05, 6.78]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 11,
					"parent": 10
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.55, 3.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [27.34, 4.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.37, 0.18],
										[0.2, 0.32],
										[0, 0.43],
										[0, 0],
										[-0.11, -0.16],
										[-0.2, -0.09],
										[-0.24, -0.01],
										[-0.2, 0.07],
										[-0.12, 0.14],
										[-0.01, 0.19],
										[0.09, 0.12],
										[0.17, 0.09],
										[0.24, 0.07],
										[0, 0],
										[0.29, 0.3],
										[-0.02, 0.46],
										[-0.22, 0.28],
										[-0.37, 0.14],
										[-0.45, -0.02],
										[-0.34, -0.18],
										[-0.18, -0.29],
										[0.01, -0.36],
										[0, 0],
										[0.22, 0.17],
										[0.36, 0.02],
										[0.18, -0.06],
										[0.1, -0.12],
										[0.01, -0.16],
										[-0.1, -0.12],
										[-0.16, -0.08],
										[-0.17, -0.05],
										[0, 0],
										[-0.22, -0.11],
										[-0.18, -0.15],
										[-0.09, -0.22],
										[0.02, -0.28],
										[0.21, -0.28],
										[0.38, -0.15],
										[0.52, 0.03],
										[0, 0]
									],
									"o": [
										[-0.5, -0.03],
										[-0.36, -0.18],
										[-0.19, -0.32],
										[0, 0],
										[0.01, 0.23],
										[0.12, 0.16],
										[0.2, 0.09],
										[0.26, 0.02],
										[0.2, -0.07],
										[0.12, -0.13],
										[0.01, -0.17],
										[-0.09, -0.11],
										[-0.18, -0.09],
										[0, 0],
										[-0.54, -0.17],
										[-0.29, -0.3],
										[0.02, -0.38],
										[0.23, -0.28],
										[0.37, -0.14],
										[0.47, 0.03],
										[0.35, 0.18],
										[0.18, 0.3],
										[0, 0],
										[-0.01, -0.28],
										[-0.21, -0.16],
										[-0.24, -0.01],
										[-0.18, 0.07],
										[-0.1, 0.13],
										[-0.01, 0.18],
										[0.11, 0.13],
										[0.17, 0.08],
										[0, 0],
										[0.24, 0.07],
										[0.23, 0.11],
										[0.18, 0.16],
										[0.1, 0.22],
										[-0.02, 0.39],
										[-0.21, 0.28],
										[-0.38, 0.14],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.43, 6.73],
										[1.12, 6.42],
										[0.28, 5.68],
										[0, 4.56],
										[1.16, 4.63],
										[1.34, 5.21],
										[1.81, 5.58],
										[2.48, 5.73],
										[3.17, 5.65],
										[3.65, 5.35],
										[3.85, 4.86],
										[3.72, 4.43],
										[3.33, 4.13],
										[2.72, 3.89],
										[1.99, 3.65],
										[0.74, 2.94],
										[0.35, 1.8],
										[0.72, 0.8],
										[1.61, 0.18],
										[2.85, 0.01],
										[4.06, 0.32],
										[4.84, 1.03],
										[5.1, 2.02],
										[3.96, 1.96],
										[3.62, 1.28],
										[2.77, 1],
										[2.13, 1.08],
										[1.7, 1.36],
										[1.53, 1.79],
										[1.68, 2.25],
										[2.09, 2.55],
										[2.6, 2.75],
										[3.2, 2.95],
										[3.89, 3.22],
										[4.49, 3.62],
										[4.89, 4.19],
										[5.01, 4.94],
										[4.66, 5.93],
										[3.78, 6.57],
										[2.43, 6.74],
										[2.43, 6.73]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 12,
					"parent": 10
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.92, 3.38] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [22.27, 4.4] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 6.55],
										[0.05, 5.56],
										[1.21, 5.63],
										[1.47, 1.06],
										[0.32, 0.99],
										[0.37, 0],
										[3.85, 0.2],
										[3.79, 1.19],
										[2.64, 1.13],
										[2.38, 5.7],
										[3.54, 5.76],
										[3.48, 6.75],
										[0, 6.56],
										[0, 6.55]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 13,
					"parent": 10
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.51, 3.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [17.2, 4.12] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.33, -0.19],
										[-0.16, -0.33],
										[0.02, -0.41],
										[0.19, -0.3],
										[0.36, -0.15],
										[0.51, 0.02],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.2, 0.07],
										[-0.1, 0.16],
										[-0.01, 0.23],
										[0.08, 0.17],
										[0.19, 0.1],
										[0.3, 0.02],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0.5, 0.03],
										[0.33, 0.2],
										[0.16, 0.33],
										[-0.03, 0.41],
										[-0.2, 0.3],
										[-0.35, 0.14],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.3, 0.01],
										[0.19, -0.07],
										[0.1, -0.15],
										[0.01, -0.23],
										[-0.08, -0.17],
										[-0.18, -0.1],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 6.55],
										[0.38, 0],
										[2.83, 0.14],
										[4.08, 0.47],
										[4.81, 1.26],
										[5.01, 2.37],
										[4.68, 3.44],
										[3.86, 4.11],
										[2.57, 4.29],
										[0.82, 4.18],
										[0.87, 3.22],
										[2.47, 3.31],
										[3.2, 3.22],
										[3.64, 2.88],
										[3.81, 2.3],
										[3.71, 1.69],
										[3.31, 1.29],
										[2.59, 1.11],
										[1.49, 1.05],
										[1.18, 6.62],
										[0, 6.55]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.68, 6.76],
										[2.26, 3.7],
										[3.55, 3.77],
										[5, 6.84],
										[3.69, 6.76],
										[3.68, 6.76]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 14,
					"parent": 10
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.64, 3.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [8.96, 3.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0.99],
										[0.05, 0],
										[5.27, 0.29],
										[5.22, 1.29],
										[3.19, 1.17],
										[2.88, 6.73],
										[1.71, 6.67],
										[2.02, 1.11],
										[0, 0.99]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 15,
					"parent": 10
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.06, 3.38] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [3.06, 3.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, 0.45],
										[0.12, 0.57],
										[0, 0],
										[0.15, -0.44],
										[0.13, -0.33],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.09, -0.35],
										[-0.1, -0.45],
										[0, 0],
										[-0.18, 0.56],
										[-0.14, 0.44],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.01, 6.42],
										[2.67, 0],
										[4.16, 0.08],
										[6.12, 6.77],
										[4.83, 6.7],
										[3.86, 3.23],
										[3.57, 2.01],
										[3.25, 0.47],
										[3.5, 0.49],
										[3.01, 1.99],
										[2.61, 3.15],
										[1.29, 6.49],
										[0, 6.42],
										[0.01, 6.42]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.43, 4.88],
										[1.49, 3.93],
										[4.94, 4.13],
										[4.88, 5.07],
										[1.43, 4.88]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 16,
					"parent": 10
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [23.31, 6.78] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [23.66, 8.1] },
						"r": { "a": 0, "k": 3.26 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -1.1],
										[0, 0],
										[-1.1, 0],
										[0, 0],
										[0, 1.1],
										[0, 0],
										[1.1, 0]
									],
									"o": [
										[0, 0],
										[-1.1, 0],
										[0, 0],
										[0, 1.1],
										[0, 0],
										[1.1, 0],
										[0, 0],
										[0, -1.1],
										[0, 0]
									],
									"v": [
										[44.63, 0],
										[2, 0],
										[0, 2],
										[0, 11.57],
										[2, 13.57],
										[44.63, 13.57],
										[46.63, 11.57],
										[46.63, 2],
										[44.63, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.984, 0.78, 0.153] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 17,
					"parent": 9
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [28.87, 8.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [261.7, 97.09] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 18,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [23.55, 4.57] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [29.18, 8.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 19,
					"parent": 18
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.88, 3.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [44.21, 5.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 6.55],
										[0.38, 0],
										[1.55, 0.07],
										[1.44, 2.01],
										[1.33, 3.58],
										[1.32, 4.16],
										[1.18, 6.61],
										[0.01, 6.55],
										[0, 6.55]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.14, 0.2],
										[-0.16, 0.19],
										[-0.2, 0.21],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0.16, -0.22],
										[0.15, -0.19],
										[0.17, -0.19],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.95, 4.99],
										[1.01, 3.87],
										[1.46, 3.25],
										[1.93, 2.68],
										[2.48, 2.09],
										[4.31, 0.22],
										[5.77, 0.31],
										[2.82, 3.29],
										[2.73, 3.25],
										[0.95, 4.99]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.05, 6.78],
										[2.14, 3.58],
										[2.94, 2.74],
										[5.44, 6.86],
										[4.05, 6.78]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 20,
					"parent": 19
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.91, 3.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [37.49, 5.33] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.44, 0.29],
										[0.23, 0.51],
										[-0.04, 0.71],
										[-0.29, 0.49],
										[-0.47, 0.25],
										[-0.57, -0.03],
										[-0.3, -0.12],
										[-0.23, -0.2],
										[-0.14, -0.29],
										[-0.03, -0.36],
										[0, 0],
										[0.09, 0.16],
										[0.14, 0.11],
										[0.17, 0.07],
										[0.2, 0.02],
										[0.29, -0.16],
										[0.18, -0.33],
										[0.03, -0.49],
										[-0.14, -0.35],
										[-0.27, -0.19],
										[-0.35, -0.02],
										[-0.17, 0.05],
										[-0.14, 0.09],
										[-0.1, 0.15],
										[-0.04, 0.19],
										[0, 0],
										[0.17, -0.27],
										[0.26, -0.2],
										[0.33, -0.1],
										[0.39, 0.02],
										[0, 0]
									],
									"o": [
										[-0.57, -0.03],
										[-0.43, -0.29],
										[-0.23, -0.52],
										[0.04, -0.7],
										[0.29, -0.49],
										[0.47, -0.24],
										[0.36, 0.02],
										[0.3, 0.12],
										[0.24, 0.21],
										[0.14, 0.29],
										[0, 0],
										[-0.03, -0.2],
										[-0.08, -0.15],
										[-0.13, -0.11],
										[-0.17, -0.06],
										[-0.35, -0.02],
										[-0.29, 0.17],
										[-0.17, 0.34],
										[-0.03, 0.5],
										[0.14, 0.35],
										[0.27, 0.19],
										[0.2, 0.01],
										[0.18, -0.04],
										[0.15, -0.09],
										[0.1, -0.14],
										[0, 0],
										[-0.06, 0.31],
										[-0.16, 0.26],
										[-0.25, 0.19],
										[-0.32, 0.1],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.81, 6.73],
										[1.3, 6.25],
										[0.3, 5.04],
										[0.01, 3.21],
										[0.5, 1.42],
										[1.64, 0.32],
										[3.2, 0.01],
										[4.19, 0.21],
										[5, 0.7],
										[5.57, 1.46],
										[5.83, 2.43],
										[4.64, 2.36],
										[4.48, 1.83],
										[4.15, 1.43],
										[3.7, 1.17],
										[3.15, 1.06],
										[2.19, 1.27],
										[1.49, 2.02],
										[1.18, 3.26],
										[1.35, 4.54],
										[1.96, 5.36],
										[2.88, 5.68],
										[3.44, 5.63],
										[3.92, 5.42],
										[4.29, 5.06],
										[4.51, 4.55],
										[5.7, 4.61],
										[5.36, 5.48],
										[4.73, 6.17],
										[3.87, 6.61],
										[2.8, 6.72],
										[2.81, 6.73]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 21,
					"parent": 19
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.06, 3.38] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [30.93, 5.03] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, 0.45],
										[0.12, 0.57],
										[0, 0],
										[0.15, -0.44],
										[0.13, -0.33],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.09, -0.36],
										[-0.1, -0.45],
										[0, 0],
										[-0.18, 0.56],
										[-0.14, 0.44],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.01, 6.42],
										[2.67, 0],
										[4.16, 0.08],
										[6.13, 6.77],
										[4.83, 6.69],
										[3.86, 3.22],
										[3.57, 2.01],
										[3.25, 0.47],
										[3.5, 0.48],
										[3.01, 1.99],
										[2.6, 3.15],
										[1.29, 6.49],
										[0, 6.41],
										[0.01, 6.42]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.44, 4.88],
										[1.49, 3.93],
										[4.94, 4.13],
										[4.88, 5.07],
										[1.44, 4.88]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 22,
					"parent": 19
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.51, 3.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [24.86, 4.62] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.33, -0.19],
										[-0.16, -0.33],
										[0.02, -0.41],
										[0.2, -0.3],
										[0.36, -0.14],
										[0.51, 0.02],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.19, 0.08],
										[-0.1, 0.16],
										[-0.01, 0.23],
										[0.08, 0.17],
										[0.19, 0.1],
										[0.3, 0.02],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0.5, 0.03],
										[0.34, 0.2],
										[0.16, 0.33],
										[-0.03, 0.41],
										[-0.19, 0.3],
										[-0.35, 0.15],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.3, 0.02],
										[0.2, -0.07],
										[0.1, -0.16],
										[0.02, -0.23],
										[-0.08, -0.17],
										[-0.18, -0.1],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.01, 6.55],
										[0.38, 0],
										[2.83, 0.14],
										[4.08, 0.47],
										[4.82, 1.26],
										[5.02, 2.37],
										[4.68, 3.44],
										[3.86, 4.1],
										[2.57, 4.28],
										[0.82, 4.18],
										[0.88, 3.21],
										[2.47, 3.3],
										[3.2, 3.22],
										[3.64, 2.87],
										[3.81, 2.3],
										[3.71, 1.69],
										[3.31, 1.28],
										[2.58, 1.11],
										[1.49, 1.05],
										[1.18, 6.61],
										[0, 6.55],
										[0.01, 6.55]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.69, 6.76],
										[2.27, 3.7],
										[3.55, 3.78],
										[5.01, 6.84],
										[3.69, 6.77],
										[3.69, 6.76]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 23,
					"parent": 19
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.64, 3.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [18.98, 4.21] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0.99],
										[0.06, 0],
										[5.27, 0.29],
										[5.22, 1.29],
										[3.2, 1.17],
										[2.88, 6.73],
										[1.71, 6.67],
										[2.02, 1.11],
										[0, 0.99]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 24,
					"parent": 19
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.94, 3.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [9.98, 3.76] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.09, -0.19],
										[-0.1, -0.24],
										[-0.09, -0.29],
										[0, 0],
										[0, 0.26],
										[0, 0.24],
										[0, 0.16],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.11, 0.21],
										[0.12, 0.26],
										[0.17, 0.37],
										[0, 0],
										[0, -0.28],
										[0.01, -0.22],
										[0.01, -0.13],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0.09, 0.16],
										[0.09, 0.2],
										[0.1, 0.24],
										[0, 0],
										[0, -0.25],
										[0, -0.26],
										[0.01, -0.23],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.11, -0.21],
										[-0.1, -0.21],
										[-0.12, -0.26],
										[0, 0],
										[0, 0.32],
										[0, 0.28],
										[0, 0.22],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 6.55],
										[0.38, 0],
										[1.7, 0.08],
										[3.76, 3.81],
										[4.03, 4.34],
										[4.33, 4.99],
										[4.62, 5.78],
										[4.49, 5.78],
										[4.48, 5.01],
										[4.49, 4.27],
										[4.51, 3.68],
										[4.7, 0.25],
										[5.89, 0.32],
										[5.52, 6.87],
										[4.19, 6.79],
										[2.33, 3.43],
										[2, 2.79],
										[1.67, 2.09],
										[1.24, 1.14],
										[1.41, 1.15],
										[1.41, 2.06],
										[1.4, 2.83],
										[1.39, 3.37],
										[1.2, 6.63],
										[0.01, 6.56],
										[0, 6.55]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 25,
					"parent": 19
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.01, 3.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [3.01, 3.37] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.44, 0.29],
										[0.24, 0.52],
										[-0.04, 0.7],
										[-0.29, 0.49],
										[-0.47, 0.24],
										[-0.57, -0.03],
										[-0.44, -0.29],
										[-0.23, -0.51],
										[0.04, -0.7],
										[0.29, -0.49],
										[0.47, -0.24],
										[0.58, 0.03],
										[0, 0]
									],
									"o": [
										[-0.57, -0.03],
										[-0.44, -0.29],
										[-0.24, -0.52],
										[0.04, -0.7],
										[0.29, -0.49],
										[0.47, -0.24],
										[0.57, 0.03],
										[0.44, 0.29],
										[0.24, 0.52],
										[-0.04, 0.71],
										[-0.29, 0.49],
										[-0.47, 0.24],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.83, 6.73],
										[1.31, 6.25],
										[0.3, 5.03],
										[0.01, 3.2],
										[0.5, 1.41],
										[1.64, 0.32],
										[3.21, 0],
										[4.72, 0.49],
										[5.73, 1.71],
										[6.02, 3.55],
										[5.52, 5.33],
										[4.38, 6.42],
										[2.82, 6.73],
										[2.83, 6.73]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.28, 0.16],
										[-0.17, 0.34],
										[-0.03, 0.5],
										[0.14, 0.35],
										[0.27, 0.2],
										[0.36, 0.02],
										[0.28, -0.16],
										[0.18, -0.33],
										[0.03, -0.5],
										[-0.14, -0.35],
										[-0.26, -0.2],
										[-0.36, -0.02],
										[0, 0]
									],
									"o": [
										[0.36, 0.02],
										[0.29, -0.16],
										[0.18, -0.33],
										[0.03, -0.5],
										[-0.14, -0.35],
										[-0.26, -0.19],
										[-0.35, -0.02],
										[-0.28, 0.17],
										[-0.17, 0.34],
										[-0.03, 0.5],
										[0.14, 0.35],
										[0.27, 0.19],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.89, 5.68],
										[3.85, 5.47],
										[4.54, 4.72],
										[4.84, 3.48],
										[4.68, 2.2],
										[4.08, 1.38],
										[3.15, 1.06],
										[2.19, 1.28],
										[1.49, 2.03],
										[1.19, 3.28],
										[1.35, 4.55],
										[1.96, 5.37],
										[2.89, 5.69],
										[2.89, 5.68]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 26,
					"parent": 19
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [28.53, 6.78] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [28.87, 8.4] },
						"r": { "a": 0, "k": 3.26 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -1.1],
										[0, 0],
										[-1.1, 0],
										[0, 0],
										[0, 1.1],
										[0, 0],
										[1.1, 0]
									],
									"o": [
										[0, 0],
										[-1.1, 0],
										[0, 0],
										[0, 1.1],
										[0, 0],
										[1.1, 0],
										[0, 0],
										[0, -1.1],
										[0, 0]
									],
									"v": [
										[55.07, 0],
										[2, 0],
										[0, 2],
										[0, 11.57],
										[2, 13.57],
										[55.07, 13.57],
										[57.07, 11.57],
										[57.07, 2],
										[55.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.698, 0.875, 0.451] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 27,
					"parent": 18
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [28.87, 8.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [263.08, 72.7] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 28,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [23.54, 4.57] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [29.18, 8.24] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 29,
					"parent": 28
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.88, 3.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [44.21, 5.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 6.55],
										[0.38, 0],
										[1.55, 0.06],
										[1.44, 2.01],
										[1.33, 3.58],
										[1.32, 4.16],
										[1.18, 6.61],
										[0.01, 6.55],
										[0, 6.55]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.14, 0.2],
										[-0.16, 0.19],
										[-0.2, 0.21],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0.16, -0.22],
										[0.15, -0.19],
										[0.17, -0.19],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.94, 4.99],
										[1.01, 3.87],
										[1.45, 3.25],
										[1.92, 2.68],
										[2.48, 2.09],
										[4.3, 0.22],
										[5.76, 0.31],
										[2.81, 3.29],
										[2.73, 3.25],
										[0.94, 4.99]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.05, 6.78],
										[2.14, 3.58],
										[2.94, 2.74],
										[5.44, 6.86],
										[4.05, 6.78]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 30,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.91, 3.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [37.49, 5.33] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.44, 0.29],
										[0.23, 0.51],
										[-0.04, 0.71],
										[-0.29, 0.49],
										[-0.47, 0.25],
										[-0.57, -0.03],
										[-0.3, -0.12],
										[-0.24, -0.2],
										[-0.14, -0.29],
										[-0.03, -0.36],
										[0, 0],
										[0.09, 0.16],
										[0.14, 0.11],
										[0.17, 0.07],
										[0.2, 0.02],
										[0.29, -0.16],
										[0.18, -0.33],
										[0.03, -0.49],
										[-0.14, -0.35],
										[-0.27, -0.19],
										[-0.35, -0.02],
										[-0.18, 0.05],
										[-0.14, 0.09],
										[-0.1, 0.15],
										[-0.04, 0.19],
										[0, 0],
										[0.17, -0.27],
										[0.26, -0.2],
										[0.33, -0.1],
										[0.39, 0.02],
										[0, 0]
									],
									"o": [
										[-0.57, -0.03],
										[-0.44, -0.29],
										[-0.23, -0.52],
										[0.04, -0.7],
										[0.29, -0.49],
										[0.47, -0.24],
										[0.36, 0.02],
										[0.31, 0.12],
										[0.23, 0.21],
										[0.14, 0.29],
										[0, 0],
										[-0.02, -0.2],
										[-0.08, -0.15],
										[-0.13, -0.11],
										[-0.17, -0.06],
										[-0.35, -0.02],
										[-0.29, 0.17],
										[-0.17, 0.34],
										[-0.03, 0.5],
										[0.14, 0.35],
										[0.27, 0.19],
										[0.2, 0.01],
										[0.18, -0.04],
										[0.14, -0.09],
										[0.1, -0.14],
										[0, 0],
										[-0.06, 0.31],
										[-0.16, 0.26],
										[-0.25, 0.2],
										[-0.32, 0.1],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.81, 6.73],
										[1.3, 6.25],
										[0.3, 5.04],
										[0.01, 3.21],
										[0.5, 1.42],
										[1.64, 0.32],
										[3.2, 0],
										[4.19, 0.21],
										[5, 0.7],
										[5.57, 1.46],
										[5.83, 2.43],
										[4.64, 2.37],
										[4.48, 1.84],
										[4.15, 1.44],
										[3.7, 1.17],
										[3.15, 1.06],
										[2.19, 1.27],
										[1.49, 2.02],
										[1.18, 3.27],
										[1.35, 4.55],
										[1.96, 5.36],
										[2.88, 5.68],
										[3.44, 5.63],
										[3.92, 5.42],
										[4.29, 5.06],
										[4.51, 4.55],
										[5.7, 4.62],
										[5.36, 5.48],
										[4.73, 6.17],
										[3.87, 6.61],
										[2.8, 6.73],
										[2.81, 6.73]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 31,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.06, 3.38] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [30.93, 5.03] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, 0.45],
										[0.12, 0.58],
										[0, 0],
										[0.15, -0.44],
										[0.13, -0.33],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.09, -0.36],
										[-0.1, -0.45],
										[0, 0],
										[-0.18, 0.56],
										[-0.14, 0.44],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.01, 6.42],
										[2.67, 0],
										[4.16, 0.08],
										[6.13, 6.77],
										[4.84, 6.69],
										[3.87, 3.22],
										[3.58, 2.01],
										[3.25, 0.46],
										[3.5, 0.48],
										[3.01, 1.99],
										[2.61, 3.15],
										[1.29, 6.49],
										[0, 6.41],
										[0.01, 6.42]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.44, 4.87],
										[1.49, 3.93],
										[4.94, 4.12],
										[4.89, 5.07],
										[1.44, 4.87]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 32,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.51, 3.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [24.86, 4.63] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.33, -0.19],
										[-0.16, -0.33],
										[0.02, -0.41],
										[0.2, -0.3],
										[0.36, -0.14],
										[0.51, 0.02],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.19, 0.08],
										[-0.1, 0.16],
										[-0.01, 0.23],
										[0.08, 0.17],
										[0.19, 0.1],
										[0.3, 0.02],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0.5, 0.03],
										[0.34, 0.2],
										[0.16, 0.33],
										[-0.03, 0.41],
										[-0.19, 0.3],
										[-0.35, 0.15],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.3, 0.02],
										[0.2, -0.07],
										[0.1, -0.16],
										[0.02, -0.23],
										[-0.08, -0.17],
										[-0.18, -0.1],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.01, 6.55],
										[0.38, 0],
										[2.83, 0.14],
										[4.08, 0.47],
										[4.82, 1.26],
										[5.01, 2.37],
										[4.68, 3.44],
										[3.86, 4.1],
										[2.57, 4.28],
										[0.82, 4.18],
										[0.88, 3.21],
										[2.47, 3.3],
										[3.2, 3.22],
										[3.64, 2.87],
										[3.81, 2.3],
										[3.71, 1.69],
										[3.31, 1.28],
										[2.58, 1.11],
										[1.49, 1.05],
										[1.17, 6.61],
										[0, 6.55],
										[0.01, 6.55]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.69, 6.76],
										[2.27, 3.7],
										[3.55, 3.78],
										[5.01, 6.84],
										[3.7, 6.77],
										[3.69, 6.76]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 33,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.63, 3.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [18.98, 4.21] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0.99],
										[0.05, 0],
										[5.27, 0.29],
										[5.22, 1.29],
										[3.2, 1.17],
										[2.88, 6.73],
										[1.71, 6.67],
										[2.02, 1.11],
										[0, 0.99]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 34,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.94, 3.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [9.98, 3.76] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.09, -0.2],
										[-0.11, -0.24],
										[-0.09, -0.29],
										[0, 0],
										[0, 0.26],
										[0, 0.24],
										[0, 0.16],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.11, 0.21],
										[0.12, 0.26],
										[0.17, 0.37],
										[0, 0],
										[0, -0.28],
										[0.01, -0.22],
										[0.01, -0.13],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0.09, 0.16],
										[0.09, 0.2],
										[0.1, 0.24],
										[0, 0],
										[0, -0.25],
										[0, -0.26],
										[0.01, -0.23],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.11, -0.21],
										[-0.1, -0.21],
										[-0.12, -0.26],
										[0, 0],
										[0, 0.32],
										[0, 0.28],
										[0, 0.22],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 6.55],
										[0.38, 0],
										[1.7, 0.07],
										[3.76, 3.81],
										[4.03, 4.34],
										[4.33, 4.99],
										[4.62, 5.78],
										[4.49, 5.78],
										[4.48, 5.01],
										[4.49, 4.27],
										[4.5, 3.68],
										[4.7, 0.25],
										[5.89, 0.32],
										[5.52, 6.87],
										[4.18, 6.79],
										[2.33, 3.43],
										[2, 2.79],
										[1.66, 2.09],
										[1.24, 1.14],
										[1.41, 1.15],
										[1.41, 2.06],
										[1.4, 2.83],
										[1.38, 3.37],
										[1.2, 6.63],
										[0, 6.56],
										[0, 6.55]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 35,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.01, 3.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [3.01, 3.37] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.44, 0.29],
										[0.24, 0.52],
										[-0.04, 0.7],
										[-0.29, 0.49],
										[-0.47, 0.24],
										[-0.57, -0.03],
										[-0.44, -0.29],
										[-0.23, -0.51],
										[0.04, -0.7],
										[0.29, -0.49],
										[0.47, -0.24],
										[0.58, 0.03],
										[0, 0]
									],
									"o": [
										[-0.57, -0.03],
										[-0.44, -0.29],
										[-0.23, -0.51],
										[0.04, -0.7],
										[0.29, -0.49],
										[0.47, -0.24],
										[0.57, 0.04],
										[0.44, 0.29],
										[0.24, 0.52],
										[-0.04, 0.71],
										[-0.29, 0.49],
										[-0.47, 0.24],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.83, 6.73],
										[1.31, 6.25],
										[0.3, 5.03],
										[0.01, 3.2],
										[0.5, 1.41],
										[1.64, 0.32],
										[3.21, 0.01],
										[4.72, 0.49],
										[5.73, 1.71],
										[6.02, 3.54],
										[5.52, 5.33],
										[4.38, 6.42],
										[2.82, 6.73],
										[2.83, 6.73]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.28, 0.16],
										[-0.17, 0.34],
										[-0.03, 0.5],
										[0.14, 0.35],
										[0.26, 0.2],
										[0.36, 0.02],
										[0.28, -0.16],
										[0.18, -0.33],
										[0.03, -0.5],
										[-0.14, -0.35],
										[-0.26, -0.19],
										[-0.36, -0.02],
										[0, 0]
									],
									"o": [
										[0.36, 0.02],
										[0.29, -0.16],
										[0.18, -0.33],
										[0.03, -0.5],
										[-0.13, -0.35],
										[-0.26, -0.19],
										[-0.35, -0.02],
										[-0.28, 0.17],
										[-0.17, 0.34],
										[-0.03, 0.5],
										[0.14, 0.35],
										[0.27, 0.2],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.89, 5.68],
										[3.85, 5.47],
										[4.54, 4.72],
										[4.84, 3.48],
										[4.68, 2.2],
										[4.08, 1.38],
										[3.15, 1.06],
										[2.19, 1.28],
										[1.49, 2.03],
										[1.19, 3.28],
										[1.35, 4.54],
										[1.96, 5.36],
										[2.89, 5.69],
										[2.89, 5.68]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.294, 0.302, 0.318] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 36,
					"parent": 29
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [28.53, 6.78] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [28.87, 8.4] },
						"r": { "a": 0, "k": 3.26 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -1.1],
										[0, 0],
										[-1.1, 0],
										[0, 0],
										[0, 1.1],
										[0, 0],
										[1.1, 0]
									],
									"o": [
										[0, 0],
										[-1.1, 0],
										[0, 0],
										[0, 1.1],
										[0, 0],
										[1.1, 0],
										[0, 0],
										[0, -1.1],
										[0, 0]
									],
									"v": [
										[55.07, 0],
										[2, 0],
										[0, 2],
										[0, 11.57],
										[2, 13.57],
										[55.07, 13.57],
										[57.07, 11.57],
										[57.07, 2],
										[55.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.698, 0.875, 0.451] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 37,
					"parent": 28
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.25, 2.35] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [37.24, 59.31],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [37.24, 59.31],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [37.24, 59.31],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [37.24, 59.31],
									"t": 78
								},
								{ "s": [37.25, 59.31], "t": 108 }
							]
						},
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.23, 0.14],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.22, 0.16],
										[0, 0],
										[0, 0]
									],
									"v": [
										[5.43, 4.61],
										[10.5, 1.67],
										[9.82, 0.51],
										[5.14, 3.24],
										[0.8, 0],
										[0, 1.07],
										[4.7, 4.57],
										[5.44, 4.61],
										[5.43, 4.61]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.718, 0.726, 0.745] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 38,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [64.87, 9.59] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [135.38, 114.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 39,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Reduce inventory 10%",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [54.5, 6.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [74.96, 9.59] },
						"r": { "a": 0, "k": 3.26 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.38, -0.2],
										[-0.18, -0.35],
										[0, -0.45],
										[0.18, -0.34],
										[0.38, -0.2],
										[0.59, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.25, 0.12],
										[-0.11, 0.22],
										[0, 0.3],
										[0.11, 0.23],
										[0.25, 0.12],
										[0.41, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0.59, 0],
										[0.38, 0.2],
										[0.18, 0.35],
										[0, 0.45],
										[-0.18, 0.34],
										[-0.38, 0.19],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.4, 0],
										[0.25, -0.12],
										[0.11, -0.22],
										[0, -0.3],
										[-0.11, -0.23],
										[-0.25, -0.13],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.92, 10],
										[0.92, 2.44],
										[3.47, 2.44],
										[4.93, 2.74],
										[5.77, 3.56],
										[6.04, 4.76],
										[5.77, 5.94],
										[4.93, 6.75],
										[3.49, 7.05],
										[1.42, 7.05],
										[1.42, 6.22],
										[3.46, 6.22],
										[4.43, 6.04],
										[4.97, 5.54],
										[5.14, 4.76],
										[4.97, 3.96],
										[4.43, 3.44],
										[3.44, 3.25],
										[1.83, 3.25],
										[1.83, 10],
										[0.92, 10]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.48, 6.6],
										[6.34, 10],
										[5.27, 10],
										[3.44, 6.6],
										[4.48, 6.6]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.4, 0.24],
										[0.21, 0.44],
										[0, 0.58],
										[-0.21, 0.44],
										[-0.38, 0.25],
										[-0.51, 0],
										[-0.29, -0.1],
										[-0.24, -0.22],
										[-0.14, -0.36],
										[0, -0.53],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, 0.25],
										[0.23, 0.15],
										[0.32, 0],
										[0.25, -0.17],
										[0.14, -0.27],
										[0, -0.31],
										[0, 0],
										[-0.15, -0.3],
										[-0.27, -0.16],
										[-0.35, 0],
										[-0.18, 0.06],
										[-0.14, 0.13],
										[-0.07, 0.2],
										[0, 0],
										[0.21, -0.22],
										[0.31, -0.12],
										[0.38, 0]
									],
									"o": [
										[-0.55, 0],
										[-0.39, -0.24],
										[-0.21, -0.44],
										[0, -0.58],
										[0.21, -0.45],
										[0.38, -0.25],
										[0.3, 0],
										[0.29, 0.1],
										[0.24, 0.22],
										[0.14, 0.36],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.32],
										[-0.13, -0.25],
										[-0.23, -0.15],
										[-0.35, 0],
										[-0.25, 0.17],
										[-0.14, 0.27],
										[0, 0],
										[0, 0.43],
										[0.15, 0.3],
										[0.27, 0.15],
										[0.23, 0],
										[0.19, -0.07],
										[0.14, -0.13],
										[0, 0],
										[-0.09, 0.29],
										[-0.21, 0.21],
										[-0.31, 0.12],
										[0, 0]
									],
									"v": [
										[9.77, 10.12],
										[8.35, 9.76],
										[7.44, 8.74],
										[7.12, 7.21],
										[7.44, 5.67],
										[8.33, 4.63],
										[9.68, 4.25],
										[10.55, 4.4],
										[11.34, 4.88],
										[11.91, 5.75],
										[12.12, 7.09],
										[12.12, 7.46],
										[7.74, 7.46],
										[7.74, 6.71],
										[11.23, 6.71],
										[11.04, 5.85],
										[10.5, 5.25],
										[9.68, 5.04],
										[8.78, 5.29],
										[8.2, 5.96],
										[7.99, 6.84],
										[7.99, 7.34],
										[8.22, 8.43],
										[8.84, 9.11],
										[9.77, 9.34],
										[10.39, 9.24],
										[10.87, 8.94],
										[11.19, 8.45],
										[12.03, 8.69],
										[11.58, 9.44],
										[10.81, 9.94],
										[9.77, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.36, 0.24],
										[0.2, 0.44],
										[0, 0.6],
										[-0.2, 0.44],
										[-0.36, 0.24],
										[-0.48, 0],
										[-0.21, -0.12],
										[-0.11, -0.16],
										[-0.06, -0.1],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.12, -0.16],
										[0.22, -0.12],
										[0.36, 0]
									],
									"o": [
										[-0.47, 0],
										[-0.36, -0.24],
										[-0.2, -0.44],
										[0, -0.6],
										[0.2, -0.44],
										[0.36, -0.24],
										[0.37, 0],
										[0.22, 0.12],
										[0.12, 0.15],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, 0.1],
										[-0.12, 0.16],
										[-0.22, 0.12],
										[0, 0]
									],
									"v": [
										[15.58, 10.12],
										[14.33, 9.76],
										[13.48, 8.74],
										[13.18, 7.18],
										[13.48, 5.63],
										[14.34, 4.61],
										[15.6, 4.25],
										[16.47, 4.44],
										[16.97, 4.85],
										[17.24, 5.23],
										[17.31, 5.23],
										[17.31, 2.44],
										[18.18, 2.44],
										[18.18, 10],
										[17.34, 10],
										[17.34, 9.13],
										[17.24, 9.13],
										[16.97, 9.52],
										[16.46, 9.94],
										[15.58, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.24, 0.18],
										[-0.13, 0.32],
										[0, 0.43],
										[0.12, 0.32],
										[0.24, 0.18],
										[0.35, 0],
										[0.25, -0.19],
										[0.12, -0.32],
										[0, -0.4],
										[-0.12, -0.33],
										[-0.24, -0.19],
										[-0.36, 0]
									],
									"o": [
										[0.35, 0],
										[0.24, -0.18],
										[0.13, -0.33],
										[0, -0.42],
										[-0.12, -0.32],
										[-0.24, -0.18],
										[-0.37, 0],
										[-0.24, 0.19],
										[-0.12, 0.32],
										[0, 0.4],
										[0.13, 0.33],
										[0.25, 0.19],
										[0, 0]
									],
									"v": [
										[15.7, 9.34],
										[16.59, 9.06],
										[17.14, 8.3],
										[17.33, 7.16],
										[17.14, 6.05],
										[16.6, 5.31],
										[15.7, 5.04],
										[14.78, 5.32],
										[14.23, 6.09],
										[14.05, 7.16],
										[14.23, 8.26],
										[14.79, 9.05],
										[15.7, 9.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.28, -0.2],
										[0.43, 0],
										[0.28, 0.16],
										[0.16, 0.32],
										[0, 0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.23, -0.25],
										[-0.36, 0],
										[-0.22, 0.11],
										[-0.15, 0.23],
										[0, 0.35]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.13, 0.29],
										[-0.28, 0.2],
										[-0.35, 0],
										[-0.28, -0.16],
										[-0.16, -0.32],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0.41],
										[0.23, 0.25],
										[0.22, 0],
										[0.23, -0.11],
										[0.16, -0.23],
										[0, 0]
									],
									"v": [
										[23.48, 7.68],
										[23.48, 4.33],
										[24.35, 4.33],
										[24.35, 10],
										[23.48, 10],
										[23.48, 9.04],
										[23.42, 9.04],
										[22.8, 9.77],
										[21.73, 10.07],
										[20.79, 9.84],
										[20.14, 9.13],
										[19.9, 7.93],
										[19.9, 4.33],
										[20.77, 4.33],
										[20.77, 7.87],
										[21.12, 8.86],
										[22.01, 9.23],
										[22.68, 9.07],
										[23.24, 8.56],
										[23.48, 7.68]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.38, 0.25],
										[0.21, 0.44],
										[0, 0.57],
										[-0.21, 0.44],
										[-0.38, 0.25],
										[-0.51, 0],
										[-0.32, -0.15],
										[-0.2, -0.27],
										[-0.05, -0.35],
										[0, 0],
										[0.23, 0.2],
										[0.38, 0],
										[0.26, -0.18],
										[0.14, -0.32],
										[0, -0.43],
										[-0.14, -0.32],
										[-0.25, -0.18],
										[-0.34, 0],
										[-0.18, 0.08],
										[-0.13, 0.15],
										[-0.05, 0.21],
										[0, 0],
										[0.19, -0.27],
										[0.32, -0.16],
										[0.42, 0]
									],
									"o": [
										[-0.53, 0],
										[-0.38, -0.25],
										[-0.21, -0.44],
										[0, -0.58],
										[0.21, -0.44],
										[0.38, -0.25],
										[0.4, 0],
										[0.32, 0.15],
										[0.2, 0.27],
										[0, 0],
										[-0.07, -0.26],
										[-0.23, -0.2],
										[-0.34, 0],
										[-0.25, 0.17],
										[-0.14, 0.32],
										[0, 0.44],
										[0.14, 0.33],
										[0.26, 0.18],
										[0.23, 0],
										[0.18, -0.08],
										[0.13, -0.15],
										[0, 0],
										[-0.05, 0.33],
										[-0.19, 0.27],
										[-0.32, 0.16],
										[0, 0]
									],
									"v": [
										[28.25, 10.12],
										[26.88, 9.74],
										[25.99, 8.7],
										[25.68, 7.19],
										[26, 5.67],
										[26.89, 4.63],
										[28.23, 4.25],
										[29.31, 4.47],
										[30.1, 5.1],
										[30.48, 6.03],
										[29.61, 6.03],
										[29.17, 5.34],
										[28.25, 5.04],
										[27.36, 5.3],
										[26.76, 6.04],
										[26.55, 7.16],
										[26.76, 8.31],
										[27.35, 9.07],
										[28.25, 9.34],
										[28.87, 9.22],
										[29.33, 8.88],
										[29.61, 8.35],
										[30.48, 8.35],
										[30.11, 9.25],
										[29.35, 9.89],
										[28.25, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.4, 0.24],
										[0.21, 0.44],
										[0, 0.58],
										[-0.21, 0.44],
										[-0.38, 0.25],
										[-0.51, 0],
										[-0.29, -0.1],
										[-0.24, -0.22],
										[-0.14, -0.36],
										[0, -0.53],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, 0.25],
										[0.23, 0.15],
										[0.32, 0],
										[0.25, -0.17],
										[0.14, -0.27],
										[0, -0.31],
										[0, 0],
										[-0.15, -0.3],
										[-0.27, -0.16],
										[-0.35, 0],
										[-0.18, 0.06],
										[-0.14, 0.13],
										[-0.07, 0.2],
										[0, 0],
										[0.21, -0.22],
										[0.31, -0.12],
										[0.38, 0]
									],
									"o": [
										[-0.55, 0],
										[-0.39, -0.24],
										[-0.21, -0.44],
										[0, -0.58],
										[0.21, -0.45],
										[0.38, -0.25],
										[0.3, 0],
										[0.29, 0.1],
										[0.24, 0.22],
										[0.14, 0.36],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.32],
										[-0.13, -0.25],
										[-0.23, -0.15],
										[-0.35, 0],
										[-0.25, 0.17],
										[-0.14, 0.27],
										[0, 0],
										[0, 0.43],
										[0.15, 0.3],
										[0.27, 0.15],
										[0.23, 0],
										[0.19, -0.07],
										[0.14, -0.13],
										[0, 0],
										[-0.09, 0.29],
										[-0.21, 0.21],
										[-0.31, 0.12],
										[0, 0]
									],
									"v": [
										[34.13, 10.12],
										[32.72, 9.76],
										[31.81, 8.74],
										[31.49, 7.21],
										[31.81, 5.67],
										[32.7, 4.63],
										[34.04, 4.25],
										[34.92, 4.4],
										[35.71, 4.88],
										[36.27, 5.75],
										[36.48, 7.09],
										[36.48, 7.46],
										[32.11, 7.46],
										[32.11, 6.71],
										[35.59, 6.71],
										[35.4, 5.85],
										[34.86, 5.25],
										[34.04, 5.04],
										[33.14, 5.29],
										[32.56, 5.96],
										[32.36, 6.84],
										[32.36, 7.34],
										[32.58, 8.43],
										[33.21, 9.11],
										[34.13, 9.34],
										[34.75, 9.24],
										[35.24, 8.94],
										[35.55, 8.45],
										[36.39, 8.69],
										[35.95, 9.44],
										[35.17, 9.94],
										[34.13, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[40.73, 10],
										[40.73, 4.33],
										[41.6, 4.33],
										[41.6, 10],
										[40.73, 10]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.12, 0.12],
										[0, 0.16],
										[-0.12, 0.12],
										[-0.17, 0],
										[-0.12, -0.12],
										[0, -0.16],
										[0.12, -0.12],
										[0.17, 0]
									],
									"o": [
										[-0.17, 0],
										[-0.12, -0.12],
										[0, -0.16],
										[0.12, -0.12],
										[0.17, 0],
										[0.12, 0.12],
										[0, 0.16],
										[-0.12, 0.12],
										[0, 0]
									],
									"v": [
										[41.18, 3.38],
										[40.74, 3.21],
										[40.55, 2.79],
										[40.74, 2.37],
										[41.18, 2.2],
										[41.61, 2.37],
										[41.8, 2.79],
										[41.61, 3.21],
										[41.18, 3.38]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.27, 0.17],
										[-0.43, 0],
										[-0.29, -0.16],
										[-0.16, -0.32],
										[0, -0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.23, 0.25],
										[0.4, 0],
										[0.22, -0.12],
										[0.13, -0.23],
										[0, -0.33]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, -0.29],
										[0.27, -0.18],
										[0.38, 0],
										[0.29, 0.16],
										[0.16, 0.32],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.45],
										[-0.23, -0.25],
										[-0.28, 0],
										[-0.22, 0.12],
										[-0.13, 0.23],
										[0, 0]
									],
									"v": [
										[44.07, 6.59],
										[44.07, 10],
										[43.2, 10],
										[43.2, 4.33],
										[44.04, 4.33],
										[44.04, 5.21],
										[44.12, 5.21],
										[44.72, 4.52],
										[45.77, 4.25],
										[46.78, 4.49],
										[47.45, 5.2],
										[47.69, 6.4],
										[47.69, 10],
										[46.82, 10],
										[46.82, 6.45],
										[46.47, 5.41],
										[45.52, 5.04],
										[44.77, 5.22],
										[44.26, 5.75],
										[44.07, 6.59]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[53.72, 4.33],
										[51.62, 10],
										[50.74, 10],
										[48.64, 4.33],
										[49.58, 4.33],
										[51.15, 8.85],
										[51.21, 8.85],
										[52.77, 4.33],
										[53.72, 4.33]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.4, 0.24],
										[0.21, 0.44],
										[0, 0.58],
										[-0.21, 0.44],
										[-0.38, 0.25],
										[-0.51, 0],
										[-0.29, -0.1],
										[-0.24, -0.22],
										[-0.14, -0.36],
										[0, -0.53],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, 0.25],
										[0.23, 0.15],
										[0.32, 0],
										[0.25, -0.17],
										[0.14, -0.27],
										[0, -0.31],
										[0, 0],
										[-0.15, -0.3],
										[-0.27, -0.16],
										[-0.35, 0],
										[-0.18, 0.06],
										[-0.14, 0.13],
										[-0.07, 0.2],
										[0, 0],
										[0.21, -0.22],
										[0.31, -0.12],
										[0.38, 0]
									],
									"o": [
										[-0.55, 0],
										[-0.39, -0.24],
										[-0.21, -0.44],
										[0, -0.58],
										[0.21, -0.45],
										[0.38, -0.25],
										[0.3, 0],
										[0.29, 0.1],
										[0.24, 0.22],
										[0.14, 0.36],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.32],
										[-0.13, -0.25],
										[-0.23, -0.15],
										[-0.35, 0],
										[-0.25, 0.17],
										[-0.14, 0.27],
										[0, 0],
										[0, 0.43],
										[0.15, 0.3],
										[0.27, 0.15],
										[0.23, 0],
										[0.19, -0.07],
										[0.14, -0.13],
										[0, 0],
										[-0.09, 0.29],
										[-0.21, 0.21],
										[-0.31, 0.12],
										[0, 0]
									],
									"v": [
										[57.04, 10.12],
										[55.63, 9.76],
										[54.72, 8.74],
										[54.4, 7.21],
										[54.72, 5.67],
										[55.61, 4.63],
										[56.96, 4.25],
										[57.83, 4.4],
										[58.62, 4.88],
										[59.18, 5.75],
										[59.39, 7.09],
										[59.39, 7.46],
										[55.02, 7.46],
										[55.02, 6.71],
										[58.51, 6.71],
										[58.32, 5.85],
										[57.78, 5.25],
										[56.96, 5.04],
										[56.06, 5.29],
										[55.48, 5.96],
										[55.27, 6.84],
										[55.27, 7.34],
										[55.49, 8.43],
										[56.12, 9.11],
										[57.04, 9.34],
										[57.67, 9.24],
										[58.15, 8.94],
										[58.46, 8.45],
										[59.31, 8.69],
										[58.86, 9.44],
										[58.08, 9.94],
										[57.04, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.27, 0.17],
										[-0.43, 0],
										[-0.29, -0.16],
										[-0.16, -0.32],
										[0, -0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.23, 0.25],
										[0.4, 0],
										[0.22, -0.12],
										[0.13, -0.23],
										[0, -0.33]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, -0.29],
										[0.27, -0.18],
										[0.38, 0],
										[0.29, 0.16],
										[0.16, 0.32],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.45],
										[-0.23, -0.25],
										[-0.28, 0],
										[-0.22, 0.12],
										[-0.13, 0.23],
										[0, 0]
									],
									"v": [
										[61.59, 6.59],
										[61.59, 10],
										[60.72, 10],
										[60.72, 4.33],
										[61.56, 4.33],
										[61.56, 5.21],
										[61.64, 5.21],
										[62.24, 4.52],
										[63.29, 4.25],
										[64.3, 4.49],
										[64.97, 5.2],
										[65.21, 6.4],
										[65.21, 10],
										[64.34, 10],
										[64.34, 6.45],
										[63.99, 5.41],
										[63.04, 5.04],
										[62.29, 5.22],
										[61.78, 5.75],
										[61.59, 6.59]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[69.27, 4.33],
										[69.27, 5.07],
										[66.33, 5.07],
										[66.33, 4.33],
										[69.27, 4.33]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.07, -0.12],
										[-0.11, -0.04],
										[-0.13, 0],
										[-0.06, 0.01],
										[-0.04, 0.01],
										[0, 0],
										[0.11, -0.02],
										[0.16, 0],
										[0.24, 0.11],
										[0.16, 0.22],
										[0, 0.33],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0.25],
										[0.07, 0.12],
										[0.12, 0.04],
										[0.1, 0],
										[0.06, -0.01],
										[0, 0],
										[-0.06, 0.02],
										[-0.11, 0.02],
										[-0.25, 0],
										[-0.23, -0.11],
										[-0.15, -0.22],
										[0, 0],
										[0, 0]
									],
									"v": [
										[67.19, 2.97],
										[68.06, 2.97],
										[68.06, 8.38],
										[68.17, 8.93],
										[68.45, 9.17],
										[68.81, 9.23],
										[69.05, 9.22],
										[69.2, 9.19],
										[69.37, 9.97],
										[69.13, 10.04],
										[68.72, 10.07],
										[68, 9.92],
										[67.42, 9.43],
										[67.19, 8.61],
										[67.19, 2.97]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.39, 0.24],
										[0.22, 0.44],
										[0, 0.59],
										[-0.21, 0.44],
										[-0.38, 0.24],
										[-0.51, 0],
										[-0.38, -0.24],
										[-0.21, -0.44],
										[0, -0.59],
										[0.22, -0.44],
										[0.39, -0.24],
										[0.51, 0]
									],
									"o": [
										[-0.51, 0],
										[-0.38, -0.24],
										[-0.21, -0.44],
										[0, -0.59],
										[0.22, -0.44],
										[0.39, -0.24],
										[0.51, 0],
										[0.39, 0.24],
										[0.22, 0.44],
										[0, 0.59],
										[-0.21, 0.44],
										[-0.38, 0.24],
										[0, 0]
									],
									"v": [
										[72.82, 10.12],
										[71.48, 9.75],
										[70.58, 8.73],
										[70.25, 7.19],
										[70.58, 5.65],
										[71.48, 4.62],
										[72.82, 4.25],
										[74.17, 4.62],
										[75.07, 5.65],
										[75.4, 7.19],
										[75.07, 8.73],
										[74.17, 9.75],
										[72.82, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.25, 0.2],
										[-0.12, 0.32],
										[0, 0.38],
										[0.12, 0.33],
										[0.25, 0.2],
										[0.39, 0],
										[0.25, -0.2],
										[0.12, -0.33],
										[0, -0.38],
										[-0.12, -0.32],
										[-0.25, -0.2],
										[-0.39, 0]
									],
									"o": [
										[0.39, 0],
										[0.25, -0.2],
										[0.12, -0.32],
										[0, -0.38],
										[-0.12, -0.33],
										[-0.25, -0.2],
										[-0.39, 0],
										[-0.25, 0.2],
										[-0.12, 0.33],
										[0, 0.38],
										[0.12, 0.32],
										[0.25, 0.2],
										[0, 0]
									],
									"v": [
										[72.82, 9.34],
										[73.79, 9.04],
										[74.34, 8.25],
										[74.52, 7.19],
										[74.34, 6.13],
										[73.79, 5.34],
										[72.82, 5.04],
										[71.86, 5.34],
										[71.31, 6.13],
										[71.13, 7.19],
										[71.31, 8.25],
										[71.86, 9.04],
										[72.82, 9.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.27, 0.17],
										[-0.34, 0],
										[-0.1, 0],
										[-0.05, 0],
										[0, 0],
										[0.11, 0.01],
										[0.12, 0],
										[0.22, -0.12],
										[0.13, -0.2],
										[0, -0.26],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, -0.28],
										[0.27, -0.17],
										[0.06, 0],
										[0.1, 0],
										[0, 0],
										[-0.03, -0.01],
										[-0.1, -0.02],
										[-0.28, 0],
										[-0.21, 0.11],
										[-0.12, 0.2],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[76.73, 10],
										[76.73, 4.33],
										[77.57, 4.33],
										[77.57, 5.18],
										[77.63, 5.18],
										[78.19, 4.5],
										[79.1, 4.24],
										[79.34, 4.24],
										[79.56, 4.25],
										[79.56, 5.14],
										[79.36, 5.11],
										[79.03, 5.08],
										[78.29, 5.25],
										[77.78, 5.73],
										[77.6, 6.41],
										[77.6, 10],
										[76.73, 10]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.12, 0.02],
										[0.04, 0.02],
										[0, 0],
										[-0.16, 0.01],
										[-0.13, 0.13],
										[-0.11, 0.29],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.16, -0.19],
										[0.21, -0.09],
										[0.26, 0]
									],
									"o": [
										[-0.15, 0],
										[-0.12, -0.02],
										[0, 0],
										[0.21, 0.05],
										[0.16, -0.01],
										[0.13, -0.13],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.11, 0.29],
										[-0.16, 0.19],
										[-0.21, 0.09],
										[0, 0]
									],
									"v": [
										[81.33, 12.13],
										[80.93, 12.09],
										[80.69, 12.02],
										[80.92, 11.26],
										[81.48, 11.31],
										[81.91, 11.1],
										[82.26, 10.47],
										[82.42, 10.03],
										[80.32, 4.33],
										[81.27, 4.33],
										[82.84, 8.85],
										[82.9, 8.85],
										[84.46, 4.33],
										[85.41, 4.33],
										[83, 10.83],
										[82.6, 11.55],
										[82.04, 11.99],
										[81.33, 12.13]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[92.13, 2.44],
										[92.13, 10],
										[91.21, 10],
										[91.21, 3.4],
										[91.17, 3.4],
										[89.32, 4.62],
										[89.32, 3.69],
										[91.21, 2.44],
										[92.13, 2.44]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.39, 0.3],
										[0.21, 0.58],
										[0, 0.82],
										[-0.21, 0.58],
										[-0.39, 0.31],
										[-0.55, 0],
										[-0.39, -0.31],
										[-0.21, -0.58],
										[0, -0.82],
										[0.21, -0.58],
										[0.39, -0.31],
										[0.56, 0]
									],
									"o": [
										[-0.56, 0],
										[-0.39, -0.31],
										[-0.21, -0.58],
										[0, -0.82],
										[0.21, -0.58],
										[0.39, -0.31],
										[0.55, 0],
										[0.39, 0.31],
										[0.21, 0.58],
										[0, 0.82],
										[-0.21, 0.58],
										[-0.39, 0.3],
										[0, 0]
									],
									"v": [
										[96.77, 10.1],
										[95.35, 9.65],
										[94.45, 8.32],
										[94.14, 6.22],
										[94.45, 4.12],
										[95.35, 2.79],
										[96.77, 2.33],
										[98.18, 2.79],
										[99.08, 4.12],
										[99.4, 6.22],
										[99.09, 8.32],
										[98.19, 9.65],
										[96.77, 10.1]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.31, 0.53],
										[0, 0.98],
										[0.14, 0.46],
										[0.26, 0.24],
										[0.36, 0],
										[0.31, -0.54],
										[0, -0.98],
										[-0.14, -0.46],
										[-0.26, -0.24],
										[-0.37, 0]
									],
									"o": [
										[0.55, 0],
										[0.31, -0.53],
										[0, -0.65],
										[-0.14, -0.46],
										[-0.26, -0.24],
										[-0.55, 0],
										[-0.31, 0.54],
										[0, 0.65],
										[0.14, 0.46],
										[0.26, 0.24],
										[0, 0]
									],
									"v": [
										[96.77, 9.29],
										[98.05, 8.49],
										[98.51, 6.22],
										[98.3, 4.55],
										[97.7, 3.49],
										[96.77, 3.13],
										[95.49, 3.94],
										[95.03, 6.22],
										[95.23, 7.89],
										[95.83, 8.93],
										[96.77, 9.29]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.11, 0.23],
										[-0.22, 0.14],
										[-0.32, 0],
										[-0.22, -0.14],
										[-0.11, -0.23],
										[0, -0.28],
										[0, 0],
										[0.11, -0.23],
										[0.22, -0.14],
										[0.31, 0],
										[0.22, 0.14],
										[0.11, 0.23],
										[0, 0.28]
									],
									"o": [
										[0, 0],
										[0, -0.28],
										[0.12, -0.23],
										[0.22, -0.14],
										[0.32, 0],
										[0.22, 0.14],
										[0.11, 0.23],
										[0, 0],
										[0, 0.28],
										[-0.11, 0.23],
										[-0.22, 0.14],
										[-0.32, 0],
										[-0.22, -0.14],
										[-0.11, -0.23],
										[0, 0]
									],
									"v": [
										[104.66, 8.58],
										[104.66, 8.18],
										[104.83, 7.43],
										[105.33, 6.87],
										[106.14, 6.66],
										[106.94, 6.87],
										[107.43, 7.43],
										[107.6, 8.18],
										[107.6, 8.58],
										[107.43, 9.34],
										[106.93, 9.9],
										[106.14, 10.1],
										[105.33, 9.9],
										[104.83, 9.34],
										[104.66, 8.58]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.11, -0.18],
										[-0.27, 0],
										[-0.11, 0.18],
										[0, 0.23],
										[0, 0],
										[0.1, 0.18],
										[0.27, 0],
										[0.11, -0.18],
										[0, -0.23]
									],
									"o": [
										[0, 0],
										[0, 0.23],
										[0.11, 0.18],
										[0.26, 0],
										[0.11, -0.18],
										[0, 0],
										[0, -0.23],
										[-0.1, -0.18],
										[-0.26, 0],
										[-0.11, 0.18],
										[0, 0]
									],
									"v": [
										[105.41, 8.18],
										[105.41, 8.58],
										[105.57, 9.2],
										[106.14, 9.47],
										[106.68, 9.2],
										[106.84, 8.58],
										[106.84, 8.18],
										[106.69, 7.57],
										[106.14, 7.3],
										[105.58, 7.57],
										[105.41, 8.18]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.11, 0.23],
										[-0.22, 0.14],
										[-0.32, 0],
										[-0.22, -0.14],
										[-0.11, -0.23],
										[0, -0.28],
										[0, 0],
										[0.11, -0.23],
										[0.22, -0.14],
										[0.32, 0],
										[0.22, 0.14],
										[0.11, 0.23],
										[0, 0.28]
									],
									"o": [
										[0, 0],
										[0, -0.28],
										[0.12, -0.23],
										[0.22, -0.14],
										[0.32, 0],
										[0.22, 0.14],
										[0.11, 0.23],
										[0, 0],
										[0, 0.28],
										[-0.11, 0.23],
										[-0.22, 0.14],
										[-0.32, 0],
										[-0.22, -0.14],
										[-0.11, -0.23],
										[0, 0]
									],
									"v": [
										[100.89, 4.25],
										[100.89, 3.85],
										[101.06, 3.1],
										[101.56, 2.54],
										[102.37, 2.33],
										[103.17, 2.54],
										[103.66, 3.1],
										[103.83, 3.85],
										[103.83, 4.25],
										[103.66, 5.01],
										[103.17, 5.57],
										[102.37, 5.78],
										[101.56, 5.57],
										[101.06, 5.01],
										[100.89, 4.25]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.11, -0.18],
										[-0.27, 0],
										[-0.11, 0.18],
										[0, 0.23],
										[0, 0],
										[0.1, 0.18],
										[0.27, 0],
										[0.11, -0.18],
										[0, -0.23]
									],
									"o": [
										[0, 0],
										[0, 0.23],
										[0.11, 0.18],
										[0.26, 0],
										[0.11, -0.18],
										[0, 0],
										[0, -0.23],
										[-0.1, -0.18],
										[-0.26, 0],
										[-0.11, 0.18],
										[0, 0]
									],
									"v": [
										[101.64, 3.85],
										[101.64, 4.25],
										[101.81, 4.87],
										[102.37, 5.14],
										[102.91, 4.87],
										[103.08, 4.25],
										[103.08, 3.85],
										[102.92, 3.24],
										[102.37, 2.97],
										[101.81, 3.24],
										[101.64, 3.85]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[101.17, 10],
										[106.37, 2.44],
										[107.21, 2.44],
										[102.01, 10],
										[101.17, 10]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 40,
					"parent": 39
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.79, 5.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [5.79, 6.05] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 41,
					"parent": 39
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.63, 2.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [5.79, 5.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 1.45],
										[1.45, 0],
										[0, -1.45],
										[-1.45, 0]
									],
									"o": [
										[1.45, 0],
										[0, -1.45],
										[-1.45, 0],
										[0, 1.45],
										[0, 0]
									],
									"v": [
										[2.63, 5.26],
										[5.26, 2.63],
										[2.63, 0],
										[0, 2.63],
										[2.63, 5.26]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 78
									},
									{ "s": [1.215], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.898, 0.431, 0] }
						}
					],
					"ind": 42,
					"parent": 41
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.79, 5.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [5.79, 5.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 3.2],
										[3.2, 0],
										[0, -3.2],
										[-3.2, 0]
									],
									"o": [
										[3.2, 0],
										[0, -3.2],
										[-3.2, 0],
										[0, 3.2],
										[0, 0]
									],
									"v": [
										[5.79, 11.58],
										[11.58, 5.79],
										[5.79, 0],
										[0, 5.79],
										[5.79, 11.58]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 78
									},
									{ "s": [1.215], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.898, 0.431, 0] }
						}
					],
					"ind": 43,
					"parent": 41
				},
				{
					"ty": 4,
					"nm": "Increase revenue 15%",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [53.5, 6.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [145.86, 90.16] },
						"r": { "a": 0, "k": 3.26 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.83, 2.44],
										[1.83, 10],
										[0.92, 10],
										[0.92, 2.44],
										[1.83, 2.44]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.27, 0.17],
										[-0.43, 0],
										[-0.29, -0.16],
										[-0.16, -0.32],
										[0, -0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.23, 0.25],
										[0.4, 0],
										[0.22, -0.12],
										[0.13, -0.23],
										[0, -0.33]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, -0.29],
										[0.27, -0.18],
										[0.38, 0],
										[0.29, 0.16],
										[0.16, 0.32],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.45],
										[-0.23, -0.25],
										[-0.28, 0],
										[-0.22, 0.12],
										[-0.13, 0.23],
										[0, 0]
									],
									"v": [
										[4.42, 6.59],
										[4.42, 10],
										[3.55, 10],
										[3.55, 4.33],
										[4.39, 4.33],
										[4.39, 5.21],
										[4.47, 5.21],
										[5.07, 4.52],
										[6.12, 4.25],
										[7.13, 4.49],
										[7.8, 5.2],
										[8.04, 6.4],
										[8.04, 10],
										[7.17, 10],
										[7.17, 6.45],
										[6.82, 5.41],
										[5.87, 5.04],
										[5.12, 5.22],
										[4.61, 5.75],
										[4.42, 6.59]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.38, 0.25],
										[0.21, 0.44],
										[0, 0.57],
										[-0.21, 0.44],
										[-0.38, 0.25],
										[-0.51, 0],
										[-0.32, -0.15],
										[-0.2, -0.27],
										[-0.05, -0.35],
										[0, 0],
										[0.23, 0.2],
										[0.38, 0],
										[0.26, -0.18],
										[0.14, -0.32],
										[0, -0.43],
										[-0.14, -0.32],
										[-0.25, -0.18],
										[-0.34, 0],
										[-0.18, 0.08],
										[-0.13, 0.15],
										[-0.05, 0.21],
										[0, 0],
										[0.19, -0.27],
										[0.32, -0.16],
										[0.42, 0]
									],
									"o": [
										[-0.53, 0],
										[-0.38, -0.25],
										[-0.21, -0.44],
										[0, -0.58],
										[0.21, -0.44],
										[0.38, -0.25],
										[0.4, 0],
										[0.32, 0.15],
										[0.2, 0.27],
										[0, 0],
										[-0.07, -0.26],
										[-0.23, -0.2],
										[-0.34, 0],
										[-0.25, 0.17],
										[-0.14, 0.32],
										[0, 0.44],
										[0.14, 0.33],
										[0.26, 0.18],
										[0.23, 0],
										[0.18, -0.08],
										[0.13, -0.15],
										[0, 0],
										[-0.05, 0.33],
										[-0.19, 0.27],
										[-0.32, 0.16],
										[0, 0]
									],
									"v": [
										[11.94, 10.12],
										[10.56, 9.74],
										[9.68, 8.7],
										[9.37, 7.19],
										[9.69, 5.67],
										[10.58, 4.63],
										[11.92, 4.25],
										[13, 4.47],
										[13.79, 5.1],
										[14.17, 6.03],
										[13.3, 6.03],
										[12.85, 5.34],
										[11.94, 5.04],
										[11.04, 5.3],
										[10.45, 6.04],
										[10.24, 7.16],
										[10.45, 8.31],
										[11.04, 9.07],
										[11.94, 9.34],
										[12.56, 9.22],
										[13.02, 8.88],
										[13.3, 8.35],
										[14.17, 8.35],
										[13.8, 9.25],
										[13.04, 9.89],
										[11.94, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.27, 0.17],
										[-0.34, 0],
										[-0.1, 0],
										[-0.05, 0],
										[0, 0],
										[0.11, 0.01],
										[0.12, 0],
										[0.22, -0.12],
										[0.13, -0.2],
										[0, -0.26],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, -0.28],
										[0.27, -0.17],
										[0.06, 0],
										[0.1, 0],
										[0, 0],
										[-0.03, -0.01],
										[-0.1, -0.02],
										[-0.28, 0],
										[-0.21, 0.11],
										[-0.12, 0.2],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[15.44, 10],
										[15.44, 4.33],
										[16.29, 4.33],
										[16.29, 5.18],
										[16.34, 5.18],
										[16.91, 4.5],
										[17.82, 4.24],
										[18.06, 4.24],
										[18.28, 4.25],
										[18.28, 5.14],
										[18.08, 5.11],
										[17.75, 5.08],
										[17.01, 5.25],
										[16.5, 5.73],
										[16.31, 6.41],
										[16.31, 10],
										[15.44, 10]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.4, 0.24],
										[0.21, 0.44],
										[0, 0.58],
										[-0.21, 0.44],
										[-0.38, 0.25],
										[-0.51, 0],
										[-0.29, -0.1],
										[-0.24, -0.22],
										[-0.14, -0.36],
										[0, -0.53],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, 0.25],
										[0.23, 0.15],
										[0.32, 0],
										[0.25, -0.17],
										[0.14, -0.27],
										[0, -0.31],
										[0, 0],
										[-0.15, -0.3],
										[-0.27, -0.16],
										[-0.35, 0],
										[-0.18, 0.06],
										[-0.14, 0.13],
										[-0.07, 0.2],
										[0, 0],
										[0.21, -0.22],
										[0.31, -0.12],
										[0.38, 0]
									],
									"o": [
										[-0.55, 0],
										[-0.39, -0.24],
										[-0.21, -0.44],
										[0, -0.58],
										[0.21, -0.45],
										[0.38, -0.25],
										[0.3, 0],
										[0.29, 0.1],
										[0.24, 0.22],
										[0.14, 0.36],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.32],
										[-0.13, -0.25],
										[-0.23, -0.15],
										[-0.35, 0],
										[-0.25, 0.17],
										[-0.14, 0.27],
										[0, 0],
										[0, 0.43],
										[0.15, 0.3],
										[0.27, 0.15],
										[0.23, 0],
										[0.19, -0.07],
										[0.14, -0.13],
										[0, 0],
										[-0.09, 0.29],
										[-0.21, 0.21],
										[-0.31, 0.12],
										[0, 0]
									],
									"v": [
										[21.52, 10.12],
										[20.1, 9.76],
										[19.19, 8.74],
										[18.87, 7.21],
										[19.19, 5.67],
										[20.09, 4.63],
										[21.43, 4.25],
										[22.31, 4.4],
										[23.09, 4.88],
										[23.66, 5.75],
										[23.87, 7.09],
										[23.87, 7.46],
										[19.49, 7.46],
										[19.49, 6.71],
										[22.98, 6.71],
										[22.79, 5.85],
										[22.25, 5.25],
										[21.43, 5.04],
										[20.53, 5.29],
										[19.95, 5.96],
										[19.75, 6.84],
										[19.75, 7.34],
										[19.97, 8.43],
										[20.59, 9.11],
										[21.52, 9.34],
										[22.14, 9.24],
										[22.62, 8.94],
										[22.94, 8.45],
										[23.78, 8.69],
										[23.33, 9.44],
										[22.56, 9.94],
										[21.52, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.29, 0.14],
										[0.17, 0.26],
										[0, 0.37],
										[-0.13, 0.2],
										[-0.21, 0.12],
										[-0.26, 0.06],
										[-0.26, 0.03],
										[-0.21, 0.02],
										[-0.1, 0.06],
										[0, 0.14],
										[0, 0],
										[0.2, 0.2],
										[0.4, 0],
										[0.24, -0.18],
										[0.1, -0.21],
										[0, 0],
										[-0.25, 0.19],
										[-0.29, 0.08],
										[-0.29, 0],
										[-0.24, -0.04],
										[-0.22, -0.13],
										[-0.15, -0.27],
										[0, -0.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.14, -0.14],
										[0.23, -0.1],
										[0.33, 0]
									],
									"o": [
										[-0.36, 0],
										[-0.29, -0.14],
										[-0.17, -0.26],
										[0, -0.33],
										[0.13, -0.2],
										[0.21, -0.12],
										[0.26, -0.06],
										[0.34, -0.04],
										[0.22, -0.02],
										[0.1, -0.06],
										[0, 0],
										[0, -0.36],
										[-0.2, -0.2],
										[-0.42, 0],
										[-0.24, 0.18],
										[0, 0],
										[0.15, -0.34],
										[0.25, -0.19],
										[0.3, -0.08],
										[0.18, 0],
										[0.24, 0.04],
										[0.22, 0.13],
										[0.15, 0.27],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, 0.12],
										[-0.14, 0.14],
										[-0.23, 0.1],
										[0, 0]
									],
									"v": [
										[26.86, 10.13],
										[25.88, 9.93],
										[25.19, 9.34],
										[24.93, 8.39],
										[25.12, 7.6],
										[25.63, 7.12],
										[26.34, 6.86],
										[27.13, 6.72],
										[27.97, 6.62],
										[28.44, 6.5],
										[28.59, 6.2],
										[28.59, 6.17],
										[28.29, 5.32],
										[27.39, 5.02],
										[26.42, 5.29],
										[25.92, 5.88],
										[25.09, 5.58],
										[25.68, 4.78],
										[26.49, 4.37],
										[27.36, 4.25],
										[27.99, 4.32],
										[28.68, 4.58],
										[29.24, 5.18],
										[29.46, 6.26],
										[29.46, 10],
										[28.59, 10],
										[28.59, 9.23],
										[28.55, 9.23],
										[28.25, 9.63],
										[27.7, 9.99],
										[26.86, 10.13]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.24, 0.14],
										[-0.12, 0.21],
										[0, 0.24],
										[0, 0],
										[0.13, -0.04],
										[0.16, -0.03],
										[0.15, -0.02],
										[0.09, -0.01],
										[0.2, -0.07],
										[0.12, -0.13],
										[0, -0.22],
										[-0.22, -0.16],
										[-0.35, 0]
									],
									"o": [
										[0.34, 0],
										[0.24, -0.14],
										[0.12, -0.21],
										[0, 0],
										[-0.04, 0.04],
										[-0.12, 0.03],
										[-0.16, 0.02],
										[-0.15, 0.02],
										[-0.23, 0.03],
										[-0.19, 0.06],
										[-0.12, 0.13],
										[0, 0.3],
										[0.23, 0.15],
										[0, 0]
									],
									"v": [
										[27, 9.35],
										[27.87, 9.15],
										[28.41, 8.62],
										[28.59, 7.95],
										[28.59, 7.15],
										[28.35, 7.27],
										[27.92, 7.36],
										[27.45, 7.43],
										[27.08, 7.47],
										[26.45, 7.62],
										[25.98, 7.91],
										[25.8, 8.43],
										[26.13, 9.12],
										[27, 9.35]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0.1, 0.12],
										[0.16, 0.08],
										[0.25, 0],
										[0.23, -0.16],
										[0, -0.24],
										[-0.16, -0.13],
										[-0.33, -0.08],
										[0, 0],
										[-0.25, -0.25],
										[0, -0.4],
										[0.19, -0.26],
										[0.33, -0.15],
										[0.44, 0],
										[0.38, 0.25],
										[0.1, 0.48],
										[0, 0],
										[-0.22, -0.15],
										[-0.36, 0],
										[-0.24, 0.17],
										[0, 0.24],
										[0.14, 0.13],
										[0.29, 0.07],
										[0, 0],
										[0.24, 0.26],
										[0, 0.39],
										[-0.18, 0.25],
										[-0.31, 0.14],
										[-0.4, 0],
										[-0.32, -0.25],
										[-0.14, -0.4]
									],
									"o": [
										[0, 0],
										[-0.05, -0.13],
										[-0.09, -0.13],
										[-0.16, -0.08],
										[-0.35, 0],
										[-0.23, 0.16],
										[0, 0.22],
										[0.16, 0.13],
										[0, 0],
										[0.51, 0.12],
										[0.25, 0.25],
										[0, 0.32],
										[-0.18, 0.26],
										[-0.33, 0.15],
										[-0.58, 0],
										[-0.38, -0.25],
										[0, 0],
										[0.08, 0.31],
										[0.22, 0.15],
										[0.41, 0],
										[0.24, -0.17],
										[0, -0.2],
										[-0.14, -0.14],
										[0, 0],
										[-0.52, -0.12],
										[-0.24, -0.26],
										[0, -0.32],
										[0.18, -0.25],
										[0.32, -0.14],
										[0.56, 0],
										[0.32, 0.25],
										[0, 0]
									],
									"v": [
										[35.07, 5.6],
										[34.29, 5.82],
										[34.07, 5.44],
										[33.69, 5.13],
										[33.06, 5.01],
										[32.19, 5.25],
										[31.85, 5.85],
										[32.09, 6.36],
										[32.83, 6.68],
										[33.67, 6.88],
										[34.8, 7.45],
										[35.17, 8.42],
										[34.89, 9.29],
										[34.12, 9.9],
										[32.96, 10.12],
										[31.52, 9.74],
										[30.8, 8.64],
										[31.63, 8.43],
										[32.08, 9.12],
										[32.94, 9.35],
										[33.91, 9.09],
										[34.27, 8.46],
										[34.07, 7.97],
										[33.43, 7.67],
										[32.49, 7.44],
										[31.34, 6.87],
										[30.98, 5.89],
										[31.25, 5.04],
										[31.99, 4.46],
										[33.06, 4.25],
										[34.38, 4.62],
										[35.07, 5.6]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.4, 0.24],
										[0.21, 0.44],
										[0, 0.58],
										[-0.21, 0.44],
										[-0.38, 0.25],
										[-0.51, 0],
										[-0.29, -0.1],
										[-0.24, -0.22],
										[-0.14, -0.36],
										[0, -0.53],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, 0.25],
										[0.23, 0.15],
										[0.32, 0],
										[0.25, -0.17],
										[0.14, -0.27],
										[0, -0.31],
										[0, 0],
										[-0.15, -0.3],
										[-0.27, -0.16],
										[-0.35, 0],
										[-0.18, 0.06],
										[-0.14, 0.13],
										[-0.07, 0.2],
										[0, 0],
										[0.21, -0.22],
										[0.31, -0.12],
										[0.38, 0]
									],
									"o": [
										[-0.55, 0],
										[-0.39, -0.24],
										[-0.21, -0.44],
										[0, -0.58],
										[0.21, -0.45],
										[0.38, -0.25],
										[0.3, 0],
										[0.29, 0.1],
										[0.24, 0.22],
										[0.14, 0.36],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.32],
										[-0.13, -0.25],
										[-0.23, -0.15],
										[-0.35, 0],
										[-0.25, 0.17],
										[-0.14, 0.27],
										[0, 0],
										[0, 0.43],
										[0.15, 0.3],
										[0.27, 0.15],
										[0.23, 0],
										[0.19, -0.07],
										[0.14, -0.13],
										[0, 0],
										[-0.09, 0.29],
										[-0.21, 0.21],
										[-0.31, 0.12],
										[0, 0]
									],
									"v": [
										[38.87, 10.12],
										[37.45, 9.76],
										[36.54, 8.74],
										[36.22, 7.21],
										[36.54, 5.67],
										[37.43, 4.63],
										[38.78, 4.25],
										[39.65, 4.4],
										[40.44, 4.88],
										[41, 5.75],
										[41.21, 7.09],
										[41.21, 7.46],
										[36.84, 7.46],
										[36.84, 6.71],
										[40.33, 6.71],
										[40.14, 5.85],
										[39.6, 5.25],
										[38.78, 5.04],
										[37.88, 5.29],
										[37.3, 5.96],
										[37.09, 6.84],
										[37.09, 7.34],
										[37.31, 8.43],
										[37.94, 9.11],
										[38.87, 9.34],
										[39.49, 9.24],
										[39.97, 8.94],
										[40.28, 8.45],
										[41.13, 8.69],
										[40.68, 9.44],
										[39.9, 9.94],
										[38.87, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.27, 0.17],
										[-0.34, 0],
										[-0.1, 0],
										[-0.05, 0],
										[0, 0],
										[0.11, 0.01],
										[0.12, 0],
										[0.22, -0.12],
										[0.13, -0.2],
										[0, -0.26],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, -0.28],
										[0.27, -0.17],
										[0.06, 0],
										[0.1, 0],
										[0, 0],
										[-0.03, -0.01],
										[-0.1, -0.02],
										[-0.28, 0],
										[-0.21, 0.11],
										[-0.12, 0.2],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[45.46, 10],
										[45.46, 4.33],
										[46.31, 4.33],
										[46.31, 5.18],
										[46.37, 5.18],
										[46.93, 4.5],
										[47.84, 4.24],
										[48.08, 4.24],
										[48.3, 4.25],
										[48.3, 5.14],
										[48.1, 5.11],
										[47.77, 5.08],
										[47.03, 5.25],
										[46.52, 5.73],
										[46.34, 6.41],
										[46.34, 10],
										[45.46, 10]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.4, 0.24],
										[0.21, 0.44],
										[0, 0.58],
										[-0.21, 0.44],
										[-0.38, 0.25],
										[-0.51, 0],
										[-0.29, -0.1],
										[-0.24, -0.22],
										[-0.14, -0.36],
										[0, -0.53],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, 0.25],
										[0.23, 0.15],
										[0.32, 0],
										[0.25, -0.17],
										[0.14, -0.27],
										[0, -0.31],
										[0, 0],
										[-0.15, -0.3],
										[-0.27, -0.16],
										[-0.35, 0],
										[-0.18, 0.06],
										[-0.14, 0.13],
										[-0.07, 0.2],
										[0, 0],
										[0.21, -0.22],
										[0.31, -0.12],
										[0.38, 0]
									],
									"o": [
										[-0.55, 0],
										[-0.39, -0.24],
										[-0.21, -0.44],
										[0, -0.58],
										[0.21, -0.45],
										[0.38, -0.25],
										[0.3, 0],
										[0.29, 0.1],
										[0.24, 0.22],
										[0.14, 0.36],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.32],
										[-0.13, -0.25],
										[-0.23, -0.15],
										[-0.35, 0],
										[-0.25, 0.17],
										[-0.14, 0.27],
										[0, 0],
										[0, 0.43],
										[0.15, 0.3],
										[0.27, 0.15],
										[0.23, 0],
										[0.19, -0.07],
										[0.14, -0.13],
										[0, 0],
										[-0.09, 0.29],
										[-0.21, 0.21],
										[-0.31, 0.12],
										[0, 0]
									],
									"v": [
										[51.54, 10.12],
										[50.13, 9.76],
										[49.21, 8.74],
										[48.9, 7.21],
										[49.21, 5.67],
										[50.11, 4.63],
										[51.45, 4.25],
										[52.33, 4.4],
										[53.11, 4.88],
										[53.68, 5.75],
										[53.89, 7.09],
										[53.89, 7.46],
										[49.52, 7.46],
										[49.52, 6.71],
										[53, 6.71],
										[52.81, 5.85],
										[52.27, 5.25],
										[51.45, 5.04],
										[50.55, 5.29],
										[49.97, 5.96],
										[49.77, 6.84],
										[49.77, 7.34],
										[49.99, 8.43],
										[50.61, 9.11],
										[51.54, 9.34],
										[52.16, 9.24],
										[52.64, 8.94],
										[52.96, 8.45],
										[53.8, 8.69],
										[53.35, 9.44],
										[52.58, 9.94],
										[51.54, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[59.68, 4.33],
										[57.58, 10],
										[56.7, 10],
										[54.6, 4.33],
										[55.54, 4.33],
										[57.11, 8.85],
										[57.17, 8.85],
										[58.74, 4.33],
										[59.68, 4.33]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.4, 0.24],
										[0.21, 0.44],
										[0, 0.58],
										[-0.21, 0.44],
										[-0.38, 0.25],
										[-0.51, 0],
										[-0.29, -0.1],
										[-0.24, -0.22],
										[-0.14, -0.36],
										[0, -0.53],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, 0.25],
										[0.23, 0.15],
										[0.32, 0],
										[0.25, -0.17],
										[0.14, -0.27],
										[0, -0.31],
										[0, 0],
										[-0.15, -0.3],
										[-0.27, -0.16],
										[-0.35, 0],
										[-0.18, 0.06],
										[-0.14, 0.13],
										[-0.07, 0.2],
										[0, 0],
										[0.21, -0.22],
										[0.31, -0.12],
										[0.38, 0]
									],
									"o": [
										[-0.55, 0],
										[-0.39, -0.24],
										[-0.21, -0.44],
										[0, -0.58],
										[0.21, -0.45],
										[0.38, -0.25],
										[0.3, 0],
										[0.29, 0.1],
										[0.24, 0.22],
										[0.14, 0.36],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.32],
										[-0.13, -0.25],
										[-0.23, -0.15],
										[-0.35, 0],
										[-0.25, 0.17],
										[-0.14, 0.27],
										[0, 0],
										[0, 0.43],
										[0.15, 0.3],
										[0.27, 0.15],
										[0.23, 0],
										[0.19, -0.07],
										[0.14, -0.13],
										[0, 0],
										[-0.09, 0.29],
										[-0.21, 0.21],
										[-0.31, 0.12],
										[0, 0]
									],
									"v": [
										[63.01, 10.12],
										[61.59, 9.76],
										[60.68, 8.74],
										[60.36, 7.21],
										[60.68, 5.67],
										[61.57, 4.63],
										[62.92, 4.25],
										[63.79, 4.4],
										[64.58, 4.88],
										[65.15, 5.75],
										[65.36, 7.09],
										[65.36, 7.46],
										[60.98, 7.46],
										[60.98, 6.71],
										[64.47, 6.71],
										[64.28, 5.85],
										[63.74, 5.25],
										[62.92, 5.04],
										[62.02, 5.29],
										[61.44, 5.96],
										[61.23, 6.84],
										[61.23, 7.34],
										[61.46, 8.43],
										[62.08, 9.11],
										[63.01, 9.34],
										[63.63, 9.24],
										[64.11, 8.94],
										[64.42, 8.45],
										[65.27, 8.69],
										[64.82, 9.44],
										[64.04, 9.94],
										[63.01, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.27, 0.17],
										[-0.43, 0],
										[-0.29, -0.16],
										[-0.16, -0.32],
										[0, -0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.23, 0.25],
										[0.4, 0],
										[0.22, -0.12],
										[0.13, -0.23],
										[0, -0.33]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, -0.29],
										[0.27, -0.18],
										[0.38, 0],
										[0.29, 0.16],
										[0.16, 0.32],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.45],
										[-0.23, -0.25],
										[-0.28, 0],
										[-0.22, 0.12],
										[-0.13, 0.23],
										[0, 0]
									],
									"v": [
										[67.55, 6.59],
										[67.55, 10],
										[66.68, 10],
										[66.68, 4.33],
										[67.52, 4.33],
										[67.52, 5.21],
										[67.6, 5.21],
										[68.2, 4.52],
										[69.25, 4.25],
										[70.26, 4.49],
										[70.93, 5.2],
										[71.17, 6.4],
										[71.17, 10],
										[70.3, 10],
										[70.3, 6.45],
										[69.95, 5.41],
										[69, 5.04],
										[68.25, 5.22],
										[67.74, 5.75],
										[67.55, 6.59]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.28, -0.2],
										[0.43, 0],
										[0.28, 0.16],
										[0.16, 0.32],
										[0, 0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.23, -0.25],
										[-0.36, 0],
										[-0.22, 0.11],
										[-0.15, 0.23],
										[0, 0.35]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.13, 0.29],
										[-0.28, 0.2],
										[-0.35, 0],
										[-0.28, -0.16],
										[-0.16, -0.32],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0.41],
										[0.23, 0.25],
										[0.22, 0],
										[0.23, -0.11],
										[0.16, -0.23],
										[0, 0]
									],
									"v": [
										[76.34, 7.68],
										[76.34, 4.33],
										[77.21, 4.33],
										[77.21, 10],
										[76.34, 10],
										[76.34, 9.04],
										[76.28, 9.04],
										[75.66, 9.77],
										[74.6, 10.07],
										[73.65, 9.84],
										[73, 9.13],
										[72.76, 7.93],
										[72.76, 4.33],
										[73.64, 4.33],
										[73.64, 7.87],
										[73.98, 8.86],
										[74.88, 9.23],
										[75.54, 9.07],
										[76.11, 8.56],
										[76.34, 7.68]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.4, 0.24],
										[0.21, 0.44],
										[0, 0.58],
										[-0.21, 0.44],
										[-0.38, 0.25],
										[-0.51, 0],
										[-0.29, -0.1],
										[-0.24, -0.22],
										[-0.14, -0.36],
										[0, -0.53],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, 0.25],
										[0.23, 0.15],
										[0.32, 0],
										[0.25, -0.17],
										[0.14, -0.27],
										[0, -0.31],
										[0, 0],
										[-0.15, -0.3],
										[-0.27, -0.16],
										[-0.35, 0],
										[-0.18, 0.06],
										[-0.14, 0.13],
										[-0.07, 0.2],
										[0, 0],
										[0.21, -0.22],
										[0.31, -0.12],
										[0.38, 0]
									],
									"o": [
										[-0.55, 0],
										[-0.39, -0.24],
										[-0.21, -0.44],
										[0, -0.58],
										[0.21, -0.45],
										[0.38, -0.25],
										[0.3, 0],
										[0.29, 0.1],
										[0.24, 0.22],
										[0.14, 0.36],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.32],
										[-0.13, -0.25],
										[-0.23, -0.15],
										[-0.35, 0],
										[-0.25, 0.17],
										[-0.14, 0.27],
										[0, 0],
										[0, 0.43],
										[0.15, 0.3],
										[0.27, 0.15],
										[0.23, 0],
										[0.19, -0.07],
										[0.14, -0.13],
										[0, 0],
										[-0.09, 0.29],
										[-0.21, 0.21],
										[-0.31, 0.12],
										[0, 0]
									],
									"v": [
										[81.19, 10.12],
										[79.77, 9.76],
										[78.86, 8.74],
										[78.54, 7.21],
										[78.86, 5.67],
										[79.75, 4.63],
										[81.1, 4.25],
										[81.97, 4.4],
										[82.76, 4.88],
										[83.32, 5.75],
										[83.54, 7.09],
										[83.54, 7.46],
										[79.16, 7.46],
										[79.16, 6.71],
										[82.65, 6.71],
										[82.46, 5.85],
										[81.92, 5.25],
										[81.1, 5.04],
										[80.2, 5.29],
										[79.62, 5.96],
										[79.41, 6.84],
										[79.41, 7.34],
										[79.64, 8.43],
										[80.26, 9.11],
										[81.19, 9.34],
										[81.81, 9.24],
										[82.29, 8.94],
										[82.6, 8.45],
										[83.45, 8.69],
										[83, 9.44],
										[82.22, 9.94],
										[81.19, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[90.43, 2.44],
										[90.43, 10],
										[89.51, 10],
										[89.51, 3.4],
										[89.47, 3.4],
										[87.62, 4.62],
										[87.62, 3.69],
										[89.51, 2.44],
										[90.43, 2.44]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0.17],
										[0.21, 0.3],
										[0.02, 0.38],
										[0, 0],
										[-0.28, -0.22],
										[-0.39, 0],
										[-0.24, 0.15],
										[-0.14, 0.25],
										[0, 0.32],
										[0.15, 0.26],
										[0.25, 0.15],
										[0.32, 0],
										[0.24, -0.07],
										[0.16, -0.11],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.23, 0.08],
										[-0.25, 0],
										[-0.36, -0.22],
										[-0.21, -0.38],
										[0, -0.49],
										[0.22, -0.38],
										[0.38, -0.22],
										[0.48, 0]
									],
									"o": [
										[-0.43, 0],
										[-0.35, -0.17],
										[-0.21, -0.3],
										[0, 0],
										[0.03, 0.34],
										[0.28, 0.22],
										[0.31, 0],
										[0.24, -0.15],
										[0.14, -0.26],
										[0, -0.33],
										[-0.14, -0.26],
										[-0.25, -0.15],
										[-0.23, 0],
										[-0.24, 0.07],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.16, -0.12],
										[0.23, -0.08],
										[0.46, 0],
										[0.36, 0.22],
										[0.21, 0.38],
										[0, 0.48],
										[-0.21, 0.38],
										[-0.38, 0.22],
										[0, 0]
									],
									"v": [
										[94.97, 10.1],
										[93.8, 9.84],
										[92.96, 9.14],
										[92.62, 8.11],
										[93.51, 8.11],
										[93.97, 8.96],
										[94.97, 9.29],
										[95.8, 9.07],
										[96.37, 8.47],
										[96.58, 7.61],
										[96.36, 6.72],
										[95.77, 6.11],
										[94.91, 5.88],
										[94.2, 5.99],
										[93.6, 6.26],
										[92.74, 6.16],
										[93.2, 2.44],
										[97.13, 2.44],
										[97.13, 3.25],
										[93.96, 3.25],
										[93.7, 5.48],
										[93.74, 5.48],
										[94.33, 5.17],
										[95.06, 5.05],
										[96.3, 5.38],
										[97.15, 6.28],
										[97.47, 7.59],
										[97.14, 8.88],
										[96.25, 9.78],
										[94.97, 10.1]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.11, 0.23],
										[-0.22, 0.14],
										[-0.32, 0],
										[-0.22, -0.14],
										[-0.11, -0.23],
										[0, -0.28],
										[0, 0],
										[0.11, -0.23],
										[0.22, -0.14],
										[0.31, 0],
										[0.22, 0.14],
										[0.11, 0.23],
										[0, 0.28]
									],
									"o": [
										[0, 0],
										[0, -0.28],
										[0.11, -0.23],
										[0.22, -0.14],
										[0.32, 0],
										[0.22, 0.14],
										[0.11, 0.23],
										[0, 0],
										[0, 0.28],
										[-0.11, 0.23],
										[-0.22, 0.14],
										[-0.32, 0],
										[-0.22, -0.14],
										[-0.11, -0.23],
										[0, 0]
									],
									"v": [
										[102.79, 8.58],
										[102.79, 8.18],
										[102.96, 7.43],
										[103.46, 6.87],
										[104.27, 6.66],
										[105.07, 6.87],
										[105.56, 7.43],
										[105.73, 8.18],
										[105.73, 8.58],
										[105.56, 9.34],
										[105.06, 9.9],
										[104.27, 10.1],
										[103.46, 9.9],
										[102.96, 9.34],
										[102.79, 8.58]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.11, -0.18],
										[-0.27, 0],
										[-0.11, 0.18],
										[0, 0.23],
										[0, 0],
										[0.1, 0.18],
										[0.27, 0],
										[0.11, -0.18],
										[0, -0.23]
									],
									"o": [
										[0, 0],
										[0, 0.23],
										[0.11, 0.18],
										[0.26, 0],
										[0.11, -0.18],
										[0, 0],
										[0, -0.23],
										[-0.1, -0.18],
										[-0.26, 0],
										[-0.11, 0.18],
										[0, 0]
									],
									"v": [
										[103.54, 8.18],
										[103.54, 8.58],
										[103.71, 9.2],
										[104.27, 9.47],
										[104.81, 9.2],
										[104.98, 8.58],
										[104.98, 8.18],
										[104.82, 7.57],
										[104.27, 7.3],
										[103.71, 7.57],
										[103.54, 8.18]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.11, 0.23],
										[-0.22, 0.14],
										[-0.31, 0],
										[-0.22, -0.14],
										[-0.11, -0.23],
										[0, -0.28],
										[0, 0],
										[0.11, -0.23],
										[0.22, -0.14],
										[0.31, 0],
										[0.22, 0.14],
										[0.11, 0.23],
										[0, 0.28]
									],
									"o": [
										[0, 0],
										[0, -0.28],
										[0.12, -0.23],
										[0.22, -0.14],
										[0.32, 0],
										[0.22, 0.14],
										[0.11, 0.23],
										[0, 0],
										[0, 0.28],
										[-0.11, 0.23],
										[-0.22, 0.14],
										[-0.32, 0],
										[-0.22, -0.14],
										[-0.11, -0.23],
										[0, 0]
									],
									"v": [
										[99.02, 4.25],
										[99.02, 3.85],
										[99.19, 3.1],
										[99.69, 2.54],
										[100.5, 2.33],
										[101.3, 2.54],
										[101.8, 3.1],
										[101.96, 3.85],
										[101.96, 4.25],
										[101.79, 5.01],
										[101.3, 5.57],
										[100.5, 5.78],
										[99.69, 5.57],
										[99.19, 5.01],
										[99.02, 4.25]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.11, -0.18],
										[-0.27, 0],
										[-0.11, 0.18],
										[0, 0.23],
										[0, 0],
										[0.1, 0.18],
										[0.27, 0],
										[0.11, -0.18],
										[0, -0.23]
									],
									"o": [
										[0, 0],
										[0, 0.23],
										[0.11, 0.18],
										[0.26, 0],
										[0.11, -0.18],
										[0, 0],
										[0, -0.23],
										[-0.1, -0.18],
										[-0.26, 0],
										[-0.11, 0.18],
										[0, 0]
									],
									"v": [
										[99.78, 3.85],
										[99.78, 4.25],
										[99.94, 4.87],
										[100.5, 5.14],
										[101.05, 4.87],
										[101.21, 4.25],
										[101.21, 3.85],
										[101.05, 3.24],
										[100.5, 2.97],
										[99.94, 3.24],
										[99.78, 3.85]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[99.3, 10],
										[104.5, 2.44],
										[105.34, 2.44],
										[100.14, 10],
										[99.3, 10]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 44,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.79, 5.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [77.68, 86.69] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 45,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.63, 2.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [5.79, 5.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 1.45],
										[1.45, 0],
										[0, -1.45],
										[-1.45, 0]
									],
									"o": [
										[1.45, 0],
										[0, -1.45],
										[-1.45, 0],
										[0, 1.45],
										[0, 0]
									],
									"v": [
										[2.63, 5.26],
										[5.26, 2.63],
										[2.63, 0],
										[0, 2.63],
										[2.63, 5.26]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 78
									},
									{ "s": [1.215], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.417, 0.603, 0.137] }
						}
					],
					"ind": 46,
					"parent": 45
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.79, 5.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [5.79, 5.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 3.2],
										[3.2, 0],
										[0, -3.2],
										[-3.2, 0]
									],
									"o": [
										[3.2, 0],
										[0, -3.2],
										[-3.2, 0],
										[0, 3.2],
										[0, 0]
									],
									"v": [
										[5.79, 11.58],
										[11.58, 5.79],
										[5.79, 0],
										[0, 5.79],
										[5.79, 11.58]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 78
									},
									{ "s": [1.215], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.417, 0.603, 0.137] }
						}
					],
					"ind": 47,
					"parent": 45
				},
				{
					"ty": 4,
					"nm": "Team Goals",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [30, 6.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [63.44, 33.67] },
						"r": { "a": 0, "k": 3.26 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.38, 3.72],
										[0.38, 2.43],
										[6.56, 2.43],
										[6.56, 3.72],
										[4.25, 3.72],
										[4.25, 10],
										[2.7, 10],
										[2.7, 3.72],
										[0.38, 3.72]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.42, 0.24],
										[0.23, 0.44],
										[0, 0.6],
										[-0.22, 0.44],
										[-0.41, 0.25],
										[-0.55, 0],
										[-0.32, -0.12],
										[-0.24, -0.24],
										[-0.14, -0.36],
										[0, -0.49],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.09, 0.22],
										[0.18, 0.12],
										[0.26, 0],
										[0.19, -0.12],
										[0.09, -0.21],
										[0, -0.27],
										[0, 0],
										[-0.11, -0.22],
										[-0.2, -0.11],
										[-0.26, 0],
										[-0.15, 0.05],
										[-0.1, 0.1],
										[-0.05, 0.15],
										[0, 0],
										[0.23, -0.24],
										[0.34, -0.13],
										[0.44, 0]
									],
									"o": [
										[-0.58, 0],
										[-0.42, -0.24],
										[-0.22, -0.44],
										[0, -0.59],
										[0.22, -0.44],
										[0.41, -0.25],
										[0.37, 0],
										[0.32, 0.12],
										[0.24, 0.24],
										[0.14, 0.36],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.29],
										[-0.09, -0.22],
										[-0.18, -0.12],
										[-0.26, 0],
										[-0.18, 0.12],
										[-0.09, 0.21],
										[0, 0],
										[0, 0.33],
										[0.11, 0.22],
										[0.2, 0.11],
										[0.18, 0],
										[0.15, -0.05],
										[0.11, -0.1],
										[0, 0],
										[-0.09, 0.31],
										[-0.23, 0.23],
										[-0.34, 0.13],
										[0, 0]
									],
									"v": [
										[9.35, 10.11],
										[7.85, 9.76],
										[6.88, 8.75],
										[6.55, 7.19],
										[6.88, 5.65],
										[7.83, 4.62],
										[9.27, 4.25],
										[10.31, 4.43],
										[11.16, 4.97],
										[11.73, 5.86],
										[11.94, 7.13],
										[11.94, 7.56],
										[7.17, 7.56],
										[7.17, 6.6],
										[11.19, 6.6],
										[10.48, 6.86],
										[10.34, 6.09],
										[9.94, 5.58],
										[9.29, 5.4],
										[8.61, 5.58],
										[8.2, 6.08],
										[8.05, 6.79],
										[8.05, 7.47],
										[8.22, 8.29],
										[8.68, 8.8],
										[9.37, 8.96],
										[9.86, 8.89],
										[10.23, 8.66],
										[10.47, 8.29],
										[11.85, 8.55],
										[11.38, 9.38],
										[10.52, 9.92],
										[9.35, 10.11]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.29, 0.13],
										[0.17, 0.25],
										[0, 0.38],
										[-0.12, 0.21],
										[-0.2, 0.13],
										[-0.25, 0.07],
										[-0.28, 0.03],
										[-0.2, 0.03],
										[-0.09, 0.06],
										[0, 0.12],
										[0, 0],
										[0.07, 0.11],
										[0.14, 0.06],
										[0.19, 0],
										[0.15, -0.06],
										[0.09, -0.1],
										[0.04, -0.12],
										[0, 0],
										[-0.23, 0.23],
										[-0.34, 0.12],
										[-0.42, 0],
										[-0.29, -0.07],
										[-0.23, -0.15],
										[-0.13, -0.25],
										[0, -0.34],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.15, -0.14],
										[0.22, -0.08],
										[0.28, 0]
									],
									"o": [
										[-0.36, 0],
										[-0.28, -0.13],
										[-0.16, -0.25],
										[0, -0.31],
										[0.12, -0.21],
										[0.2, -0.13],
										[0.26, -0.07],
										[0.33, -0.03],
										[0.2, -0.03],
										[0.09, -0.06],
										[0, 0],
										[0, -0.16],
										[-0.07, -0.11],
										[-0.13, -0.06],
										[-0.2, 0],
										[-0.15, 0.06],
										[-0.09, 0.1],
										[0, 0],
										[0.1, -0.33],
										[0.23, -0.23],
										[0.34, -0.12],
										[0.3, 0],
										[0.29, 0.07],
										[0.23, 0.15],
										[0.14, 0.24],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.09, 0.18],
										[-0.15, 0.13],
										[-0.21, 0.08],
										[0, 0]
									],
									"v": [
										[14.67, 10.11],
										[13.7, 9.92],
										[13.02, 9.36],
										[12.78, 8.41],
										[12.95, 7.62],
										[13.43, 7.11],
										[14.11, 6.81],
										[14.92, 6.67],
										[15.71, 6.58],
										[16.15, 6.44],
										[16.3, 6.16],
										[16.3, 6.14],
										[16.19, 5.72],
										[15.89, 5.47],
										[15.41, 5.38],
										[14.89, 5.47],
										[14.54, 5.7],
										[14.34, 6.03],
										[12.94, 5.81],
										[13.43, 4.96],
										[14.27, 4.43],
										[15.41, 4.25],
										[16.3, 4.36],
										[17.07, 4.7],
										[17.62, 5.3],
										[17.82, 6.18],
										[17.82, 10],
										[16.38, 10],
										[16.38, 9.21],
										[16.33, 9.21],
										[15.96, 9.68],
										[15.41, 9.99],
										[14.67, 10.11]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.18, 0.09],
										[-0.1, 0.16],
										[0, 0.2],
										[0, 0],
										[0.09, -0.03],
										[0.11, -0.02],
										[0.11, -0.02],
										[0.08, -0.01],
										[0.14, -0.06],
										[0.08, -0.1],
										[0, -0.16],
										[-0.07, -0.1],
										[-0.13, -0.05],
										[-0.17, 0]
									],
									"o": [
										[0.24, 0],
										[0.18, -0.09],
										[0.1, -0.16],
										[0, 0],
										[-0.04, 0.03],
										[-0.09, 0.03],
										[-0.11, 0.02],
										[-0.11, 0.02],
										[-0.19, 0.03],
										[-0.14, 0.06],
										[-0.08, 0.1],
										[0, 0.15],
										[0.07, 0.1],
										[0.13, 0.05],
										[0, 0]
									],
									"v": [
										[15.1, 9.04],
										[15.73, 8.9],
										[16.15, 8.51],
										[16.31, 7.97],
										[16.31, 7.35],
										[16.1, 7.45],
										[15.8, 7.52],
										[15.47, 7.57],
										[15.18, 7.61],
										[14.69, 7.75],
										[14.36, 7.99],
										[14.24, 8.37],
										[14.35, 8.74],
										[14.66, 8.96],
										[15.1, 9.04]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.17, 0.22],
										[-0.23, 0.1],
										[-0.25, 0],
										[-0.25, -0.26],
										[-0.12, -0.54],
										[0, 0],
										[-0.19, 0.23],
										[-0.26, 0.11],
										[-0.29, 0],
										[-0.27, -0.15],
										[-0.16, -0.29],
										[0, -0.41],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.17, 0.16],
										[0.25, 0],
										[0.14, -0.08],
										[0.08, -0.15],
										[0, -0.2],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.17, 0.16],
										[0.26, 0],
										[0.15, -0.08],
										[0.08, -0.16],
										[0, -0.23],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.09, -0.35],
										[0.17, -0.22],
										[0.23, -0.1],
										[0.41, 0],
										[0.25, 0.26],
										[0, 0],
										[0.08, -0.36],
										[0.19, -0.24],
										[0.26, -0.12],
										[0.35, 0],
										[0.27, 0.15],
										[0.16, 0.28],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.32],
										[-0.17, -0.16],
										[-0.19, 0],
										[-0.14, 0.08],
										[-0.07, 0.15],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.28],
										[-0.16, -0.17],
										[-0.18, 0],
										[-0.14, 0.08],
										[-0.08, 0.16],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[19.12, 10],
										[19.12, 4.32],
										[20.54, 4.32],
										[20.61, 5.73],
										[20.5, 5.73],
										[20.89, 4.88],
										[21.49, 4.39],
										[22.22, 4.24],
										[23.21, 4.63],
										[23.76, 5.83],
										[23.58, 5.83],
										[23.99, 4.93],
										[24.67, 4.41],
										[25.5, 4.24],
										[26.43, 4.46],
										[27.08, 5.13],
										[27.32, 6.17],
										[27.32, 10],
										[25.79, 10],
										[25.79, 6.46],
										[25.53, 5.74],
										[24.89, 5.51],
										[24.39, 5.64],
										[24.07, 5.98],
										[23.95, 6.51],
										[23.95, 10],
										[22.48, 10],
										[22.48, 6.42],
										[22.23, 5.76],
										[21.6, 5.51],
										[21.11, 5.63],
										[20.77, 5.99],
										[20.65, 6.57],
										[20.65, 10],
										[19.12, 10]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.53, 0.31],
										[0.3, 0.58],
										[0, 0.8],
										[-0.31, 0.58],
										[-0.53, 0.31],
										[-0.66, 0],
										[-0.37, -0.13],
										[-0.28, -0.23],
										[-0.18, -0.31],
										[-0.05, -0.38],
										[0, 0],
										[0.1, 0.14],
										[0.14, 0.1],
										[0.18, 0.05],
										[0.21, 0],
										[0.3, -0.2],
										[0.17, -0.37],
										[0, -0.53],
										[-0.16, -0.38],
										[-0.3, -0.2],
										[-0.41, 0],
										[-0.26, 0.13],
										[-0.14, 0.24],
										[0, 0.33],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.28, -0.48],
										[0.49, -0.26],
										[0.63, 0]
									],
									"o": [
										[-0.71, 0],
										[-0.53, -0.31],
										[-0.3, -0.58],
										[0, -0.82],
										[0.31, -0.58],
										[0.53, -0.31],
										[0.43, 0],
										[0.37, 0.12],
										[0.29, 0.23],
										[0.18, 0.31],
										[0, 0],
										[-0.05, -0.18],
										[-0.09, -0.15],
										[-0.14, -0.1],
										[-0.18, -0.05],
										[-0.39, 0],
										[-0.3, 0.19],
										[-0.17, 0.37],
										[0, 0.53],
										[0.17, 0.37],
										[0.3, 0.2],
										[0.37, 0],
										[0.26, -0.13],
										[0.14, -0.25],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0.66],
										[-0.28, 0.47],
										[-0.49, 0.25],
										[0, 0]
									],
									"v": [
										[34.48, 10.1],
										[32.61, 9.63],
										[31.36, 8.29],
										[30.92, 6.23],
										[31.38, 4.13],
										[32.65, 2.79],
										[34.44, 2.33],
										[35.63, 2.52],
										[36.61, 3.04],
										[37.31, 3.85],
										[37.66, 4.88],
										[36.09, 4.88],
										[35.86, 4.39],
										[35.51, 4.02],
										[35.04, 3.79],
										[34.47, 3.71],
										[33.43, 4],
										[32.74, 4.85],
										[32.49, 6.21],
										[32.73, 7.58],
										[33.43, 8.43],
										[34.49, 8.73],
										[35.42, 8.53],
										[36.02, 7.96],
										[36.24, 7.1],
										[36.56, 7.15],
										[34.59, 7.15],
										[34.59, 5.97],
										[37.74, 5.97],
										[37.74, 6.91],
										[37.32, 8.62],
										[36.16, 9.72],
										[34.48, 10.1]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.42, 0.24],
										[0.23, 0.44],
										[0, 0.58],
										[-0.22, 0.44],
										[-0.42, 0.24],
										[-0.57, 0],
										[-0.41, -0.25],
										[-0.22, -0.44],
										[0, -0.59],
										[0.23, -0.44],
										[0.42, -0.25],
										[0.57, 0]
									],
									"o": [
										[-0.57, 0],
										[-0.42, -0.25],
										[-0.22, -0.44],
										[0, -0.59],
										[0.23, -0.44],
										[0.42, -0.25],
										[0.57, 0],
										[0.42, 0.24],
										[0.23, 0.44],
										[0, 0.58],
										[-0.22, 0.44],
										[-0.41, 0.24],
										[0, 0]
									],
									"v": [
										[41.44, 10.11],
										[39.96, 9.75],
										[38.99, 8.72],
										[38.66, 7.19],
										[38.99, 5.65],
										[39.96, 4.62],
										[41.44, 4.25],
										[42.92, 4.62],
										[43.88, 5.65],
										[44.22, 7.19],
										[43.88, 8.72],
										[42.92, 9.75],
										[41.44, 10.11]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.18, 0.15],
										[-0.09, 0.26],
										[0, 0.33],
										[0.09, 0.26],
										[0.18, 0.15],
										[0.27, 0],
										[0.18, -0.15],
										[0.09, -0.26],
										[0, -0.34],
										[-0.09, -0.26],
										[-0.18, -0.15],
										[-0.27, 0]
									],
									"o": [
										[0.27, 0],
										[0.18, -0.15],
										[0.09, -0.26],
										[0, -0.34],
										[-0.09, -0.26],
										[-0.18, -0.15],
										[-0.27, 0],
										[-0.18, 0.15],
										[-0.09, 0.26],
										[0, 0.33],
										[0.09, 0.26],
										[0.18, 0.15],
										[0, 0]
									],
									"v": [
										[41.44, 8.91],
										[42.12, 8.69],
										[42.53, 8.07],
										[42.67, 7.18],
										[42.53, 6.29],
										[42.12, 5.67],
										[41.44, 5.45],
										[40.76, 5.67],
										[40.35, 6.29],
										[40.21, 7.18],
										[40.35, 8.07],
										[40.76, 8.69],
										[41.44, 8.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.29, 0.13],
										[0.17, 0.25],
										[0, 0.38],
										[-0.12, 0.21],
										[-0.2, 0.13],
										[-0.25, 0.07],
										[-0.28, 0.03],
										[-0.2, 0.03],
										[-0.09, 0.06],
										[0, 0.12],
										[0, 0],
										[0.07, 0.11],
										[0.14, 0.06],
										[0.19, 0],
										[0.15, -0.06],
										[0.09, -0.1],
										[0.04, -0.12],
										[0, 0],
										[-0.23, 0.23],
										[-0.34, 0.12],
										[-0.42, 0],
										[-0.29, -0.07],
										[-0.23, -0.15],
										[-0.13, -0.25],
										[0, -0.34],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.15, -0.14],
										[0.22, -0.08],
										[0.28, 0]
									],
									"o": [
										[-0.36, 0],
										[-0.28, -0.13],
										[-0.16, -0.25],
										[0, -0.31],
										[0.12, -0.21],
										[0.2, -0.13],
										[0.26, -0.07],
										[0.33, -0.03],
										[0.2, -0.03],
										[0.09, -0.06],
										[0, 0],
										[0, -0.16],
										[-0.07, -0.11],
										[-0.13, -0.06],
										[-0.2, 0],
										[-0.15, 0.06],
										[-0.09, 0.1],
										[0, 0],
										[0.1, -0.33],
										[0.23, -0.23],
										[0.34, -0.12],
										[0.3, 0],
										[0.29, 0.07],
										[0.23, 0.15],
										[0.14, 0.24],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.09, 0.18],
										[-0.15, 0.13],
										[-0.21, 0.08],
										[0, 0]
									],
									"v": [
										[46.96, 10.11],
										[45.99, 9.92],
										[45.32, 9.36],
										[45.07, 8.41],
										[45.25, 7.62],
										[45.72, 7.11],
										[46.41, 6.81],
										[47.22, 6.67],
										[48.01, 6.58],
										[48.45, 6.44],
										[48.59, 6.16],
										[48.59, 6.14],
										[48.49, 5.72],
										[48.19, 5.47],
										[47.7, 5.38],
										[47.19, 5.47],
										[46.84, 5.7],
										[46.63, 6.03],
										[45.24, 5.81],
										[45.72, 4.96],
										[46.57, 4.43],
										[47.71, 4.25],
										[48.6, 4.36],
										[49.37, 4.7],
										[49.91, 5.3],
										[50.12, 6.18],
										[50.12, 10],
										[48.67, 10],
										[48.67, 9.21],
										[48.62, 9.21],
										[48.26, 9.68],
										[47.7, 9.99],
										[46.96, 10.11]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.18, 0.09],
										[-0.1, 0.16],
										[0, 0.2],
										[0, 0],
										[0.09, -0.03],
										[0.11, -0.02],
										[0.11, -0.02],
										[0.08, -0.01],
										[0.14, -0.06],
										[0.08, -0.1],
										[0, -0.16],
										[-0.07, -0.1],
										[-0.13, -0.05],
										[-0.17, 0]
									],
									"o": [
										[0.24, 0],
										[0.18, -0.09],
										[0.1, -0.16],
										[0, 0],
										[-0.04, 0.03],
										[-0.09, 0.03],
										[-0.11, 0.02],
										[-0.11, 0.02],
										[-0.19, 0.03],
										[-0.14, 0.06],
										[-0.08, 0.1],
										[0, 0.15],
										[0.07, 0.1],
										[0.13, 0.05],
										[0, 0]
									],
									"v": [
										[47.39, 9.04],
										[48.02, 8.9],
										[48.45, 8.51],
										[48.6, 7.97],
										[48.6, 7.35],
										[48.4, 7.45],
										[48.09, 7.52],
										[47.76, 7.57],
										[47.48, 7.61],
										[46.98, 7.75],
										[46.65, 7.99],
										[46.54, 8.37],
										[46.65, 8.74],
										[46.95, 8.96],
										[47.39, 9.04]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[52.94, 2.43],
										[52.94, 10],
										[51.42, 10],
										[51.42, 2.43],
										[52.94, 2.43]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.35, 0.13],
										[0.22, 0.25],
										[0.06, 0.35],
										[0, 0],
										[-0.19, -0.13],
										[-0.31, 0],
										[-0.17, 0.11],
										[0, 0.17],
										[0.12, 0.09],
										[0.25, 0.05],
										[0, 0],
										[0.27, 0.27],
										[0, 0.42],
										[-0.2, 0.26],
										[-0.36, 0.14],
										[-0.48, 0],
										[-0.33, -0.13],
										[-0.2, -0.23],
										[-0.07, -0.31],
										[0, 0],
										[0.17, 0.12],
										[0.28, 0],
										[0.17, -0.1],
										[0, -0.18],
										[-0.11, -0.1],
										[-0.27, -0.05],
										[0, 0],
										[-0.27, -0.25],
										[0, -0.41],
										[0.22, -0.28],
										[0.38, -0.16],
										[0.5, 0]
									],
									"o": [
										[-0.46, 0],
										[-0.35, -0.13],
										[-0.22, -0.25],
										[0, 0],
										[0.07, 0.26],
										[0.19, 0.13],
										[0.29, 0],
										[0.17, -0.11],
										[0, -0.15],
										[-0.12, -0.09],
										[0, 0],
										[-0.55, -0.11],
										[-0.27, -0.27],
										[0, -0.37],
										[0.2, -0.26],
										[0.36, -0.14],
										[0.45, 0],
										[0.33, 0.12],
										[0.2, 0.23],
										[0, 0],
										[-0.06, -0.19],
										[-0.16, -0.13],
										[-0.25, 0],
										[-0.17, 0.1],
										[0, 0.14],
										[0.11, 0.1],
										[0, 0],
										[0.55, 0.11],
										[0.27, 0.25],
										[0, 0.37],
										[-0.22, 0.28],
										[-0.38, 0.16],
										[0, 0]
									],
									"v": [
										[56.5, 10.11],
										[55.29, 9.92],
										[54.42, 9.35],
										[53.99, 8.45],
										[55.41, 8.2],
										[55.8, 8.8],
										[56.54, 8.99],
										[57.23, 8.83],
										[57.48, 8.41],
										[57.3, 8.04],
										[56.75, 7.83],
										[55.77, 7.62],
										[54.54, 7.05],
										[54.14, 6.01],
										[54.44, 5.07],
										[55.27, 4.46],
										[56.52, 4.25],
										[57.69, 4.44],
										[58.48, 4.96],
										[58.89, 5.76],
										[57.54, 6],
										[57.21, 5.53],
										[56.54, 5.34],
										[55.92, 5.5],
										[55.66, 5.92],
										[55.82, 6.28],
										[56.39, 6.51],
										[57.41, 6.71],
										[58.64, 7.26],
										[59.04, 8.25],
										[58.71, 9.23],
										[57.81, 9.88],
										[56.5, 10.11]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 48,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Launch portal",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [34, 6.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [107.72, 63.57] },
						"r": { "a": 0, "k": 3.26 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.92, 10],
										[0.92, 2.44],
										[1.83, 2.44],
										[1.83, 9.19],
										[5.35, 9.19],
										[5.35, 10],
										[0.92, 10]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.29, 0.14],
										[0.17, 0.26],
										[0, 0.37],
										[-0.13, 0.2],
										[-0.21, 0.12],
										[-0.26, 0.06],
										[-0.26, 0.03],
										[-0.21, 0.02],
										[-0.1, 0.06],
										[0, 0.14],
										[0, 0],
										[0.2, 0.2],
										[0.4, 0],
										[0.24, -0.18],
										[0.1, -0.21],
										[0, 0],
										[-0.25, 0.19],
										[-0.29, 0.08],
										[-0.29, 0],
										[-0.24, -0.04],
										[-0.22, -0.13],
										[-0.15, -0.27],
										[0, -0.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.14, -0.14],
										[0.23, -0.1],
										[0.33, 0]
									],
									"o": [
										[-0.36, 0],
										[-0.29, -0.14],
										[-0.17, -0.26],
										[0, -0.33],
										[0.13, -0.2],
										[0.21, -0.12],
										[0.26, -0.06],
										[0.34, -0.04],
										[0.22, -0.02],
										[0.1, -0.06],
										[0, 0],
										[0, -0.36],
										[-0.2, -0.2],
										[-0.42, 0],
										[-0.24, 0.18],
										[0, 0],
										[0.15, -0.34],
										[0.25, -0.19],
										[0.3, -0.08],
										[0.18, 0],
										[0.24, 0.04],
										[0.22, 0.13],
										[0.15, 0.27],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, 0.12],
										[-0.14, 0.14],
										[-0.23, 0.1],
										[0, 0]
									],
									"v": [
										[8.32, 10.13],
										[7.34, 9.93],
										[6.64, 9.34],
										[6.38, 8.39],
										[6.57, 7.6],
										[7.09, 7.12],
										[7.8, 6.86],
										[8.58, 6.72],
										[9.42, 6.62],
										[9.89, 6.5],
										[10.05, 6.2],
										[10.05, 6.17],
										[9.75, 5.32],
										[8.85, 5.02],
										[7.87, 5.29],
										[7.37, 5.88],
										[6.54, 5.58],
										[7.14, 4.78],
										[7.95, 4.37],
										[8.82, 4.25],
										[9.45, 4.32],
										[10.14, 4.58],
										[10.7, 5.18],
										[10.92, 6.26],
										[10.92, 10],
										[10.05, 10],
										[10.05, 9.23],
										[10, 9.23],
										[9.71, 9.63],
										[9.16, 9.99],
										[8.32, 10.13]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.24, 0.14],
										[-0.12, 0.21],
										[0, 0.24],
										[0, 0],
										[0.13, -0.04],
										[0.16, -0.03],
										[0.15, -0.02],
										[0.09, -0.01],
										[0.2, -0.07],
										[0.12, -0.13],
										[0, -0.22],
										[-0.22, -0.16],
										[-0.35, 0]
									],
									"o": [
										[0.34, 0],
										[0.24, -0.14],
										[0.12, -0.21],
										[0, 0],
										[-0.04, 0.04],
										[-0.12, 0.03],
										[-0.16, 0.02],
										[-0.15, 0.02],
										[-0.23, 0.03],
										[-0.19, 0.06],
										[-0.12, 0.13],
										[0, 0.3],
										[0.23, 0.15],
										[0, 0]
									],
									"v": [
										[8.45, 9.35],
										[9.32, 9.15],
										[9.86, 8.62],
										[10.05, 7.95],
										[10.05, 7.15],
										[9.8, 7.27],
										[9.37, 7.36],
										[8.9, 7.43],
										[8.54, 7.47],
										[7.9, 7.62],
										[7.43, 7.91],
										[7.25, 8.43],
										[7.59, 9.12],
										[8.45, 9.35]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.28, -0.2],
										[0.43, 0],
										[0.28, 0.16],
										[0.16, 0.32],
										[0, 0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.23, -0.25],
										[-0.36, 0],
										[-0.22, 0.11],
										[-0.15, 0.23],
										[0, 0.35]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.13, 0.29],
										[-0.28, 0.2],
										[-0.35, 0],
										[-0.28, -0.16],
										[-0.16, -0.32],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0.41],
										[0.23, 0.25],
										[0.22, 0],
										[0.23, -0.11],
										[0.16, -0.23],
										[0, 0]
									],
									"v": [
										[16.08, 7.68],
										[16.08, 4.33],
										[16.95, 4.33],
										[16.95, 10],
										[16.08, 10],
										[16.08, 9.04],
										[16.02, 9.04],
										[15.4, 9.77],
										[14.34, 10.07],
										[13.39, 9.84],
										[12.74, 9.13],
										[12.51, 7.93],
										[12.51, 4.33],
										[13.38, 4.33],
										[13.38, 7.87],
										[13.73, 8.86],
										[14.62, 9.23],
										[15.28, 9.07],
										[15.85, 8.56],
										[16.08, 7.68]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.27, 0.17],
										[-0.43, 0],
										[-0.29, -0.16],
										[-0.16, -0.32],
										[0, -0.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.23, 0.25],
										[0.4, 0],
										[0.22, -0.12],
										[0.13, -0.23],
										[0, -0.33]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, -0.29],
										[0.27, -0.18],
										[0.38, 0],
										[0.29, 0.16],
										[0.16, 0.32],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.45],
										[-0.23, -0.25],
										[-0.28, 0],
										[-0.22, 0.12],
										[-0.13, 0.23],
										[0, 0]
									],
									"v": [
										[19.42, 6.59],
										[19.42, 10],
										[18.55, 10],
										[18.55, 4.33],
										[19.39, 4.33],
										[19.39, 5.21],
										[19.47, 5.21],
										[20.07, 4.52],
										[21.12, 4.25],
										[22.13, 4.49],
										[22.8, 5.2],
										[23.04, 6.4],
										[23.04, 10],
										[22.17, 10],
										[22.17, 6.45],
										[21.82, 5.41],
										[20.87, 5.04],
										[20.12, 5.22],
										[19.61, 5.75],
										[19.42, 6.59]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.38, 0.25],
										[0.21, 0.44],
										[0, 0.57],
										[-0.21, 0.44],
										[-0.38, 0.25],
										[-0.51, 0],
										[-0.32, -0.15],
										[-0.2, -0.27],
										[-0.05, -0.35],
										[0, 0],
										[0.23, 0.2],
										[0.38, 0],
										[0.26, -0.18],
										[0.14, -0.32],
										[0, -0.43],
										[-0.14, -0.32],
										[-0.25, -0.18],
										[-0.34, 0],
										[-0.18, 0.08],
										[-0.13, 0.15],
										[-0.05, 0.21],
										[0, 0],
										[0.19, -0.27],
										[0.32, -0.16],
										[0.42, 0]
									],
									"o": [
										[-0.53, 0],
										[-0.38, -0.25],
										[-0.21, -0.44],
										[0, -0.58],
										[0.21, -0.44],
										[0.38, -0.25],
										[0.4, 0],
										[0.32, 0.15],
										[0.2, 0.27],
										[0, 0],
										[-0.07, -0.26],
										[-0.23, -0.2],
										[-0.34, 0],
										[-0.25, 0.17],
										[-0.14, 0.32],
										[0, 0.44],
										[0.14, 0.33],
										[0.26, 0.18],
										[0.23, 0],
										[0.18, -0.08],
										[0.13, -0.15],
										[0, 0],
										[-0.05, 0.33],
										[-0.19, 0.27],
										[-0.32, 0.16],
										[0, 0]
									],
									"v": [
										[26.94, 10.12],
										[25.57, 9.74],
										[24.68, 8.7],
										[24.37, 7.19],
										[24.69, 5.67],
										[25.58, 4.63],
										[26.92, 4.25],
										[28, 4.47],
										[28.79, 5.1],
										[29.17, 6.03],
										[28.3, 6.03],
										[27.85, 5.34],
										[26.94, 5.04],
										[26.05, 5.3],
										[25.45, 6.04],
										[25.24, 7.16],
										[25.45, 8.31],
										[26.04, 9.07],
										[26.94, 9.34],
										[27.56, 9.22],
										[28.02, 8.88],
										[28.3, 8.35],
										[29.17, 8.35],
										[28.8, 9.25],
										[28.04, 9.89],
										[26.94, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.27, 0.17],
										[-0.45, 0],
										[-0.29, -0.16],
										[-0.16, -0.32],
										[0, -0.49],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.23, 0.25],
										[0.41, 0],
										[0.23, -0.12],
										[0.13, -0.23],
										[0, -0.33]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.13, -0.29],
										[0.27, -0.17],
										[0.39, 0],
										[0.29, 0.15],
										[0.16, 0.32],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -0.45],
										[-0.23, -0.25],
										[-0.29, 0],
										[-0.22, 0.12],
										[-0.13, 0.23],
										[0, 0]
									],
									"v": [
										[31.32, 6.59],
										[31.32, 10],
										[30.44, 10],
										[30.44, 2.44],
										[31.32, 2.44],
										[31.32, 5.21],
										[31.39, 5.21],
										[31.99, 4.52],
										[33.06, 4.25],
										[34.07, 4.49],
										[34.75, 5.19],
										[34.99, 6.4],
										[34.99, 10],
										[34.12, 10],
										[34.12, 6.45],
										[33.77, 5.41],
										[32.81, 5.04],
										[32.04, 5.22],
										[31.51, 5.75],
										[31.32, 6.59]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.11, 0.15],
										[-0.21, 0.12],
										[-0.37, 0],
										[-0.36, -0.24],
										[-0.2, -0.44],
										[0, -0.6],
										[0.2, -0.44],
										[0.36, -0.24],
										[0.47, 0],
										[0.22, 0.12],
										[0.12, 0.16],
										[0.06, 0.1],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.06, -0.1],
										[0.12, -0.16],
										[0.22, -0.12],
										[0.48, 0],
										[0.36, 0.24],
										[0.2, 0.44],
										[0, 0.6],
										[-0.2, 0.44],
										[-0.36, 0.24],
										[-0.36, 0],
										[-0.22, -0.12],
										[-0.12, -0.16],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[39.51, 12.13],
										[39.51, 4.33],
										[40.36, 4.33],
										[40.36, 5.23],
										[40.46, 5.23],
										[40.72, 4.85],
										[41.22, 4.44],
										[42.1, 4.25],
										[43.36, 4.61],
										[44.21, 5.63],
										[44.52, 7.18],
										[44.21, 8.74],
										[43.37, 9.76],
										[42.11, 10.12],
										[41.24, 9.94],
										[40.73, 9.52],
										[40.46, 9.13],
										[40.38, 9.13],
										[40.38, 12.13],
										[39.51, 12.13]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.13, -0.33],
										[-0.24, -0.18],
										[-0.35, 0],
										[-0.24, 0.19],
										[-0.12, 0.33],
										[0, 0.4],
										[0.12, 0.32],
										[0.25, 0.19],
										[0.37, 0],
										[0.24, -0.18],
										[0.12, -0.32],
										[0, -0.42]
									],
									"o": [
										[0, 0.43],
										[0.13, 0.32],
										[0.24, 0.18],
										[0.36, 0],
										[0.25, -0.19],
										[0.13, -0.33],
										[0, -0.4],
										[-0.12, -0.32],
										[-0.24, -0.19],
										[-0.35, 0],
										[-0.24, 0.18],
										[-0.12, 0.32],
										[0, 0]
									],
									"v": [
										[40.37, 7.16],
										[40.56, 8.3],
										[41.11, 9.06],
										[42, 9.34],
										[42.91, 9.05],
										[43.46, 8.26],
										[43.65, 7.16],
										[43.47, 6.09],
										[42.91, 5.32],
										[42, 5.04],
										[41.1, 5.31],
										[40.55, 6.05],
										[40.37, 7.16]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.39, 0.24],
										[0.22, 0.44],
										[0, 0.59],
										[-0.21, 0.44],
										[-0.38, 0.24],
										[-0.51, 0],
										[-0.38, -0.24],
										[-0.21, -0.44],
										[0, -0.59],
										[0.22, -0.44],
										[0.39, -0.24],
										[0.51, 0]
									],
									"o": [
										[-0.51, 0],
										[-0.38, -0.24],
										[-0.21, -0.44],
										[0, -0.59],
										[0.22, -0.44],
										[0.39, -0.24],
										[0.51, 0],
										[0.39, 0.24],
										[0.22, 0.44],
										[0, 0.59],
										[-0.21, 0.44],
										[-0.38, 0.24],
										[0, 0]
									],
									"v": [
										[48.16, 10.12],
										[46.81, 9.75],
										[45.91, 8.73],
										[45.58, 7.19],
										[45.91, 5.65],
										[46.81, 4.62],
										[48.16, 4.25],
										[49.5, 4.62],
										[50.4, 5.65],
										[50.73, 7.19],
										[50.4, 8.73],
										[49.5, 9.75],
										[48.16, 10.12]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.25, 0.2],
										[-0.12, 0.32],
										[0, 0.38],
										[0.12, 0.33],
										[0.25, 0.2],
										[0.39, 0],
										[0.25, -0.2],
										[0.12, -0.33],
										[0, -0.38],
										[-0.12, -0.32],
										[-0.25, -0.2],
										[-0.39, 0]
									],
									"o": [
										[0.39, 0],
										[0.25, -0.2],
										[0.12, -0.32],
										[0, -0.38],
										[-0.12, -0.33],
										[-0.25, -0.2],
										[-0.39, 0],
										[-0.25, 0.2],
										[-0.12, 0.33],
										[0, 0.38],
										[0.12, 0.32],
										[0.25, 0.2],
										[0, 0]
									],
									"v": [
										[48.16, 9.34],
										[49.12, 9.04],
										[49.67, 8.25],
										[49.85, 7.19],
										[49.67, 6.13],
										[49.12, 5.34],
										[48.16, 5.04],
										[47.2, 5.34],
										[46.64, 6.13],
										[46.46, 7.19],
										[46.64, 8.25],
										[47.2, 9.04],
										[48.16, 9.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.27, 0.17],
										[-0.34, 0],
										[-0.1, 0],
										[-0.05, 0],
										[0, 0],
										[0.11, 0.01],
										[0.12, 0],
										[0.22, -0.12],
										[0.13, -0.2],
										[0, -0.26],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, -0.28],
										[0.27, -0.17],
										[0.06, 0],
										[0.1, 0],
										[0, 0],
										[-0.03, -0.01],
										[-0.1, -0.02],
										[-0.28, 0],
										[-0.21, 0.11],
										[-0.12, 0.2],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[52.06, 10],
										[52.06, 4.33],
										[52.9, 4.33],
										[52.9, 5.18],
										[52.96, 5.18],
										[53.52, 4.5],
										[54.43, 4.24],
										[54.67, 4.24],
										[54.89, 4.25],
										[54.89, 5.14],
										[54.69, 5.11],
										[54.36, 5.08],
										[53.62, 5.25],
										[53.11, 5.73],
										[52.93, 6.41],
										[52.93, 10],
										[52.06, 10]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[58.75, 4.33],
										[58.75, 5.07],
										[55.81, 5.07],
										[55.81, 4.33],
										[58.75, 4.33]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.07, -0.12],
										[-0.11, -0.04],
										[-0.13, 0],
										[-0.06, 0.01],
										[-0.04, 0.01],
										[0, 0],
										[0.11, -0.02],
										[0.16, 0],
										[0.24, 0.11],
										[0.16, 0.22],
										[0, 0.33],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0.25],
										[0.07, 0.12],
										[0.12, 0.04],
										[0.1, 0],
										[0.06, -0.01],
										[0, 0],
										[-0.06, 0.02],
										[-0.11, 0.02],
										[-0.25, 0],
										[-0.23, -0.11],
										[-0.15, -0.22],
										[0, 0],
										[0, 0]
									],
									"v": [
										[56.67, 2.97],
										[57.54, 2.97],
										[57.54, 8.38],
										[57.64, 8.93],
										[57.92, 9.17],
										[58.29, 9.23],
										[58.53, 9.22],
										[58.67, 9.19],
										[58.85, 9.97],
										[58.6, 10.04],
										[58.2, 10.07],
										[57.48, 9.92],
										[56.89, 9.43],
										[56.67, 8.61],
										[56.67, 2.97]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.29, 0.14],
										[0.17, 0.26],
										[0, 0.37],
										[-0.13, 0.2],
										[-0.21, 0.12],
										[-0.26, 0.06],
										[-0.26, 0.03],
										[-0.21, 0.02],
										[-0.1, 0.06],
										[0, 0.14],
										[0, 0],
										[0.2, 0.2],
										[0.4, 0],
										[0.24, -0.18],
										[0.1, -0.21],
										[0, 0],
										[-0.25, 0.19],
										[-0.29, 0.08],
										[-0.29, 0],
										[-0.24, -0.04],
										[-0.22, -0.13],
										[-0.15, -0.27],
										[0, -0.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.14, -0.14],
										[0.23, -0.1],
										[0.33, 0]
									],
									"o": [
										[-0.36, 0],
										[-0.29, -0.14],
										[-0.17, -0.26],
										[0, -0.33],
										[0.13, -0.2],
										[0.21, -0.12],
										[0.26, -0.06],
										[0.34, -0.04],
										[0.22, -0.02],
										[0.1, -0.06],
										[0, 0],
										[0, -0.36],
										[-0.2, -0.2],
										[-0.42, 0],
										[-0.24, 0.18],
										[0, 0],
										[0.15, -0.34],
										[0.25, -0.19],
										[0.3, -0.08],
										[0.18, 0],
										[0.24, 0.04],
										[0.22, 0.13],
										[0.15, 0.27],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.06, 0.12],
										[-0.14, 0.14],
										[-0.23, 0.1],
										[0, 0]
									],
									"v": [
										[61.73, 10.13],
										[60.75, 9.93],
										[60.05, 9.34],
										[59.79, 8.39],
										[59.99, 7.6],
										[60.5, 7.12],
										[61.21, 6.86],
										[61.99, 6.72],
										[62.83, 6.62],
										[63.31, 6.5],
										[63.46, 6.2],
										[63.46, 6.17],
										[63.16, 5.32],
										[62.26, 5.02],
										[61.28, 5.29],
										[60.78, 5.88],
										[59.96, 5.58],
										[60.55, 4.78],
										[61.36, 4.37],
										[62.23, 4.25],
										[62.86, 4.32],
										[63.55, 4.58],
										[64.11, 5.18],
										[64.33, 6.26],
										[64.33, 10],
										[63.46, 10],
										[63.46, 9.23],
										[63.41, 9.23],
										[63.12, 9.63],
										[62.57, 9.99],
										[61.73, 10.13]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.24, 0.14],
										[-0.12, 0.21],
										[0, 0.24],
										[0, 0],
										[0.13, -0.04],
										[0.16, -0.03],
										[0.15, -0.02],
										[0.09, -0.01],
										[0.2, -0.07],
										[0.12, -0.13],
										[0, -0.22],
										[-0.22, -0.16],
										[-0.35, 0]
									],
									"o": [
										[0.34, 0],
										[0.24, -0.14],
										[0.12, -0.21],
										[0, 0],
										[-0.04, 0.04],
										[-0.12, 0.03],
										[-0.16, 0.02],
										[-0.15, 0.02],
										[-0.23, 0.03],
										[-0.19, 0.06],
										[-0.12, 0.13],
										[0, 0.3],
										[0.23, 0.15],
										[0, 0]
									],
									"v": [
										[61.86, 9.35],
										[62.73, 9.15],
										[63.27, 8.62],
										[63.46, 7.95],
										[63.46, 7.15],
										[63.21, 7.27],
										[62.79, 7.36],
										[62.32, 7.43],
										[61.95, 7.47],
										[61.32, 7.62],
										[60.84, 7.91],
										[60.67, 8.43],
										[61, 9.12],
										[61.86, 9.35]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[66.79, 2.44],
										[66.79, 10],
										[65.92, 10],
										[65.92, 2.44],
										[66.79, 2.44]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0, 0, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 49,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Group",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.79, 5.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [59.02, 61.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 50,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.63, 2.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [5.79, 5.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 1.45],
										[1.45, 0],
										[0, -1.45],
										[-1.45, 0]
									],
									"o": [
										[1.45, 0],
										[0, -1.45],
										[-1.45, 0],
										[0, 1.45],
										[0, 0]
									],
									"v": [
										[2.63, 5.26],
										[5.26, 2.63],
										[2.63, 0],
										[0, 2.63],
										[2.63, 5.26]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 78
									},
									{ "s": [1.215], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.417, 0.603, 0.137] }
						}
					],
					"ind": 51,
					"parent": 50
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.79, 5.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [5.79, 5.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 3.2],
										[3.2, 0],
										[0, -3.2],
										[-3.2, 0]
									],
									"o": [
										[3.2, 0],
										[0, -3.2],
										[-3.2, 0],
										[0, 3.2],
										[0, 0]
									],
									"v": [
										[5.79, 11.58],
										[11.58, 5.79],
										[5.79, 0],
										[0, 5.79],
										[5.79, 11.58]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1.215],
										"t": 78
									},
									{ "s": [1.215], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.417, 0.603, 0.137] }
						}
					],
					"ind": 52,
					"parent": 50
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [148.25, 62.07] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [161.44, 79.1] },
						"r": { "a": 0, "k": 3.26 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -3.31],
										[0, 0],
										[-3.31, 0],
										[0, 0],
										[0, 3.31],
										[0, 0],
										[3.31, 0]
									],
									"o": [
										[0, 0],
										[-3.31, 0],
										[0, 0],
										[0, 3.31],
										[0, 0],
										[3.31, 0],
										[0, 0],
										[0, -3.31],
										[0, 0]
									],
									"v": [
										[290.5, 0],
										[6, 0],
										[0, 6],
										[0, 118.14],
										[6, 124.14],
										[290.5, 124.14],
										[296.5, 118.14],
										[296.5, 6],
										[290.5, 0]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [1],
										"t": 78
									},
									{ "s": [1], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.867, 0.871, 0.882] }
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 53,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"bm": 1,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [148.25, 62.07] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [151.54, 85.87] },
						"r": { "a": 0, "k": 3.26 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, -3.31],
										[0, 0],
										[-3.31, 0],
										[0, 0],
										[0, 3.31],
										[0, 0],
										[3.31, 0]
									],
									"o": [
										[0, 0],
										[-3.31, 0],
										[0, 0],
										[0, 3.31],
										[0, 0],
										[3.31, 0],
										[0, 0],
										[0, -3.31],
										[0, 0]
									],
									"v": [
										[290.5, 0],
										[6, 0],
										[0, 6],
										[0, 118.14],
										[6, 124.14],
										[290.5, 124.14],
										[296.5, 118.14],
										[296.5, 6],
										[290.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.031, 0.059, 0.13] },
							"r": 1,
							"o": { "a": 0, "k": 10 }
						}
					],
					"ind": 54,
					"parent": 3
				},
				{
					"ty": 4,
					"nm": "Team Goals Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [167.63, 80.97] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [167.63, 80.97] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": {
							"a": 1,
							"k": [
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 0
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 24
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 72
								},
								{
									"o": { "x": 0.33, "y": 1 },
									"i": { "x": 0.68, "y": 1 },
									"s": [0],
									"t": 78
								},
								{ "s": [100], "t": 108 }
							]
						}
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[335.27, 0],
										[335.27, 161.93],
										[0, 161.93],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 55
				}
			]
		},
		{
			"id": "3975f5e9ec0071838e2f478b030e45a745141912",
			"e": 1,
			"w": 565,
			"h": 183,
			"p": "data:image/webp;base64,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",
			"u": ""
		},
		{
			"nm": "[Asset] Shapes/Round 5",
			"id": "19",
			"layers": [
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [165.28, 159.99] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [174.81, 162.99] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 12.511],
										[1.993, 11.245],
										[65.136, 10.558],
										[12.126, 0],
										[11.537, -1.894],
										[12.028, -66.48],
										[0, -12.697],
										[-1.993, -11.098],
										[-65.283, -10.902],
										[-12.607, 0],
										[-11.095, 1.796],
										[-11.929, 66.774],
										[0, 0]
									],
									"o": [
										[1.993, -11.098],
										[0, -12.511],
										[-12.028, -66.862],
										[-11.095, -1.805],
										[-12.126, 0],
										[-65.185, 10.902],
										[-2.042, 11.245],
										[0, 12.707],
										[11.929, 66.382],
										[11.537, 1.943],
										[12.607, 0],
										[65.234, -10.607],
										[0, 0],
										[0, 0]
									],
									"v": [
										[321.546, 192.619],
										[324.57, 157.235],
										[321.497, 121.371],
										[197.892, 2.728],
										[162.987, 0],
										[126.668, 2.924],
										[3.063, 121.371],
										[0, 157.235],
										[3.014, 192.619],
										[126.668, 311.066],
										[162.987, 313.99],
										[197.892, 311.262],
										[321.595, 192.619],
										[321.546, 192.619]
									]
								}
							}
						},
						{
							"ty": "st",
							"nm": "",
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"o": { "a": 0, "k": 100 },
							"w": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [6],
										"t": 0
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [6],
										"t": 24
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [6],
										"t": 72
									},
									{
										"o": { "x": 0.33, "y": 1 },
										"i": { "x": 0.68, "y": 1 },
										"s": [6],
										"t": 78
									},
									{ "s": [6], "t": 108 }
								]
							},
							"c": { "a": 0, "k": [0.988, 0.655, 0] }
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.988, 0.655, 0] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Shapes/Round 5 Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [174.5, 160] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [174.5, 160] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[349, 0],
										[349, 320],
										[0, 320],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 2
				}
			]
		},
		{
			"nm": "[Asset] Ambient/Atlassian/Abstract/Combo 2",
			"id": "20",
			"layers": [
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [690.5, 388.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [690.5, 388.5] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [30.52, 126.16] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1309.75, 187.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.22, -0.5],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[1.19, 0.5],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 3.6],
										[61.05, 3.6],
										[61.05, 0],
										[0, 0],
										[0, 250.8],
										[3.6, 252.32],
										[3.6, 3.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 2,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [32.32, 127.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1307.94, 184.95] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.19, -0.52]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[1.18, 0.52],
										[0, 0]
									],
									"v": [
										[3.6, 254.4],
										[3.6, 3.6],
										[64.64, 3.6],
										[64.64, 0],
										[0, 0],
										[0, 252.87],
										[3.6, 254.4]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [28.73, 134.11] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1311.54, 199.06] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-5.15, -1.9],
										[-0.23, -0.09],
										[-2.37, -0.83],
										[-0.26, -0.09],
										[-5.32, -1.67],
										[-0.68, -0.22],
										[-2.03, -0.6],
										[-0.75, -0.22],
										[-2.7, -0.76],
										[-0.03, -0.01],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[4.86, 2],
										[0.23, 0.09],
										[2.32, 0.85],
										[0.26, 0.09],
										[5.05, 1.75],
										[0.68, 0.22],
										[1.98, 0.62],
										[0.75, 0.22],
										[2.65, 0.78],
										[0.01, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[57.45, 102.65],
										[57.45, 0],
										[0, 0],
										[0, 248.71],
										[15.03, 254.57],
										[15.74, 254.83],
										[22.76, 257.35],
										[23.55, 257.62],
										[39.11, 262.77],
										[41.13, 263.4],
										[47.14, 265.23],
										[49.37, 265.89],
										[57.38, 268.21],
										[57.44, 268.22],
										[57.44, 102.62],
										[57.45, 102.65]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 4,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [71.92, 71.94] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [71.92, 71.94] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 5,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.03, 0.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1340.24, 333.19] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.03, 0.01],
										[-0.03, -0.01]
									],
									"o": [
										[0, 0],
										[0.01, 0],
										[0, 0]
									],
									"v": [
										[0.06, 0.01],
										[0, 0],
										[0.06, 0.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 6,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.4, 0.14] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1305.98, 322.44] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.26, 0.09],
										[-0.26, -0.09]
									],
									"o": [
										[-0.27, -0.09],
										[0.26, 0.09],
										[0, 0]
									],
									"v": [
										[0.79, 0.27],
										[0, 0],
										[0.79, 0.27]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 7,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.01, 0.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1322.96, 328.05] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.66, 0.22],
										[-0.66, -0.22]
									],
									"o": [
										[-0.68, -0.22],
										[0.68, 0.22],
										[0, 0]
									],
									"v": [
										[2.01, 0.63],
										[0, 0],
										[2.01, 0.63]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 8,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.35, 0.13] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1298.21, 319.66] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 9,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.11, 0.33] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1331.09, 330.54] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.73, 0.22],
										[-0.75, -0.22]
									],
									"o": [
										[-0.75, -0.22],
										[0.75, 0.22],
										[0, 0]
									],
									"v": [
										[2.23, 0.66],
										[0, 0],
										[2.23, 0.66]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 10,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.88, 1.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1070.49, 494.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0.53, -0.12],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[-0.53, 0.12],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.63, 3.25],
										[3.75, 0.6],
										[2.33, 0],
										[0.75, 0.35],
										[0, 2.13],
										[2.65, 3.25],
										[2.63, 3.25]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 11,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 7.95] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.66, 545.49] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 7.4],
										[3.6, 0],
										[0, 8.52],
										[0, 15.9],
										[3.6, 7.4]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 12,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.93, 0.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1071.87, 492.56] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.62, -0.13],
										[0, 0],
										[0, 0]
									],
									"o": [
										[-0.62, 0.13],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.86, 0],
										[0, 0.4],
										[1.42, 1.01],
										[1.86, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 13,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.81, 1.13] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1069.44, 495.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.15, 0.24],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[1.14, -0.26],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.61, 1.12],
										[0.96, 0],
										[0, 2.26],
										[3.44, 1.51],
										[3.61, 1.12]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 14,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.54, 1.88] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.92, 629.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.08, 0.83],
										[1.11, 0],
										[0, 2.66],
										[2.65, 3.77],
										[3.08, 2.75],
										[3.08, 0.83]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 15,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.49, 2.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1109.51, 487.22] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[1.11, -0.17],
										[0, 0],
										[-1.11, 0.17]
									],
									"o": [
										[0, 0],
										[-1.11, 0.16],
										[0, 0],
										[1.11, -0.17],
										[0, 0]
									],
									"v": [
										[3.34, 3.88],
										[4.98, 0],
										[1.64, 0.5],
										[0, 4.4],
										[3.34, 3.88]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 16,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.99, 2.73] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1049.48, 626.03] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 4.63],
										[1.97, 5.47],
										[1.97, 0],
										[0, 4.63]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 17,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.58, 4.3] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.45, 634.89] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.52, 0],
										[0, 1.21],
										[0, 8.6],
										[3.16, 1.11],
										[0.52, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 18,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.42, 2.04] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1147.72, 482.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[1.08, -0.1],
										[0, 0],
										[-1.08, 0.1]
									],
									"o": [
										[0, 0],
										[-1.08, 0.1],
										[0, 0],
										[1.08, -0.1],
										[0, 0]
									],
									"v": [
										[3.25, 3.77],
										[4.85, 0],
										[1.6, 0.3],
										[0, 4.07],
										[3.25, 3.77]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 19,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.94, 8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1111.17, 569.03] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.13, 6.23],
										[0, 16],
										[5.75, 9.77],
										[9.88, 0],
										[4.13, 6.23]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 20,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.38, 1.47] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1175.19, 501.65] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.69, 2.94],
										[2.76, 0.69],
										[1.12, 0],
										[0, 2.65],
										[0.69, 2.94]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 21,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.98, 6.06] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1178.91, 494.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.2, 6.23],
										[0, 11.44],
										[1.64, 12.13],
										[3.83, 9.77],
										[7.95, 0],
										[2.2, 6.23]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 22,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.37, 1.91] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1185.04, 479.91] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[1.06, -0.06],
										[0, 0],
										[-1.05, 0.04],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-1.06, 0.04],
										[0, 0],
										[1.06, -0.06],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.19, 3.68],
										[4.75, 0],
										[1.55, 0.16],
										[0, 3.83],
										[3.18, 3.68],
										[3.19, 3.68]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 23,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.75, 0.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1173.75, 503.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 1.91],
										[1.5, 0.29],
										[0.81, 0],
										[0, 1.91]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 24,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.8, 1.87] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1053.4, 631.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 2.26],
										[3.52, 3.74],
										[5.6, 1.5],
										[2.09, 0],
										[0, 2.26]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 25,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.22, 0.6] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1050.25, 631.28] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 1.02],
										[0.43, 1.21],
										[0.43, 0],
										[0, 1.02]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 26,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.81, 1.68] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1047.68, 628.91] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 3.12],
										[0.52, 3.35],
										[1.63, 0.69],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 27,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.66, 593.33] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.51],
										[0, 0],
										[0, 3.12],
										[3.6, 4.65],
										[3.6, 1.51]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 28,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.8, 1.87] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1077.48, 605.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.07, 0],
										[0, 2.24],
										[3.52, 3.74],
										[5.6, 1.5],
										[2.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 29,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.66, 557.09] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.53],
										[0, 0],
										[0, 3.12],
										[3.6, 4.65],
										[3.6, 1.53]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 30,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.8, 1.86] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1101.55, 579.44] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.09, 0],
										[0, 2.24],
										[3.52, 3.73],
										[5.6, 1.48],
										[2.09, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 31,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.66, 520.85] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 4.63],
										[3.6, 1.51],
										[0, 0],
										[0, 3.12],
										[3.6, 4.63]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 32,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.8, 1.87] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1125.63, 553.38] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.52, 3.74],
										[5.6, 1.5],
										[2.07, 0],
										[0, 2.26],
										[3.52, 3.74]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 33,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.8, 1.87] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1149.69, 527.32] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[5.6, 1.5],
										[2.09, 0],
										[0, 2.24],
										[3.52, 3.74],
										[5.6, 1.5]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 34,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.64, 0.89] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1067.71, 493.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.09, -0.24],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[-1.09, 0.24],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.28, 0],
										[0, 0.72],
										[2.52, 1.78],
										[3.27, 0],
										[3.28, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 35,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.74, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1073.99, 494.52] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.64, 0.35],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[1.64, -0.36],
										[0, 0],
										[0, 0]
									],
									"v": [
										[5.48, 1.84],
										[1.12, 0],
										[0, 2.65],
										[0.56, 2.88],
										[5.48, 1.83],
										[5.48, 1.84]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 36,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.26, 1.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1133.14, 484.06] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[1.91, -0.24],
										[0, 0],
										[-1.96, 0.22]
									],
									"o": [
										[0, 0],
										[-1.93, 0.23],
										[0, 0],
										[1.94, -0.23],
										[0, 0]
									],
									"v": [
										[12.51, 2.86],
										[5.75, 0],
										[0, 0.69],
										[6.66, 3.51],
										[12.51, 2.86]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 37,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.98, 1.72] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1172.95, 501.12] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.83, 3.44],
										[3.96, 0.79],
										[2.07, 0],
										[0, 2.24],
										[2.83, 3.44]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 38,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.18, 8.52] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1119.17, 562.29] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.13, 7.27],
										[0, 17.04],
										[14.37, 1.48],
										[10.85, 0],
										[4.13, 7.27]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 39,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.04, 2.6] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1175.09, 497.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.09, 0],
										[0, 4.42],
										[1.88, 5.21],
										[4.09, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 40,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [10.87, 13.26] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1057.75, 506.8] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-5.8, 1.29],
										[0, 0],
										[0, 0],
										[6.33, -1.65],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[5.67, -1.45],
										[0, 0],
										[0, 0],
										[-6.49, 1.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.58, 7.44],
										[20.77, 3.32],
										[21.73, 1.06],
										[19.22, 0],
										[0, 4.66],
										[0, 24.99],
										[3.6, 26.52],
										[3.6, 7.45],
										[3.58, 7.44]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 41,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.13, 2.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1139.77, 482.99] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[4.72, -0.56],
										[0, 0],
										[-1.97, 0.2]
									],
									"o": [
										[0, 0],
										[-4.79, 0.46],
										[0, 0],
										[1.96, -0.22],
										[0, 0]
									],
									"v": [
										[12.66, 3.77],
										[14.26, 0],
										[0, 1.53],
										[6.76, 4.39],
										[12.66, 3.77]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 42,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [17.84, 3.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1166.39, 481.21] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[11.21, -1.04],
										[0, 0],
										[-11.55, 0.55],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-11.52, 0.53],
										[0, 0],
										[11.21, -1.05],
										[0, 0],
										[0, 0]
									],
									"v": [
										[34.13, 3.67],
										[35.69, 0],
										[1.6, 2.33],
										[0, 6.1],
										[34.13, 3.68],
										[34.13, 3.67]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 43,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.59, 2.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1121.95, 485.95] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[4.92, -0.73],
										[0, 0],
										[-7.81, 0.91]
									],
									"o": [
										[0, 0],
										[-5.01, 0.62],
										[0, 0],
										[7.64, -1.15],
										[0, 0]
									],
									"v": [
										[23.19, 2.82],
										[16.53, 0],
										[1.64, 2.03],
										[0, 5.91],
										[23.19, 2.82]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 44,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 5.68] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.66, 550.61] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 8.5],
										[0, 9.83],
										[3.6, 11.35],
										[3.6, 0],
										[0, 8.5]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 45,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.76, 12.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1089.52, 592.48] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[21.99, 0],
										[0, 23.81],
										[3.52, 25.31],
										[25.52, 1.48],
										[21.99, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 46,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [18.15, 4.7] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1090.51, 490.22] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-10.27, 1.61],
										[0, 0],
										[11.71, -2.49],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[9.93, -2.06],
										[0, 0],
										[-12.2, 1.87],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.36, 9.4],
										[34.65, 3.9],
										[36.29, 0],
										[0.43, 6.53],
										[0, 7.54],
										[4.36, 9.38],
										[4.36, 9.4]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 47,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.63, 4.81] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1050.5, 636.5] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 0.42],
										[3.6, 0.19],
										[3.16, 0],
										[0, 7.5],
										[0, 9.61],
										[7.26, 1.74],
										[3.74, 0.26],
										[3.6, 0.42]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 48,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 17.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.66, 575.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.53],
										[0, 0],
										[0, 33.12],
										[3.6, 34.63],
										[3.6, 1.53]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 49,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.64, 10.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1188.4, 488.08] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[3.52, -0.14],
										[0, 0],
										[-1.24, 0.06],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[-3.55, 0.1],
										[0, 0],
										[1.24, -0.06],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.13, 11.11],
										[0, 20.88],
										[19.29, 0],
										[8.67, 0.37],
										[7.12, 4.06],
										[10.82, 3.88],
										[4.14, 11.11],
										[4.13, 11.11]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 50,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.41, 12.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1161.39, 514.3] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.51, 25.31],
										[24.02, 3.11],
										[24.83, 1.19],
										[21.99, 0],
										[0, 23.81],
										[3.51, 25.31]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 51,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 12.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.66, 533.86] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.51],
										[0, 0],
										[0, 24.4],
										[3.6, 15.88],
										[3.6, 1.51]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 52,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.76, 12.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1065.45, 618.54] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[21.99, 0],
										[0, 23.81],
										[3.51, 25.31],
										[25.52, 1.5],
										[21.99, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 53,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 16.9] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.66, 611.03] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 29.16],
										[3.6, 1.53],
										[0, 0],
										[0, 33.11],
										[1.63, 33.8],
										[3.6, 29.16]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 54,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.76, 12.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1137.66, 540.35] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[25.52, 1.5],
										[21.99, 0],
										[0, 23.81],
										[3.52, 25.31],
										[25.52, 1.5]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 55,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.26, 0.72] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1047.12, 631.08] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 1.44],
										[0.52, 0.23],
										[0, 0],
										[0, 1.44]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 56,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.76, 5.9] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1105.6, 573.16] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[9.52, 0],
										[0, 10.32],
										[3.51, 11.8],
										[5.39, 9.77],
										[9.52, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 57,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.37, 0.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1071.44, 495.92] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.24, 0.06]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0.24, -0.06],
										[0, 0]
									],
									"v": [
										[0.73, 0.23],
										[0.17, 0],
										[0, 0.39],
										[0.73, 0.23]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 58,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.56, 1.89] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1044.83, 555.33] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.12, 1.12],
										[0.47, 0],
										[0, 1.12],
										[0, 2.94],
										[2, 3.78],
										[3.12, 1.12]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 59,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.79, 0.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1070.15, 492.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.53, 0.12],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0.53, -0.12],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.36, 0],
										[0, 0.86],
										[1.58, 0.52],
										[0.36, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 60,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.39, 2.22] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1072.1, 490.26] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.62, 0.13],
										[0, 0],
										[0.65, -0.13],
										[0.5, -0.12],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0.62, -0.13],
										[0, 0],
										[-0.65, 0.13],
										[-0.5, 0.1],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.01, 3.91],
										[1.24, 4.43],
										[3.09, 4.03],
										[4.79, 0],
										[2.86, 0.4],
										[1.35, 0.73],
										[0, 3.91],
										[0.01, 3.91]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 61,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.56, 4.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1045.3, 550.31] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.12, 0],
										[0, 7.38],
										[2.65, 8.5],
										[3.12, 7.38],
										[3.12, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 62,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1, 2.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1044.27, 559.16] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 5.58],
										[2, 0.85],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 63,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 7.95] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1045.07, 639.75] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 8.52],
										[0, 15.9],
										[3.6, 7.4],
										[3.6, 0],
										[0, 8.52]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 64,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.49, 2.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1111.15, 483.34] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.12, -0.16],
										[0, 0],
										[-1.12, 0.17],
										[0, 0]
									],
									"o": [
										[-1.11, 0.16],
										[0, 0],
										[1.11, -0.17],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.98, 0],
										[1.64, 0.49],
										[0, 4.37],
										[3.34, 3.87],
										[4.98, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 65,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.88, 1.68] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1105.99, 581.12] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.75, 1.14],
										[3.77, 1.11],
										[1.12, 0],
										[0, 2.65],
										[1.7, 3.37],
										[3.75, 1.14]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 66,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.85, 2.36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1103.95, 584.44] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2, 0],
										[0, 4.72],
										[3.7, 0.72],
										[2, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 67,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.42, 2.03] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1149.3, 478.76] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.09, -0.1],
										[0, 0],
										[-1.08, 0.1],
										[0, 0],
										[0, 0]
									],
									"o": [
										[-1.08, 0.1],
										[0, 0],
										[1.08, -0.1],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.85, 0],
										[1.6, 0.29],
										[0, 4.06],
										[3.25, 3.76],
										[4.83, 0],
										[4.85, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 68,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.38, 4.87] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1108.6, 575.67] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.01, 6.23],
										[0, 8.63],
										[2.65, 9.74],
										[6.76, 0],
										[1.01, 6.23]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 69,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.54, 1.54] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1176.04, 502.42] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 2.24],
										[1.96, 3.08],
										[3.08, 0.43],
										[2.07, 0],
										[0, 2.24]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 70,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.37, 1.91] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1186.6, 476.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.06, -0.04],
										[0, 0],
										[-1.08, 0.06],
										[0, 0]
									],
									"o": [
										[-1.06, 0.04],
										[0, 0],
										[1.06, -0.04],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.73, 0],
										[1.55, 0.13],
										[0, 3.81],
										[3.19, 3.65],
										[4.73, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 71,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.79, 5.7] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1172.66, 508.82] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 11.4],
										[5.75, 5.17],
										[7.58, 0.83],
										[5.62, 0],
										[4.13, 1.63],
										[0, 11.4]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 72,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.09, 1.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1177.66, 499.91] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.01, 2.79],
										[2.19, 0],
										[0, 2.36],
										[1.01, 2.79]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 73,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.8, 1.86] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1056.93, 633.05] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.07, 0],
										[0, 2.24],
										[3.52, 3.73],
										[5.6, 1.48],
										[2.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 74,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1045.07, 628.04] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.51],
										[0, 0],
										[0, 3.12],
										[3.6, 4.63],
										[3.6, 1.51]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 75,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.8, 1.86] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1081.01, 607] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.07, 0],
										[0, 2.24],
										[3.51, 3.73],
										[5.6, 1.48],
										[2.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 76,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1045.07, 591.8] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.53],
										[0, 0],
										[0, 3.12],
										[3.6, 4.65],
										[3.6, 1.53]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 77,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.8, 1.66] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1046.07, 556.22] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.12, 0],
										[0, 2.66],
										[1.6, 3.32],
										[1.6, 0.2],
										[1.12, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 78,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.01, 0.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1107.86, 580.56] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.01, 0],
										[0, 0.03],
										[0.01, 0.01],
										[0.01, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 79,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.24, 0.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1043.51, 553.9] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 1.31],
										[0.47, 0.19],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 80,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.47, 1.51] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1103.75, 580.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.07, 0],
										[0, 2.24],
										[1.83, 3.02],
										[2.95, 0.37],
										[2.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 81,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1045.07, 519.33] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.53],
										[0, 0],
										[0, 3.12],
										[3.6, 4.65],
										[3.6, 1.53]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 82,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.8, 1.86] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1129.15, 554.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.07, 0],
										[0, 2.24],
										[3.51, 3.73],
										[5.6, 1.48],
										[2.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 83,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.64, 1.75] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1065.08, 491.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.09, 0.24],
										[0, 0],
										[0, 0],
										[0.86, -0.2],
										[0.73, -0.17],
										[0, 0],
										[0, 0]
									],
									"o": [
										[1.09, -0.24],
										[0, 0],
										[0, 0],
										[-0.86, 0.19],
										[-0.73, 0.17],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[5.64, 3.48],
										[8.92, 2.76],
										[9.28, 1.9],
										[4.78, 0],
										[2.2, 0.59],
										[0, 1.11],
										[5.64, 3.5],
										[5.64, 3.48]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 84,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.8, 1.86] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1153.22, 528.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.52, 3.73],
										[5.6, 1.48],
										[2.07, 0],
										[0, 2.24],
										[3.52, 3.73]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 85,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.82, 1.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1178.27, 502.96] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.55, 3.31],
										[3.64, 1.06],
										[1.12, 0],
										[0, 2.65],
										[1.55, 3.31]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 86,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.16, 1.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1126.48, 481.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.93, 0.23],
										[0, 0],
										[0.29, -0.03],
										[1.6, -0.22],
										[0, 0],
										[0, 0]
									],
									"o": [
										[1.91, -0.24],
										[0, 0],
										[-0.27, 0.03],
										[-1.6, 0.2],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[6.57, 3.53],
										[12.33, 2.83],
										[5.64, 0],
										[4.8, 0.1],
										[0, 0.73],
										[6.56, 3.51],
										[6.57, 3.53]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 87,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.13, 2.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1198.03, 476.28] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[2.29, -0.07],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[-2.27, 0.06],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[10.18, 4.53],
										[12.26, 2.29],
										[6.86, 0],
										[0, 0.22],
										[10.18, 4.52],
										[10.18, 4.53]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 88,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.76, 12.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1068.96, 620.03] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[22.01, 0],
										[0, 23.81],
										[3.52, 25.29],
										[25.52, 1.48],
										[22.01, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 89,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.41, 13.69] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1054.68, 504.84] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-6.49, 1.47],
										[0, 0],
										[1.5, -0.37],
										[1.02, -0.24],
										[3.19, -0.85],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[6.31, -1.65],
										[0, 0],
										[-1.5, 0.35],
										[-1.02, 0.24],
										[-3.21, 0.79],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 25.86],
										[3.6, 27.38],
										[3.6, 7.05],
										[22.81, 2.39],
										[17.17, 0],
										[12.7, 1.06],
										[9.64, 1.8],
										[0.03, 4.26],
										[0, 4.26],
										[0, 25.86]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 90,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [18.75, 5.21] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1091.55, 486.85] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-12.18, 1.87],
										[0, 0],
										[0.91, -0.14],
										[0.85, -0.14],
										[2.88, -0.49],
										[0.35, -0.06],
										[3.27, -0.62],
										[0.73, -0.14],
										[2.47, -0.52],
										[0.45, -0.1],
										[0, 0],
										[0, 0]
									],
									"o": [
										[11.71, -2.49],
										[0, 0],
										[-0.91, 0.13],
										[-0.86, 0.13],
										[-2.88, 0.46],
										[-0.35, 0.06],
										[-3.27, 0.56],
										[-0.73, 0.14],
										[-2.46, 0.47],
										[-0.45, 0.09],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 10.42],
										[35.86, 3.88],
										[37.5, 0],
										[34.77, 0.4],
										[32.19, 0.81],
										[23.55, 2.23],
										[22.5, 2.4],
										[12.7, 4.19],
										[10.49, 4.62],
										[3.08, 6.1],
										[1.73, 6.39],
										[0.03, 10.42],
										[0, 10.42]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 91,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.76, 12.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1141.18, 541.84] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[25.52, 1.48],
										[21.99, 0],
										[0, 23.81],
										[3.52, 25.29],
										[25.52, 1.48]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 92,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [10.26, 11.84] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1162.75, 516.59] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.52, 23.68],
										[16.38, 9.77],
										[20.51, 0],
										[0, 22.2],
										[3.52, 23.68]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 93,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 16.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1045.07, 536.78] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 25.93],
										[3.6, 1.53],
										[0, 0],
										[0, 33.12],
										[0.47, 33.31],
										[3.6, 25.93]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 94,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11, 12.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1118.87, 567.91] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[21.99, 1.48],
										[18.48, 0],
										[4.11, 15.55],
										[0, 25.29],
										[0, 25.31],
										[21.99, 1.48]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 95,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 16.89] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1045.07, 574.11] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 0.66],
										[2, 0],
										[0, 4.73],
										[0, 32.26],
										[3.6, 33.78],
										[3.6, 0.66]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 96,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [17.82, 3.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1167.97, 477.48] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-11.52, 0.53],
										[0, 0],
										[6.11, -0.42],
										[0.36, -0.03],
										[2.89, -0.23],
										[0.42, -0.03],
										[1.61, -0.14],
										[0, 0],
										[0, 0]
									],
									"o": [
										[11.21, -1.02],
										[0, 0],
										[-6.01, 0.26],
										[-0.36, 0.03],
										[-2.88, 0.2],
										[-0.42, 0.03],
										[-1.61, 0.13],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 6.01],
										[34.09, 3.68],
										[35.64, 0],
										[17.45, 1.01],
										[16.37, 1.08],
										[7.7, 1.73],
										[6.44, 1.83],
										[1.6, 2.26],
										[0.01, 6.01],
										[0, 6.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 97,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 17.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1045.07, 609.92] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.53],
										[0, 0],
										[0, 33.12],
										[3.6, 34.63],
										[3.6, 1.53]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 98,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.26, 2.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1137.23, 479.67] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-4.79, 0.46],
										[0, 0],
										[0.49, -0.04],
										[0.04, 0],
										[6.63, -0.82],
										[0.39, -0.04],
										[0, 0],
										[0, 0]
									],
									"o": [
										[4.72, -0.55],
										[0, 0],
										[-0.49, 0.04],
										[-0.04, 0],
										[-6.56, 0.63],
										[-0.39, 0.04],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[6.67, 5.29],
										[20.93, 3.77],
										[22.53, 0],
										[21.07, 0.13],
										[20.96, 0.13],
										[1.17, 2.3],
										[0, 2.45],
										[6.69, 5.28],
										[6.67, 5.29]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 99,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.24, 0.66] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1046.63, 554.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.47, 0],
										[0, 1.12],
										[0.47, 1.32],
										[0.47, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 100,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 5.73] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1045.07, 634.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.51],
										[0, 0],
										[0, 11.47],
										[3.6, 2.95],
										[3.6, 1.51]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 101,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.44, 2.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1119.44, 482.63] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-5.01, 0.63],
										[0, 0],
										[0.93, -0.13],
										[0.89, -0.13],
										[0.4, -0.06],
										[0, 0],
										[0, 0]
									],
									"o": [
										[4.92, -0.73],
										[0, 0],
										[-0.93, 0.13],
										[-0.89, 0.13],
										[-0.4, 0.06],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 4.81],
										[14.89, 2.78],
										[8.33, 0],
										[5.51, 0.37],
										[2.85, 0.75],
										[1.64, 0.92],
										[0, 4.79],
										[0, 4.81]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 102,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.84, 1.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1202.59, 475.08] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[2.57, -0.07],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[-2.55, 0.04],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[7.68, 0],
										[0, 0.19],
										[5.39, 2.47],
										[7.67, 0.01],
										[7.68, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 103,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.92, 1.59] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1068.16, 490.37] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[1.65, -0.37],
										[0.29, -0.07],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-1.65, 0.36],
										[-0.29, 0.07],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.49, 3.18],
										[5.84, 0],
										[0.88, 1.08],
										[0, 1.28],
										[4.5, 3.18],
										[4.49, 3.18]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 104,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.69, 2.17] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1176.32, 506.12] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.38, 0.66],
										[1.83, 0],
										[0, 4.33],
										[3.38, 0.66]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 105,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.94, 1.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1105.29, 578.24] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 2.03],
										[0.88, 2.4],
										[1.88, 0],
										[0, 2.03]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 106,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.19, 8.53] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1050.46, 641.97] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 7.87],
										[3.6, 5.76],
										[0, 14.26],
										[0, 17.06],
										[14.38, 1.48],
										[10.86, 0],
										[3.6, 7.87]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 107,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.26, 14.06] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1189.83, 488.32] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.98, -0.03],
										[0, 0],
										[-3.55, 0.1]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.98, 0.03],
										[0, 0],
										[3.52, -0.14],
										[0, 0]
									],
									"v": [
										[20.47, 3.38],
										[1.18, 24.26],
										[0, 27.05],
										[2.52, 28.11],
										[24.51, 4.3],
										[14.33, 0],
										[11.39, 0.1],
										[9.85, 3.76],
										[20.47, 3.38]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 108,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.91, 12.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1092.19, 593.96] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[23.82, 0.78],
										[21.99, 0],
										[0, 23.83],
										[3.52, 25.31],
										[21.82, 5.5],
										[23.82, 0.78]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 109,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.29, 0.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1106.27, 482.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.85, 0.14],
										[0.85, -0.14]
									],
									"o": [
										[0.86, -0.13],
										[-0.86, 0.13],
										[0, 0]
									],
									"v": [
										[0, 0.4],
										[2.57, 0],
										[0, 0.4]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 110,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1, 0.13] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1126.12, 479.47] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.66, -0.09],
										[-0.29, 0.03],
										[-0.39, 0.04],
										[0, 0]
									],
									"o": [
										[-0.66, 0.09],
										[0.27, -0.03],
										[0.39, -0.04],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2, 0],
										[0, 0.26],
										[0.83, 0.16],
										[2, 0.01],
										[2, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 111,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.33, 0.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1116.16, 480.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 112,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.01, 77.54] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1043.28, 572.96] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0.01, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 144.89],
										[0, 0],
										[0.03, 0],
										[0, 0],
										[0, 155.07],
										[0, 144.89]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 113,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.06, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1146.97, 477.17] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.04, 0],
										[0.04, 0]
									],
									"o": [
										[0, 0],
										[-0.04, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.11, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 114,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.54, 0.04] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1167.06, 475.52] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 115,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.63, 0.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1157.2, 476.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 116,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.73, 0.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1064.36, 490.22] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.17, -0.26],
										[-0.86, 0.2],
										[-0.29, 0.07],
										[0, 0]
									],
									"o": [
										[-1.15, 0.26],
										[0.86, -0.2],
										[0.29, -0.07],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.47, 0.01],
										[0, 0.79],
										[2.57, 0.2],
										[3.45, 0],
										[3.47, 0.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 117,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.53, 0.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1054.44, 492.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.02, 0.24],
										[1.02, -0.24]
									],
									"o": [
										[1.02, -0.26],
										[-1.02, 0.24],
										[0, 0]
									],
									"v": [
										[0, 0.73],
										[3.06, 0],
										[0, 0.73]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 118,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.11, 0.22] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1084.37, 486.06] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 119,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.53, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1095.81, 483.97] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 120,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.64, 0.35] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1074.21, 488.09] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.09, -0.23],
										[-0.65, 0.13],
										[-0.45, 0.1]
									],
									"o": [
										[-1.09, 0.23],
										[0.65, -0.13],
										[0.45, -0.1],
										[0, 0]
									],
									"v": [
										[3.28, 0],
										[0, 0.69],
										[1.93, 0.29],
										[3.28, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 121,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [69.56, 75.31] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1119.97, 556.85] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[1.24, -0.06],
										[1.05, -0.06],
										[11.22, -1.05],
										[1.08, -0.1],
										[1.97, -0.22],
										[1.94, -0.23],
										[7.64, -1.17],
										[1.11, -0.17],
										[9.93, -2.06],
										[1.64, -0.36],
										[0.24, -0.06],
										[1.14, -0.26],
										[5.67, -1.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.24, 0.04],
										[-1.06, 0.04],
										[-11.54, 0.56],
										[-1.08, 0.1],
										[-1.97, 0.2],
										[-1.96, 0.22],
										[-7.83, 0.91],
										[-1.12, 0.17],
										[-10.27, 1.61],
										[-1.64, 0.35],
										[-0.24, 0.06],
										[-1.15, 0.24],
										[-5.8, 1.29],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.27, 148.15],
										[24.27, 124.34],
										[26.34, 122.1],
										[48.33, 98.29],
										[50.4, 96.04],
										[59.93, 85.72],
										[65.68, 79.49],
										[72.4, 72.23],
										[74.47, 69.98],
										[96.46, 46.17],
										[98.53, 43.93],
										[120.53, 20.11],
										[122.6, 17.87],
										[126.68, 13.45],
										[132.44, 7.22],
										[139.11, 0],
										[135.41, 0.17],
										[132.24, 0.32],
										[98.1, 2.73],
										[94.85, 3.04],
										[88.95, 3.65],
										[83.1, 4.3],
										[59.91, 7.4],
										[56.57, 7.91],
										[26.28, 13.41],
										[21.36, 14.46],
										[20.63, 14.62],
										[17.19, 15.37],
										[0, 19.48],
										[0, 150.62],
										[0.14, 150.46],
										[2.22, 148.21],
										[2.27, 148.15]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 122,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [168.82, 151.64] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1212.18, 625.36] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.98, 0.16],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.99, 0.12],
										[0, 0],
										[0, 0],
										[0, 0],
										[1.01, 0.07],
										[0, 0],
										[0, 0],
										[3.01, 0.2],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[1.02, 0.06],
										[0, 0],
										[0, 0],
										[0, 0],
										[1.03, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.96, -0.16],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.98, -0.12],
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.01, -0.09],
										[0, 0],
										[0, 0],
										[-2.93, -0.23],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.02, -0.04],
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.04, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[337.54, 44.17],
										[337.54, 41.05],
										[313.9, 31.05],
										[322.07, 11.7],
										[319.15, 11.22],
										[311.25, 29.93],
										[283.16, 18.06],
										[287.9, 6.83],
										[284.94, 6.47],
										[280.52, 16.93],
										[252.43, 5.06],
										[253.21, 3.22],
										[250.19, 2.98],
										[249.77, 3.96],
										[246.82, 2.72],
										[237.89, 2.07],
										[248.65, 6.62],
										[236.78, 34.72],
										[208.69, 22.85],
										[217.95, 0.94],
										[214.89, 0.79],
										[206.04, 21.71],
										[177.95, 9.84],
										[182.11, 0],
										[178.99, 0],
										[175.3, 8.72],
										[160.82, 2.59],
										[158.75, 4.83],
										[174.2, 11.37],
										[162.33, 39.47],
										[136.75, 28.66],
										[134.68, 30.91],
										[161.21, 42.11],
										[149.34, 70.21],
										[121.25, 58.34],
										[131.29, 34.57],
										[125.53, 40.8],
										[118.6, 57.22],
										[112.69, 54.72],
										[110.62, 56.96],
										[117.49, 59.87],
										[105.62, 87.97],
										[88.62, 80.79],
										[86.55, 83.03],
										[104.5, 90.63],
										[92.64, 118.73],
										[64.56, 106.86],
										[62.5, 109.11],
										[60.66, 111.11],
										[58.82, 113.11],
										[48.94, 136.49],
										[40.51, 132.92],
										[38.44, 135.16],
										[47.81, 139.13],
										[35.95, 167.23],
										[16.44, 158.99],
										[14.37, 161.23],
										[34.84, 169.88],
										[22.97, 197.98],
										[0, 188.27],
										[0, 191.39],
										[21.86, 200.63],
										[10, 228.73],
										[0.01, 224.51],
										[0.01, 227.63],
										[8.88, 231.39],
										[0.01, 252.38],
										[0.01, 259.78],
										[11.54, 232.51],
										[39.63, 244.38],
										[27.76, 272.48],
										[0.03, 260.76],
										[0.03, 263.88],
										[26.64, 275.13],
										[14.82, 303.1],
										[14.76, 303.21],
										[14.47, 303.1],
										[0.01, 296.98],
										[0.01, 300.11],
										[7.08, 303.1],
										[7.49, 303.27],
										[17.85, 303.27],
										[17.92, 303.1],
										[29.27, 276.25],
										[57.36, 288.12],
										[51.04, 303.1],
										[50.96, 303.27],
										[54.09, 303.27],
										[54.16, 303.1],
										[60.01, 289.24],
										[88.1, 301.11],
										[87.27, 303.1],
										[87.2, 303.27],
										[90.32, 303.27],
										[90.39, 303.1],
										[90.75, 302.24],
										[92.79, 303.1],
										[93.21, 303.27],
										[100.6, 303.27],
										[100.19, 303.1],
										[91.87, 299.59],
										[103.74, 271.49],
										[131.83, 283.36],
										[123.49, 303.1],
										[123.42, 303.27],
										[126.54, 303.27],
										[126.61, 303.1],
										[134.48, 284.48],
										[162.57, 296.35],
										[159.72, 303.1],
										[159.65, 303.27],
										[162.77, 303.27],
										[162.85, 303.1],
										[165.22, 297.47],
										[178.52, 303.1],
										[178.94, 303.27],
										[186.34, 303.27],
										[185.92, 303.1],
										[166.34, 294.83],
										[178.21, 266.73],
										[206.3, 278.6],
										[195.94, 303.1],
										[195.87, 303.27],
										[198.99, 303.27],
										[199.07, 303.1],
										[208.95, 279.72],
										[237.04, 291.59],
										[232.18, 303.1],
										[232.11, 303.27],
										[235.23, 303.27],
										[235.3, 303.1],
										[239.69, 292.71],
										[264.26, 303.1],
										[264.67, 303.27],
										[272.07, 303.27],
										[271.65, 303.1],
										[271.55, 303.06],
										[283.42, 274.96],
										[311.51, 286.83],
										[304.63, 303.08],
										[304.56, 303.26],
										[307.68, 303.26],
										[307.75, 303.08],
										[314.15, 287.95],
										[337.64, 297.88],
										[337.64, 294.75],
										[315.28, 285.3],
										[327.14, 257.2],
										[337.64, 261.63],
										[337.64, 258.51],
										[328.27, 254.54],
										[337.64, 232.34],
										[337.64, 222.27],
										[310.52, 210.8],
										[322.38, 182.7],
										[337.64, 189.15],
										[337.64, 186.02],
										[323.5, 180.05],
										[335.37, 151.95],
										[337.64, 152.92],
										[337.64, 149.79],
										[336.49, 149.31],
										[337.64, 146.59],
										[337.64, 139.19],
										[333.85, 148.18],
										[305.75, 136.31],
										[317.62, 108.21],
										[337.64, 116.67],
										[337.64, 113.55],
										[318.74, 105.57],
										[330.61, 77.47],
										[337.63, 80.43],
										[337.63, 77.31],
										[331.72, 74.8],
										[337.63, 60.82],
										[337.63, 53.42],
										[329.07, 73.67],
										[300.98, 61.8],
										[312.85, 33.7],
										[337.62, 44.17],
										[337.54, 44.17]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[251.3, 7.71],
										[279.39, 19.58],
										[267.52, 47.68],
										[239.43, 35.81],
										[251.3, 7.71]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[253.4, 81.08],
										[241.53, 109.18],
										[213.44, 97.31],
										[225.3, 69.21],
										[253.4, 81.08]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[226.44, 66.56],
										[238.31, 38.46],
										[266.4, 50.33],
										[254.53, 78.43],
										[226.44, 66.56]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[128.09, 206.18],
										[100, 194.31],
										[111.87, 166.21],
										[139.96, 178.08],
										[128.09, 206.18]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[142.62, 179.2],
										[170.71, 191.07],
										[158.85, 219.17],
										[130.75, 207.3],
										[142.62, 179.2]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[143.73, 176.56],
										[155.6, 148.46],
										[183.69, 160.33],
										[171.82, 188.43],
										[143.73, 176.56]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[227.42, 142.57],
										[215.55, 170.67],
										[187.46, 158.8],
										[199.32, 130.7],
										[227.42, 142.57]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[200.45, 128.05],
										[212.31, 99.95],
										[240.41, 111.82],
										[228.54, 139.92],
										[200.45, 128.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[184.81, 157.68],
										[156.72, 145.81],
										[168.59, 117.71],
										[196.68, 129.58],
										[184.81, 157.68]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[186.35, 161.45],
										[214.44, 173.32],
										[202.58, 201.42],
										[174.48, 189.55],
										[186.35, 161.45]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[217.07, 174.44],
										[245.17, 186.31],
										[233.3, 214.41],
										[205.21, 202.54],
										[217.07, 174.44]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[247.81, 187.43],
										[275.91, 199.3],
										[264.04, 227.4],
										[235.95, 215.53],
										[247.81, 187.43]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[218.2, 171.79],
										[230.06, 143.69],
										[258.16, 155.56],
										[246.29, 183.66],
										[218.2, 171.79]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[231.19, 141.05],
										[243.05, 112.95],
										[271.15, 124.82],
										[259.28, 152.92],
										[231.19, 141.05]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[210.79, 96.18],
										[182.7, 84.31],
										[194.56, 56.21],
										[222.66, 68.08],
										[210.79, 96.18]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[209.67, 98.83],
										[197.8, 126.93],
										[169.71, 115.06],
										[181.57, 86.96],
										[209.67, 98.83]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[167.06, 113.94],
										[138.97, 102.07],
										[150.83, 73.97],
										[178.93, 85.84],
										[167.06, 113.94]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[165.94, 116.59],
										[154.07, 144.69],
										[125.98, 132.82],
										[137.85, 104.72],
										[165.94, 116.59]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[152.95, 147.33],
										[141.08, 175.43],
										[112.99, 163.56],
										[124.86, 135.46],
										[152.95, 147.33]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[110.34, 162.44],
										[82.25, 150.57],
										[94.12, 122.47],
										[122.21, 134.34],
										[110.34, 162.44]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[109.22, 165.09],
										[97.35, 193.19],
										[69.26, 181.32],
										[81.13, 153.22],
										[109.22, 165.09]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[96.23, 195.84],
										[84.36, 223.94],
										[56.27, 212.07],
										[68.14, 183.97],
										[96.23, 195.84]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[83.24, 226.58],
										[71.38, 254.68],
										[43.28, 242.81],
										[55.15, 214.71],
										[83.24, 226.58]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[85.89, 227.71],
										[113.98, 239.58],
										[102.12, 267.68],
										[74.02, 255.81],
										[85.89, 227.71]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[87.01, 225.04],
										[98.88, 196.94],
										[126.97, 208.81],
										[115.1, 236.91],
										[87.01, 225.04]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[129.62, 209.95],
										[157.71, 221.82],
										[145.84, 249.92],
										[117.75, 238.05],
										[129.62, 209.95]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[160.36, 222.94],
										[188.45, 234.81],
										[176.58, 262.91],
										[148.49, 251.04],
										[160.36, 222.94]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[161.48, 220.3],
										[173.35, 192.2],
										[201.44, 204.07],
										[189.57, 232.17],
										[161.48, 220.3]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[204.09, 205.19],
										[232.18, 217.06],
										[220.31, 245.16],
										[192.22, 233.29],
										[204.09, 205.19]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[234.83, 218.18],
										[262.92, 230.05],
										[251.05, 258.15],
										[222.96, 246.28],
										[234.83, 218.18]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[265.56, 231.17],
										[293.66, 243.04],
										[281.79, 271.14],
										[253.7, 259.27],
										[265.56, 231.17]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[266.69, 228.53],
										[278.55, 200.43],
										[306.65, 212.3],
										[294.78, 240.4],
										[266.69, 228.53]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[248.94, 184.79],
										[260.8, 156.69],
										[288.9, 168.56],
										[277.03, 196.66],
										[248.94, 184.79]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[261.93, 154.04],
										[273.79, 125.94],
										[301.89, 137.81],
										[290.02, 165.91],
										[261.93, 154.04]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[244.18, 110.3],
										[256.04, 82.2],
										[284.13, 94.07],
										[272.27, 122.17],
										[244.18, 110.3]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[257.18, 79.55],
										[269.05, 51.45],
										[297.14, 63.32],
										[285.27, 91.42],
										[257.18, 79.55]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[235.66, 37.34],
										[223.79, 65.44],
										[195.7, 53.57],
										[207.57, 25.47],
										[235.66, 37.34]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[176.83, 12.47],
										[204.92, 24.34],
										[193.05, 52.44],
										[164.96, 40.57],
										[176.83, 12.47]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[163.84, 43.22],
										[191.93, 55.09],
										[180.06, 83.19],
										[151.97, 71.32],
										[163.84, 43.22]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[120.11, 60.98],
										[148.2, 72.85],
										[136.34, 100.95],
										[108.24, 89.08],
										[120.11, 60.98]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[107.12, 91.72],
										[135.21, 103.59],
										[123.35, 131.69],
										[95.25, 119.82],
										[107.12, 91.72]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[63.39, 109.48],
										[91.48, 121.35],
										[79.62, 149.45],
										[51.52, 137.58],
										[63.39, 109.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[50.4, 140.23],
										[78.5, 152.1],
										[66.63, 180.2],
										[38.54, 168.33],
										[50.4, 140.23]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[37.41, 170.96],
										[65.51, 182.83],
										[53.64, 210.93],
										[25.55, 199.06],
										[37.41, 170.96]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[12.54, 229.81],
										[24.41, 201.71],
										[52.5, 213.58],
										[40.64, 241.68],
										[12.54, 229.81]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.29, 273.55],
										[42.16, 245.45],
										[70.25, 257.32],
										[58.39, 285.42],
										[30.29, 273.55]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[89.13, 298.41],
										[61.03, 286.54],
										[72.9, 258.44],
										[100.99, 270.31],
										[89.13, 298.41]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[104.76, 268.78],
										[116.63, 240.68],
										[144.72, 252.55],
										[132.85, 280.65],
										[104.76, 268.78]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[163.59, 293.66],
										[135.5, 281.79],
										[147.37, 253.69],
										[175.46, 265.56],
										[163.59, 293.66]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[179.23, 264.04],
										[191.1, 235.94],
										[219.19, 247.81],
										[207.32, 275.91],
										[179.23, 264.04]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[209.97, 277.03],
										[221.84, 248.93],
										[249.93, 260.8],
										[238.06, 288.9],
										[209.97, 277.03]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[268.8, 301.89],
										[240.71, 290.02],
										[252.58, 261.92],
										[280.67, 273.79],
										[268.8, 301.89]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[312.53, 284.14],
										[284.44, 272.27],
										[296.3, 244.17],
										[324.4, 256.04],
										[312.53, 284.14]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[337.39, 225.29],
										[325.52, 253.39],
										[297.43, 241.52],
										[309.29, 213.42],
										[337.39, 225.29]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[307.77, 209.65],
										[279.68, 197.78],
										[291.54, 169.68],
										[319.64, 181.55],
										[307.77, 209.65]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[332.62, 150.82],
										[320.76, 178.92],
										[292.66, 167.05],
										[304.53, 138.95],
										[332.62, 150.82]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[303.01, 135.16],
										[274.91, 123.29],
										[286.78, 95.19],
										[314.87, 107.06],
										[303.01, 135.16]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[327.86, 76.33],
										[316, 104.43],
										[287.9, 92.56],
										[299.77, 64.46],
										[327.86, 76.33]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[298.25, 60.67],
										[270.15, 48.8],
										[282.02, 20.7],
										[310.11, 32.57],
										[298.25, 60.67]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 123,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [154.93, 160.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [213.94, 160.65] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[300.26, 9.63],
										[304.33, 0],
										[301.21, 0],
										[297.61, 8.5],
										[277.5, 0],
										[270.11, 0],
										[296.49, 11.15],
										[284.62, 39.25],
										[256.53, 27.38],
										[268.1, 0],
										[264.98, 0],
										[253.88, 26.26],
										[225.79, 14.39],
										[231.86, 0.01],
										[228.74, 0.01],
										[223.15, 13.28],
										[195.05, 1.38],
										[195.64, 0],
										[192.52, 0],
										[192.41, 0.26],
										[191.77, 0],
										[184.38, 0],
										[191.28, 2.92],
										[179.42, 31.02],
										[151.32, 19.15],
										[159.41, 0.01],
										[156.29, 0.01],
										[148.68, 18.03],
										[120.58, 6.16],
										[123.17, 0.01],
										[120.05, 0.01],
										[117.92, 5.04],
										[107.12, 0.47],
										[105.98, 3.12],
										[116.8, 7.7],
										[104.93, 35.8],
										[93.87, 31.12],
										[92.74, 33.77],
										[103.83, 38.46],
										[91.96, 66.56],
										[80.62, 61.77],
										[79.49, 64.42],
										[90.84, 69.22],
										[78.97, 97.32],
										[67.38, 92.41],
										[66.24, 95.06],
										[77.86, 99.97],
										[66, 128.07],
										[54.13, 123.06],
										[52.99, 125.71],
										[64.87, 130.73],
										[53.01, 158.83],
										[40.88, 153.71],
										[39.74, 156.35],
										[51.9, 161.49],
										[40.03, 189.59],
										[27.63, 184.36],
										[26.5, 187],
										[38.91, 192.25],
										[27.04, 220.35],
										[14.38, 215],
										[13.25, 217.65],
										[25.94, 223.02],
										[14.07, 251.12],
										[1.14, 245.65],
										[0, 248.3],
										[10.9, 252.9],
										[18.3, 252.9],
										[16.73, 252.24],
										[28.6, 224.14],
										[56.69, 236.01],
										[49.55, 252.9],
										[52.68, 252.9],
										[59.34, 237.13],
										[87.43, 249],
										[85.79, 252.9],
										[88.91, 252.9],
										[90.07, 250.12],
										[96.63, 252.9],
										[104.03, 252.9],
										[91.2, 247.48],
										[103.06, 219.38],
										[131.16, 231.25],
										[122.01, 252.89],
										[125.13, 252.89],
										[133.8, 232.35],
										[161.9, 244.22],
										[150.03, 272.32],
										[147.15, 271.12],
										[147.15, 274.24],
										[148.91, 274.99],
										[147.15, 279.14],
										[147.15, 286.54],
										[151.55, 276.12],
										[179.65, 287.99],
										[167.78, 316.09],
										[147.15, 307.37],
										[147.15, 310.5],
										[166.66, 318.74],
										[165.58, 321.3],
										[168.7, 321.3],
										[169.3, 319.86],
										[172.71, 321.3],
										[180.11, 321.3],
										[170.43, 317.2],
										[182.29, 289.1],
										[198.53, 295.96],
										[199.58, 293.29],
										[183.4, 286.45],
										[195.27, 258.35],
										[210.79, 264.91],
										[211.84, 262.24],
										[196.39, 255.71],
										[208.26, 227.61],
										[223.04, 233.85],
										[224.09, 231.17],
										[209.37, 224.94],
										[221.23, 196.84],
										[235.3, 202.79],
										[236.35, 200.11],
										[222.35, 194.2],
										[234.22, 166.1],
										[247.56, 171.74],
										[248.61, 169.06],
										[235.33, 163.45],
										[247.2, 135.35],
										[259.8, 140.67],
										[260.85, 138],
										[248.3, 132.69],
										[260.17, 104.59],
										[272.05, 109.61],
										[273.1, 106.93],
										[261.28, 101.94],
										[273.15, 73.84],
										[284.29, 78.56],
										[285.34, 75.88],
										[274.25, 71.19],
										[286.12, 43.09],
										[296.55, 47.5],
										[297.6, 44.82],
										[287.24, 40.44],
										[299.11, 12.35],
										[308.8, 16.45],
										[309.85, 13.77],
										[300.22, 9.7],
										[300.26, 9.63]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[252.76, 28.91],
										[240.9, 57.01],
										[212.8, 45.14],
										[224.67, 17.04],
										[252.76, 28.91]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[86.38, 172.87],
										[98.25, 144.77],
										[126.34, 156.64],
										[114.47, 184.74],
										[86.38, 172.87]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[113.35, 187.39],
										[101.48, 215.49],
										[73.39, 203.62],
										[85.26, 175.52],
										[113.35, 187.39]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[196.05, 77.41],
										[184.18, 105.51],
										[156.09, 93.64],
										[167.95, 65.54],
										[196.05, 77.41]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[169.07, 62.88],
										[180.94, 34.78],
										[209.03, 46.65],
										[197.17, 74.75],
										[169.07, 62.88]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[143.1, 124.37],
										[154.96, 96.27],
										[183.06, 108.14],
										[171.19, 136.24],
										[143.1, 124.37]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[170.07, 138.89],
										[158.2, 166.99],
										[130.11, 155.12],
										[141.97, 127.02],
										[170.07, 138.89]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[153.44, 92.5],
										[125.35, 80.63],
										[137.21, 52.53],
										[165.31, 64.4],
										[153.44, 92.5]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[152.32, 95.15],
										[140.45, 123.25],
										[112.36, 111.38],
										[124.22, 83.28],
										[152.32, 95.15]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[139.33, 125.9],
										[127.46, 154],
										[99.37, 142.13],
										[111.23, 114.03],
										[139.33, 125.9]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[128.99, 157.76],
										[157.08, 169.64],
										[145.21, 197.74],
										[117.12, 185.87],
										[128.99, 157.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[159.72, 170.76],
										[187.82, 182.63],
										[175.95, 210.73],
										[147.86, 198.86],
										[159.72, 170.76]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[160.85, 168.11],
										[172.71, 140.01],
										[200.81, 151.88],
										[188.94, 179.98],
										[160.85, 168.11]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[173.84, 137.36],
										[185.7, 109.26],
										[213.8, 121.13],
										[201.93, 149.23],
										[173.84, 137.36]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[186.82, 106.62],
										[198.69, 78.52],
										[226.78, 90.39],
										[214.92, 118.49],
										[186.82, 106.62]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[199.81, 75.87],
										[211.68, 47.77],
										[239.77, 59.64],
										[227.91, 87.74],
										[199.81, 75.87]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[193.94, 4.04],
										[222.04, 15.91],
										[210.17, 44.01],
										[182.08, 32.14],
										[193.94, 4.04]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[178.29, 33.67],
										[166.43, 61.77],
										[138.33, 49.9],
										[150.2, 21.8],
										[178.29, 33.67]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[119.48, 8.79],
										[147.57, 20.66],
										[135.7, 48.76],
										[107.61, 36.89],
										[119.48, 8.79]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[106.49, 39.54],
										[134.58, 51.41],
										[122.71, 79.51],
										[94.62, 67.64],
										[106.49, 39.54]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[93.5, 70.29],
										[121.59, 82.16],
										[109.72, 110.26],
										[81.63, 98.39],
										[93.5, 70.29]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[80.51, 101.03],
										[108.6, 112.9],
										[96.73, 141],
										[68.64, 129.13],
										[80.51, 101.03]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[67.51, 131.78],
										[95.6, 143.65],
										[83.73, 171.75],
										[55.64, 159.88],
										[67.51, 131.78]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[54.52, 162.53],
										[82.61, 174.4],
										[70.74, 202.5],
										[42.65, 190.63],
										[54.52, 162.53]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[29.66, 221.36],
										[41.53, 193.26],
										[69.62, 205.13],
										[57.75, 233.23],
										[29.66, 221.36]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[88.49, 246.24],
										[60.4, 234.37],
										[72.27, 206.27],
										[100.36, 218.14],
										[88.49, 246.24]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[104.13, 216.61],
										[116, 188.51],
										[144.09, 200.38],
										[132.22, 228.48],
										[104.13, 216.61]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[134.87, 229.61],
										[146.74, 201.51],
										[174.83, 213.38],
										[162.96, 241.48],
										[134.87, 229.61]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[180.7, 285.21],
										[152.6, 273.35],
										[164.47, 245.25],
										[192.56, 257.12],
										[180.7, 285.21]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[193.69, 254.47],
										[165.59, 242.6],
										[177.46, 214.5],
										[205.55, 226.37],
										[193.69, 254.47]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[206.69, 223.72],
										[178.6, 211.85],
										[190.46, 183.75],
										[218.56, 195.62],
										[206.69, 223.72]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[219.68, 192.97],
										[191.59, 181.1],
										[203.45, 153],
										[231.55, 164.87],
										[219.68, 192.97]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[232.67, 162.23],
										[204.58, 150.36],
										[216.44, 122.26],
										[244.53, 134.13],
										[232.67, 162.23]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[245.66, 131.48],
										[217.56, 119.61],
										[229.43, 91.51],
										[257.52, 103.38],
										[245.66, 131.48]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[258.65, 100.73],
										[230.55, 88.86],
										[242.42, 60.76],
										[270.51, 72.63],
										[258.65, 100.73]
									]
								}
							}
						},
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[271.63, 70],
										[243.54, 58.13],
										[255.41, 30.03],
										[283.5, 41.9],
										[271.63, 70]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 124,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [109.04, 69.36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [614.01, 230.12] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.66, -0.1],
										[2.4, -0.42],
										[0.27, -0.04],
										[2.78, -0.58],
										[0.33, -0.07],
										[2.39, -0.56],
										[0.55, -0.13],
										[2.63, -0.72],
										[0.03, -0.01],
										[2.66, -0.81],
										[0.59, -0.19],
										[2.03, -0.68],
										[0.7, -0.24],
										[2.52, -0.92],
										[0.01, -0.01],
										[18.1, -11.5],
										[3.54, -2.46],
										[1.74, -1.27],
										[5.01, -4.16],
										[2.49, -2.19],
										[0.45, -0.4],
										[2.27, -2.17],
										[0.52, -0.5],
										[2.2, -2.26],
										[0.35, -0.35],
										[1.99, -2.16],
										[0.42, -0.45],
										[2.06, -2.4],
										[0.45, -0.52],
										[2.01, -2.56],
										[0.22, -0.29],
										[4.04, -5.94],
										[0.03, -0.06],
										[-19.06, 0],
										[0, 0],
										[0, 0],
										[-23.46, 10.29],
										[-10.5, 10.2],
										[0, 39.6],
										[0.01, 0.76],
										[0.3, -0.04],
										[2.33, -0.33],
										[0, 0]
									],
									"o": [
										[-0.66, 0.09],
										[-2.42, 0.36],
										[-0.27, 0.04],
										[-2.79, 0.49],
										[-0.33, 0.07],
										[-2.39, 0.5],
										[-0.55, 0.13],
										[-2.65, 0.63],
										[-0.03, 0],
										[-2.69, 0.72],
										[-0.59, 0.17],
										[-2.04, 0.63],
										[-0.7, 0.23],
										[-2.53, 0.86],
										[-0.03, 0],
										[-20.08, 7.42],
										[-3.62, 2.3],
										[-1.77, 1.22],
										[-5.22, 3.8],
										[-2.56, 2.12],
										[-0.45, 0.4],
										[-2.34, 2.09],
										[-0.53, 0.5],
										[-2.27, 2.19],
										[-0.33, 0.35],
										[-2.03, 2.1],
										[-0.42, 0.45],
										[-2.11, 2.35],
										[-0.45, 0.52],
										[-2.09, 2.49],
										[-0.22, 0.29],
										[-4.4, 5.63],
										[-0.03, 0.06],
										[16.63, 3.45],
										[0, 0],
										[0, 0],
										[31.42, -0.73],
										[15.19, -6.66],
										[23.76, -23.06],
										[0, -0.76],
										[-0.3, 0.03],
										[-2.34, 0.27],
										[0, 0],
										[0, 0]
									],
									"v": [
										[210.14, 1.01],
										[208.16, 1.29],
										[200.91, 2.45],
										[200.09, 2.58],
										[191.74, 4.17],
										[190.74, 4.39],
										[183.57, 5.99],
										[181.95, 6.37],
										[174.02, 8.39],
										[173.95, 8.4],
										[165.92, 10.7],
										[164.15, 11.25],
										[158.04, 13.21],
										[155.93, 13.91],
										[148.36, 16.58],
										[148.29, 16.6],
										[90.92, 45.05],
										[80.19, 52.19],
										[74.93, 55.93],
										[59.57, 67.87],
										[52.01, 74.34],
										[50.66, 75.54],
										[43.74, 81.93],
										[42.18, 83.44],
										[35.46, 90.1],
										[34.45, 91.15],
										[28.44, 97.54],
										[27.19, 98.89],
										[20.94, 106.01],
										[19.62, 107.57],
										[13.45, 115.13],
										[12.79, 115.98],
										[0.1, 133.32],
										[0, 133.48],
										[53.7, 138.67],
										[60.89, 138.67],
										[60.89, 138.73],
										[143.56, 122.14],
										[182.26, 96.72],
										[218.08, 2.29],
										[218.07, 0],
										[217.15, 0.12],
										[210.14, 1.02],
										[210.14, 1.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 125,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [71.91, 38.84] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [130.61, 408.96] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[1.21, 0.01],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.19, -0.03],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[140.22, 74.08],
										[0, 74.08],
										[0, 77.68],
										[143.82, 77.68],
										[143.82, 0.09],
										[140.22, 0],
										[140.22, 74.1],
										[140.22, 74.08]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 126,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [73.71, 40.6] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [132.41, 410.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.19, 0.03],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[-1.18, -0.04],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[147.41, 0.09],
										[143.82, 0],
										[143.82, 77.6],
										[0, 77.6],
										[0, 81.19],
										[147.41, 81.19],
										[147.41, 0.09]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 127,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [70.11, 37.11] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [128.83, 407.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0.1, 0],
										[0.53, 0],
										[2.55, 0.01],
										[0.32, 0],
										[2.36, -0.01],
										[0.5, 0],
										[2.6, -0.06],
										[0.49, -0.01],
										[2.42, -0.09],
										[0.4, -0.01],
										[2.68, -0.14],
										[0.58, -0.03],
										[2.63, -0.2],
										[0.16, -0.01],
										[2.76, -0.24],
										[0.62, -0.06],
										[2.79, -0.3],
										[0.2, -0.03],
										[2.63, -0.35],
										[0.6, -0.07],
										[2.79, -0.42],
										[0.46, -0.07],
										[2.52, -0.43],
										[0.53, -0.09],
										[2.81, -0.53],
										[0.59, -0.12],
										[2.57, -0.55],
										[0.35, -0.09],
										[2.82, -0.66],
										[0.63, -0.16],
										[2.86, -0.76],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-0.1, 0],
										[-0.53, 0],
										[-2.5, -0.04],
										[-0.32, 0],
										[-2.33, 0],
										[-0.5, 0],
										[-2.57, 0.03],
										[-0.49, 0],
										[-2.37, 0.06],
										[-0.4, 0.01],
										[-2.65, 0.12],
										[-0.58, 0.03],
										[-2.6, 0.16],
										[-0.16, 0],
										[-2.73, 0.2],
										[-0.62, 0.06],
										[-2.76, 0.26],
										[-0.2, 0.03],
										[-2.62, 0.29],
										[-0.6, 0.07],
										[-2.78, 0.36],
										[-0.46, 0.07],
										[-2.5, 0.37],
										[-0.53, 0.09],
										[-2.79, 0.47],
										[-0.59, 0.12],
										[-2.57, 0.5],
										[-0.36, 0.07],
										[-2.82, 0.62],
										[-0.63, 0.14],
										[-2.86, 0.71],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[140.2, 74.21],
										[140.2, 0.12],
										[139.9, 0.12],
										[138.29, 0.09],
										[130.71, 0],
										[129.76, 0],
										[122.71, 0.01],
										[121.19, 0.01],
										[113.42, 0.14],
										[111.95, 0.19],
										[104.78, 0.42],
										[103.57, 0.46],
										[95.57, 0.85],
										[93.84, 0.95],
										[85.99, 1.47],
										[85.53, 1.5],
										[77.27, 2.17],
										[75.42, 2.35],
										[67.09, 3.18],
										[66.47, 3.25],
										[58.57, 4.2],
										[56.76, 4.43],
										[48.42, 5.6],
										[47.04, 5.81],
										[39.5, 7.02],
										[37.9, 7.28],
										[29.52, 8.81],
										[27.76, 9.15],
										[20.02, 10.73],
										[18.96, 10.96],
										[10.5, 12.89],
										[8.6, 13.35],
										[0, 15.54],
										[0, 74.21],
										[140.22, 74.21],
										[140.2, 74.21]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 128,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [58.7, 446] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 129,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [58.7, 449.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 130,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.88, 0.17] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [87.34, 378.97] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 131,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.31, 0.04] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [125.47, 373.21] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 132,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.93, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [135.05, 372.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 133,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.23, 0.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [144.46, 371.47] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.16, 0.01],
										[0.16, -0.01]
									],
									"o": [
										[0.16, 0],
										[-0.16, 0],
										[0, 0]
									],
									"v": [
										[0, 0.03],
										[0.46, 0],
										[0, 0.03]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 134,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.86, 0.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [153.41, 370.89] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 135,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.91, 0.12] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [116.35, 374.31] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.6, 0.07],
										[0.6, -0.07]
									],
									"o": [
										[0.6, -0.09],
										[-0.6, 0.07],
										[0, 0]
									],
									"v": [
										[0, 0.23],
										[1.81, 0],
										[0, 0.23]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 136,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.95, 0.23] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [68.25, 383.11] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.63, 0.16],
										[0.63, -0.16]
									],
									"o": [
										[0.63, -0.16],
										[-0.63, 0.14],
										[0, 0]
									],
									"v": [
										[0, 0.46],
										[1.9, 0],
										[0, 0.46]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 137,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.53, 0.12] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [78.19, 380.84] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.35, 0.09],
										[0.35, -0.09]
									],
									"o": [
										[0.36, -0.07],
										[-0.36, 0.07],
										[0, 0]
									],
									"v": [
										[0, 0.23],
										[1.06, 0],
										[0, 0.23]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 138,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.69, 0.11] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [106.42, 375.69] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 139,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.6, 0.02] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [162.89, 370.43] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 140,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.8, 0.13] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [97.4, 377.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 141,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.73, 0.02] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [171.4, 370.16] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.49, -0.01],
										[-0.49, 0.01]
									],
									"o": [
										[-0.49, 0],
										[0.49, 0],
										[0, 0]
									],
									"v": [
										[1.47, 0],
										[0, 0.04],
										[1.47, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 142,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 29.34] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [58.7, 414.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 58.67],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 143,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.81, 0.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [197.82, 370.08] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.53, -0.01],
										[0.53, 0]
									],
									"o": [
										[0.55, 0],
										[-0.53, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.61, 0.03],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 144,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.76, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [180.67, 370] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 145,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.47, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [188.95, 369.97] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 146,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [161.58, 29.36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [694.75, 659.43] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[7.19, 51.52],
										[7.19, 0],
										[0, 0],
										[0, 58.72],
										[323.16, 58.72],
										[323.16, 51.52],
										[7.19, 51.52]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 147,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [157.99, 25.75] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [698.35, 655.82] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[315.98, 0],
										[0, 0],
										[0, 51.51],
										[315.98, 51.51],
										[315.98, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 148,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [161.59, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [694.76, 688.79] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 149,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [44.43, 82.47] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1017.76, 327.9] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.06, -0.06],
										[-1.99, -2.23],
										[-0.24, -0.29],
										[-1.68, -1.99],
										[-0.33, -0.39],
										[-1.78, -2.27],
										[-0.24, -0.32],
										[-1.54, -2.04],
										[-0.35, -0.46],
										[-1.67, -2.39],
										[-0.13, -0.17],
										[-1.52, -2.32],
										[-0.26, -0.42],
										[-2.99, -5.21],
										[-0.12, -0.22],
										[-0.16, -0.27],
										[-0.62, -1.14],
										[-0.39, -0.7],
										[-0.58, -1.09],
										[-0.4, -0.79],
										[-0.52, -1.01],
										[-0.46, -0.95],
										[-0.42, -0.89],
										[-0.58, -1.22],
										[-0.3, -0.63],
										[-1.61, -3.91],
										[-0.09, -0.22],
										[-0.68, -1.76],
										[-0.16, -0.43],
										[-0.56, -1.54],
										[-0.19, -0.53],
										[-0.49, -1.45],
										[-0.22, -0.59],
										[-0.46, -1.4],
										[-0.2, -0.65],
										[-0.4, -1.37],
										[-0.2, -0.66],
										[-0.37, -1.38],
										[-0.19, -0.68],
										[-0.37, -1.45],
										[-0.14, -0.58],
										[-0.47, -2.04],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[42.71, 42.66],
										[0, 0],
										[-1.19, -1.25],
										[0, 0]
									],
									"o": [
										[0, 0],
										[2.04, 2.17],
										[0.26, 0.29],
										[1.73, 1.96],
										[0.33, 0.39],
										[1.86, 2.22],
										[0.24, 0.32],
										[1.58, 2.01],
										[0.35, 0.46],
										[1.74, 2.35],
										[0.13, 0.19],
										[1.57, 2.26],
										[0.27, 0.42],
										[3.27, 5.02],
										[0.11, 0.2],
										[0.16, 0.27],
										[0.65, 1.12],
										[0.39, 0.69],
										[0.59, 1.08],
										[0.42, 0.79],
										[0.52, 1.01],
										[0.47, 0.94],
										[0.43, 0.88],
										[0.59, 1.22],
										[0.29, 0.63],
										[1.77, 3.86],
										[0.09, 0.22],
										[0.7, 1.74],
										[0.17, 0.43],
										[0.59, 1.54],
										[0.2, 0.53],
										[0.52, 1.44],
										[0.2, 0.6],
										[0.47, 1.4],
										[0.22, 0.65],
										[0.43, 1.37],
										[0.2, 0.68],
										[0.4, 1.37],
										[0.19, 0.68],
										[0.39, 1.45],
										[0.14, 0.57],
										[0.52, 2.04],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-13.61, -59.21],
										[0, 0],
										[1.21, 1.24],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.62, 8.83],
										[3.8, 9.02],
										[9.85, 15.61],
										[10.6, 16.46],
										[15.72, 22.37],
										[16.7, 23.52],
										[22.18, 30.27],
										[22.91, 31.22],
										[27.59, 37.32],
										[28.62, 38.7],
										[33.73, 45.81],
										[34.11, 46.36],
										[38.74, 53.22],
										[39.54, 54.46],
										[48.92, 69.8],
										[49.28, 70.42],
										[49.74, 71.24],
										[51.64, 74.63],
										[52.79, 76.73],
										[54.53, 79.98],
										[55.77, 82.37],
										[57.32, 85.39],
										[58.72, 88.23],
										[60.01, 90.89],
										[61.74, 94.56],
										[62.63, 96.46],
										[67.69, 108.11],
										[67.95, 108.76],
										[70.04, 114],
										[70.53, 115.29],
										[72.25, 119.91],
										[72.83, 121.52],
										[74.35, 125.87],
										[74.97, 127.67],
										[76.35, 131.84],
										[76.97, 133.78],
										[78.22, 137.88],
										[78.83, 139.9],
										[79.99, 144.01],
										[80.55, 146.03],
										[81.7, 150.4],
										[82.15, 152.14],
										[83.63, 158.27],
										[84.34, 161.33],
										[0, 161.33],
										[0, 164.93],
										[88.85, 164.93],
										[87.14, 157.46],
										[0, 0],
										[0, 5.09],
										[3.6, 8.83],
										[3.62, 8.83]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 150,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.32, 3.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1009.77, 295.24] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.52, -2.32],
										[1.58, 2.27]
									],
									"o": [
										[1.57, 2.26],
										[-1.51, -2.3],
										[0, 0]
									],
									"v": [
										[0, 0],
										[4.63, 6.86],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 151,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.34, 3.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [998.6, 279.7] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 152,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.55, 3.55] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1004.51, 287.69] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 153,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.22, 0.87] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1055.29, 396.7] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 154,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.28, 1.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1053.63, 390.45] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 155,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 78.12] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [975.16, 328.65] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[1.21, 1.24],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-1.19, -1.25],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 156.24],
										[3.6, 3.74],
										[0, 0],
										[0, 156.24],
										[3.6, 156.24]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 156,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.03, 3.29] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [980.16, 257.76] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.99, -2.23],
										[2.06, 2.17]
									],
									"o": [
										[2.04, 2.16],
										[-1.99, -2.22],
										[0, 0]
									],
									"v": [
										[0, 0],
										[6.06, 6.59],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 157,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.74, 3.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [992.77, 272.35] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.8, -2.29],
										[1.86, 2.23]
									],
									"o": [
										[1.86, 2.22],
										[-1.8, -2.27],
										[0, 0]
									],
									"v": [
										[0, 0],
										[5.48, 6.75],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 158,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.56, 2.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [986.49, 264.85] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.68, -1.99],
										[1.73, 1.94]
									],
									"o": [
										[1.73, 1.96],
										[-1.68, -2],
										[0, 0]
									],
									"v": [
										[0, 0],
										[5.12, 5.91],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 159,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.3, 1.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1051.89, 384.32] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.2, -0.66],
										[0.2, 0.66]
									],
									"o": [
										[0.2, 0.68],
										[-0.2, -0.68],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.6, 2.01],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 160,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.31, 0.9] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.02, 372.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.22, -0.59],
										[0.22, 0.59]
									],
									"o": [
										[0.2, 0.6],
										[-0.2, -0.6],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.62, 1.8],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 161,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.13, 0.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1041.17, 353.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 162,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.65, 1.33] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1032.71, 335.01] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.42, -0.89],
										[0.43, 0.89]
									],
									"o": [
										[0.43, 0.88],
										[-0.43, -0.89],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.29, 2.66],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 163,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.45, 0.95] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1035.54, 340.94] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.3, -0.63],
										[0.3, 0.63]
									],
									"o": [
										[0.29, 0.63],
										[-0.29, -0.63],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.89, 1.9],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 164,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.69, 7.67] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1017.58, 307.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.99, -5.21],
										[3.27, 5.02]
									],
									"o": [
										[3.27, 5.01],
										[-2.99, -5.19],
										[0, 0]
									],
									"v": [
										[0, 0],
										[9.38, 15.34],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 165,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.24, 0.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1043.63, 360.08] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.16, -0.43],
										[0.16, 0.43]
									],
									"o": [
										[0.17, 0.43],
										[-0.16, -0.43],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.49, 1.29],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 166,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.31, 0.97] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1050.01, 378.24] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.2, -0.65],
										[0.2, 0.65]
									],
									"o": [
										[0.22, 0.65],
										[-0.2, -0.65],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.62, 1.94],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 167,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.29, 0.81] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1045.89, 366.13] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.19, -0.53],
										[0.19, 0.53]
									],
									"o": [
										[0.2, 0.53],
										[-0.19, -0.53],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.58, 1.61],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 168,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.95, 1.7] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1024.04, 318.38] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.62, -1.14],
										[0.63, 1.12]
									],
									"o": [
										[0.65, 1.14],
										[-0.63, -1.14],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.9, 3.4],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 169,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.87, 1.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1027.01, 323.8] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 170,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.78, 1.51] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1029.89, 329.33] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.52, -1.01],
										[0.52, 1.01]
									],
									"o": [
										[0.52, 1.01],
										[-0.5, -1.01],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.55, 3.02],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 171,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [48.5, 88.52] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1018.23, 325.45] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-1.19, -1.21],
										[0, 0],
										[-13.61, -59.21],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.53, 2.09],
										[0.17, 0.68],
										[0.37, 1.38],
										[0.23, 0.82],
										[0.36, 1.24],
										[0.26, 0.86],
										[0.37, 1.18],
										[0.29, 0.88],
										[0.39, 1.15],
										[0.32, 0.89],
										[0.4, 1.12],
										[0.32, 0.89],
										[0.43, 1.12],
										[0.35, 0.86],
										[0.46, 1.14],
										[0.35, 0.83],
										[0.55, 1.27],
										[0.43, 0.98],
										[0.73, 1.58],
										[0.42, 0.91],
										[0.47, 1.01],
										[0.47, 0.95],
										[0.47, 0.94],
										[0.5, 0.98],
										[0.46, 0.89],
										[0.55, 0.99],
										[0.46, 0.83],
										[0.58, 1.01],
										[0.47, 0.81],
										[0.6, 1.02],
										[0.46, 0.76],
										[0.65, 1.04],
										[0.43, 0.69],
										[0.72, 1.11],
										[0.3, 0.47],
										[2.99, 4.14],
										[0.27, 0.37],
										[0.86, 1.15],
										[0.4, 0.53],
										[0.85, 1.09],
										[0.43, 0.56],
										[0.86, 1.08],
										[0.45, 0.55],
										[0.88, 1.05],
										[0.45, 0.53],
										[0.93, 1.05],
										[0.43, 0.49],
										[0.98, 1.08],
										[0.35, 0.39],
										[1.08, 1.14],
										[0.14, 0.14],
										[4.24, 4.01],
										[0, 0]
									],
									"o": [
										[0, 0],
										[1.21, 1.19],
										[0, 0],
										[42.71, 42.66],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.47, -2.09],
										[-0.17, -0.68],
										[-0.36, -1.4],
										[-0.22, -0.82],
										[-0.35, -1.24],
										[-0.26, -0.88],
										[-0.36, -1.18],
										[-0.27, -0.89],
										[-0.37, -1.15],
										[-0.3, -0.91],
										[-0.39, -1.12],
										[-0.32, -0.89],
										[-0.42, -1.12],
										[-0.33, -0.88],
										[-0.45, -1.14],
										[-0.35, -0.85],
										[-0.53, -1.28],
										[-0.42, -0.98],
										[-0.69, -1.6],
										[-0.42, -0.91],
										[-0.47, -1.01],
										[-0.46, -0.96],
										[-0.46, -0.94],
										[-0.5, -0.99],
										[-0.46, -0.89],
										[-0.53, -1.01],
										[-0.46, -0.85],
										[-0.56, -1.02],
										[-0.46, -0.81],
										[-0.59, -1.04],
										[-0.45, -0.76],
										[-0.63, -1.05],
										[-0.42, -0.68],
										[-0.7, -1.11],
										[-0.3, -0.46],
										[-2.79, -4.27],
										[-0.27, -0.37],
										[-0.85, -1.17],
										[-0.39, -0.52],
										[-0.83, -1.11],
										[-0.43, -0.56],
										[-0.85, -1.08],
										[-0.45, -0.55],
										[-0.88, -1.06],
										[-0.45, -0.53],
										[-0.91, -1.06],
										[-0.42, -0.49],
										[-0.96, -1.09],
										[-0.36, -0.39],
										[-1.06, -1.17],
										[-0.13, -0.14],
										[-4.01, -4.23],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.04, 0],
										[0.04, 10.01],
										[3.64, 13.61],
										[3.64, 8.52],
										[90.78, 165.98],
										[92.49, 173.45],
										[3.64, 173.45],
										[3.64, 169.85],
										[0.04, 169.85],
										[0.04, 177.05],
										[97.01, 177.05],
										[94.28, 165.18],
										[92.76, 158.92],
										[92.23, 156.89],
										[91.14, 152.72],
										[90.45, 150.27],
										[89.38, 146.54],
										[88.61, 143.94],
										[87.51, 140.4],
										[86.67, 137.74],
										[85.53, 134.3],
										[84.61, 131.61],
										[83.41, 128.24],
										[82.45, 125.55],
										[81.19, 122.18],
										[80.18, 119.55],
										[78.81, 116.14],
										[77.79, 113.61],
										[76.18, 109.8],
										[74.91, 106.86],
										[72.78, 102.1],
										[71.52, 99.38],
										[70.1, 96.34],
										[68.69, 93.47],
										[67.29, 90.66],
										[65.78, 87.71],
										[64.4, 85.05],
										[62.79, 82.04],
										[61.41, 79.51],
										[59.71, 76.47],
										[58.31, 74.04],
										[56.52, 70.96],
										[55.15, 68.67],
										[53.24, 65.52],
										[51.96, 63.48],
										[49.84, 60.14],
										[48.94, 58.75],
										[40.28, 46.13],
										[39.46, 44.99],
										[36.88, 41.52],
										[35.7, 39.94],
										[33.17, 36.65],
										[31.88, 34.98],
										[29.3, 31.75],
										[27.96, 30.1],
										[25.33, 26.92],
										[23.99, 25.34],
										[21.25, 22.16],
										[19.97, 20.7],
										[17.06, 17.45],
										[16, 16.29],
										[12.79, 12.83],
										[12.38, 12.42],
										[0, 0.04],
										[0.04, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 172,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.7, 1.22] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1028.76, 312.11] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.46, -0.82],
										[0.47, 0.81]
									],
									"o": [
										[0.46, 0.81],
										[-0.46, -0.81],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.4, 2.43],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 173,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.68, 1.14] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1025.58, 306.67] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 174,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.64, 0.73] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [990.36, 258.32] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.43, -0.49],
										[0.43, 0.49]
									],
									"o": [
										[0.43, 0.49],
										[-0.42, -0.49],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.28, 1.45],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 175,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.69, 1.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1031.85, 317.65] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.45, -0.85],
										[0.46, 0.83]
									],
									"o": [
										[0.46, 0.85],
										[-0.46, -0.85],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.38, 2.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 176,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.64, 1.02] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1022.33, 301.36] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.42, -0.69],
										[0.43, 0.69]
									],
									"o": [
										[0.43, 0.68],
										[-0.42, -0.68],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.28, 2.04],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 177,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.7, 1.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1037.75, 328.93] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 178,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.69, 1.33] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1034.84, 323.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.46, -0.89],
										[0.46, 0.89]
									],
									"o": [
										[0.46, 0.88],
										[-0.46, -0.89],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.38, 2.66],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 179,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.67, 0.83] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [998.38, 267.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.45, -0.56],
										[0.45, 0.55]
									],
									"o": [
										[0.45, 0.55],
										[-0.45, -0.55],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.34, 1.65],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 180,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.53, 0.58] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [986.28, 253.76] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.35, -0.39],
										[0.35, 0.39]
									],
									"o": [
										[0.36, 0.39],
										[-0.36, -0.39],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.06, 1.17],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 181,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.59, 0.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1006.04, 277.6] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.39, -0.53],
										[0.4, 0.53]
									],
									"o": [
										[0.4, 0.52],
										[-0.39, -0.52],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.18, 1.58],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 182,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.2, 0.21] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [982.34, 249.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.14, -0.14],
										[0.14, 0.14]
									],
									"o": [
										[0.13, 0.14],
										[-0.13, -0.14],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.4, 0.42],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 183,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.65, 0.83] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1002.27, 272.68] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.43, -0.56],
										[0.43, 0.56]
									],
									"o": [
										[0.43, 0.55],
										[-0.43, -0.56],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.29, 1.67],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 184,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.45, 0.7] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1019.13, 296.32] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.29, -0.47],
										[0.3, 0.47]
									],
									"o": [
										[0.3, 0.46],
										[-0.3, -0.46],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.91, 1.4],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 185,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.41, 0.57] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1009.62, 282.43] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 186,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.67, 0.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [994.41, 263.01] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 187,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.06, 2.38] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1043.61, 341.35] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.7, -1.6],
										[0.73, 1.58]
									],
									"o": [
										[0.72, 1.58],
										[-0.69, -1.6],
										[0, 0]
									],
									"v": [
										[0, 0],
										[2.13, 4.76],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 188,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.71, 1.52] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1040.57, 334.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.47, -1.01],
										[0.47, 1.01]
									],
									"o": [
										[0.49, 1.01],
										[-0.47, -1.01],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.42, 3.04],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 189,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.57, 1.72] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1055.83, 372.92] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.37, -1.15],
										[0.39, 1.15]
									],
									"o": [
										[0.39, 1.14],
										[-0.37, -1.15],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.14, 3.44],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 190,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.63, 1.68] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1051.57, 360.75] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 191,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.55, 1.77] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1057.8, 379.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 192,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.6, 1.68] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1053.76, 366.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 193,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 79.92] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [971.56, 326.85] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.21, 1.19],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[-1.19, -1.21],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 3.6],
										[0, 0],
										[0, 159.84],
										[3.6, 159.84],
										[3.6, 3.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 194,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.12, 9.06] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1064.61, 404.9] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.53, 2.09],
										[-0.49, -2.1]
									],
									"o": [
										[-0.47, -2.09],
										[0.52, 2.09],
										[0, 0]
									],
									"v": [
										[1.51, 6.26],
										[0, 0],
										[1.51, 6.26]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 195,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.53, 1.86] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1059.65, 385.31] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 196,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.81, 1.91] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1046.75, 348.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 197,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.68, 1.7] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1049.25, 354.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 198,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.55, 2.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1061.41, 391.7] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.36, -1.4],
										[0.37, 1.38]
									],
									"o": [
										[0.37, 1.4],
										[-0.36, -1.4],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.09, 4.17],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 199,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [40.37, 76.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1017.36, 330.52] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.52, 2.03],
										[0.14, 0.58],
										[0.4, 1.45],
										[0.19, 0.68],
										[0.39, 1.37],
										[0.2, 0.66],
										[0.42, 1.37],
										[0.2, 0.65],
										[0.47, 1.38],
										[0.22, 0.59],
										[0.52, 1.45],
										[0.19, 0.53],
										[0.58, 1.54],
										[0.16, 0.43],
										[0.7, 1.74],
										[0.09, 0.22],
										[1.77, 3.84],
										[0.3, 0.63],
										[0.59, 1.22],
										[0.43, 0.89],
										[0.46, 0.95],
										[0.52, 1.01],
										[0.42, 0.79],
										[0.59, 1.08],
										[0.39, 0.7],
										[0.63, 1.12],
										[0.27, 0.47],
										[3.27, 5.01],
										[0.26, 0.42],
										[1.58, 2.27],
										[0.13, 0.17],
										[1.73, 2.35],
										[0.35, 0.46],
										[1.58, 2.01],
										[0.24, 0.32],
										[1.86, 2.23],
										[0.33, 0.39],
										[1.73, 1.94],
										[0.24, 0.27],
										[2.06, 2.17],
										[0.06, 0.07],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[-0.47, -2.06],
										[-0.14, -0.58],
										[-0.37, -1.47],
										[-0.19, -0.68],
										[-0.39, -1.37],
										[-0.2, -0.68],
										[-0.42, -1.37],
										[-0.2, -0.65],
										[-0.45, -1.4],
										[-0.2, -0.6],
										[-0.5, -1.45],
										[-0.19, -0.53],
										[-0.56, -1.54],
										[-0.16, -0.43],
										[-0.68, -1.76],
										[-0.09, -0.22],
										[-1.61, -3.93],
										[-0.29, -0.63],
										[-0.58, -1.22],
										[-0.43, -0.89],
										[-0.46, -0.95],
										[-0.5, -1.01],
										[-0.42, -0.79],
										[-0.58, -1.09],
										[-0.37, -0.7],
										[-0.63, -1.14],
										[-0.27, -0.47],
										[-2.99, -5.21],
										[-0.27, -0.42],
										[-1.51, -2.3],
										[-0.13, -0.19],
										[-1.67, -2.4],
										[-0.35, -0.46],
										[-1.54, -2.06],
										[-0.24, -0.32],
										[-1.8, -2.27],
										[-0.32, -0.39],
										[-1.68, -2],
										[-0.24, -0.29],
										[-1.99, -2.23],
										[-0.06, -0.06],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[80.01, 149.44],
										[78.52, 143.31],
										[78.08, 141.56],
										[76.93, 137.19],
										[76.37, 135.18],
										[75.2, 131.06],
										[74.6, 129.05],
										[73.35, 124.95],
										[72.73, 123],
										[71.35, 118.83],
										[70.73, 117.03],
										[69.2, 112.69],
										[68.63, 111.08],
										[66.9, 106.46],
										[66.41, 105.16],
										[64.33, 99.93],
										[64.07, 99.28],
										[59, 87.62],
										[58.11, 85.72],
										[56.39, 82.06],
										[55.09, 79.39],
										[53.7, 76.56],
										[52.14, 73.54],
										[50.91, 71.15],
										[49.17, 67.9],
										[48.02, 65.8],
										[46.12, 62.4],
										[45.3, 60.96],
										[35.92, 45.62],
										[35.11, 44.39],
										[30.48, 37.52],
										[30.11, 36.98],
										[25, 29.87],
										[23.96, 28.49],
										[19.29, 22.39],
										[18.56, 21.44],
										[13.08, 14.69],
										[12.1, 13.54],
										[6.98, 7.63],
										[6.23, 6.78],
										[0.17, 0.19],
										[0, 0],
										[0, 152.5],
										[80.74, 152.5],
										[80.03, 149.44],
										[80.01, 149.44]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 200,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 29.35] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [533.17, 659.42] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 201,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 3.6] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [856.33, 685.19] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 202,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 25.75] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [856.33, 655.82] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 203,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [192.46, 73.36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [663.87, 703.43] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[384.93, 58.72],
										[61.77, 58.72],
										[61.77, 0],
										[0, 0],
										[0, 146.72],
										[384.93, 146.72],
										[384.93, 58.72]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 204,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [192.46, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [663.87, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[384.93, 0],
										[0, 0],
										[0, 0.17],
										[384.93, 0.17],
										[384.93, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 205,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [192.46, 99.31] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [725.63, 589.48] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[7.19, 139.9],
										[7.19, 7.19],
										[377.73, 7.19],
										[377.73, 191.42],
										[323.16, 191.42],
										[323.16, 198.61],
										[384.93, 198.61],
										[384.93, 0],
										[0, 0],
										[0, 139.9],
										[7.19, 139.9]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 206,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 0.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1281.02, 312.91] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-1.21, -0.5],
										[1.19, 0.5]
									],
									"o": [
										[0, 0],
										[1.19, 0.5],
										[-1.22, -0.5],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 0.03],
										[3.6, 1.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 207,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1340.26, 63.15] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 208,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1340.26, 59.55] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 209,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 0.78] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1277.43, 311.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.21, -0.5],
										[0, 0],
										[1.18, 0.52],
										[0, 0]
									],
									"o": [
										[1.19, 0.52],
										[0, 0],
										[-1.19, -0.5],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0.01],
										[3.6, 1.55],
										[3.6, 1.53],
										[0, 0],
										[0, 0.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 210,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.51, 1.26] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1302.07, 321.05] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[2.3, 0.85],
										[-2.37, -0.83]
									],
									"o": [
										[-2.37, -0.83],
										[2.32, 0.85],
										[0, 0]
									],
									"v": [
										[7.02, 2.52],
										[0, 0],
										[7.02, 2.52]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 211,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.78, 2.58] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1314.17, 325.17] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[5.05, 1.76],
										[-5.32, -1.67]
									],
									"o": [
										[-5.32, -1.68],
										[5.05, 1.76],
										[0, 0]
									],
									"v": [
										[15.56, 5.15],
										[0, 0],
										[15.56, 5.15]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 212,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.01, 1.16] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1336.22, 332.03] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[2.65, 0.79],
										[-2.7, -0.76]
									],
									"o": [
										[-2.7, -0.76],
										[2.65, 0.78],
										[0, 0]
									],
									"v": [
										[8.01, 2.32],
										[0, 0],
										[8.01, 2.32]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 213,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 134.13] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1340.26, 199.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 12.99],
										[0, 102.65],
										[0, 110.73],
										[0, 268.25],
										[0, 110.73],
										[0, 102.65],
										[0, 12.99],
										[0, 0],
										[0, 12.99]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 214,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.52, 2.93] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1290.34, 316.59] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-5.15, -1.9],
										[4.86, 2]
									],
									"o": [
										[4.86, 2],
										[-5.16, -1.9],
										[0, 0]
									],
									"v": [
										[0, 0],
										[15.03, 5.86],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 215,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.01, 0.91] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1326.97, 329.29] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 216,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [98.81, 155.31] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1241.46, 155.31] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, -46.85],
										[-96.86, -42.06]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-24.45, 33.38],
										[0, 85.11],
										[0, 0]
									],
									"v": [
										[132.98, 310.62],
										[132.98, 57.75],
										[197.63, 57.75],
										[197.63, 0],
										[36.95, 0],
										[0, 121.23],
										[132.98, 310.62]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 217,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [47.83, 314.36] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 2.88],
										[2.88, 2.88],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 218,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [60.82, 283.62] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 2.88],
										[2.88, 2.88],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 219,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.74, 0.99] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [73.66, 253.78] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.65, 1.99],
										[3.48, 0],
										[0.36, 0],
										[0, 0.86],
										[2.65, 1.99]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 220,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.32, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [71.57, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.65, 0],
										[1.52, 0],
										[0, 3.6],
										[3.12, 3.6],
										[4.65, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 221,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.9, 1.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [72.67, 255.01] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.8, 1.12],
										[1.15, 0],
										[0, 2.73],
										[3.12, 2.73],
										[3.8, 1.12]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 222,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [54.32, 299.01] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 2.88],
										[30.5, 2.88],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 223,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.6, 3.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [45.99, 318.16] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.56, 0],
										[0, 6.03],
										[3.14, 6.03],
										[5.21, 1.11],
										[2.56, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 224,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.16, 11.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [66.21, 271.42] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[9.19, 0],
										[0, 21.75],
										[2.65, 22.88],
										[12.31, 0],
										[9.19, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 225,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [91.57, 296.62] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 2.88],
										[2.88, 2.88],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 226,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [104.56, 265.86] },
						"r": { "a": 0, "k": -67.11 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 2.88],
										[2.88, 2.88],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 227,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.32, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [107.8, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 3.6],
										[3.12, 3.6],
										[4.63, 0],
										[1.51, 0],
										[0, 3.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 228,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.32, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [109.32, 254.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.12, 3.6],
										[4.65, 0],
										[1.52, 0],
										[0, 3.6],
										[3.12, 3.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 229,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [98.05, 281.26] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 2.88],
										[30.5, 2.88],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 230,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.35, 11.89] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [85.97, 309.28] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[10.05, 0],
										[0, 23.78],
										[3.12, 23.78],
										[12.7, 1.12],
										[10.05, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 231,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.41, 2.56] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [106.19, 262.54] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.7, 0],
										[0, 4.01],
										[2.65, 5.12],
										[4.82, 0],
										[1.7, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 232,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [122.3, 309.58] },
						"r": { "a": 0, "k": -67.11 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 2.88],
										[2.88, 2.88],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 233,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [135.29, 278.85] },
						"r": { "a": 0, "k": -67.11 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 2.88],
										[2.88, 2.88],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 234,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.32, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [144.02, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.52, 0],
										[0, 3.6],
										[3.12, 3.6],
										[4.65, 0],
										[1.52, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 235,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.32, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [145.55, 254.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.51, 0],
										[0, 3.6],
										[3.12, 3.6],
										[4.65, 0],
										[1.51, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 236,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [128.79, 294.24] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 2.88],
										[30.5, 2.88],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 237,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.6, 5.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [119.45, 315.77] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.56, 0],
										[0, 10.79],
										[3.12, 10.79],
										[7.21, 1.12],
										[4.56, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 238,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.15, 9.06] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [139.67, 269.04] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[7.18, 0],
										[0, 17.01],
										[2.65, 18.11],
										[10.3, 0],
										[7.18, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 239,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.63, 0.22] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [152.71, 320.95] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0.45],
										[1.27, 0.45],
										[0.19, 0],
										[0, 0.45]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 240,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [166.02, 291.86] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 2.88],
										[2.88, 2.88],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 241,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.04, 0.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [178.97, 259.6] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0.75],
										[2.07, 0.75],
										[0.32, 0],
										[0, 0.75]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 242,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.88, 1.51] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [179.01, 261.49] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0.81, 0],
										[0, 1.9],
										[2.65, 3.02],
										[3.77, 0.37],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 243,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.16, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [180.41, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.32, 0],
										[1.19, 0],
										[0, 2.85],
										[1.75, 3.6],
										[2.8, 3.6],
										[4.32, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 244,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.32, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [181.77, 254.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 3.6],
										[3.12, 3.6],
										[4.65, 0],
										[1.52, 0],
										[0, 3.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 245,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.26, 14.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [159.52, 306.9] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[11.88, 0],
										[0, 28.1],
										[1.08, 28.55],
										[2.93, 28.55],
										[14.53, 1.12],
										[11.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 246,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [172.51, 276.49] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 2.88],
										[30.5, 2.88],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 247,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.53, 0.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [180.53, 260.17] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.89, 0.37],
										[1.05, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 248,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [196.76, 304.86] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 2.88],
										[2.88, 2.88],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 249,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 7.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [200.72, 295.49] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 8.52],
										[0, 15.91],
										[3.6, 7.4],
										[3.6, 0],
										[0, 8.52]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 250,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 7.95] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [204.31, 286.98] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 8.5],
										[0, 15.9],
										[3.6, 7.38],
										[3.6, 0],
										[0, 8.5]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 251,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.61, 7.78] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [192.92, 313.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[6.57, 0],
										[0, 15.55],
										[3.12, 15.55],
										[9.22, 1.12],
										[6.57, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 252,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.47, 4.02] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [197.45, 300.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.93, 0],
										[0, 6.92],
										[2.66, 8.04],
										[2.93, 7.4],
										[2.93, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 253,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.3, 4.17] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [39.77, 310.97] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.14, 0],
										[0, 2.63],
										[13.48, 8.35],
										[14.6, 5.68],
										[1.14, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 254,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.52, 3.78] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [58.1, 317.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 2.65],
										[11.64, 7.57],
										[19.03, 7.57],
										[1.12, 0],
										[0, 2.65]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 255,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.17, 4.11] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [52.88, 280.28] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[14.34, 5.57],
										[1.15, 0],
										[0, 2.63],
										[13.22, 8.23],
										[14.34, 5.57]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 256,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [14.6, 6.17] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [137.66, 315.01] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.12, 0],
										[0, 2.66],
										[22.89, 12.33],
										[29.01, 12.33],
										[29.2, 11.88],
										[1.12, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 257,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [106.92, 303.12] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 30.5],
										[2.88, 30.5],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 258,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [76.18, 290.12] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 30.5],
										[2.88, 30.5],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 259,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.95, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [86.33, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[7.39, 0],
										[0, 0],
										[8.52, 3.6],
										[15.89, 3.6],
										[7.39, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 260,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [200.72, 306.52] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 3.12],
										[3.6, 4.63],
										[3.6, 1.51],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 261,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.2, 0.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [71.08, 253.22] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.4, 0],
										[0, 0],
										[2.04, 0.86],
										[2.4, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 262,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.6, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [80.17, 254.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[11.21, 3.6],
										[2.69, 0],
										[0.83, 0],
										[0, 1.99],
										[3.81, 3.6],
										[11.21, 3.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 263,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [204.31, 308.04] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 3.12],
										[3.6, 4.65],
										[3.6, 1.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 264,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [119.91, 272.37] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 30.5],
										[2.88, 30.5],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 265,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.7, 1.62] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [198.22, 305.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.12, 0],
										[0, 2.65],
										[1.4, 3.24],
										[1.4, 0.12],
										[1.12, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 266,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [181.39, 298.36] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 30.5],
										[2.88, 30.5],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 267,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [8.44, 3.33] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [95.34, 263.31] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[7.38, 0],
										[0, 0],
										[15.77, 6.66],
										[16.89, 4.01],
										[7.38, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 268,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.44, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [150.64, 285.37] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.88, 0],
										[0, 0],
										[0, 30.5],
										[2.88, 30.5],
										[2.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 269,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.07, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [171.18, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[14.14, 2.85],
										[7.38, 0],
										[0, 0],
										[8.5, 3.6],
										[13.82, 3.6],
										[14.14, 2.85]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 270,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [200.72, 270.29] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.53],
										[0, 0],
										[0, 3.12],
										[3.6, 4.65],
										[3.6, 1.53]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 271,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.95, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [163.54, 254.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[8.52, 3.6],
										[15.89, 3.6],
										[7.39, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 272,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [204.31, 271.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.51],
										[0, 0],
										[0, 3.12],
										[3.6, 4.65],
										[3.6, 1.51]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 273,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.57, 5.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [189.35, 265.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.12, 0],
										[0, 2.65],
										[19.15, 10.73],
										[19.15, 7.61],
										[1.12, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 274,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.66, 0.95] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [175.27, 260.93] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[4.52, 1.9],
										[5.32, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 275,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 12.48] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [200.72, 283.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.53],
										[0, 0],
										[0, 24.96],
										[3.6, 16.45],
										[3.6, 1.53]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 276,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [8.45, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [62.32, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[16.9, 0],
										[1.55, 0],
										[0, 3.6],
										[15.38, 3.6],
										[16.9, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 277,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 6.92] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [200.72, 314.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 1.51],
										[0, 0],
										[0, 13.84],
										[3.6, 13.84],
										[3.6, 1.51]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 278,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.26, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [79.63, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.52, 0],
										[0, 3.6],
										[14.53, 3.6],
										[6.01, 0],
										[1.52, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 279,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 5.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [200.72, 300.32] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 8.52],
										[0, 9.28],
										[3.6, 10.79],
										[3.6, 0],
										[0, 8.52]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 280,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.98, 1.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [175.47, 257.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[6.76, 2.85],
										[7.95, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 281,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [13.9, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [158.72, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.52, 0],
										[0, 3.6],
										[27.79, 3.6],
										[19.29, 0],
										[1.52, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 282,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [10.61, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [96.38, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[19.71, 3.6],
										[21.22, 0],
										[0, 0],
										[8.5, 3.6],
										[19.71, 3.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 283,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [17.31, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [125.91, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.51, 0],
										[0, 3.6],
										[33.1, 3.6],
										[34.62, 0],
										[1.51, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 284,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [10.73, 6.55] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [191.79, 262.94] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.51, 0],
										[0, 3.6],
										[17.87, 3.6],
										[17.87, 11.58],
										[21.46, 13.11],
										[21.46, 0],
										[1.51, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 285,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [8.99, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [171.98, 254.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[17.98, 0],
										[0, 0],
										[8.5, 3.6],
										[16.46, 3.6],
										[17.98, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 286,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [8.25, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [63.67, 254.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[16.5, 0.86],
										[14.46, 0],
										[1.55, 0],
										[0, 3.6],
										[15.35, 3.6],
										[16.5, 0.86]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 287,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 6.17] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [204.31, 315.01] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 12.33],
										[3.6, 12.33],
										[3.6, 1.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 288,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [17.31, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [127.43, 254.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.52, 0],
										[0, 3.6],
										[33.11, 3.6],
										[34.62, 0],
										[1.52, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 289,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [8.88, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [155.23, 254.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.52, 0],
										[0, 3.6],
										[17.76, 3.6],
										[9.25, 0],
										[1.52, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 290,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 7.46] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [204.31, 280.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 14.92],
										[3.6, 6.42],
										[3.6, 1.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 291,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.63, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [92.89, 254.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[31.26, 0],
										[0, 0],
										[8.52, 3.6],
										[29.73, 3.6],
										[31.26, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 292,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.77, 9.11] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [194.34, 261.89] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[23.55, 0],
										[1.52, 0],
										[0, 3.6],
										[19.95, 3.6],
										[19.95, 16.7],
										[23.55, 18.22],
										[23.55, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 293,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 10.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [204.31, 296.83] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 8.52],
										[0, 19.31],
										[3.6, 20.83],
										[3.6, 0],
										[0, 8.52]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 294,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.24, 0.81] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [76.14, 255.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.49, 1.61],
										[0.68, 0],
										[0, 1.61],
										[4.49, 1.61]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 295,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.28, 5.87] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [36.66, 315.3] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[5.08, 0],
										[0, 11.74],
										[16, 11.74],
										[18.56, 5.71],
										[5.08, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 296,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 17.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [82.68, 277.35] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[24.19, 0],
										[9.67, 0],
										[0, 22.88],
										[28.09, 34.75],
										[39.96, 6.66],
										[24.19, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 297,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.6, 2.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [99.88, 261.99] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[9.51, 4.01],
										[11.21, 0],
										[0, 0],
										[9.51, 4.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 298,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.01, 3.99] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [189.91, 263.97] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.16, 0],
										[0, 0.37],
										[18.02, 7.99],
										[18.02, 0],
										[0.16, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 299,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [113.42, 287.73] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 300,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.75, 7.22] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [195.17, 313.96] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[6.1, 0],
										[0, 14.43],
										[7.49, 14.43],
										[7.49, 0.59],
										[6.1, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 301,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.84, 13.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [175.04, 307.46] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[11.59, 0],
										[0, 27.42],
										[33.11, 27.42],
										[39.69, 11.87],
										[11.59, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 302,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 17.83] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [69.69, 303.34] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[11.87, 0],
										[0, 28.1],
										[17.91, 35.67],
										[29.91, 35.67],
										[39.96, 11.88],
										[11.87, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 303,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.85, 2.46] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [53.37, 318.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 4.92],
										[13.71, 4.92],
										[2.07, 0],
										[0, 4.92]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 304,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [13.49, 4.83] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [132.46, 316.34] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 9.67],
										[26.97, 9.67],
										[4.09, 0],
										[0, 9.67]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 305,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [18.84, 11.33] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [101.57, 309.84] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[9.58, 0],
										[0, 22.66],
										[33.11, 22.66],
										[37.67, 11.87],
										[9.58, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 306,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 15] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [157.15, 274.98] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[35.44, 0],
										[7.65, 0],
										[0, 18.11],
										[28.09, 30],
										[39.96, 1.9],
										[35.44, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 307,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.14, 0.38] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [198.78, 303.83] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0.65],
										[0.27, 0.76],
										[0.27, 0],
										[0, 0.65]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 308,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.51, 19.99] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [183.42, 282.99] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[31.01, 8.09],
										[11.87, 0],
										[0, 28.1],
										[28.08, 39.97],
										[31.01, 33.05],
										[31.01, 8.09]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 309,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [17.64, 8.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [124.07, 268.48] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 5.12],
										[28.09, 17.01],
										[35.27, 0],
										[2.17, 0],
										[0, 5.12]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 310,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.67, 16.84] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [46.27, 295.64] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[25.33, 5.6],
										[12.11, 0],
										[0, 28],
										[13.46, 33.68],
										[25.33, 5.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 311,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.19, 10.88] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [58.06, 270.86] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[22.38, 0],
										[7.01, 0],
										[0, 16.19],
										[13.19, 21.75],
										[22.38, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 312,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [144.17, 300.73] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 313,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 1.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [54.65, 258.17] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 314,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 1.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [56.2, 254.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 315,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.54, 5.87] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [29.93, 315.3] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[5.08, 0],
										[0, 11.74],
										[5.08, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 316,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [39.66, 292.8] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 317,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 8.82] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [50.36, 268.06] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 318,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.26, 16.68] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [85.64, 203.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[24.53, 5.25],
										[12.11, 0],
										[0, 28],
										[12.66, 33.35],
										[24.53, 5.25]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 319,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.13, 16.62] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [98.76, 172.89] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[24.27, 5.14],
										[12.11, 0],
										[0, 28],
										[12.4, 33.24],
										[24.27, 5.14]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 320,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.37, 0.13] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [251.17, 0.13] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.73, 0],
										[0, 0],
										[0.62, 0.26],
										[0.73, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 321,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.46, 2.51] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [172.63, 2.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[10.79, 5.02],
										[12.92, 0],
										[0.19, 0],
										[0, 0.46],
										[10.79, 5.02]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 322,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 15.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [230.32, 15.5] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[28.09, 31.01],
										[39.96, 2.92],
										[33.07, 0],
										[8.1, 0],
										[0, 19.14],
										[28.09, 31.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 323,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [17.84, 9.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [197.46, 9.01] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[28.08, 18.01],
										[35.69, 0],
										[2.59, 0],
										[0, 6.14],
										[28.08, 18.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 324,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.59, 13.13] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [304.4, 13.13] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[28.09, 26.26],
										[39.18, 0],
										[6.08, 0],
										[0, 14.37],
										[28.09, 26.26]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 325,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.97, 17.16] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [281.32, 213.91] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.1],
										[14.72, 34.33],
										[25.94, 5.94],
										[11.87, 0],
										[0, 28.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 326,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [10.79, 16.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [357.08, 28.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.1],
										[10.37, 32.47],
										[21.58, 4.1],
										[11.87, 0],
										[0, 28.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 327,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.52, 6.85] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [366.8, 6.85] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[9.64, 13.7],
										[15.05, 0],
										[4.07, 0],
										[0, 9.63],
										[9.64, 13.7]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 328,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.85, 6.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [270.92, 6.63] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[28.09, 13.27],
										[33.7, 0],
										[0.59, 0],
										[0, 1.38],
										[28.09, 13.27]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 329,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.51, 16.55] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [331.83, 90.31] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.09],
										[11.82, 33.09],
										[23.03, 4.7],
										[11.87, 0],
										[0, 28.09]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 330,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.87, 16.7] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [319.2, 121.21] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.09],
										[12.54, 33.39],
										[23.75, 5.02],
										[11.87, 0],
										[0, 28.09]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 331,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.85, 4.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [348.37, 4.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[23.71, 0],
										[0, 0],
										[20.11, 8.5],
										[23.71, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 332,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.6, 17.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [293.94, 183] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.1],
										[14, 34.01],
										[25.2, 5.64],
										[11.87, 0],
										[0, 28.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 333,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.24, 16.86] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [306.57, 152.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.1],
										[13.28, 33.71],
										[24.48, 5.34],
										[11.87, 0],
										[0, 28.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 334,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.75, 5.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [215.86, 315.77] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 10.81],
										[18.41, 10.81],
										[19.49, 8.24],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 335,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.45, 2.31] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [63.43, 250.48] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[12.9, 4.62],
										[2, 0],
										[0, 4.62],
										[12.9, 4.62]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 336,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12.4, 16.73] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [72.51, 234.26] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[24.8, 5.37],
										[12.11, 0],
										[0, 28],
										[12.93, 33.45],
										[24.8, 5.37]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 337,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.15, 16.39] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [344.45, 59.41] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.09],
										[11.09, 32.78],
										[22.3, 4.4],
										[11.87, 0],
										[0, 28.09]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 338,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.01, 0.72] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [229.66, 320.45] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 1.44],
										[4.03, 1.44],
										[0.62, 0],
										[0, 1.44]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 339,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 19.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [335.53, 19.63] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[28.09, 39.25],
										[39.96, 11.15],
										[13.58, 0],
										[11.57, 0],
										[0, 27.37],
										[28.09, 39.25]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 340,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [13.33, 17.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [268.69, 244.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.1],
										[15.45, 34.63],
										[26.65, 6.26],
										[11.87, 0],
										[0, 28.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 341,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [14.05, 16.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [243.44, 305.08] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.1],
										[9.68, 32.19],
										[18.11, 32.19],
										[28.11, 6.86],
										[11.87, 0],
										[0, 28.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 342,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [13.69, 17.47] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [256.06, 275.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.1],
										[16.17, 34.93],
										[27.37, 6.56],
										[11.87, 0],
										[0, 28.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 343,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [191.36, 103.26] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 344,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [226.85, 190.74] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 345,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [213.86, 221.49] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 346,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [18.38, 19.99] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [202.48, 252.24] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 20.53],
										[22.02, 20.53],
										[22.02, 38.75],
										[24.89, 39.97],
										[36.77, 11.87],
										[8.67, 0],
										[0, 20.53]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 347,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [239.84, 160] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 348,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.88, 2.45] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [206.99, 276.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 4.89],
										[1.75, 0.73],
										[0, 0],
										[0, 4.89]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 349,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [17.38, 7.88] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [129.01, 244.9] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[34.75, 11.87],
										[6.66, 0],
										[0, 15.77],
										[33.1, 15.77],
										[34.75, 11.87]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 350,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [204.35, 72.52] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 351,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [173.6, 59.53] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 352,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [265.82, 98.51] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 353,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [160.61, 90.27] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 354,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [252.83, 129.25] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 355,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [235.09, 85.52] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 356,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [222.1, 116.26] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 357,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [209.11, 147] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 358,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [196.12, 177.74] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 359,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [278.81, 67.75] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 360,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [183.13, 208.5] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 361,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.86, 1.39] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [151.73, 251.4] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 2.78],
										[7.72, 2.78],
										[1.17, 0],
										[0, 2.78]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 362,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [152.39, 195.51] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 363,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [165.38, 164.76] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 364,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [139.4, 226.25] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 365,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [178.37, 134.01] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 366,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 16.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [170.14, 236.02] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[11.87, 0],
										[0, 28.1],
										[12.83, 33.52],
										[30.81, 33.52],
										[39.96, 11.87],
										[11.87, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 367,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [270.58, 172.99] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 368,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [261.08, 24.02] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 369,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [248.08, 54.77] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 370,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [217.33, 41.78] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 371,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [147.64, 121.03] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 372,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [291.82, 37.02] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 373,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.73, 16.45] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [138.12, 80.82] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[23.46, 4.79],
										[12.11, 0],
										[0, 27.98],
										[11.59, 32.89],
										[23.46, 4.79]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 374,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [186.6, 28.77] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 375,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [309.56, 80.75] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 376,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.87, 16.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [125, 111.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[23.73, 4.91],
										[12.13, 0],
										[0, 27.98],
										[11.87, 33.01],
										[23.73, 4.91]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 377,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.59, 16.39] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [151.25, 50.13] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[23.19, 4.68],
										[12.11, 0],
										[0, 27.98],
										[11.32, 32.78],
										[23.19, 4.68]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 378,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.47, 16.34] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [164.38, 19.43] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[22.94, 4.58],
										[12.11, 0],
										[0, 28],
										[11.06, 32.68],
										[22.94, 4.58]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 379,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [322.55, 50.01] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 380,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.25, 19.99] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [222.36, 295.98] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 10.42],
										[0, 31.25],
										[20.61, 39.97],
										[32.49, 11.87],
										[4.4, 0],
										[0, 10.42]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 381,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [296.56, 111.5] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 382,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [231.62, 265.23] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 383,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [134.65, 151.77] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 384,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [108.67, 213.26] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 385,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [121.66, 182.51] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 386,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 14.38] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [95.67, 238.4] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[32.83, 28.76],
										[39.96, 11.87],
										[11.87, 0],
										[0, 28.09],
										[1.57, 28.76],
										[32.83, 28.76]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 387,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [283.57, 142.25] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 388,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [257.6, 203.73] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 389,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [12, 16.56] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [111.88, 142.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[23.99, 5.02],
										[12.11, 0],
										[0, 27.98],
										[12.13, 33.12],
										[23.99, 5.02]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 390,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [244.61, 234.49] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 391,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.9, 0.89] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1090.39, 484.94] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-3.27, 0.58],
										[3.27, -0.62]
									],
									"o": [
										[3.27, -0.62],
										[-3.27, 0.56],
										[0, 0]
									],
									"v": [
										[0, 1.78],
										[9.8, 0],
										[0, 1.78]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 392,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.8, 1.23] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.1, 494.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-3.21, 0.79],
										[3.19, -0.85]
									],
									"o": [
										[3.21, -0.85],
										[-3.21, 0.79],
										[0, 0]
									],
									"v": [
										[0, 2.46],
										[9.61, 0],
										[0, 2.46]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 393,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.7, 0.74] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1079.55, 487] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.47, 0.49],
										[2.47, -0.52]
									],
									"o": [
										[2.47, -0.5],
										[-2.46, 0.47],
										[0, 0]
									],
									"v": [
										[0, 1.48],
										[7.41, 0],
										[0, 1.48]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 394,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.32, 0.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1100.66, 483.16] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.88, 0.46],
										[2.88, -0.49]
									],
									"o": [
										[2.89, -0.49],
										[-2.88, 0.46],
										[0, 0]
									],
									"v": [
										[0, 1.42],
										[8.65, 0],
										[0, 1.42]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 395,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.34, 0.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1162.18, 475.88] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.88, 0.2],
										[2.89, -0.23]
									],
									"o": [
										[2.91, -0.23],
										[-2.88, 0.2],
										[0, 0]
									],
									"v": [
										[0, 0.65],
										[8.67, 0],
										[0, 0.65]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 396,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.47, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1162.4, 521.37] },
						"r": { "a": 0, "k": -47.28 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 397,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.21, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1142.99, 542.68] },
						"r": { "a": 0, "k": -47.27 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 398,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.9, 1.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1137.01, 478.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-6.56, 0.62],
										[6.63, -0.82]
									],
									"o": [
										[6.63, -0.82],
										[-6.56, 0.63],
										[0, 0]
									],
									"v": [
										[0, 2.17],
										[19.79, 0],
										[0, 2.17]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 399,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.21, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1118.9, 568.75] },
						"r": { "a": 0, "k": -47.27 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 400,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.49, 0.55] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1068.59, 489.3] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.65, -0.37],
										[-1.65, 0.36],
										[0, 0]
									],
									"o": [
										[-1.65, 0.36],
										[1.65, -0.37],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.98, 0],
										[0, 1.09],
										[4.96, 0.01],
										[4.98, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 401,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.21, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1070.75, 620.88] },
						"r": { "a": 0, "k": -47.27 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 402,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.37, 0.21] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1108.94, 481.84] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.92, -0.13],
										[-0.91, 0.13],
										[0, 0]
									],
									"o": [
										[-0.92, 0.13],
										[0.92, -0.14],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.75, 0],
										[0, 0.42],
										[2.73, 0.01],
										[2.75, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 403,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.24, 0.54] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1058.21, 491.68] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.47, -0.36],
										[-1.5, 0.36],
										[0, 0],
										[0, 0]
									],
									"o": [
										[-1.48, 0.35],
										[1.5, -0.36],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[4.43, 0],
										[0, 1.08],
										[4.47, 0.01],
										[4.44, 0.01],
										[4.43, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 404,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.85, 1.23] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1202.6, 475.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.55, 0.04],
										[2.57, -0.07],
										[0, 0],
										[0, 0]
									],
									"o": [
										[2.57, -0.07],
										[-2.56, 0.04],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.01, 0.19],
										[7.7, 0],
										[0, 0.17],
										[0.01, 0.17],
										[0.01, 0.19]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 405,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.73, 0.06] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1147.76, 477.09] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.47, -0.04],
										[-0.49, 0.04]
									],
									"o": [
										[-0.49, 0.04],
										[0.49, -0.04],
										[0, 0]
									],
									"v": [
										[1.45, 0],
										[0, 0.13],
										[1.45, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 406,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.47, 0.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1190.45, 474.3] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0.96, -0.04],
										[-0.98, 0.04],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-0.96, 0.03],
										[0.98, -0.03],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.92, 0],
										[2.89, 0],
										[0, 0.1],
										[2.93, 0],
										[2.92, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 407,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.1, 0.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1176.69, 474.98] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[6.11, -0.4],
										[-6.01, 0.26]
									],
									"o": [
										[-6.01, 0.26],
										[6.11, -0.42],
										[0, 0]
									],
									"v": [
										[18.2, 0],
										[0, 1.01],
										[18.2, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 408,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.42, 0.21] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1154.15, 476.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.63, -0.14],
										[-1.61, 0.13]
									],
									"o": [
										[-1.61, 0.13],
										[1.61, -0.13],
										[0, 0]
									],
									"v": [
										[4.85, 0],
										[0, 0.42],
										[4.85, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 409,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [10.6, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1050.44, 642.62] },
						"r": { "a": 0, "k": -47.28 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 410,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.41, 0.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1118.92, 480.41] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.92, -0.13],
										[-0.93, 0.13],
										[0, 0],
										[0, 0]
									],
									"o": [
										[-0.92, 0.13],
										[0.95, -0.13],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.78, 0],
										[0, 0.39],
										[2.82, 0.01],
										[2.78, 0.01],
										[2.78, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 411,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.6, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1114.24, 481.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.39, -0.06],
										[-0.4, 0.06],
										[0, 0]
									],
									"o": [
										[-0.4, 0.06],
										[0.4, -0.04],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.19, 0],
										[0, 0.17],
										[1.21, 0],
										[1.19, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 412,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.21, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1191.04, 490.35] },
						"r": { "a": 0, "k": -47.28 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 413,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [13.49, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1092.97, 596.8] },
						"r": { "a": 0, "k": -47.27 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 414,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.5, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1176.36, 506.55] },
						"r": { "a": 0, "k": -47.27 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 415,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 15.81] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1155.11, 760.98] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[11.87, 0],
										[0, 28.09],
										[8.31, 31.61],
										[31.62, 31.61],
										[39.96, 11.87],
										[11.87, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 416,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.97, 6.94] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1114.39, 769.85] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[5.85, 0],
										[0, 13.87],
										[33.11, 13.87],
										[33.95, 11.88],
										[5.85, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 417,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.21, 0.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1134.85, 776.34] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0.88],
										[2.42, 0.88],
										[0.36, 0],
										[0, 0.88]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 418,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [18.99, 11.69] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1261.31, 765.09] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[9.88, 0],
										[0, 23.38],
										[33.11, 23.38],
										[37.97, 11.87],
										[9.88, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 419,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.84, 2.81] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1213.94, 773.97] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 5.63],
										[15.68, 5.63],
										[2.37, 0],
										[0, 5.63]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 420,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1360.77, 707.15] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 421,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 14.07] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1334.78, 762.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[11.87, 0],
										[0, 28.1],
										[0.1, 28.14],
										[33.08, 28.14],
										[39.96, 11.87],
										[11.87, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 422,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 18.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1229.58, 758.6] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[11.87, 0],
										[0, 28.09],
										[19.58, 36.37],
										[29.6, 36.37],
										[39.96, 11.87],
										[11.87, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 423,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.71, 13.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1080.91, 763.35] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[11.33, 0],
										[0, 26.86],
										[33.1, 26.86],
										[39.43, 11.88],
										[11.33, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 424,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [14.48, 5.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1293.03, 771.59] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 10.39],
										[28.96, 10.39],
										[4.39, 0],
										[0, 10.39]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 425,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [17.98, 9.31] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1187.85, 767.48] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[7.87, 0],
										[0, 18.62],
										[33.11, 18.62],
										[35.96, 11.87],
										[7.87, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 426,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [14.43, 15.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1146.38, 546.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 23.81],
										[17, 31.01],
										[28.87, 2.91],
										[21.99, 0],
										[0, 23.81]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 427,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1163.36, 659.94] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 428,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.96, 8.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1377.94, 542.78] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[5.91, 16.47],
										[5.91, 0],
										[0, 13.97],
										[5.91, 16.47]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 429,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [18.32, 19.98] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1362.58, 527.42] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.09],
										[28.08, 39.96],
										[36.64, 19.71],
										[36.64, 10.46],
										[11.87, 0],
										[0, 28.09]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 430,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.82, 14.68] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1369.08, 500.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[5.57, 0.91],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[-4.75, -0.86],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 19.35],
										[23.65, 29.35],
										[23.65, 2.66],
										[8.17, 0],
										[0, 19.35]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 431,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1176.35, 629.19] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 432,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.45, 18.04] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1371.45, 569.21] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.09],
										[18.9, 36.07],
										[18.9, 2.96],
										[11.88, 0],
										[0, 28.09]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 433,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1158.61, 585.45] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 434,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 17.85] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1127.85, 574.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[21.99, 0],
										[0, 23.83],
										[28.08, 35.7],
										[39.96, 7.6],
										[21.99, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 435,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1171.59, 554.7] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 436,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1189.34, 598.43] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 437,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.07, 17.04] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1373.83, 642.69] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.1],
										[14.14, 34.09],
										[14.14, 0.96],
										[11.87, 0],
										[0, 28.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 438,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [13.31, 19.61] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1056.57, 757.17] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[14.8, 39.22],
										[26.61, 11.24],
										[0, 0],
										[0, 33.11],
										[14.46, 39.22],
										[14.8, 39.22]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 439,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.53, 1.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1046.8, 775.29] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 2.99],
										[7.06, 2.99],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 440,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1220.07, 611.44] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 441,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1202.32, 567.69] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 442,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.43, 12.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1047.7, 713.68] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 24.73],
										[8.86, 3.74],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 443,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.43, 8.21] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1162.44, 522.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[12.86, 0],
										[0, 13.91],
										[5.93, 16.42],
										[12.86, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 444,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.69, 13.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1376.21, 719.12] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[9.38, 26.17],
										[9.38, 0],
										[0, 22.2],
										[9.38, 26.17]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 445,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1207.08, 642.18] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 446,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [13.56, 19.78] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1367.34, 676.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.1],
										[27.13, 39.57],
										[27.13, 6.46],
										[11.87, 0],
										[0, 28.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 447,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [14.95, 7.58] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1365.96, 769.21] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 15.15],
										[29.89, 15.15],
										[29.89, 9.93],
										[6.4, 0],
										[0, 15.15]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 448,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.18, 18.78] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1369.71, 749.66] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.1],
										[22.37, 37.55],
										[22.37, 4.45],
										[11.87, 0],
										[0, 28.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 449,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.8, 19.99] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1063.07, 726.17] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[39.6, 11.88],
										[11.52, 0],
										[0, 27.27],
										[0, 28.24],
										[27.73, 39.97],
										[39.6, 11.88]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 450,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.99, 16.89] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1272, 491.53] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[6.8, 0.3],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[-6.49, -0.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[28.11, 33.78],
										[39.97, 5.68],
										[29.21, 1.14],
										[9.26, 0],
										[0, 21.91],
										[28.09, 33.78],
										[28.11, 33.78]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 451,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [18.46, 10.86] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1239.78, 484.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[11.22, 0.06],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-10.6, -0.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[28.08, 21.71],
										[36.92, 0.79],
										[4.16, 0],
										[0, 9.84],
										[28.09, 21.71],
										[28.08, 21.71]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 452,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1268.55, 668.17] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 453,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [17.99, 11.55] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1344.49, 492.12] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[11.36, 1.41],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-9.41, -1.5],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[28.09, 23.11],
										[35.99, 4.4],
										[4.75, 0],
										[0, 11.22],
										[28.09, 23.09],
										[28.09, 23.11]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 454,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.25, 6.86] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1312.01, 483.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[11.18, 0.95],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-9.94, -1.19],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[28.09, 13.71],
										[32.51, 3.25],
										[0.78, 0],
										[0, 1.84],
										[28.09, 13.71]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 455,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.68, 0.62] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1291.86, 477.05] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.12, 0.09],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[-1.11, -0.09],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.35, 0.27],
										[0, 0],
										[2.95, 1.24],
										[3.37, 0.26],
										[3.35, 0.27]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 456,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [10.92, 18.67] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1054.19, 683.74] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[21.85, 9.25],
										[0, 0],
										[0, 33.12],
										[9.98, 37.34],
										[21.85, 9.25]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 457,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [17.43, 18.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1060.7, 653.29] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[34.85, 8.66],
										[14.38, 0],
										[0, 15.58],
										[0, 27.04],
										[22.97, 36.75],
										[34.85, 8.66]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 458,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.95, 19.99] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1364.95, 601.9] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 28.1],
										[28.09, 39.97],
										[31.89, 30.99],
										[31.89, 8.47],
										[11.87, 0],
										[0, 28.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 459,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.08, 4.36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1213.26, 478.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[5.35, -0.09],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-5.24, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[14.49, 8.72],
										[18.17, 0],
										[2.27, 0.13],
										[0, 2.59],
										[14.49, 8.72]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 460,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.58, 1.6] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1380.32, 621.89] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.15, 3.21],
										[1.15, 0],
										[0, 2.72],
										[1.15, 3.21]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 461,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1088.89, 664.68] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 462,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1307.52, 575.93] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 463,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1294.53, 606.68] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 464,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1281.54, 637.43] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 465,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1299.3, 681.16] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 466,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1312.28, 650.41] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 467,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1211.84, 716.67] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 468,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1286.31, 711.9] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 469,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1198.86, 747.42] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 470,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1137.38, 721.43] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 471,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1124.37, 752.17] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 472,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1168.11, 734.42] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 473,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1276.79, 562.92] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 474,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1150.37, 690.69] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 475,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1224.83, 685.92] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 476,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.98, 19.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1184.57, 524.27] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 27.44],
										[28.08, 39.31],
										[39.96, 11.21],
										[13.42, 0],
										[10.04, 3.67],
										[0, 27.44]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 477,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1242.59, 729.65] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 478,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1255.58, 698.91] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 479,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1194.09, 672.92] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 480,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1215.31, 536.95] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 481,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1181.1, 703.68] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 482,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1119.63, 677.69] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 483,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1132.63, 646.94] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 484,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.15, 11.69] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1092.95, 598.49] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 19.81],
										[8.41, 23.38],
										[18.3, 0],
										[0, 19.81]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 485,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1145.6, 616.18] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 486,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1114.87, 603.2] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 487,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1356.02, 632.66] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 488,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1304.05, 755.64] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 489,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1101.89, 633.94] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 490,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1317.04, 724.9] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 491,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1093.64, 739.17] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 492,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1106.63, 708.43] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 493,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1246.06, 549.92] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 494,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1302.76, 501.42] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 495,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1289.78, 532.18] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 496,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1259.03, 519.18] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 497,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.69, 16.03] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1075.42, 624.89] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[21.99, 0],
										[0, 23.81],
										[19.51, 32.06],
										[31.39, 3.97],
										[21.99, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 498,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [18.72, 17.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1198.82, 495.86] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[25.58, 34.63],
										[37.44, 6.53],
										[21.99, 0],
										[0, 23.83],
										[25.58, 34.63]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 499,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1228.3, 506.19] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 500,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1273.32, 742.65] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 501,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1338.26, 588.92] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 502,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1237.83, 655.19] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 503,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1351.25, 558.18] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 504,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1250.82, 624.45] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 505,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1320.52, 545.17] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 506,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1343.03, 663.41] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 507,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1347.78, 737.89] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 508,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1330.04, 694.16] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 509,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1325.27, 619.66] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 510,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1263.8, 593.69] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 511,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1233.07, 580.68] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 512,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1333.52, 514.43] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 513,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.25, 15.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1075.89, 695.44] },
						"r": { "a": 0, "k": -67.1 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[30.5, 0],
										[0, 0],
										[0, 30.5],
										[30.5, 30.5],
										[30.5, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 514,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.65, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1155.09, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.43, 0.17],
										[23.23, 0.17],
										[23.3, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 515,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.59, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1077.7, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.09, 0],
										[0, 0.17],
										[33.11, 0.17],
										[33.18, 0],
										[0.09, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 516,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.45, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1135.03, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.07, 0],
										[0, 0.17],
										[2.91, 0.17],
										[2.49, 0],
										[0.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 517,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.59, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1186.39, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.07, 0],
										[0, 0.17],
										[33.11, 0.17],
										[33.18, 0],
										[0.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 518,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.59, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1113.93, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.07, 0],
										[0, 0.17],
										[33.1, 0.17],
										[33.18, 0],
										[0.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 519,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [8.08, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1214.11, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.07, 0],
										[0, 0.17],
										[16.17, 0.17],
										[15.75, 0],
										[0.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 520,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [14.98, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1365.92, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0.17],
										[29.96, 0.17],
										[29.96, 0],
										[0.07, 0],
										[0, 0.17]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 521,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.49, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1331.39, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.42, 0.17],
										[32.91, 0.17],
										[32.98, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 522,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.01, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1234.19, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.42, 0.17],
										[9.95, 0.17],
										[10.03, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 523,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [16.59, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1258.84, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.07, 0],
										[0, 0.17],
										[33.11, 0.17],
										[33.18, 0],
										[0.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 524,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [14.72, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1293.21, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.07, 0],
										[0, 0.17],
										[29.44, 0.17],
										[29.03, 0],
										[0.07, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 525,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.74, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1047.01, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 0.17],
										[7.48, 0.17],
										[7.06, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 526,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.17, 0.06] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1057.9, 776.84] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.29, 0.12],
										[0.35, 0],
										[0, 0],
										[0.29, 0.12]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 527,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.85, 1.52] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1030.31, 314.85] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.56, -1.01],
										[0.58, 1.01]
									],
									"o": [
										[0.58, 1.01],
										[-0.56, -1.02],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.7, 3.04],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 528,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.45, 1.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [988.26, 255.96] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 529,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.9, 1.54] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1027.17, 309.36] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 530,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.37, 1.59] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [992.37, 260.62] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.92, -1.06],
										[0.93, 1.05]
									],
									"o": [
										[0.92, 1.05],
										[-0.91, -1.06],
										[0, 0]
									],
									"v": [
										[0, 0],
										[2.75, 3.18],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 531,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.19, 6.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [975.96, 243.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 532,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.96, 1.58] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1023.93, 303.96] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.63, -1.05],
										[0.65, 1.04]
									],
									"o": [
										[0.65, 1.05],
										[-0.63, -1.05],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.91, 3.15],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 533,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.06, 1.67] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1020.65, 298.67] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.7, -1.12],
										[0.72, 1.11]
									],
									"o": [
										[0.72, 1.11],
										[-0.7, -1.11],
										[0, 0]
									],
									"v": [
										[0, 0],
										[2.11, 3.34],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 534,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.32, 1.59] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [996.4, 265.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.86, -1.06],
										[0.88, 1.05]
									],
									"o": [
										[0.89, 1.05],
										[-0.88, -1.06],
										[0, 0]
									],
									"v": [
										[0, 0],
										[2.63, 3.18],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 535,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.33, 6.31] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1014.36, 289.31] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.79, -4.27],
										[2.99, 4.14]
									],
									"o": [
										[2.98, 4.14],
										[-2.79, -4.27],
										[0, 0]
									],
									"v": [
										[0, 0],
										[8.66, 12.62],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 536,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.29, 1.61] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1000.34, 270.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.85, -1.08],
										[0.86, 1.08]
									],
									"o": [
										[0.86, 1.06],
										[-0.85, -1.08],
										[0, 0]
									],
									"v": [
										[0, 0],
										[2.57, 3.22],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 537,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.27, 1.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1004.19, 275.16] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 538,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.29, 1.73] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1007.92, 280.12] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 539,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.6, 1.73] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [984.14, 251.43] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.06, -1.15],
										[1.08, 1.14]
									],
									"o": [
										[1.08, 1.14],
										[-1.06, -1.17],
										[0, 0]
									],
									"v": [
										[0, 0],
										[3.21, 3.45],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 540,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.39, 1.3] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1058.73, 382.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.24, -0.86],
										[0.26, 0.86]
									],
									"o": [
										[0.26, 0.86],
										[-0.26, -0.88],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.78, 2.6],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 541,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.48, 1.35] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1052.68, 363.78] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.32, -0.89],
										[0.32, 0.89]
									],
									"o": [
										[0.33, 0.89],
										[-0.32, -0.89],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.96, 2.69],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 542,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.46, 1.35] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1054.82, 369.84] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.3, -0.89],
										[0.32, 0.89]
									],
									"o": [
										[0.32, 0.89],
										[-0.3, -0.91],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.92, 2.69],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 543,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 3.6] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [969.77, 410.36] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 544,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.27, 1.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1062.23, 394.82] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 545,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.35, 1.22] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1060.53, 388.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.23, -0.82],
										[0.23, 0.82]
									],
									"o": [
										[0.23, 0.82],
										[-0.22, -0.82],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.69, 2.45],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 546,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.81, 1.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1033.34, 320.42] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.53, -1.01],
										[0.55, 0.99]
									],
									"o": [
										[0.55, 1.01],
										[-0.53, -1.01],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.61, 3.01],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 547,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.7, 1.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1039.14, 331.77] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.46, -0.96],
										[0.47, 0.95]
									],
									"o": [
										[0.47, 0.96],
										[-0.46, -0.96],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.41, 2.88],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 548,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.76, 1.47] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1036.3, 326.06] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.49, -0.98],
										[0.5, 0.98]
									],
									"o": [
										[0.5, 0.98],
										[-0.5, -0.99],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.51, 2.95],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 549,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.51, 1.27] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1048.05, 351.75] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.35, -0.83],
										[0.35, 0.83]
									],
									"o": [
										[0.35, 0.85],
										[-0.35, -0.85],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.02, 2.53],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 550,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.5, 1.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1050.43, 357.75] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.33, -0.88],
										[0.35, 0.86]
									],
									"o": [
										[0.35, 0.88],
										[-0.33, -0.88],
										[0, 0]
									],
									"v": [
										[0, 0],
										[1.01, 2.63],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 551,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.63, 1.47] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1045.31, 345.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 552,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.63, 1.36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1041.92, 337.61] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 553,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.42, 1.33] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1056.83, 375.97] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.27, -0.89],
										[0.29, 0.88]
									],
									"o": [
										[0.29, 0.89],
										[-0.27, -0.89],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.85, 2.66],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 554,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [133.25, 283.93] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1102.96, 446.15] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-0.01, 0],
										[-3.21, 0.79],
										[-1.02, 0.24],
										[-1.48, 0.35],
										[-0.73, 0.17],
										[-1.17, 0.26],
										[-1.65, 0.36],
										[-0.49, 0.1],
										[-1.09, 0.23],
										[-2.47, 0.49],
										[-0.73, 0.14],
										[-3.27, 0.57],
										[-0.34, 0.06],
										[-2.88, 0.46],
										[-0.85, 0.14],
										[-0.92, 0.13],
										[-1.11, 0.16],
										[-0.39, 0.06],
										[-0.89, 0.13],
										[-0.92, 0.12],
										[-1.61, 0.2],
										[-0.66, 0.09],
										[-6.56, 0.63],
										[-0.04, 0],
										[-0.48, 0.04],
										[-1.08, 0.1],
										[-1.61, 0.13],
										[-0.42, 0.03],
										[-2.88, 0.2],
										[-0.36, 0.03],
										[-6.01, 0.26],
										[-1.06, 0.04],
										[-0.96, 0.03],
										[-2.29, 0.06],
										[-2.55, 0.04],
										[0, 0],
										[0, 0],
										[0, 0],
										[-4.01, -4.23],
										[-0.14, -0.14],
										[-1.06, -1.15],
										[-0.35, -0.39],
										[-0.96, -1.09],
										[-0.43, -0.49],
										[-0.92, -1.07],
										[-0.45, -0.53],
										[-0.86, -1.06],
										[-0.45, -0.56],
										[-0.85, -1.08],
										[-0.43, -0.56],
										[-0.83, -1.11],
										[-0.39, -0.53],
										[-0.85, -1.17],
										[-0.27, -0.37],
										[-2.79, -4.27],
										[-0.29, -0.48],
										[-0.7, -1.12],
										[-0.42, -0.69],
										[-0.63, -1.05],
										[-0.45, -0.76],
										[-0.59, -1.03],
										[-0.46, -0.82],
										[-0.56, -1.01],
										[-0.45, -0.85],
										[-0.53, -1.01],
										[-0.46, -0.89],
										[-0.49, -0.98],
										[-0.46, -0.93],
										[-0.46, -0.96],
										[-0.47, -1.01],
										[-0.42, -0.91],
										[-0.7, -1.6],
										[-0.42, -0.98],
										[-0.53, -1.28],
										[-0.35, -0.84],
										[-0.45, -1.14],
										[-0.33, -0.88],
										[-0.42, -1.12],
										[-0.32, -0.89],
										[-0.39, -1.12],
										[-0.3, -0.89],
										[-0.37, -1.15],
										[-0.27, -0.89],
										[-0.36, -1.18],
										[-0.24, -0.86],
										[-0.35, -1.24],
										[-0.23, -0.82],
										[-0.36, -1.4],
										[-0.17, -0.68],
										[-0.49, -2.1],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[3.21, -0.85],
										[1.02, -0.26],
										[1.48, -0.36],
										[0.75, -0.17],
										[1.15, -0.26],
										[1.65, -0.37],
										[0.5, -0.1],
										[1.09, -0.23],
										[2.47, -0.5],
										[0.73, -0.14],
										[3.27, -0.62],
										[0.34, -0.06],
										[2.89, -0.49],
										[0.86, -0.13],
										[0.92, -0.14],
										[1.11, -0.17],
										[0.4, -0.06],
										[0.89, -0.13],
										[0.92, -0.13],
										[1.61, -0.22],
										[0.66, -0.09],
										[6.63, -0.82],
										[0.04, 0],
										[0.49, -0.04],
										[1.08, -0.1],
										[1.61, -0.14],
										[0.42, -0.03],
										[2.91, -0.23],
										[0.36, -0.03],
										[6.11, -0.42],
										[1.06, -0.04],
										[0.96, -0.04],
										[2.3, -0.09],
										[2.57, -0.07],
										[0, 0],
										[0, 0],
										[0, 0],
										[4.24, 4.01],
										[0.13, 0.14],
										[1.08, 1.14],
										[0.36, 0.39],
										[0.98, 1.08],
										[0.43, 0.49],
										[0.92, 1.05],
										[0.45, 0.53],
										[0.89, 1.05],
										[0.45, 0.55],
										[0.86, 1.07],
										[0.43, 0.55],
										[0.85, 1.09],
										[0.4, 0.52],
										[0.86, 1.15],
										[0.27, 0.37],
										[2.98, 4.14],
										[0.3, 0.46],
										[0.72, 1.11],
										[0.43, 0.68],
										[0.65, 1.05],
										[0.46, 0.76],
										[0.6, 1.02],
										[0.46, 0.81],
										[0.58, 1.01],
										[0.46, 0.85],
										[0.55, 1.01],
										[0.46, 0.88],
										[0.5, 0.98],
										[0.47, 0.94],
										[0.47, 0.96],
										[0.49, 1.01],
										[0.42, 0.91],
										[0.72, 1.58],
										[0.43, 0.98],
										[0.55, 1.27],
										[0.35, 0.85],
										[0.46, 1.14],
										[0.35, 0.88],
										[0.43, 1.12],
										[0.33, 0.89],
										[0.4, 1.12],
										[0.32, 0.89],
										[0.39, 1.14],
										[0.29, 0.89],
										[0.37, 1.18],
										[0.26, 0.86],
										[0.36, 1.24],
										[0.23, 0.82],
										[0.37, 1.4],
										[0.17, 0.68],
										[0.52, 2.09],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[73.56, 488.29],
										[73.56, 333.21],
										[73.59, 333.21],
										[83.2, 330.75],
										[86.26, 330.02],
										[90.69, 328.94],
										[92.92, 328.44],
										[96.39, 327.66],
										[101.37, 326.57],
										[102.86, 326.25],
										[106.14, 325.56],
										[113.55, 324.08],
										[115.77, 323.65],
										[125.56, 321.86],
										[126.61, 321.69],
										[135.26, 320.26],
										[137.83, 319.86],
										[140.58, 319.44],
										[143.9, 318.96],
										[145.1, 318.78],
										[147.76, 318.41],
										[150.53, 318.02],
										[155.38, 317.4],
										[157.38, 317.14],
										[177.17, 314.97],
										[177.29, 314.97],
										[178.74, 314.84],
										[181.99, 314.54],
										[186.84, 314.12],
										[188.09, 314.02],
										[196.76, 313.37],
										[197.84, 313.3],
										[216.04, 312.29],
										[219.22, 312.16],
										[222.11, 312.06],
										[228.99, 311.85],
										[236.68, 311.68],
										[266.5, 279.39],
										[0, 0],
										[0, 74.76],
										[12.38, 87.13],
										[12.79, 87.55],
										[16, 91],
										[17.06, 92.17],
										[19.97, 95.42],
										[21.25, 96.88],
										[23.99, 100.06],
										[25.33, 101.64],
										[27.96, 104.82],
										[29.3, 106.47],
										[31.88, 109.7],
										[33.17, 111.36],
										[35.7, 114.66],
										[36.88, 116.24],
										[39.46, 119.71],
										[40.28, 120.85],
										[48.94, 133.46],
										[49.84, 134.86],
										[51.96, 138.2],
										[53.24, 140.24],
										[55.15, 143.39],
										[56.52, 145.68],
										[58.31, 148.76],
										[59.71, 151.19],
										[61.41, 154.23],
										[62.79, 156.76],
										[64.4, 159.76],
										[65.78, 162.43],
										[67.29, 165.38],
										[68.69, 168.18],
										[70.1, 171.06],
										[71.52, 174.1],
										[72.78, 176.82],
										[74.91, 181.58],
										[76.18, 184.51],
										[77.79, 188.33],
										[78.81, 190.86],
										[80.18, 194.27],
										[81.19, 196.9],
										[82.45, 200.27],
										[83.41, 202.96],
										[84.61, 206.33],
										[85.53, 209.02],
										[86.67, 212.46],
										[87.51, 215.12],
										[88.61, 218.66],
										[89.38, 221.26],
										[90.45, 224.99],
										[91.14, 227.43],
										[92.23, 231.61],
										[92.76, 233.63],
										[94.28, 239.89],
										[97.01, 251.76],
										[0.04, 251.76],
										[0.04, 567.87],
										[73.55, 488.29],
										[73.56, 488.29]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 555,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 79.92] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [969.77, 326.85] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 159.84],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 556,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [113.77, 70.34] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [612.86, 227.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.04, 0.06],
										[-4.42, 5.64],
										[-0.22, 0.29],
										[-2.09, 2.49],
										[-0.45, 0.52],
										[-2.11, 2.34],
										[-0.42, 0.45],
										[-2.04, 2.1],
										[-0.35, 0.35],
										[-2.27, 2.19],
										[-0.52, 0.5],
										[-2.34, 2.1],
										[-0.45, 0.39],
										[-2.56, 2.11],
										[-5.22, 3.81],
										[-1.77, 1.22],
										[-3.62, 2.3],
										[-20.08, 7.42],
										[-0.01, 0.01],
										[-2.53, 0.85],
										[-0.7, 0.23],
										[-2.04, 0.63],
										[-0.59, 0.17],
										[-2.69, 0.73],
										[-0.03, 0.01],
										[-2.66, 0.65],
										[-0.55, 0.13],
										[-2.4, 0.5],
										[-0.33, 0.07],
										[-2.79, 0.49],
										[-0.27, 0.04],
										[-2.42, 0.35],
										[-0.66, 0.1],
										[-2.34, 0.27],
										[-0.3, 0.03],
										[-1.19, 0.12],
										[0.04, 1.22],
										[24.02, -8.88],
										[27.06, -22.42],
										[17.64, -26.82],
										[-1.25, -0.27],
										[-0.72, 1.06],
										[0, 0]
									],
									"o": [
										[0, 0],
										[4.04, -5.91],
										[0.22, -0.29],
										[2.01, -2.56],
										[0.43, -0.52],
										[2.04, -2.4],
										[0.42, -0.46],
										[1.97, -2.16],
										[0.33, -0.35],
										[2.2, -2.26],
										[0.52, -0.5],
										[2.27, -2.16],
										[0.45, -0.4],
										[2.49, -2.2],
										[5.02, -4.16],
										[1.74, -1.27],
										[3.52, -2.46],
										[18.1, -11.51],
										[0.03, 0],
										[2.52, -0.94],
										[0.7, -0.24],
										[2.03, -0.68],
										[0.59, -0.19],
										[2.66, -0.81],
										[0.03, 0],
										[2.63, -0.7],
										[0.53, -0.13],
										[2.37, -0.56],
										[0.33, -0.07],
										[2.78, -0.58],
										[0.27, -0.04],
										[2.42, -0.42],
										[0.66, -0.1],
										[2.33, -0.33],
										[0.3, -0.03],
										[1.18, -0.13],
										[-0.01, -1.21],
										[-25.45, 2.56],
										[-32.51, 12.01],
										[-24.32, 20.13],
										[1.24, 0.29],
										[0.7, -1.06],
										[0, 0],
										[0, 0]
									],
									"v": [
										[5.88, 137.49],
										[6, 137.33],
										[18.69, 120],
										[19.35, 119.15],
										[25.52, 111.58],
										[26.84, 110.03],
										[33.08, 102.9],
										[34.34, 101.55],
										[40.35, 95.16],
										[41.36, 94.11],
										[48.07, 87.45],
										[49.64, 85.94],
										[56.56, 79.55],
										[57.91, 78.36],
										[65.46, 71.88],
										[80.83, 59.94],
										[86.09, 56.2],
										[96.82, 49.06],
										[154.19, 20.62],
										[154.26, 20.59],
										[161.82, 17.93],
										[163.94, 17.22],
										[170.05, 15.27],
										[171.82, 14.72],
										[179.85, 12.42],
										[179.92, 12.4],
										[187.85, 10.39],
										[189.47, 10],
										[196.63, 8.4],
										[197.64, 8.19],
										[205.98, 6.59],
										[206.8, 6.46],
										[214.05, 5.31],
										[216.04, 5.02],
										[223.04, 4.11],
										[223.97, 4],
										[227.53, 3.63],
										[227.47, 0],
										[152.95, 17.22],
										[63.19, 69.11],
										[0, 139.85],
										[3.77, 140.67],
										[5.91, 137.48],
										[5.88, 137.49]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 557,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.12, 3.56] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [529.04, 263.19] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 558,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.36, 3.33] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [543.78, 247.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 559,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.46, 3.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [552.17, 239.49] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.34, 2.1],
										[2.27, -2.17]
									],
									"o": [
										[2.27, -2.16],
										[-2.34, 2.09],
										[0, 0]
									],
									"v": [
										[0, 6.39],
										[6.92, 0],
										[0, 6.39]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 560,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.01, 3.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [536.41, 255.09] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.04, 2.1],
										[1.99, -2.16]
									],
									"o": [
										[1.97, -2.16],
										[-2.03, 2.1],
										[0, 0]
									],
									"v": [
										[0, 6.39],
										[6.01, 0],
										[0, 6.39]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 561,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.78, 1.33] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [657.11, 175.99] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.53, 0.85],
										[2.52, -0.92]
									],
									"o": [
										[2.5, -0.92],
										[-2.53, 0.86],
										[0, 0]
									],
									"v": [
										[0, 2.66],
										[7.57, 0],
										[0, 2.66]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 562,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [11.46, 9.21] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [568.45, 225.89] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[5.01, -4.16],
										[2.49, -2.19],
										[-2.56, 2.12],
										[-5.22, 3.81]
									],
									"o": [
										[-5.22, 3.8],
										[-2.56, 2.12],
										[2.49, -2.2],
										[5.02, -4.16],
										[0, 0]
									],
									"v": [
										[22.91, 0],
										[7.55, 11.94],
										[0, 18.42],
										[7.55, 11.94],
										[22.91, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 563,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [111.91, 71.38] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [614.73, 231.76] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[-24.81, 10.88],
										[-10.8, 10.5],
										[0, 40.6],
										[0.01, 0.88],
										[1.19, -0.13],
										[0, -0.75],
										[23.76, -23.06],
										[15.19, -6.66],
										[31.42, -0.73],
										[0, 0],
										[0, 0],
										[16.63, 3.45],
										[0.7, -1.06],
										[-19.84, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[33.4, -0.37],
										[15.58, -6.83],
										[24.48, -23.77],
										[0, -0.86],
										[-1.19, 0.12],
										[0, 0.78],
										[0, 39.6],
										[-10.5, 10.2],
										[-23.46, 10.29],
										[0, 0],
										[0, 0],
										[-19.06, 0],
										[-0.72, 1.06],
										[17.28, 3.7],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[59.45, 142.63],
										[59.45, 142.76],
										[147.15, 125.81],
										[186.93, 99.67],
										[223.82, 2.66],
										[223.78, 0],
										[220.21, 0.37],
										[220.23, 2.66],
										[184.41, 97.09],
										[145.7, 122.52],
										[63.03, 139.1],
										[63.03, 139.05],
										[55.84, 139.05],
										[2.14, 133.85],
										[0, 137.05],
										[55.84, 142.64],
										[59.44, 142.64],
										[59.45, 142.63]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 564,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.09, 3.78] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [521.51, 272.09] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.09, 2.49],
										[2.01, -2.56]
									],
									"o": [
										[2.01, -2.56],
										[-2.1, 2.49],
										[0, 0]
									],
									"v": [
										[0, 7.57],
										[6.17, 0],
										[0, 7.57]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 565,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.5, 0.45] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [718.61, 161.31] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 566,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.62, 0.58] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [709.5, 162.63] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.42, 0.35],
										[2.4, -0.4]
									],
									"o": [
										[2.42, -0.42],
										[-2.42, 0.36],
										[0, 0]
									],
									"v": [
										[0, 1.15],
										[7.25, 0],
										[0, 1.15]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 567,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [6.34, 8.67] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [511.42, 285.4] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-4.4, 5.63],
										[4.04, -5.93]
									],
									"o": [
										[4.04, -5.94],
										[-4.42, 5.63],
										[0, 0]
									],
									"v": [
										[0, 17.34],
										[12.69, 0],
										[0, 17.34]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 568,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.96, 1.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [682.96, 168.13] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.66, 0.65],
										[2.63, -0.72]
									],
									"o": [
										[2.63, -0.71],
										[-2.65, 0.63],
										[0, 0]
									],
									"v": [
										[0, 2.01],
										[7.93, 0],
										[0, 2.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 569,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.01, 1.15] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [674.91, 170.3] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.69, 0.73],
										[2.66, -0.81]
									],
									"o": [
										[2.66, -0.81],
										[-2.69, 0.72],
										[0, 0]
									],
									"v": [
										[0, 2.3],
										[8.03, 0],
										[0, 2.3]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 570,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.06, 0.98] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [666.08, 172.97] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 571,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.17, 0.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [700.88, 164.13] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.79, 0.5],
										[2.78, -0.58]
									],
									"o": [
										[2.78, -0.58],
										[-2.79, 0.49],
										[0, 0]
									],
									"v": [
										[0, 1.6],
										[8.34, 0],
										[0, 1.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 572,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.58, 0.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [692.12, 165.95] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.4, 0.5],
										[2.39, -0.56]
									],
									"o": [
										[2.37, -0.56],
										[-2.39, 0.5],
										[0, 0]
									],
									"v": [
										[0, 1.6],
										[7.16, 0],
										[0, 1.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 573,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [118.43, 73.92] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [611.74, 226.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.24, 0.3],
										[-24.32, 20.13],
										[-32.49, 12.03],
										[-25.46, 2.56],
										[-0.01, -1.21],
										[-1.19, 0.12],
										[0.03, 0.65],
										[0.01, 0.19],
										[0.07, 1.54],
										[0, 0.01],
										[0.29, -0.03],
										[1.74, -0.19],
										[0.7, -0.07],
										[1.38, -0.17],
										[0.66, -0.09],
										[1.96, -0.3],
										[0.25, -0.04],
										[1.77, -0.32],
										[0.66, -0.12],
										[1.39, -0.27],
										[0.65, -0.13],
										[1.96, -0.45],
										[0.13, -0.04],
										[1.83, -0.46],
										[0.63, -0.16],
										[1.42, -0.37],
										[0.6, -0.17],
										[1.93, -0.58],
										[0.06, -0.01],
										[1.9, -0.6],
										[0.59, -0.19],
										[1.42, -0.49],
										[0.57, -0.2],
										[1.91, -0.71],
										[27.37, -22.68],
										[0.06, -0.04],
										[1.58, -1.37],
										[0.6, -0.53],
										[0.99, -0.91],
										[0.73, -0.66],
										[0.85, -0.79],
										[0.79, -0.76],
										[0.75, -0.73],
										[0.83, -0.83],
										[0.69, -0.69],
										[0.86, -0.89],
										[0.62, -0.65],
										[0.88, -0.96],
										[0.56, -0.6],
										[0.91, -1.02],
										[0.5, -0.57],
										[0.92, -1.09],
										[0.45, -0.53],
										[0.95, -1.17],
										[0.39, -0.47],
										[0.96, -1.22],
										[0.33, -0.43],
										[0.98, -1.3],
										[0.29, -0.37],
										[0.99, -1.37],
										[0.23, -0.3],
										[1.02, -1.47],
										[0.16, -0.24],
										[1.04, -1.55],
										[0.09, -0.13],
										[1.06, -1.68],
										[-2.5, -0.56],
										[-0.72, 1.06],
										[0, 0]
									],
									"o": [
										[-1.25, -0.27],
										[17.64, -26.83],
										[27.06, -22.4],
										[24.02, -8.88],
										[0.04, 1.22],
										[1.19, -0.12],
										[0, -0.63],
										[0, -0.19],
										[-0.04, -1.57],
										[0, 0],
										[-0.29, 0.03],
										[-1.74, 0.16],
										[-0.69, 0.07],
										[-1.4, 0.16],
										[-0.66, 0.09],
										[-1.96, 0.26],
										[-0.24, 0.04],
										[-1.77, 0.27],
										[-0.66, 0.12],
										[-1.41, 0.26],
										[-0.65, 0.13],
										[-1.96, 0.4],
										[-0.13, 0.03],
										[-1.84, 0.42],
										[-0.62, 0.16],
										[-1.42, 0.36],
										[-0.6, 0.16],
										[-1.94, 0.53],
										[-0.06, 0.01],
										[-1.9, 0.56],
										[-0.59, 0.19],
										[-1.42, 0.46],
										[-0.58, 0.2],
										[-1.93, 0.66],
										[-32.88, 12.16],
										[-0.06, 0.04],
										[-1.61, 1.34],
										[-0.6, 0.53],
										[-1.02, 0.89],
										[-0.73, 0.66],
										[-0.85, 0.78],
										[-0.81, 0.75],
										[-0.76, 0.73],
										[-0.83, 0.82],
										[-0.69, 0.69],
										[-0.88, 0.89],
										[-0.62, 0.65],
										[-0.89, 0.95],
										[-0.56, 0.6],
										[-0.92, 1.01],
										[-0.5, 0.58],
										[-0.94, 1.08],
										[-0.45, 0.53],
										[-0.96, 1.15],
										[-0.39, 0.47],
										[-0.98, 1.21],
										[-0.35, 0.43],
										[-0.99, 1.28],
										[-0.29, 0.37],
										[-1.01, 1.37],
										[-0.23, 0.32],
										[-1.04, 1.44],
										[-0.17, 0.24],
										[-1.06, 1.54],
										[-0.09, 0.14],
										[-1.09, 1.65],
										[2.45, 0.63],
										[0.7, -1.08],
										[0, 0],
										[0, 0]
									],
									"v": [
										[9.51, 144.62],
										[5.74, 143.79],
										[68.93, 73.05],
										[158.69, 21.16],
										[233.21, 3.94],
										[233.27, 7.57],
										[236.87, 7.21],
										[236.84, 5.28],
										[236.82, 4.7],
										[236.64, 0.03],
										[236.64, 0],
										[235.79, 0.09],
										[230.58, 0.6],
										[228.5, 0.83],
										[224.32, 1.34],
										[222.33, 1.6],
										[216.47, 2.45],
										[215.75, 2.56],
										[210.44, 3.45],
										[208.46, 3.81],
										[204.26, 4.6],
										[202.33, 4.98],
										[196.46, 6.23],
										[196.06, 6.33],
										[190.55, 7.64],
										[188.68, 8.11],
										[184.42, 9.22],
										[182.61, 9.71],
										[176.78, 11.37],
										[176.63, 11.41],
										[170.94, 13.17],
										[169.19, 13.73],
										[164.92, 15.15],
										[163.19, 15.74],
										[157.44, 17.8],
										[66.63, 70.29],
										[66.46, 70.43],
										[61.68, 74.47],
										[59.87, 76.07],
										[56.83, 78.76],
										[54.63, 80.77],
										[52.07, 83.12],
										[49.68, 85.39],
										[47.41, 87.58],
										[44.91, 90.07],
										[42.85, 92.13],
										[40.25, 94.8],
										[38.39, 96.75],
										[35.73, 99.61],
										[34.05, 101.44],
										[31.31, 104.49],
										[29.8, 106.2],
										[27.01, 109.45],
										[25.68, 111.03],
										[22.81, 114.49],
										[21.65, 115.93],
										[18.74, 119.58],
										[17.74, 120.87],
										[14.77, 124.75],
										[13.92, 125.88],
										[10.92, 129.98],
										[10.24, 130.92],
										[7.16, 135.28],
										[6.67, 136],
										[3.52, 140.64],
										[3.25, 141.06],
										[0, 146.07],
										[7.41, 147.84],
										[9.54, 144.6],
										[9.51, 144.62]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 574,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.14, 1.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [541.85, 239.3] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 575,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.84, 0.91] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [528.19, 253.32] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.56, 0.6],
										[0.56, -0.6]
									],
									"o": [
										[0.56, -0.62],
										[-0.56, 0.6],
										[0, 0]
									],
									"v": [
										[0, 1.83],
										[1.68, 0],
										[0, 1.83]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 576,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.03, 1.03] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [537.19, 243.9] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.69, 0.69],
										[0.69, -0.69]
									],
									"o": [
										[0.68, -0.69],
										[-0.69, 0.69],
										[0, 0]
									],
									"v": [
										[0, 2.06],
										[2.06, 0],
										[0, 2.06]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 577,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.93, 0.97] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [532.63, 248.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 578,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.76, 0.86] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [523.86, 258.16] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 579,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.5, 0.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [511.52, 273.04] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.33, 0.43],
										[0.33, -0.43]
									],
									"o": [
										[0.33, -0.43],
										[-0.35, 0.43],
										[0, 0]
									],
									"v": [
										[0, 1.29],
										[1.01, 0],
										[0, 1.29]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 580,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.42, 0.57] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [507.64, 278.13] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 581,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.34, 0.47] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [503.86, 283.27] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.23, 0.3],
										[0.23, -0.3]
									],
									"o": [
										[0.23, -0.32],
										[-0.23, 0.32],
										[0, 0]
									],
									"v": [
										[0, 0.94],
										[0.68, 0],
										[0, 0.94]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 582,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.67, 0.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [519.64, 263.04] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.45, 0.52],
										[0.45, -0.53]
									],
									"o": [
										[0.45, -0.53],
										[-0.45, 0.53],
										[0, 0]
									],
									"v": [
										[0, 1.58],
										[1.34, 0],
										[0, 1.58]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 583,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.58, 0.72] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [515.53, 268.01] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 584,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.88, 1.03] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [653.64, 169.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.93, 0.68],
										[1.91, -0.71]
									],
									"o": [
										[1.91, -0.71],
										[-1.93, 0.66],
										[0, 0]
									],
									"v": [
										[0, 2.06],
										[5.75, 0],
										[0, 2.06]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 585,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.93, 0.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [692.72, 158.43] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.96, 0.4],
										[1.96, -0.45]
									],
									"o": [
										[1.96, -0.43],
										[-1.96, 0.4],
										[0, 0]
									],
									"v": [
										[0, 1.25],
										[5.87, 0],
										[0, 1.25]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 586,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.75, 0.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [686.62, 159.8] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.84, 0.42],
										[1.83, -0.46]
									],
									"o": [
										[1.84, -0.45],
										[-1.84, 0.42],
										[0, 0]
									],
									"v": [
										[0, 1.31],
										[5.51, 0],
										[0, 1.31]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 587,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.39, 2.02] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [557.38, 225.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.6, 1.34],
										[1.58, -1.37]
									],
									"o": [
										[1.58, -1.37],
										[-1.61, 1.34],
										[0, 0]
									],
									"v": [
										[0, 4.04],
										[4.78, 0],
										[0, 4.04]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 588,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.14, 0.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [660.38, 167.24] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 589,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.13, 0.55] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [679.88, 161.47] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.42, 0.36],
										[1.42, -0.37]
									],
									"o": [
										[1.41, -0.37],
										[-1.42, 0.36],
										[0, 0]
									],
									"v": [
										[0, 1.11],
										[4.26, 0],
										[0, 1.11]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 590,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.6, 0.26] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [726.5, 153.16] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.74, 0.16],
										[1.74, -0.19]
									],
									"o": [
										[1.73, -0.19],
										[-1.74, 0.16],
										[0, 0]
									],
									"v": [
										[0, 0.52],
										[5.21, 0],
										[0, 0.52]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 591,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.84, 0.88] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [667.11, 165.09] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.9, 0.58],
										[1.9, -0.6]
									],
									"o": [
										[1.88, -0.6],
										[-1.9, 0.56],
										[0, 0]
									],
									"v": [
										[0, 1.76],
										[5.68, 0],
										[0, 1.76]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 592,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.09, 0.25] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [719.74, 153.9] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.4, 0.16],
										[1.38, -0.17]
									],
									"o": [
										[1.4, -0.17],
										[-1.4, 0.16],
										[0, 0]
									],
									"v": [
										[0, 0.5],
										[4.17, 0],
										[0, 0.5]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 593,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.28, 1.17] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [546.65, 234.76] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.86, 0.78],
										[0.85, -0.79]
									],
									"o": [
										[0.85, -0.79],
										[-0.85, 0.78],
										[0, 0]
									],
									"v": [
										[0, 2.35],
										[2.56, 0],
										[0, 2.35]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 594,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.1, 0.4] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [699.67, 157.02] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.4, 0.24],
										[1.4, -0.27]
									],
									"o": [
										[1.4, -0.27],
										[-1.41, 0.26],
										[0, 0]
									],
									"v": [
										[0, 0.79],
										[4.2, 0],
										[0, 0.79]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 595,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.52, 1.35] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [551.65, 230.22] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.01, 0.89],
										[0.99, -0.91]
									],
									"o": [
										[1.01, -0.91],
										[-1.02, 0.89],
										[0, 0]
									],
									"v": [
										[0, 2.69],
										[3.04, 0],
										[0, 2.69]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 596,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.93, 0.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [712.71, 154.84] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.96, 0.27],
										[1.96, -0.3]
									],
									"o": [
										[1.94, -0.3],
										[-1.96, 0.26],
										[0, 0]
									],
									"v": [
										[0, 0.85],
										[5.85, 0],
										[0, 0.85]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 597,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.91, 0.83] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [673.01, 163.34] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.94, 0.53],
										[1.93, -0.58]
									],
									"o": [
										[1.94, -0.58],
										[-1.94, 0.53],
										[0, 0]
									],
									"v": [
										[0, 1.65],
										[5.83, 0],
										[0, 1.65]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 598,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.65, 0.45] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [706.41, 155.82] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.77, 0.29],
										[1.77, -0.32]
									],
									"o": [
										[1.77, -0.32],
										[-1.77, 0.27],
										[0, 0]
									],
									"v": [
										[0, 0.89],
										[5.31, 0],
										[0, 0.89]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 599,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.14, 0.21] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [496.68, 293.68] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.09, 0.13],
										[0.09, -0.13]
									],
									"o": [
										[0.09, -0.14],
										[-0.09, 0.14],
										[0, 0]
									],
									"v": [
										[0, 0.42],
										[0.27, 0],
										[0, 0.42]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 600,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 0.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [493.3, 298.89] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 0.01],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 601,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.24, 0.36] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [500.2, 288.45] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.16, 0.23],
										[0.16, -0.24]
									],
									"o": [
										[0.16, -0.24],
										[-0.17, 0.24],
										[0, 0]
									],
									"v": [
										[0, 0.72],
										[0.49, 0],
										[0, 0.72]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 602,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [114.77, 73.37] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [615.48, 233.35] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, -0.86],
										[24.48, -23.77],
										[15.59, -6.83],
										[33.4, -0.37],
										[0, 0],
										[0, 0],
										[17.26, 3.7],
										[0.7, -1.08],
										[-5.37, -0.81],
										[-0.22, -0.03],
										[-2.45, -0.3],
										[-0.22, -0.03],
										[-5.31, -0.32],
										[-0.66, -0.03],
										[-2, -0.06],
										[-0.73, -0.03],
										[-2.63, 0],
										[0, 0],
										[-10.17, 1.12],
										[-18.21, 7.99],
										[-11.49, 11.18],
										[-0.73, 0.73],
										[-1.38, 1.55],
										[0, 39.47],
										[0, 0.03],
										[0.01, 0.98],
										[1.19, -0.13],
										[0, 0]
									],
									"o": [
										[0, 0.89],
										[0, 40.6],
										[-10.8, 10.5],
										[-24.81, 10.88],
										[0, 0],
										[0, 0],
										[-19.85, 0],
										[-0.72, 1.08],
										[5.14, 1.14],
										[0.22, 0.03],
										[2.42, 0.36],
										[0.22, 0.03],
										[5.15, 0.6],
										[0.65, 0.04],
										[1.97, 0.1],
										[0.72, 0.03],
										[2.6, 0.07],
										[0, 0],
										[10.82, 0],
										[22.37, -2.45],
										[15.55, -6.82],
										[0.75, -0.72],
										[1.45, -1.5],
										[19.98, -22.69],
										[0, -0.03],
										[0, -0.99],
										[-1.21, 0.1],
										[0, 0],
										[0, 0]
									],
									"v": [
										[225.89, 0.39],
										[225.94, 3.05],
										[189.04, 100.06],
										[149.27, 126.2],
										[61.57, 143.15],
										[61.57, 143.02],
										[57.97, 143.02],
										[2.13, 137.42],
										[0, 140.66],
										[15.75, 143.56],
										[16.38, 143.65],
										[23.69, 144.63],
										[24.35, 144.72],
										[40.03, 146.08],
										[42, 146.18],
										[47.96, 146.43],
										[50.13, 146.5],
										[57.97, 146.6],
										[57.97, 146.74],
										[89.49, 145.07],
										[150.72, 129.46],
										[191.56, 102.6],
										[193.77, 100.4],
										[198.03, 95.82],
										[229.55, 3.02],
										[229.55, 2.94],
										[229.5, 0],
										[225.91, 0.36],
										[225.89, 0.39]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 603,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 0.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [729.95, 152.83] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, -0.01],
										[0, 0.01]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 0.03],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 604,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.01, 0.29] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [730.16, 157.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.01, -0.19],
										[0.01, 0.19]
									],
									"o": [
										[0, 0.19],
										[0, -0.19],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.01, 0.58],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 605,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [71.92, 71.94] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [71.92, 71.94] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 606,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [51.04, 21.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [641.21, 283.86] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-18.21, 7.99],
										[-11.49, 11.18],
										[15.55, -6.83],
										[22.37, -2.46]
									],
									"o": [
										[22.37, -2.45],
										[15.55, -6.82],
										[-11.49, 11.18],
										[-18.21, 7.99],
										[0, 0]
									],
									"v": [
										[0, 42.47],
										[61.23, 26.86],
										[102.07, 0],
										[61.23, 26.86],
										[0, 42.47]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 607,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.13, 2.29] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [696.58, 258.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.47, -1.48],
										[-1.38, 1.55]
									],
									"o": [
										[-1.38, 1.57],
										[1.45, -1.5],
										[0, 0]
									],
									"v": [
										[4.26, 0],
										[0, 4.58],
										[4.26, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 608,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.76, 46.44] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [714.46, 209.4] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 39.47],
										[19.97, -22.69]
									],
									"o": [
										[19.98, -22.69],
										[0, 39.47],
										[0, 0]
									],
									"v": [
										[0, 92.89],
										[31.52, 0.09],
										[0, 92.89]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 609,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.09, 0.04] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [549.73, 306.47] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.72, 0.03],
										[-0.73, -0.03]
									],
									"o": [
										[-0.72, -0.01],
										[0.72, 0.03],
										[0, 0]
									],
									"v": [
										[2.17, 0.07],
										[0, 0],
										[2.17, 0.07]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 610,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.99, 0.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [541.72, 306.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.66, 0.03],
										[-0.66, -0.03]
									],
									"o": [
										[-0.66, -0.03],
										[0.65, 0.04],
										[0, 0]
									],
									"v": [
										[1.97, 0.1],
										[0, 0],
										[1.97, 0.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 611,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.32, 0.04] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [516.76, 303.62] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 612,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.33, 0.04] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [524.73, 304.68] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 613,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [154.43, 54.98] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [936.15, 54.98] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.32, 59.9],
										[0, 0],
										[0, 0],
										[-115.18, -54.21],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[308.27, 109.97],
										[308.86, 0],
										[0, 0],
										[0, 109.97],
										[308.26, 109.97],
										[308.27, 109.97]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 614,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 0.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [200.72, 370.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 615,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 0.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [204.31, 370.23] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.18, -0.04],
										[1.21, 0.03]
									],
									"o": [
										[1.19, 0.04],
										[-1.19, -0.04],
										[0, 0]
									],
									"v": [
										[0, 0],
										[3.6, 0.1],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 616,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.16, 0.42] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [129.95, 372.75] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 617,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.88, 0.06] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [176.02, 370.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 618,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.59, 0.12] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [167.07, 370.29] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[2.42, -0.09],
										[-2.39, 0.06]
									],
									"o": [
										[-2.37, 0.06],
										[2.4, -0.09],
										[0, 0]
									],
									"v": [
										[7.18, 0],
										[0, 0.23],
										[7.18, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 619,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.17, 0.58] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [111.28, 375] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 620,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.23, 0.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [73.43, 381.92] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.82, 0.6],
										[2.82, -0.66]
									],
									"o": [
										[2.82, -0.68],
										[-2.82, 0.62],
										[0, 0]
									],
									"v": [
										[0, 1.93],
										[8.46, 0],
										[0, 1.93]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 621,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.79, 0.04] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [193.22, 370.02] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.52, -0.04],
										[2.55, 0.01]
									],
									"o": [
										[2.55, 0],
										[-2.5, -0.04],
										[0, 0]
									],
									"v": [
										[0, 0],
										[7.58, 0.09],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 622,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.3, 1.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [63, 384.43] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 623,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.19, 0.76] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [92.41, 378.03] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.79, 0.47],
										[2.8, -0.53]
									],
									"o": [
										[2.79, -0.53],
										[-2.79, 0.47],
										[0, 0]
									],
									"v": [
										[0, 1.53],
										[8.39, 0],
										[0, 1.53]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 624,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4.13, 0.34] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [140.1, 371.82] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.75, 0.2],
										[2.76, -0.24]
									],
									"o": [
										[2.76, -0.24],
										[-2.73, 0.2],
										[0, 0]
									],
									"v": [
										[0, 0.68],
										[8.26, 0],
										[0, 0.68]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 625,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.87, 0.79] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [82.6, 379.93] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 626,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.95, 0.47] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [121.21, 373.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.62, 0.3],
										[2.63, -0.35]
									],
									"o": [
										[2.65, -0.33],
										[-2.62, 0.29],
										[0, 0]
									],
									"v": [
										[0, 0.95],
										[7.9, 0],
										[0, 0.95]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 627,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.52, 0.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [184.96, 369.98] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[2.36, -0.01],
										[-2.33, -0.01]
									],
									"o": [
										[-2.33, 0],
										[2.36, -0.01],
										[0, 0]
									],
									"v": [
										[7.05, 0.01],
										[0, 0.02],
										[7.05, 0.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 628,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [4, 0.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [158.29, 370.64] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 629,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.15, 0] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [198.77, 370.11] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 630,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.93, 0.26] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [148.62, 371.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.6, 0.16],
										[2.63, -0.2]
									],
									"o": [
										[2.63, -0.19],
										[-2.6, 0.16],
										[0, 0]
									],
									"v": [
										[0, 0.52],
										[7.85, 0],
										[0, 0.52]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 631,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.77, 0.6] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [101.96, 376.41] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.5, 0.39],
										[2.52, -0.43]
									],
									"o": [
										[2.52, -0.42],
										[-2.5, 0.37],
										[0, 0]
									],
									"v": [
										[0, 1.21],
										[7.54, 0],
										[0, 1.21]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 632,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 0.02] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [325.63, 385.51] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 633,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [133.47, 141.12] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [192.17, 511.42] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-99.2, -46.69],
										[-0.04, 4.17],
										[69.09, 2.22],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.03, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[147.41, 81.09],
										[0, 81.09],
										[0, 282.24],
										[265.48, 282.24],
										[266.93, 15.24],
										[147.41, 0],
										[147.41, 81.11],
										[147.41, 81.09]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 634,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0, 0.02] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [395.24, 699.73] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 635,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [133.47, 46.29] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [261.77, 730.48] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[131.26, -35.01],
										[0, 0],
										[0, 0],
										[-0.01, 1.45]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0.23, -42.44],
										[0, 0]
									],
									"v": [
										[266.93, 15.56],
										[0, 15.56],
										[0, 92.58],
										[266.5, 92.58],
										[266.93, 15.56]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 636,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [133.25, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [261.54, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0.06],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 0.17],
										[266.5, 0.17],
										[266.5, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 637,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.33, 1.43] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [530.36, 250.98] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.89, 0.95],
										[0.88, -0.96]
									],
									"o": [
										[0.89, -0.96],
										[-0.89, 0.95],
										[0, 0]
									],
									"v": [
										[0, 2.86],
										[2.66, 0],
										[0, 2.86]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 638,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1, 0.13] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [716.64, 154.28] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 639,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.36, 0.06] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [709.42, 155.32] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.24, 0.03],
										[0.24, -0.04]
									],
									"o": [
										[0.24, -0.04],
										[-0.24, 0.04],
										[0, 0]
									],
									"v": [
										[0, 0.12],
										[0.72, 0],
										[0, 0.12]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 640,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.1, 1.01] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [549.03, 232.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.73, 0.66],
										[0.73, -0.66]
									],
									"o": [
										[0.73, -0.68],
										[-0.73, 0.66],
										[0, 0]
									],
									"v": [
										[0, 2.01],
										[2.2, 0],
										[0, 2.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 641,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.19, 1.14] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [544.19, 237.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 642,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.25, 1.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [539.46, 241.63] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.85, 0.83],
										[0.83, -0.83]
									],
									"o": [
										[0.83, -0.83],
										[-0.83, 0.82],
										[0, 0]
									],
									"v": [
										[0, 2.49],
										[2.5, 0],
										[0, 2.49]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 643,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.04, 0.12] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [722.87, 153.54] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.7, 0.07],
										[0.7, -0.07]
									],
									"o": [
										[0.69, -0.09],
										[-0.69, 0.07],
										[0, 0]
									],
									"v": [
										[0, 0.23],
										[2.09, 0],
										[0, 0.23]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 644,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.3, 1.34] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [534.86, 246.27] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.88, 0.88],
										[0.86, -0.89]
									],
									"o": [
										[0.86, -0.89],
										[-0.88, 0.89],
										[0, 0]
									],
									"v": [
										[0, 2.68],
										[2.6, 0],
										[0, 2.68]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 645,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.09, 2.34] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [730.04, 155.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.04, -1.57],
										[0.07, 1.54]
									],
									"o": [
										[0.09, 1.55],
										[-0.04, -1.57],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0.19, 4.68],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 646,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.5, 2.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [505.7, 280.75] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.01, 1.35],
										[0.99, -1.37]
									],
									"o": [
										[0.99, -1.38],
										[-1.02, 1.37],
										[0, 0]
									],
									"v": [
										[0, 4.1],
										[3.01, 0],
										[0, 4.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 647,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.48, 1.94] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [509.55, 275.63] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.01, 1.28],
										[0.98, -1.29]
									],
									"o": [
										[0.98, -1.29],
										[-0.99, 1.28],
										[0, 0]
									],
									"v": [
										[0, 3.87],
										[2.96, 0],
										[0, 3.87]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 648,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.54, 2.18] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [502, 285.91] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.04, 1.45],
										[1.02, -1.47]
									],
									"o": [
										[1.01, -1.47],
										[-1.04, 1.44],
										[0, 0]
									],
									"v": [
										[0, 4.36],
										[3.08, 0],
										[0, 4.36]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 649,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.63, 2.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [494.92, 296.38] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 650,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.02, 0.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [730.19, 159.06] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.01, 0.63],
										[-0.01, -0.65],
										[0, 0]
									],
									"o": [
										[0, -0.65],
										[0.01, 0.63],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.04, 1.91],
										[0, 0],
										[0.03, 1.93],
										[0.04, 1.91]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 651,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [45.49, 26.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [605.27, 196.92] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[27.37, -22.68],
										[-32.88, 12.16]
									],
									"o": [
										[-32.88, 12.16],
										[27.37, -22.66],
										[0, 0]
									],
									"v": [
										[90.98, 0],
										[0.17, 52.49],
										[90.98, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 652,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.43, 1.73] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [517.54, 265.56] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.96, 1.15],
										[0.95, -1.17]
									],
									"o": [
										[0.95, -1.15],
										[-0.96, 1.14],
										[0, 0]
									],
									"v": [
										[0, 3.45],
										[2.86, 0],
										[0, 3.45]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 653,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.4, 1.63] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [521.71, 260.63] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 654,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.37, 1.53] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [525.98, 255.78] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 655,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.7, 0.88] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [496.99, 299.78] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.49, -0.55],
										[2.45, 0.63],
										[0, 0]
									],
									"o": [
										[2.45, 0.63],
										[-2.49, -0.55],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.01, 0],
										[7.41, 1.77],
										[0, 0],
										[0.01, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 656,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.45, 1.83] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [513.48, 270.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 657,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.91, 0.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [676.84, 162.27] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.6, 0.16],
										[0.6, -0.17]
									],
									"o": [
										[0.6, -0.16],
										[-0.6, 0.16],
										[0, 0]
									],
									"v": [
										[0, 0.49],
										[1.81, 0],
										[0, 0.49]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 658,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.42, 0.04] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [729.52, 152.86] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 659,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.88, 0.28] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [663.39, 166.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 660,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.93, 0.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [682.93, 160.68] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.63, 0.16],
										[0.63, -0.16]
									],
									"o": [
										[0.62, -0.16],
										[-0.62, 0.16],
										[0, 0]
									],
									"v": [
										[0, 0.47],
										[1.87, 0],
										[0, 0.47]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 661,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.86, 0.29] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [657.38, 168.25] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 662,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.58, 2.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [498.4, 291.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 663,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.08, 0.02] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [670.02, 164.19] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.06, 0.01],
										[0.06, -0.01]
									],
									"o": [
										[0, 0],
										[-0.06, 0.01],
										[0, 0]
									],
									"v": [
										[0, 0.04],
										[0.16, 0],
										[0, 0.04]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 664,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.2, 0.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [689.57, 159.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.13, 0.04],
										[0.13, -0.04]
									],
									"o": [
										[0.13, -0.03],
										[-0.13, 0.03],
										[0, 0]
									],
									"v": [
										[0, 0.1],
										[0.4, 0],
										[0, 0.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 665,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.91, 0.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [554.09, 228.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.6, 0.52],
										[0.6, -0.53]
									],
									"o": [
										[0.6, -0.53],
										[-0.6, 0.53],
										[0, 0]
									],
									"v": [
										[0, 1.6],
										[1.81, 0],
										[0, 1.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 666,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.99, 0.18] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [702.76, 156.45] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 667,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.96, 0.19] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [696.61, 157.62] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.65, 0.12],
										[0.65, -0.13]
									],
									"o": [
										[0.63, -0.13],
										[-0.65, 0.13],
										[0, 0]
									],
									"v": [
										[0, 0.37],
										[1.93, 0],
										[0, 0.37]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 668,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [2.98, 0.12] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [545.67, 306.31] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [],
					"ind": 669,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.88, 1.45] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [508.57, 302.12] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-5.35, -0.81],
										[5.15, 1.12]
									],
									"o": [
										[5.14, 1.14],
										[-5.35, -0.81],
										[0, 0]
									],
									"v": [
										[0, 0],
										[15.75, 2.91],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 670,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [0.02, 1.47] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [730.23, 161.49] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.01, 0.98],
										[0, -0.99],
										[0, 0]
									],
									"o": [
										[0, -0.98],
										[0.01, 0.98],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.03, 2.94],
										[0, 0],
										[0.04, 2.94],
										[0.03, 2.94]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 671,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.65, 0.49] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [520.73, 304.15] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[2.42, 0.36],
										[-2.45, -0.29]
									],
									"o": [
										[-2.46, -0.29],
										[2.42, 0.36],
										[0, 0]
									],
									"v": [
										[7.31, 0.98],
										[0, 0],
										[7.31, 0.98]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 672,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [172.64, 141.02] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [557.29, 157.9] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.09, 0.13],
										[-1.06, 1.54],
										[-0.16, 0.23],
										[-1.04, 1.45],
										[-0.23, 0.3],
										[-1.01, 1.35],
										[-0.29, 0.37],
										[-1.01, 1.28],
										[-0.33, 0.43],
										[-0.98, 1.21],
										[-0.39, 0.47],
										[-0.96, 1.15],
										[-0.45, 0.52],
										[-0.94, 1.08],
										[-0.5, 0.58],
										[-0.92, 1.01],
										[-0.56, 0.6],
										[-0.89, 0.95],
										[-0.62, 0.65],
										[-0.88, 0.88],
										[-0.69, 0.69],
										[-0.85, 0.84],
										[-0.76, 0.73],
										[-0.81, 0.75],
										[-0.86, 0.78],
										[-0.73, 0.66],
										[-1.01, 0.89],
										[-0.6, 0.52],
										[-1.6, 1.34],
										[-0.06, 0.04],
										[-32.88, 12.16],
										[-1.93, 0.68],
										[-0.57, 0.2],
										[-1.42, 0.46],
										[-0.59, 0.19],
										[-1.9, 0.57],
										[-0.06, 0.01],
										[-1.94, 0.53],
										[-0.6, 0.16],
										[-1.42, 0.36],
										[-0.63, 0.16],
										[-1.84, 0.42],
										[-0.13, 0.04],
										[-1.96, 0.4],
										[-0.65, 0.12],
										[-1.39, 0.24],
										[-0.66, 0.11],
										[-1.77, 0.29],
										[-0.25, 0.03],
										[-1.96, 0.27],
										[-0.66, 0.09],
										[-1.4, 0.16],
										[-0.7, 0.07],
										[-1.74, 0.16],
										[-0.29, 0.03],
										[22.65, 21.78],
										[15, 6.68],
										[34.62, 0],
										[27.19, -12.47],
										[10.95, -10.46],
										[0, -44.72],
										[-24.34, -23.22],
										[-15.15, -6.68],
										[-10.49, -2.71],
										[-1.09, 1.65],
										[0, 0]
									],
									"o": [
										[0.09, -0.14],
										[1.04, -1.55],
										[0.16, -0.24],
										[1.01, -1.47],
										[0.23, -0.32],
										[0.99, -1.38],
										[0.29, -0.37],
										[0.98, -1.29],
										[0.33, -0.43],
										[0.96, -1.22],
										[0.39, -0.47],
										[0.95, -1.15],
										[0.45, -0.53],
										[0.92, -1.09],
										[0.5, -0.58],
										[0.91, -1.02],
										[0.56, -0.62],
										[0.89, -0.96],
										[0.62, -0.65],
										[0.86, -0.89],
										[0.68, -0.69],
										[0.83, -0.84],
										[0.75, -0.73],
										[0.79, -0.76],
										[0.85, -0.79],
										[0.73, -0.68],
										[1.01, -0.91],
										[0.6, -0.53],
										[1.58, -1.37],
										[0.06, -0.04],
										[27.37, -22.66],
										[1.91, -0.71],
										[0.57, -0.2],
										[1.42, -0.49],
										[0.59, -0.19],
										[1.88, -0.6],
										[0.06, -0.01],
										[1.94, -0.58],
										[0.6, -0.16],
										[1.41, -0.37],
										[0.62, -0.16],
										[1.84, -0.45],
										[0.13, -0.03],
										[1.96, -0.43],
										[0.63, -0.13],
										[1.39, -0.27],
										[0.66, -0.11],
										[1.77, -0.32],
										[0.25, -0.04],
										[1.94, -0.3],
										[0.66, -0.09],
										[1.4, -0.17],
										[0.69, -0.09],
										[1.73, -0.19],
										[0.29, -0.03],
										[-2.1, -38.82],
										[-11.22, -10.89],
										[-26.5, -11.9],
										[-34.62, 0],
										[-14.6, 6.68],
										[-25.01, 23.67],
										[0, 44.72],
										[11.36, 10.73],
										[9.35, 4.17],
										[1.06, -1.68],
										[0, 0],
										[0, 0]
									],
									"v": [
										[111.9, 277.01],
										[112.17, 276.6],
										[115.32, 271.95],
										[115.81, 271.23],
										[118.89, 266.87],
										[119.56, 265.94],
										[122.57, 261.83],
										[123.42, 260.7],
										[126.38, 256.83],
										[127.39, 255.53],
										[130.29, 251.88],
										[131.46, 250.44],
										[134.32, 246.99],
										[135.66, 245.4],
										[138.45, 242.15],
										[139.96, 240.44],
										[142.69, 237.39],
										[144.38, 235.56],
										[147.04, 232.7],
										[148.89, 230.76],
										[151.5, 228.08],
										[153.55, 226.02],
										[156.06, 223.53],
										[158.33, 221.35],
										[160.72, 219.07],
										[163.28, 216.73],
										[165.48, 214.71],
										[168.51, 212.02],
										[170.33, 210.43],
										[175.1, 206.38],
										[175.27, 206.24],
										[266.08, 153.75],
										[271.84, 151.69],
										[273.56, 151.1],
										[277.83, 149.68],
										[279.59, 149.12],
										[285.27, 147.36],
										[285.43, 147.32],
										[291.26, 145.67],
										[293.07, 145.18],
										[297.33, 144.07],
										[299.2, 143.59],
										[304.7, 142.28],
										[305.11, 142.18],
										[310.98, 140.93],
										[312.9, 140.56],
										[317.1, 139.77],
										[319.09, 139.41],
										[324.4, 138.51],
										[325.12, 138.4],
										[330.97, 137.55],
										[332.97, 137.29],
										[337.14, 136.79],
										[339.23, 136.56],
										[344.43, 136.04],
										[345.28, 135.95],
										[306.49, 43.98],
										[266.74, 17.71],
										[173.99, 0],
										[78.81, 18.43],
										[40.15, 43.98],
										[0, 146.18],
										[38.94, 245.76],
										[78.83, 271.75],
										[108.63, 282.04],
										[111.88, 277.03],
										[111.9, 277.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 673,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [3.92, 0.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [554.75, 306.56] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[2.6, 0.06],
										[-2.63, 0]
									],
									"o": [
										[-2.63, 0],
										[2.6, 0.07],
										[0, 0]
									],
									"v": [
										[7.84, 0.1],
										[0, 0],
										[7.84, 0.1]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 674,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.84, 0.68] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [532.9, 305.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[5.14, 0.6],
										[-5.31, -0.32]
									],
									"o": [
										[-5.31, -0.32],
										[5.15, 0.59],
										[0, 0]
									],
									"v": [
										[15.68, 1.37],
										[0, 0],
										[15.68, 1.37]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 675,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [119.9, 47.65] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [849.85, 199.26] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, -0.01],
										[-0.04, -1.57],
										[-0.01, -0.19],
										[-0.01, -0.63],
										[-9, 0],
										[-33.23, -12.29],
										[-26.76, -22.16],
										[-6.46, -6.39],
										[0, 0],
										[5.37, 4.45],
										[32.88, 12.16],
										[36.49, 0],
										[8.98, -0.78],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0.09, 1.55],
										[0, 0.19],
										[0.01, 0.63],
										[8.89, -0.79],
										[35.63, 0],
										[32.12, 11.87],
										[7, 5.8],
										[0, 0],
										[-5.05, -4.78],
										[-27.37, -22.66],
										[-34.05, -12.59],
										[-9.08, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 1.21],
										[0, 1.24],
										[0.19, 5.91],
										[0.2, 6.49],
										[0.24, 8.4],
										[27.09, 7.21],
										[130.87, 25.73],
										[219.59, 77.01],
										[239.8, 95.31],
										[239.8, 85.29],
										[224.18, 71.45],
										[133.37, 18.96],
										[27.09, 0],
										[0, 1.18],
										[0, 1.21]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 676,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [261.21, 67.89] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [708.54, 346.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[31.65, 22.76],
										[39.56, 0],
										[32.35, -23.29],
										[13.98, -37.01],
										[0, 0],
										[0, 0],
										[0, 0],
										[-20.24, 31.32],
										[2.43, 0.62],
										[8.46, -36.76],
										[0, 0],
										[0, 0],
										[0, 0],
										[-30.48, 21.94],
										[-38.03, 0],
										[-31.13, -22.4],
										[-13.48, -35.68],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-13.97, -37.01],
										[-32.35, -23.28],
										[-39.56, 0],
										[-31.63, 22.76],
										[0, 0],
										[0, 0],
										[0, 0],
										[8.46, -36.78],
										[-2.49, -0.55],
										[-20.01, 31.48],
										[0, 0],
										[0, 0],
										[0, 0],
										[13.48, -35.67],
										[31.13, -22.4],
										[38.03, 0],
										[30.48, 21.94],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[489.96, 128.59],
										[489.34, 126.96],
										[419.62, 35.6],
										[309.7, 0],
										[199.78, 35.6],
										[130.06, 126.96],
										[129.45, 128.59],
										[9.03, 128.59],
										[9.74, 125.52],
										[53.34, 22.49],
										[45.94, 20.72],
										[2.73, 123.91],
										[0, 135.78],
										[134.42, 135.78],
										[136.79, 129.51],
										[203.99, 41.44],
										[309.7, 7.19],
										[415.42, 41.44],
										[482.61, 129.51],
										[484.98, 135.78],
										[522.43, 135.78],
										[522.43, 128.59],
										[489.96, 128.59]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 677,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [20.32, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1360.58, 63.15] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[40.64, 0],
										[0, 0],
										[0, 3.6],
										[40.64, 3.6],
										[40.64, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 678,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [50.84, 63.51] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1330.07, 375.67] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[1.19, 0.5],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-1.21, -0.49],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 123.42],
										[3.6, 1.5],
										[0, 0],
										[0, 127.02],
										[101.68, 127.02],
										[101.68, 123.42],
										[3.61, 123.42],
										[3.6, 123.42]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 679,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [52.63, 66.08] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1328.25, 376.7] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[1.19, 0.5],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[-1.21, -0.52],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 128.56],
										[3.6, 1.54],
										[0, 0],
										[0, 132.16],
										[105.27, 132.16],
										[105.27, 128.56],
										[3.58, 128.56],
										[3.6, 128.56]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 680,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [20.32, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1360.58, 59.55] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[40.64, 0],
										[0, 0],
										[0, 3.6],
										[40.64, 3.6],
										[40.64, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 681,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [49.04, 185.33] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1331.86, 250.28] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0.03, 0.01],
										[2.65, 0.79],
										[0.73, 0.22],
										[1.99, 0.62],
										[0.66, 0.22],
										[5.05, 1.76],
										[0.26, 0.09],
										[2.32, 0.85],
										[0.23, 0.09],
										[4.86, 2],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[-2.7, -0.76],
										[-0.75, -0.22],
										[-2.03, -0.61],
										[-0.68, -0.21],
										[-5.32, -1.67],
										[-0.27, -0.09],
										[-2.37, -0.83],
										[-0.23, -0.09],
										[-5.16, -1.9],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[57.44, 12.99],
										[57.44, 268.25],
										[57.38, 268.24],
										[49.37, 265.92],
										[47.14, 265.26],
										[41.12, 263.43],
										[39.11, 262.8],
										[23.55, 257.65],
										[22.76, 257.37],
										[15.74, 254.86],
										[15.03, 254.6],
										[0, 248.74],
										[0, 370.67],
										[98.07, 370.67],
										[98.07, 0],
										[57.44, 0],
										[57.44, 12.99]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 682,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [29.35, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [29.35, 446] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[58.7, 0],
										[0, 0],
										[0, 3.6],
										[58.7, 3.6],
										[58.7, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 683,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [27.71, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [27.71, 258.18] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[53.87, 3.6],
										[55.42, 0],
										[0, 0],
										[0, 3.6],
										[53.87, 3.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 684,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 24.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [200.72, 345.67] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[-1.19, -0.03],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[1.21, 0.03],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.6, 0],
										[0, 0],
										[0, 48.92],
										[3.6, 49.01],
										[3.6, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 685,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [28.49, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [28.49, 254.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[55.42, 3.6],
										[56.98, 0],
										[0, 0],
										[0, 3.6],
										[55.42, 3.6]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 686,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [29.35, 1.8] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [29.35, 449.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[58.7, 0],
										[0, 0],
										[0, 3.6],
										[58.7, 3.6],
										[58.7, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 687,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [1.8, 24.55] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [204.31, 345.72] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.19, -0.04],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[1.21, 0.03],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 49.01],
										[3.6, 49.11],
										[3.6, 0],
										[0, 0],
										[0, 49.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.812, 0.882, 0.992] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 688,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [99.45, 92.11] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [99.45, 352.08] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-2.86, 0.7],
										[-0.63, 0.16],
										[-2.82, 0.6],
										[-0.35, 0.09],
										[-2.57, 0.5],
										[-0.59, 0.11],
										[-2.79, 0.48],
										[-0.53, 0.09],
										[-2.5, 0.39],
										[-0.46, 0.07],
										[-2.78, 0.36],
										[-0.6, 0.07],
										[-2.62, 0.3],
										[-0.2, 0.03],
										[-2.76, 0.26],
										[-0.62, 0.06],
										[-2.75, 0.2],
										[-0.16, 0.02],
										[-2.6, 0.16],
										[-0.57, 0.03],
										[-2.65, 0.11],
										[-0.4, 0.01],
										[-2.39, 0.06],
										[-0.49, 0.01],
										[-2.57, 0.03],
										[-0.5, 0],
										[-2.33, -0.02],
										[-0.32, 0],
										[-2.52, -0.04],
										[-0.53, -0.02],
										[-0.1, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[2.86, -0.76],
										[0.63, -0.16],
										[2.82, -0.68],
										[0.36, -0.07],
										[2.57, -0.55],
										[0.59, -0.12],
										[2.79, -0.53],
										[0.53, -0.09],
										[2.52, -0.42],
										[0.46, -0.07],
										[2.79, -0.42],
										[0.6, -0.09],
										[2.65, -0.33],
										[0.2, -0.03],
										[2.79, -0.3],
										[0.62, -0.06],
										[2.76, -0.24],
										[0.16, 0],
										[2.63, -0.19],
										[0.58, -0.03],
										[2.68, -0.14],
										[0.4, -0.01],
										[2.4, -0.09],
										[0.49, 0],
										[2.6, -0.06],
										[0.5, 0],
										[2.36, -0.01],
										[0.32, 0],
										[2.55, 0],
										[0.55, 0],
										[0.1, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[58.7, 125.57],
										[67.3, 123.38],
										[69.2, 122.92],
										[77.66, 120.99],
										[78.73, 120.76],
										[86.46, 119.18],
										[88.22, 118.83],
										[96.61, 117.31],
										[98.2, 117.05],
										[105.74, 115.84],
										[107.12, 115.62],
										[115.46, 114.46],
										[117.28, 114.23],
										[125.17, 113.28],
										[125.79, 113.21],
										[134.12, 112.37],
										[135.98, 112.2],
										[144.23, 111.52],
										[144.69, 111.49],
										[152.55, 110.98],
										[154.27, 110.88],
										[162.27, 110.49],
										[163.48, 110.44],
										[170.66, 110.21],
										[172.12, 110.17],
										[179.89, 110.04],
										[181.42, 110.04],
										[188.46, 110.03],
										[189.41, 110.03],
										[196.99, 110.11],
										[198.61, 110.14],
										[198.91, 110.14],
										[198.91, 61.22],
										[27.39, 61.22],
										[32.47, 49.48],
										[33.6, 46.83],
										[45.71, 18.83],
										[46.85, 16.19],
										[53.86, 0],
										[0, 0],
										[0, 184.23],
										[58.7, 184.23],
										[58.7, 125.55],
										[58.7, 125.57]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 689,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [20.32, 28.88] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [1360.58, 28.88] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[40.64, 0],
										[0, 0],
										[0, 57.75],
										[40.64, 57.75],
										[40.64, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 690,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [256.7, 123.97] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [713.07, 282.8] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[32.12, 11.88],
										[35.63, 0],
										[8.89, -0.79],
										[0, -0.98],
										[0, -0.03],
										[19.97, -22.69],
										[1.47, -1.48],
										[0.75, -0.72],
										[15.55, -6.83],
										[22.37, -2.46],
										[10.82, 0],
										[0, 0],
										[2.6, 0.06],
										[0.72, 0.03],
										[1.97, 0.1],
										[0.66, 0.03],
										[5.14, 0.6],
										[0.22, 0.03],
										[2.42, 0.36],
										[0.22, 0.03],
										[5.14, 1.14],
										[8.46, -36.78],
										[0, 0],
										[0, 0],
										[0, 0],
										[-31.65, 22.76],
										[-39.54, 0],
										[-32.37, -23.3],
										[-13.98, -37.01],
										[0, 0],
										[0, 0],
										[0, 0],
										[7, 5.8],
										[0, 0]
									],
									"o": [
										[-26.75, -22.14],
										[-33.24, -12.29],
										[-8.99, 0],
										[0.01, 0.98],
										[0, 0.03],
										[0, 39.47],
										[-1.38, 1.57],
										[-0.73, 0.75],
										[-11.49, 11.18],
										[-18.22, 7.99],
										[-10.17, 1.11],
										[0, 0],
										[-2.63, 0],
										[-0.72, -0.01],
										[-2, -0.06],
										[-0.66, -0.03],
										[-5.31, -0.32],
										[-0.22, -0.03],
										[-2.46, -0.29],
										[-0.22, -0.03],
										[-5.35, -0.81],
										[-20.24, 31.32],
										[0, 0],
										[0, 0],
										[0, 0],
										[13.97, -37.01],
										[32.35, -23.28],
										[39.54, 0],
										[31.63, 22.76],
										[0, 0],
										[0, 0],
										[0, 0],
										[-6.46, -6.39],
										[0, 0],
										[0, 0]
									],
									"v": [
										[493.17, 69.8],
										[404.45, 18.52],
										[300.66, 0],
										[273.82, 1.19],
										[273.85, 4.13],
										[273.85, 4.22],
										[242.33, 97.02],
										[238.08, 101.59],
										[235.86, 103.8],
										[195.02, 130.66],
										[133.79, 146.27],
										[102.27, 147.94],
										[102.27, 147.79],
										[94.43, 147.69],
										[92.26, 147.62],
										[86.31, 147.38],
										[84.34, 147.28],
										[68.66, 145.91],
										[67.99, 145.82],
										[60.69, 144.85],
										[60.05, 144.76],
										[44.3, 141.85],
										[0.7, 244.89],
										[0, 247.95],
										[120.41, 247.95],
										[121.03, 246.32],
										[190.75, 154.96],
										[300.66, 119.36],
										[410.59, 154.96],
										[480.31, 246.32],
										[480.93, 247.95],
										[513.39, 247.95],
										[513.39, 88.11],
										[493.18, 69.81],
										[493.17, 69.8]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 691,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [185.27, 92.11] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [725.63, 589.48] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[315.97, 132.7],
										[315.97, 184.23],
										[370.54, 184.23],
										[370.54, 0],
										[0, 0],
										[0, 132.7],
										[315.97, 132.7]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 692,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [83.18, 126.39] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [83.18, 126.39] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[56.98, 252.78],
										[58.98, 248.17],
										[60.11, 245.53],
										[72.22, 217.53],
										[73.37, 214.9],
										[85.49, 186.9],
										[86.62, 184.27],
										[98.73, 156.27],
										[99.89, 153.62],
										[112, 125.64],
										[113.13, 122.99],
										[125.26, 95],
										[126.4, 92.36],
										[138.51, 64.37],
										[139.66, 61.72],
										[151.77, 33.74],
										[152.91, 31.09],
										[165.02, 3.09],
										[166.17, 0.46],
										[166.36, 0],
										[0, 0],
										[0, 252.78],
										[56.98, 252.78]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 693,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [690.42, 388.38] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [690.42, 388.38] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.04, 0],
										[0, -0.07],
										[0.23, -42.44],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[30.48, 21.94],
										[38.05, 0],
										[31.11, -22.4],
										[13.48, -35.68],
										[0, 0],
										[0, 0],
										[0, 0],
										[-20.01, 31.47],
										[9.35, 4.19],
										[11.36, 10.75],
										[0, 44.7],
										[-25, 23.67],
										[-14.6, 6.69],
										[-34.61, 0],
										[-26.5, -11.91],
										[-11.22, -10.88],
										[-2.1, -38.8],
										[-9.08, 0],
										[-34.05, -12.58],
										[-27.37, -22.68],
										[-5.05, -4.78],
										[0, 0],
										[0, 0],
										[0, 0],
										[-5.24, -0.01],
										[-1.04, 0],
										[-10.6, -0.46],
										[-1.02, -0.06],
										[-6.5, -0.43],
										[-2.93, -0.23],
										[-1.11, -0.1],
										[-1.01, -0.07],
										[-9.94, -1.19],
										[-0.98, -0.12],
										[-9.4, -1.5],
										[-0.96, -0.16],
										[-4.74, -0.86],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 85.09],
										[-24.46, 33.38],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.03, 0],
										[0, -0.07],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[131.26, -35.01],
										[0, -0.07],
										[-0.01, 1.47],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-13.46, -35.67],
										[-31.13, -22.4],
										[-38.05, 0],
										[-30.48, 21.94],
										[0, 0],
										[0, 0],
										[0, 0],
										[8.46, -36.76],
										[-10.47, -2.71],
										[-15.15, -6.68],
										[-24.34, -23.22],
										[0, -44.7],
										[10.95, -10.45],
										[27.17, -12.49],
										[34.61, 0],
										[15, 6.68],
										[22.64, 21.78],
										[8.98, -0.79],
										[36.48, 0],
										[32.88, 12.16],
										[5.37, 4.45],
										[0, 0],
										[0, 0],
										[0, 0],
										[5.35, -0.1],
										[1.03, 0],
										[11.23, 0.06],
										[1.02, 0.04],
										[6.8, 0.32],
										[3.01, 0.2],
										[1.13, 0.09],
										[1, 0.09],
										[11.17, 0.95],
										[0.99, 0.12],
										[11.38, 1.39],
										[1, 0.16],
										[5.57, 0.91],
										[0, 0],
										[0, 0],
										[0, 0],
										[-96.88, -42.06],
										[0, -46.85],
										[0, 0],
										[-0.33, 59.9],
										[-115.18, -54.21],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[69.09, 2.23],
										[0, -0.07],
										[-0.04, 4.19],
										[-99.19, -46.69],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[128.29, 699.75],
										[395.23, 699.75],
										[395.23, 699.75],
										[394.79, 776.77],
										[471.41, 776.77],
										[471.41, 630.05],
										[533.16, 630.05],
										[533.16, 490.15],
										[918.08, 490.15],
										[918.08, 688.76],
										[856.32, 688.76],
										[856.32, 776.76],
										[1043.26, 776.76],
										[1043.26, 650.47],
										[969.75, 730.05],
										[969.75, 413.95],
										[932.31, 413.95],
										[929.94, 407.67],
										[862.75, 319.6],
										[757.02, 285.36],
										[651.31, 319.6],
										[584.12, 407.67],
										[581.75, 413.95],
										[447.33, 413.95],
										[450.06, 402.08],
										[493.27, 298.88],
										[463.46, 288.6],
										[423.58, 262.61],
										[384.64, 163.03],
										[424.79, 60.83],
										[463.45, 35.28],
										[558.63, 16.85],
										[651.38, 34.56],
										[691.13, 60.83],
										[729.92, 152.8],
										[757.01, 151.62],
										[863.29, 170.59],
										[954.1, 223.07],
										[969.72, 236.91],
										[969.72, 162.15],
										[1236.22, 441.54],
										[1206.4, 473.83],
										[1222.3, 473.7],
										[1225.42, 473.7],
										[1258.19, 474.49],
										[1261.25, 474.63],
										[1281.2, 475.77],
										[1290.13, 476.42],
										[1293.49, 476.69],
										[1296.51, 476.94],
										[1328.24, 480.19],
										[1331.2, 480.55],
										[1362.44, 484.95],
										[1365.36, 485.43],
										[1380.84, 488.09],
										[1380.84, 442.78],
										[1275.58, 442.78],
										[1275.58, 310.62],
										[1142.59, 121.23],
										[1179.55, 0],
										[1090.54, 0],
										[1089.95, 109.97],
										[781.69, 109.97],
										[781.69, 0],
										[374.3, 0],
										[368.89, 13.7],
										[367.84, 16.37],
										[356.63, 44.75],
										[355.58, 47.42],
										[344.38, 75.8],
										[343.33, 78.47],
										[332.12, 106.85],
										[331.07, 109.52],
										[319.87, 137.9],
										[318.82, 140.57],
										[307.61, 168.95],
										[306.56, 171.62],
										[295.35, 199.99],
										[294.3, 202.67],
										[283.1, 231.04],
										[282.05, 233.72],
										[270.84, 262.09],
										[269.79, 264.77],
										[258.59, 293.14],
										[257.54, 295.82],
										[247.54, 321.14],
										[206.16, 321.14],
										[206.16, 370.25],
										[325.68, 385.49],
										[325.68, 385.49],
										[324.22, 652.49],
										[58.75, 652.49],
										[58.75, 451.34],
										[0, 451.34],
										[0, 776.73],
										[128.29, 776.73],
										[128.29, 699.71],
										[128.29, 699.75]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [0.914, 0.949, 0.996] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 694,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [64.15, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [64.15, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[128.29, 0],
										[0, 0],
										[0, 0.17],
										[128.29, 0.17],
										[128.29, 0]
									]
								}
							}
						}
					],
					"ind": 695,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [93.47, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [949.8, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[186.94, 0],
										[0, 0],
										[0, 0.17],
										[186.94, 0.17],
										[186.94, 0]
									]
								}
							}
						}
					],
					"ind": 696,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [38.31, 0.09] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [433.11, 776.87] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, -0.06],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 0],
										[0, 0.17],
										[76.61, 0.17],
										[76.61, 0],
										[0, 0]
									]
								}
							}
						}
					],
					"ind": 697,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Ambient/Atlassian/Abstract/Combo 2 Bg",
					"sr": 1,
					"st": 0,
					"op": 109,
					"ip": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [690.5, 388.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [690.5, 388.5] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"shapes": [
						{
							"ty": "sh",
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1381, 0],
										[1381, 777],
										[0, 777],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 698
				}
			]
		}
	]
}
